
(function(global, factory) {
	typeof define === "function" && define.amd ? define(factory) : typeof module === "object" && module.exports ? (module.exports = factory()) : (global.KiteIcons = factory());
})(this, function () {
	var icons = [
	{
		"id": "ki-a",
		"name": "ki-a",
		"tags": "ki-a",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M18,9H14a3.00328,3.00328,0,0,0-3,3V23h2V19h6v4h2V12A3.00328,3.00328,0,0,0,18,9Zm-5,8V12a1.001,1.001,0,0,1,1-1h4a1.001,1.001,0,0,1,1,1v5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-a11y",
		"name": "ki-a11y",
		"tags": "ki-a11y",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "4.5",
					"r": "2.5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M28 11L28 9 4 9 4 11 13 11 13 30 15 30 15 19 17 19 17 30 19 30 19 11 28 11z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-activity",
		"name": "ki-activity",
		"tags": "ki-activity",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M10,29H5a3.00328,3.00328,0,0,1-3-3V12h8ZM4,14V26a1.00067,1.00067,0,0,0,1,1H8V14Z"
				},
				{
					"d": "M27,29H22V9h8V26A3.00328,3.00328,0,0,1,27,29Zm-3-2h3a1.00067,1.00067,0,0,0,1-1V11H24Z"
				},
				{
					"d": "M20,29H12V4h8Zm-6-2h4V6H14Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-activity-f",
		"name": "ki-activity-f",
		"tags": "ki-activity-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,12h8a0,0,0,0,1,0,0V28a0,0,0,0,1,0,0H4a2,2,0,0,1-2-2V12A0,0,0,0,1,2,12Z"
				},
				{
					"d": "M22,9h8a0,0,0,0,1,0,0V26a2,2,0,0,1-2,2H22a0,0,0,0,1,0,0V9A0,0,0,0,1,22,9Z"
				},
				{
					"d": "M12 4H20V28H12z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-agent",
		"name": "ki-agent",
		"tags": "ki-agent",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.96826,11.374a9.9871,9.9871,0,0,0-19.93652,0L2,12.18066v7.63868l4.03174.80664A8.00478,8.00478,0,0,0,13,27.93054V30h6V24H13v1.90967a6.00621,6.00621,0,0,1-4.90375-4.87073L9,21.21973V10.78027l-.92529.18506a7.99144,7.99144,0,0,1,15.85058,0L23,10.78027V21.21973l7-1.40039V12.18066ZM15,26h2v2H15ZM4,13.81934l3-.59961v5.56054l-3-.59961Zm24,4.36132-3,.59961V13.21973l3,.59961Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-agent-f",
		"name": "ki-agent-f",
		"tags": "ki-agent-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.96826,11.374a9.9871,9.9871,0,0,0-19.93652,0L2,12.18066v7.63868l4.03174.80664A8.00478,8.00478,0,0,0,13,27.93054V30h6V24H13v1.90967a6.00621,6.00621,0,0,1-4.90375-4.87073L9,21.21973V10.78027l-.92529.18506a7.99144,7.99144,0,0,1,15.85058,0L23,10.78027V21.21973l7-1.40039V12.18066Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-airplay",
		"name": "ki-airplay",
		"tags": "ki-airplay",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,23.5H22v-2h4a1.001,1.001,0,0,0,1-1V8.5a1.001,1.001,0,0,0-1-1H6a1.001,1.001,0,0,0-1,1v12a1.001,1.001,0,0,0,1,1h4v2H6a3.00328,3.00328,0,0,1-3-3V8.5a3.00328,3.00328,0,0,1,3-3H26a3.00328,3.00328,0,0,1,3,3v12A3.00328,3.00328,0,0,1,26,23.5Z"
				},
				{
					"d": "M16 19.5L9 26.5 23 26.5 16 19.5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-align-center",
		"name": "ki-align-center",
		"tags": "ki-align-center",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3 3H29V5H3z"
				},
				{
					"d": "M3 19H29V21H3z"
				},
				{
					"d": "M5 11H27V13H5z"
				},
				{
					"d": "M7 27H25V29H7z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-align-justify",
		"name": "ki-align-justify",
		"tags": "ki-align-justify",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3 3H29V5H3z"
				},
				{
					"d": "M3 11H29V13H3z"
				},
				{
					"d": "M3 19H29V21H3z"
				},
				{
					"d": "M3 27H29V29H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-align-left",
		"name": "ki-align-left",
		"tags": "ki-align-left",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,3H28a1,1,0,0,1,1,1V4a1,1,0,0,1-1,1H3A0,0,0,0,1,3,5V3A0,0,0,0,1,3,3Z"
				},
				{
					"d": "M3,11H24a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H3a0,0,0,0,1,0,0V11A0,0,0,0,1,3,11Z"
				},
				{
					"d": "M3,19H28a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H3a0,0,0,0,1,0,0V19A0,0,0,0,1,3,19Z"
				},
				{
					"d": "M3,27H20a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H3a0,0,0,0,1,0,0V27A0,0,0,0,1,3,27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-align-right",
		"name": "ki-align-right",
		"tags": "ki-align-right",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,3H28a1,1,0,0,1,1,1V4a1,1,0,0,1-1,1H3A0,0,0,0,1,3,5V3A0,0,0,0,1,3,3Z",
					"transform": "rotate(-180 16 4)"
				},
				{
					"d": "M7,11H28a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H7a0,0,0,0,1,0,0V11A0,0,0,0,1,7,11Z",
					"transform": "rotate(180 18 12)"
				},
				{
					"d": "M3,19H28a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H3a0,0,0,0,1,0,0V19A0,0,0,0,1,3,19Z",
					"transform": "rotate(-180 16 20)"
				},
				{
					"d": "M11,27H28a1,1,0,0,1,1,1v0a1,1,0,0,1-1,1H11a0,0,0,0,1,0,0V27A0,0,0,0,1,11,27Z",
					"transform": "rotate(180 20 28)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-amplified-audio",
		"name": "ki-amplified-audio",
		"tags": "ki-amplified-audio",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,9a2.0026,2.0026,0,0,1,2,2h2a4,4,0,0,0-8,0v4h2V14a2,2,0,0,1,0,4v2a4,4,0,0,0,0-8V11A2.0026,2.0026,0,0,1,21,9Z"
				},
				{
					"d": "M21.9668,3.05664A8.00322,8.00322,0,0,0,13,11h2a6.00257,6.00257,0,0,1,6.73242-5.957A6.23366,6.23366,0,0,1,27,11.294a8.7726,8.7726,0,0,1-1.25,4.51171l-.21484.3584A10.78457,10.78457,0,0,0,24,21.70605v1.12207a3.1183,3.1183,0,0,1-2.70215,3.15821A3.001,3.001,0,0,1,18,23H16a4.99912,4.99912,0,0,0,5.00977,5q.23877,0,.47753-.02344A5.13219,5.13219,0,0,0,26,22.82812V21.70605a8.7726,8.7726,0,0,1,1.25-4.51171l.21484-.3584A10.78457,10.78457,0,0,0,29,11.294,8.155,8.155,0,0,0,21.9668,3.05664Z"
				},
				{
					"d": "M7.19,6.81006,5.78,8.22A10.9831,10.9831,0,0,1,9,16a10.9831,10.9831,0,0,1-3.22,7.78l1.41,1.40991A12.9792,12.9792,0,0,0,11,16,12.97877,12.97877,0,0,0,7.19,6.81006Z"
				},
				{
					"d": "M4.36,9.64l-1.41,1.41A6.97612,6.97612,0,0,1,5,16a6.97612,6.97612,0,0,1-2.05,4.95l1.41,1.41A8.97211,8.97211,0,0,0,7,16,8.97211,8.97211,0,0,0,4.36,9.64Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-android",
		"name": "ki-android",
		"tags": "ki-android",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.44355,19.89824A1.16607,1.16607,0,1,1,23.60942,18.732a1.16746,1.16746,0,0,1-1.16587,1.16625m-12.8871,0A1.16607,1.16607,0,1,1,10.72233,18.732a1.16744,1.16744,0,0,1-1.16588,1.16625M22.86171,12.875l2.33022-4.03574a.48478.48478,0,1,0-.83968-.48474l-2.35938,4.08682a14.64769,14.64769,0,0,0-11.98574,0L7.64775,8.35449a.48478.48478,0,1,0-.83968.48474L9.13829,12.875A13.75844,13.75844,0,0,0,2,23.88781H30A13.76012,13.76012,0,0,0,22.86171,12.875"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-announcement",
		"name": "ki-announcement",
		"tags": "ki-announcement",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,19.7207l2,.66675V28H7a3.00328,3.00328,0,0,0,3-3V22.38745L22,26.3877V3.53809L2,11.31641ZM8,25a1.00067,1.00067,0,0,1-1,1H6V21.05408l2,.66675Zm12-1.3877-2-.66662V7.23962l2-.77771ZM4,12.68359,16,8.01733V22.27905L4,18.2793Z"
				},
				{
					"d": "M24.37868 4.50011H28.621319999999997V6.4999H24.37868z",
					"transform": "rotate(-45 26.5 5.5)"
				},
				{
					"d": "M25.50011 24.37868H27.4999V28.621319999999997H25.50011z",
					"transform": "rotate(-45 26.5 26.5)"
				},
				{
					"d": "M25 15H30V17H25z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-announcement-f",
		"name": "ki-announcement-f",
		"tags": "ki-announcement-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,19.7207l2,.66675V28H7a3.00328,3.00328,0,0,0,3-3V22.38745L22,26.3877V3.53809L2,11.31641ZM8,25a1.00067,1.00067,0,0,1-1,1H6V21.05408l2,.66675Zm12-1.3877-2-.66662V7.23962l2-.77771Z"
				},
				{
					"d": "M24.37868 4.50011H28.621319999999997V6.4999H24.37868z",
					"transform": "rotate(-45 26.5 5.5)"
				},
				{
					"d": "M25.50011 24.37868H27.4999V28.621319999999997H25.50011z",
					"transform": "rotate(-45 26.5 26.5)"
				},
				{
					"d": "M25 15H30V17H25z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-apple",
		"name": "ki-apple",
		"tags": "ki-apple",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.291,23.82766a15.22281,15.22281,0,0,1-1.50538,2.70659,13.751,13.751,0,0,1-1.9392,2.34363,3.76177,3.76177,0,0,1-2.49227,1.0975,6.24688,6.24688,0,0,1-2.30216-.54961,6.60571,6.60571,0,0,0-2.47844-.54789,6.82974,6.82974,0,0,0-2.54861.54789,6.85719,6.85719,0,0,1-2.20226.579,3.54186,3.54186,0,0,1-2.54861-1.12688,14.43925,14.43925,0,0,1-2.02821-2.42659A16.78263,16.78263,0,0,1,5.101,22.19093a15.60016,15.60016,0,0,1-.90063-5.07753A9.27243,9.27243,0,0,1,5.418,12.26229,7.14273,7.14273,0,0,1,7.96814,9.68274a6.86018,6.86018,0,0,1,3.4477-.97289,8.11806,8.11806,0,0,1,2.66666.62065,8.57245,8.57245,0,0,0,2.11514.622A12.65633,12.65633,0,0,0,18.543,9.21989a7.75237,7.75237,0,0,1,3.18792-.566,6.769,6.769,0,0,1,5.30256,2.79179,5.89815,5.89815,0,0,0-3.1283,5.35821,5.911,5.911,0,0,0,1.94092,4.45376,6.37818,6.37818,0,0,0,1.9392,1.27206q-.23332.67665-.4943,1.298Z"
				},
				{
					"d": "M21.88821,2.56016a5.97321,5.97321,0,0,1-1.53131,3.918A5.217,5.217,0,0,1,16.02378,8.617a4.35871,4.35871,0,0,1-.0325-.5306,6.1371,6.1371,0,0,1,1.62447-3.95929,6.25431,6.25431,0,0,1,1.979-1.48585A5.9005,5.9005,0,0,1,21.85883,2a5.08623,5.08623,0,0,1,.02938.56014Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-apple-watch",
		"name": "ki-apple-watch",
		"tags": "ki-apple-watch",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,9.85742a1,1,0,0,0,0,2A4.14258,4.14258,0,1,1,11.85742,16a1,1,0,0,0-2,0A6.14258,6.14258,0,1,0,16,9.85742Z"
				},
				{
					"d": "M26,10V9a3.00328,3.00328,0,0,0-3-3h-.21875l-1-4H10.21875l-1,4H9A3.00328,3.00328,0,0,0,6,9V23a3.00328,3.00328,0,0,0,3,3h.21875l1,4h11.5625l1-4H23a3.00328,3.00328,0,0,0,3-3V14a1,1,0,0,0,1-1V11A1,1,0,0,0,26,10ZM11.78125,4h8.4375l.5,2h-9.4375Zm8.4375,24h-8.4375l-.5-2h9.4375ZM24,23a1.00067,1.00067,0,0,1-1,1H9a1.00067,1.00067,0,0,1-1-1V9A1.00067,1.00067,0,0,1,9,8H23a1.00067,1.00067,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-archive",
		"name": "ki-archive",
		"tags": "ki-archive",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,4H2v7H4V25a3.00328,3.00328,0,0,0,3,3H25a3.00328,3.00328,0,0,0,3-3V11h2ZM26,25a1.00067,1.00067,0,0,1-1,1H7a1.00067,1.00067,0,0,1-1-1V11H26ZM28,9H4V6H28Z"
				},
				{
					"d": "M13,18h6a3.00328,3.00328,0,0,0,3-3V14H20v1a1.00067,1.00067,0,0,1-1,1H13a1.00067,1.00067,0,0,1-1-1V14H10v1A3.00328,3.00328,0,0,0,13,18Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-down",
		"name": "ki-arrow-down",
		"tags": "ki-arrow-down",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 2.04L17 2.04 17 26.567 28.021 15.546 29.435 16.96 16 30.395 2.565 16.96 3.979 15.546 15 26.567 15 2.04z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-down-left",
		"name": "ki-arrow-down-left",
		"tags": "ki-arrow-down-left",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.707 4.707L27.293 3.293 5 25.586 5 10 3 10 3 29 22 29 22 27 6.414 27 28.707 4.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-down-right",
		"name": "ki-arrow-down-right",
		"tags": "ki-arrow-down-right",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3.293 4.707L4.707 3.293 27 25.586 27 10 29 10 29 29 10 29 10 27 25.586 27 3.293 4.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-left",
		"name": "ki-arrow-left",
		"tags": "ki-arrow-left",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30 15L30 17 5.473 17 16.494 28.021 15.08 29.435 1.645 16 15.08 2.565 16.494 3.979 5.473 15 30 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-right",
		"name": "ki-arrow-right",
		"tags": "ki-arrow-right",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M1.645 15L1.645 17 26.172 17 15.151 28.021 16.565 29.435 30 16 16.565 2.565 15.151 3.979 26.172 15 1.645 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-up",
		"name": "ki-arrow-up",
		"tags": "ki-arrow-up",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17 30L15 30 15 5.473 3.979 16.494 2.565 15.08 16 1.645 29.435 15.08 28.021 16.494 17 5.473 17 30z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-up-left",
		"name": "ki-arrow-up-left",
		"tags": "ki-arrow-up-left",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.707 27.293L27.293 28.707 5 6.414 5 22 3 22 3 3 22 3 22 5 6.414 5 28.707 27.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-arrow-up-right",
		"name": "ki-arrow-up-right",
		"tags": "ki-arrow-up-right",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4.707 28.707L3.293 27.293 25.586 5 10 5 10 3 29 3 29 22 27 22 27 6.414 4.707 28.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-asterisk",
		"name": "ki-asterisk",
		"tags": "ki-asterisk",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30 15L18.414 15 26.606 6.808 25.192 5.394 17 13.586 17 2 15 2 15 13.586 6.808 5.394 5.394 6.808 13.586 15 2 15 2 17 13.586 17 5.394 25.192 6.808 26.606 15 18.414 15 30 17 30 17 18.414 25.192 26.606 26.606 25.192 18.414 17 30 17 30 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-at",
		"name": "ki-at",
		"tags": "ki-at",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2a14,14,0,0,0,0,28,13.82707,13.82707,0,0,0,8.44-2.84009c.14-.09985.28-.2.41-.30993l-1.43-1.43006a.647.647,0,0,1-.09.08008A11.99927,11.99927,0,1,1,28,16v2.5a2.5,2.5,0,0,1-5,0V9H21v2.11a6.99767,6.99767,0,1,0,.44,9.28991A4.473,4.473,0,0,0,29.95,19H30V16A14.01541,14.01541,0,0,0,16,2Zm0,19a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-attachment",
		"name": "ki-attachment",
		"tags": "ki-attachment",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30a9.00984,9.00984,0,0,1-9-9V12H9v9a7,7,0,0,0,14,0V8.5a4.5,4.5,0,0,0-9,0V21a2,2,0,0,0,4,0V10h2V21a4,4,0,0,1-8,0V8.5a6.5,6.5,0,0,1,13,0V21A9.00984,9.00984,0,0,1,16,30Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-audio-description",
		"name": "ki-audio-description",
		"tags": "ki-audio-description",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.24,6.81006,24.83,8.22a11.009,11.009,0,0,1,0,15.56006l1.41,1.40991a12.98833,12.98833,0,0,0,0-18.37988Z"
				},
				{
					"d": "M23.41,9.64l-1.41,1.41A7.00112,7.00112,0,0,1,22,20.95l1.41,1.41a8.98084,8.98084,0,0,0,0-12.72Z"
				},
				{
					"d": "M16.99609,22h-5V10h5a3.00328,3.00328,0,0,1,3,3v6A3.00328,3.00328,0,0,1,16.99609,22Zm-3-2h3a1.00067,1.00067,0,0,0,1-1V13a1.00067,1.00067,0,0,0-1-1h-3Z"
				},
				{
					"d": "M5.82227,10A2.98544,2.98544,0,0,0,2.835,12.72852L2,21.90918l1.99219.18164L4.27332,19H7.99609v3h2V10ZM4.4552,17l.372-4.08984A.99486.99486,0,0,1,5.82227,12H7.99609v5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-autopay",
		"name": "ki-autopay",
		"tags": "ki-autopay",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.00049,12.99951v-1a3.00328,3.00328,0,0,0-3-3h-1v-2h-2v2h-1a3.00328,3.00328,0,0,0-3,3v2a3.00328,3.00328,0,0,0,3,3h1v4h-1a1.00067,1.00067,0,0,1-1-1v-1h-2v1a3.00328,3.00328,0,0,0,3,3h1v2h2v-2h1a3.00328,3.00328,0,0,0,3-3v-2a3.00328,3.00328,0,0,0-3-3h-1v-4h1a1.00067,1.00067,0,0,1,1,1v1Zm-3,4a1.00067,1.00067,0,0,1,1,1v2a1.00067,1.00067,0,0,1-1,1h-1v-4Zm-3-2h-1a1.00067,1.00067,0,0,1-1-1v-2a1.00067,1.00067,0,0,1,1-1h1Z"
				},
				{
					"d": "M29,16H27A10.99505,10.99505,0,0,0,6.21,11H9v2H3V7H5V9.08A12.99669,12.99669,0,0,1,29,16Z"
				},
				{
					"d": "M29,19v6H27V22.92A12.99667,12.99667,0,0,1,3,16H5a10.99505,10.99505,0,0,0,20.79,5H23V19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-backspace",
		"name": "ki-backspace",
		"tags": "ki-backspace",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,6H11.49512A3.00419,3.00419,0,0,0,9.25293,7.00586L1.69336,16l7.55957,8.99414A3.00419,3.00419,0,0,0,11.49512,26H27a3.06373,3.06373,0,0,0,3-3.11719V9.11719A3.06373,3.06373,0,0,0,27,6Zm1,16.88281A1.06433,1.06433,0,0,1,27,24H11.49512a.98893.98893,0,0,1-.7295-.31445L4.30664,16l6.44824-7.67285A1.00289,1.00289,0,0,1,11.49512,8H27a1.06433,1.06433,0,0,1,1,1.11719Z"
				},
				{
					"d": "M22.293 11.293L19 14.586 15.707 11.293 14.293 12.707 17.586 16 14.293 19.293 15.707 20.707 19 17.414 22.293 20.707 23.707 19.293 20.414 16 23.707 12.707 22.293 11.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-backspace-f",
		"name": "ki-backspace-f",
		"tags": "ki-backspace-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,6H11.5A3.01737,3.01737,0,0,0,9.25,7.01L1.69,16l7.56,8.99A3.01737,3.01737,0,0,0,11.5,26H27a3.06821,3.06821,0,0,0,3-3.12V9.12A3.06817,3.06817,0,0,0,27,6ZM23.71,19.29l-1.42,1.42L19,17.41l-3.29,3.3-1.42-1.42L17.59,16l-3.3-3.29,1.42-1.42L19,14.59l3.29-3.3,1.42,1.42L20.41,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bank",
		"name": "ki-bank",
		"tags": "ki-bank",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17.51074,3.72412a3.00074,3.00074,0,0,0-3.02246,0L3,10.42529v3.57422H7v9H5v2H27v-2H25v-9h4V10.42529ZM9,13.99951h6v9H9Zm14,9H17v-9h6Zm4-11H5v-.42578L15.49609,5.45166v-.001a1.0006,1.0006,0,0,1,1.00684.001L27,11.57373Z"
				},
				{
					"d": "M3 26.99951H29V28.99951H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bank-f",
		"name": "ki-bank-f",
		"tags": "ki-bank-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,14V10.43L17.51,3.72a3.01757,3.01757,0,0,0-3.02,0L3,10.43V14H7v9H5v2H27V23H25V14ZM15,23H9V14h6Zm8,0H17V14h6Z"
				},
				{
					"d": "M3 26.99951H29V28.99951H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-barn",
		"name": "ki-barn",
		"tags": "ki-barn",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.84082,8.30273,16,2.88184,5.15918,8.30273,3.03809,15.72559,3,27a2.0026,2.0026,0,0,0,2,2H27a2.0026,2.0026,0,0,0,2-2V16ZM21.07941,19,17,24.82764V19ZM15,24.82764,10.92059,19H15Zm-5-3.65528L14.07941,27H10ZM17.92059,27,22,21.17236V27ZM27,27H24V19h1V17H7v2H8v8H5V16.13965L6.84082,9.69727,16,5.11816l9.15918,4.57911L27,16.13965Z"
				},
				{
					"d": "M13,9H12v2h1v4h6V11h1V9H13Zm4,4H15V11h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-battery-empty",
		"name": "ki-battery-empty",
		"tags": "ki-battery-empty",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,6H20V2H12V6H11A3.00328,3.00328,0,0,0,8,9V27a3.00328,3.00328,0,0,0,3,3H21a3.00328,3.00328,0,0,0,3-3V9A3.00328,3.00328,0,0,0,21,6ZM14,4h4V6H14Zm8,23a1.001,1.001,0,0,1-1,1H11a1.001,1.001,0,0,1-1-1V9a1.001,1.001,0,0,1,1-1H21a1.001,1.001,0,0,1,1,1Z"
				},
				{
					"d": "M18.293 14.293L16 16.586 13.707 14.293 12.293 15.707 14.586 18 12.293 20.293 13.707 21.707 16 19.414 18.293 21.707 19.707 20.293 17.414 18 19.707 15.707 18.293 14.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-battery-full",
		"name": "ki-battery-full",
		"tags": "ki-battery-full",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,6H20V2H12V6H11A3.00328,3.00328,0,0,0,8,9V27a3.00328,3.00328,0,0,0,3,3H21a3.00328,3.00328,0,0,0,3-3V9A3.00328,3.00328,0,0,0,21,6ZM14,4h4V6H14Zm8,23a1.00067,1.00067,0,0,1-1,1H11a1.00067,1.00067,0,0,1-1-1V9a1.00067,1.00067,0,0,1,1-1H21a1.00067,1.00067,0,0,1,1,1Z"
				},
				{
					"d": "M12 10H20V26H12z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-battery-half",
		"name": "ki-battery-half",
		"tags": "ki-battery-half",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,6H20V2H12V6H11A3.00328,3.00328,0,0,0,8,9V27a3.00328,3.00328,0,0,0,3,3H21a3.00328,3.00328,0,0,0,3-3V9A3.00328,3.00328,0,0,0,21,6ZM14,4h4V6H14Zm8,23a1.00067,1.00067,0,0,1-1,1H11a1.00067,1.00067,0,0,1-1-1V9a1.00067,1.00067,0,0,1,1-1H21a1.00067,1.00067,0,0,1,1,1Z"
				},
				{
					"d": "M12 17H20V26H12z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-billing",
		"name": "ki-billing",
		"tags": "ki-billing",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.00045 10.99953H20.00045V12.99953H8.00045z"
				},
				{
					"d": "M8.00045 14.99953H13.00045V16.99953H8.00045z"
				},
				{
					"d": "M17.00045 14.99953H20.00045V16.99953H17.00045z"
				},
				{
					"d": "M26.00049,12.99951h-1v-7a3.00328,3.00328,0,0,0-3-3H5.92334A2.92681,2.92681,0,0,0,3.00049,5.92334V25.99951a3.00328,3.00328,0,0,0,3,3h20a3.00328,3.00328,0,0,0,3-3v-10A3.00328,3.00328,0,0,0,26.00049,12.99951Zm-20,14a1.00067,1.00067,0,0,1-1-1V5.92334a.9242.9242,0,0,1,.92285-.92383H22.00049a1.00067,1.00067,0,0,1,1,1v20a3,3,0,0,0,.05688.56372c.011.05774.02979.11206.04407.16858.02258.0896.03943.18158.06995.2677Zm21-1a1,1,0,0,1-2,0v-11h1a1.00067,1.00067,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-billing-f",
		"name": "ki-billing-f",
		"tags": "ki-billing-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,13H25V6a3.00879,3.00879,0,0,0-3-3H5.92A2.92342,2.92342,0,0,0,3,5.92V26a3.00883,3.00883,0,0,0,3,3H26a3.00883,3.00883,0,0,0,3-3V16A3.00879,3.00879,0,0,0,26,13ZM13,17H8V15h5Zm7,0H17V15h3Zm0-4H8V11H20Zm7,13a1,1,0,0,1-2,0V15h1a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-biometrics",
		"name": "ki-biometrics",
		"tags": "ki-biometrics",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,21a3,3,0,0,1-6,0V13a3,3,0,0,0-6,0v1h2V13a1,1,0,0,1,2,0v8a5,5,0,0,0,10,0V20H25Z"
				},
				{
					"d": "M15,21V16H13v5a9.00984,9.00984,0,0,0,9,9V28A7.00848,7.00848,0,0,1,15,21Z"
				},
				{
					"d": "M9.18066,23.166A12.90533,12.90533,0,0,0,12.32715,29.669l1.48633-1.3379A10.90506,10.90506,0,0,1,11.15332,22.834Z"
				},
				{
					"d": "M7,20V13a8.94435,8.94435,0,0,1,.74805-3.59961L5.916,8.59961A10.91072,10.91072,0,0,0,5,13v8a16.74427,16.74427,0,0,0,1.72266,7.44043l1.79492-.88086A14.77088,14.77088,0,0,1,7,21Z"
				},
				{
					"d": "M16,6a7.00848,7.00848,0,0,0-7,7v8h2V13a5.00085,5.00085,0,0,1,9.332-2.499L22.0625,9.499A7.02449,7.02449,0,0,0,16,6Z"
				},
				{
					"d": "M23,22V13a7.03725,7.03725,0,0,0-.09668-1.166l-1.97266.332A5.04091,5.04091,0,0,1,21,13v9Z"
				},
				{
					"d": "M16,2A10.91544,10.91544,0,0,0,7.2002,6.39844L8.7998,7.59961A9.00033,9.00033,0,0,1,25,13v5h2V13A11.01245,11.01245,0,0,0,16,2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-block-sender",
		"name": "ki-block-sender",
		"tags": "ki-block-sender",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M5,22V20a6.00472,6.00472,0,0,1,6-6,5.51341,5.51341,0,1,0-3.43658-1.21277A8.00392,8.00392,0,0,0,3,20v4h9l-1-2ZM7.5,8.5A3.5,3.5,0,1,1,11,12,3.50424,3.50424,0,0,1,7.5,8.5Z"
				},
				{
					"d": "M21,13a8,8,0,1,0,8,8A8.00917,8.00917,0,0,0,21,13Zm6,8A5.96077,5.96077,0,0,1,25.885,24.47131l-8.35578-8.35656A5.99045,5.99045,0,0,1,27,21ZM15,21a5.96077,5.96077,0,0,1,1.11505-3.47131l8.35578,8.35656A5.99045,5.99045,0,0,1,15,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bold",
		"name": "ki-bold",
		"tags": "ki-bold",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.31311,14.50171A6.99217,6.99217,0,0,0,19,2H5V30H18.5a8.495,8.495,0,0,0,4.81311-15.49829ZM8,5H19a4,4,0,0,1,0,8H8ZM18.5,27H8V16H18.5a5.5,5.5,0,0,1,0,11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bookmark",
		"name": "ki-bookmark",
		"tags": "ki-bookmark",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,30a.99713.99713,0,0,1-.58789-.19141L16,22.23633,5.58789,29.80859A1,1,0,0,1,4,29V5A3.00328,3.00328,0,0,1,7,2H25a3.00328,3.00328,0,0,1,3,3V29a1.00085,1.00085,0,0,1-1,1ZM16,20a.99478.99478,0,0,1,.58789.19141L26,27.03613V5a1.00067,1.00067,0,0,0-1-1H7A1.00067,1.00067,0,0,0,6,5V27.03613l9.41211-6.84472A.99478.99478,0,0,1,16,20Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bookmark-f",
		"name": "ki-bookmark-f",
		"tags": "ki-bookmark-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,2H7A3.00879,3.00879,0,0,0,4,5V29a.98806.98806,0,0,0,.55.89,1.00217,1.00217,0,0,0,1.04-.08L16,22.24l10.41,7.57007A1.00425,1.00425,0,0,0,28,29V5A3.00879,3.00879,0,0,0,25,2ZM16,4h9a1.00291,1.00291,0,0,1,1,1V27.03662l-5.1778-3.76587L16.59,20.18994l-.01288-.00659L16,19.76367Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-broken-image",
		"name": "ki-broken-image",
		"tags": "ki-broken-image",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m26,4H7l2,2h17c.54999,0,1,.45001,1,1v9.85999l-5.06-4.21002-3.14001,3.15002,1.41003,1.40997,1.84998-1.85999,4.94,4.12v4.53003l1.87,1.87c.08002-.28003.13-.57001.13-.87V7c0-1.65002-1.34998-3-3-3Z"
				},
				{
					"d": "m21,10c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3,1.3457,3,3,3,3-1.3457,3-3Zm-4,0c0-.55176.44824-1,1-1s1,.44824,1,1-.44824,1-1,1-1-.44824-1-1Z"
				},
				{
					"d": "m2.29297,4.70703l1.00482,1.00482c-.18774.39093-.29779.82568-.29779,1.28815v21h22.58594l1.70703,1.70703,1.41406-1.41406L3.70703,3.29297l-1.41406,1.41406Zm6.28998,6.28998l-3.58295,3.58295v-7.16589l3.58295,3.58295Zm-3.58295,15.00299v-8.58002l4.99792-5.008,13.58801,13.58801H5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-broken-image-f",
		"name": "ki-broken-image-f",
		"tags": "ki-broken-image-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "18",
					"cy": "10",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "m26,4H7l2,2h17c.54999,0,1,.45001,1,1v9.85999l-5.06-4.21002-3.14001,3.15002,8.20001,8.20001,1.87,1.87c.08002-.28003.13-.57001.13-.87V7c0-1.65002-1.34998-3-3-3Z"
				},
				{
					"d": "m2.28998,4.70996l1.01001,1c-.19.39001-.29999.83002-.29999,1.29004v21h22.59003l1.69995,1.70996,1.42004-1.41998L3.71002,3.28998l-1.42004,1.41998Zm2.71002,2.70001l3.58002,3.59003-3.58002,3.57996v-7.16998Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bug",
		"name": "ki-bug",
		"tags": "ki-bug",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,11.90967A6.00438,6.00438,0,0,0,29,6H27a4.004,4.004,0,0,1-4,4H9A4.004,4.004,0,0,1,5,6H3a6.00438,6.00438,0,0,0,5,5.90967V14H3v2H8v2.09033A6.00438,6.00438,0,0,0,3,24H5a3.99562,3.99562,0,0,1,3-3.858V22a8,8,0,0,0,16,0V20.142A3.99562,3.99562,0,0,1,27,24h2a6.00438,6.00438,0,0,0-5-5.90967V16h5V14H24ZM22,22a6,6,0,0,1-12,0V12H22Z"
				},
				{
					"d": "M12 14H20V16H12z"
				},
				{
					"d": "M12 18H20V20H12z"
				},
				{
					"d": "M12 22H20V24H12z"
				},
				{
					"d": "M13,8h8V7A5,5,0,0,0,11,7V8h2Zm3-4a3.00159,3.00159,0,0,1,2.81476,2H13.18524A3.00159,3.00159,0,0,1,16,4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-bug-f",
		"name": "ki-bug-f",
		"tags": "ki-bug-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,11.90991A6.00674,6.00674,0,0,0,29,6H27a3.99891,3.99891,0,0,1-4,4H9A3.99891,3.99891,0,0,1,5,6H3a6.00674,6.00674,0,0,0,5,5.90991V14H3v2H8v2.09A6.007,6.007,0,0,0,3,24H5a3.99981,3.99981,0,0,1,3-3.86V22a8,8,0,0,0,16,0V20.14A3.99981,3.99981,0,0,1,27,24h2a6.007,6.007,0,0,0-5-5.91V16h5V14H24ZM20,24H12V22h8Zm0-4H12V18h8Zm0-4H12V14h8Z"
				},
				{
					"d": "M21,7V8H11V7A5,5,0,0,1,21,7Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-calculator",
		"name": "ki-calculator",
		"tags": "ki-calculator",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,3H6A3.00328,3.00328,0,0,0,3,6V29H26a3.00328,3.00328,0,0,0,3-3V6A3.00328,3.00328,0,0,0,26,3ZM5,15h6v5H5Zm14,5H13V15h6Zm-8,7H5V22h6Zm8,0H13V22h6Zm8-1a1.001,1.001,0,0,1-1,1H21V22h6Zm0-6H21V15h6Zm-6-7H5V6A1.001,1.001,0,0,1,6,5H26a1.001,1.001,0,0,1,1,1v7Z"
				},
				{
					"d": "M11 8H21V10H11z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-calendar",
		"name": "ki-calendar",
		"tags": "ki-calendar",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20 20H24V24H20z"
				},
				{
					"d": "M25,6V3H23V6H9V3H7V6H3V26a3.00328,3.00328,0,0,0,3,3H26a3.00328,3.00328,0,0,0,3-3V6Zm2,2v3H5V8ZM26,27H6a1.00067,1.00067,0,0,1-1-1V13H27V26A1.00067,1.00067,0,0,1,26,27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-calendar-f",
		"name": "ki-calendar-f",
		"tags": "ki-calendar-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,6V3H23V6H9V3H7V6H3V26a3.00883,3.00883,0,0,0,3,3H26a3.00883,3.00883,0,0,0,3-3V6ZM24,24H20V20h4Zm3-11H5V11H27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-incoming",
		"name": "ki-call-incoming",
		"tags": "ki-call-incoming",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.99 17L16.47 16.88 22.6 23.01 21.19 24.43 12.62 15.86 21.19 7.29 22.6 8.71 16.43 14.88 28.01 15 27.99 17z"
				},
				{
					"d": "M8.73975,19a10.35335,10.35335,0,0,1-.08008-6h2.90674l3.69287-6.15527-3.1709-3.1709a2.99193,2.99193,0,0,0-4.31983.07226A18.16684,18.16684,0,0,0,7.769,28.25391a2.91139,2.91139,0,0,0,2.10694.957c.02392.001.04785.001.07129.001a3.03834,3.03834,0,0,0,2.14062-.88574l3.17139-3.1709L11.56641,19Zm1.93359,7.91211a1.01714,1.01714,0,0,1-.74951.2998A.92645.92645,0,0,1,9.25,26.91016,16.17482,16.17482,0,0,1,9.24951,5.08984a.92837.92837,0,0,1,.67432-.30175h.02441a1.03,1.03,0,0,1,.72559.2998l2.06689,2.06738L10.43359,11H7.38184l-.27637.55273c-1.11768,2.23536-1.13818,5.51172-.0542,8.76368L7.2793,21h3.15429l2.30713,3.84473Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-incoming-f",
		"name": "ki-call-incoming-f",
		"tags": "ki-call-incoming-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.99 17L16.47 16.88 22.6 23.01 21.19 24.43 12.62 15.86 21.19 7.29 22.6 8.71 16.43 14.88 28.01 15 27.99 17z"
				},
				{
					"d": "M11.57,19l3.69,6.16-3.17,3.17a3.06133,3.06133,0,0,1-2.14.88H9.88a2.9024,2.9024,0,0,1-2.11-.96,18.15688,18.15688,0,0,1,0-24.5,2.90246,2.90246,0,0,1,2.11-.96,2.94694,2.94694,0,0,1,2.21.88l3.17,3.17L11.57,13H7.66a10.31635,10.31635,0,0,0,.08,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-missed",
		"name": "ki-call-missed",
		"tags": "ki-call-missed",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23 13L23 15 25.586 15 21 19.586 14.707 13.293 13.293 14.707 21 22.414 27 16.414 27 19 29 19 29 13 23 13z"
				},
				{
					"d": "M8.73975,19a10.35335,10.35335,0,0,1-.08008-6h2.90674l3.69287-6.15527-3.1709-3.1709a2.99193,2.99193,0,0,0-4.31983.07226A18.16684,18.16684,0,0,0,7.769,28.25391a2.91139,2.91139,0,0,0,2.10694.957c.02392.001.04785.001.07129.001a3.03834,3.03834,0,0,0,2.14062-.88574l3.17139-3.1709L11.56641,19Zm1.93359,7.91211a1.01714,1.01714,0,0,1-.74951.2998A.92645.92645,0,0,1,9.25,26.91016,16.17482,16.17482,0,0,1,9.24951,5.08984a.92837.92837,0,0,1,.67432-.30175h.02441a1.03,1.03,0,0,1,.72559.2998l2.06689,2.06738L10.43359,11H7.38184l-.27637.55273c-1.11768,2.23536-1.13818,5.51172-.0542,8.76368L7.2793,21h3.15429l2.30713,3.84473Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-missed-f",
		"name": "ki-call-missed-f",
		"tags": "ki-call-missed-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11.57,19l3.69,6.16-3.17,3.17a3.06133,3.06133,0,0,1-2.14.88H9.88a2.9024,2.9024,0,0,1-2.11-.96,18.15688,18.15688,0,0,1,0-24.5,2.90246,2.90246,0,0,1,2.11-.96,2.94694,2.94694,0,0,1,2.21.88l3.17,3.17L11.57,13H8.66a10.31635,10.31635,0,0,0,.08,6Z"
				},
				{
					"d": "M23 13L23 15 25.586 15 21 19.586 14.707 13.293 13.293 14.707 21 22.414 27 16.414 27 19 29 19 29 13 23 13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-outgoing",
		"name": "ki-call-outgoing",
		"tags": "ki-call-outgoing",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.73975,19a10.35335,10.35335,0,0,1-.08008-6h2.90674l3.69287-6.15527-3.1709-3.1709a2.99193,2.99193,0,0,0-4.31983.07226A18.16684,18.16684,0,0,0,7.769,28.25391a2.91139,2.91139,0,0,0,2.10694.957c.02392.001.04785.001.07129.001a3.03834,3.03834,0,0,0,2.14062-.88574l3.17139-3.1709L11.56641,19Zm1.93359,7.91211a1.01714,1.01714,0,0,1-.74951.2998A.92645.92645,0,0,1,9.25,26.91016,16.17482,16.17482,0,0,1,9.24951,5.08984a.92837.92837,0,0,1,.67432-.30175h.02441a1.03,1.03,0,0,1,.72559.2998l2.06689,2.06738L10.43359,11H7.38184l-.27637.55273c-1.11768,2.23536-1.13818,5.51172-.0542,8.76368L7.2793,21h3.15429l2.30713,3.84473Z"
				},
				{
					"d": "M20.843 7.291L19.429 8.705 25.61 14.886 14.02 15 14.04 17 25.554 16.887 19.426 23.015 20.84 24.429 29.411 15.858 20.843 7.291z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-call-outgoing-f",
		"name": "ki-call-outgoing-f",
		"tags": "ki-call-outgoing-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11.57,19l3.69,6.16-3.17,3.17a3.06133,3.06133,0,0,1-2.14.88H9.88a2.9024,2.9024,0,0,1-2.11-.96,18.15688,18.15688,0,0,1,0-24.5,2.90246,2.90246,0,0,1,2.11-.96,2.94694,2.94694,0,0,1,2.21.88l3.17,3.17L11.57,13H7.66a10.31635,10.31635,0,0,0,.08,6Z"
				},
				{
					"d": "M20.843 7.291L19.429 8.705 25.61 14.886 14.02 15 14.04 17 25.554 16.887 19.426 23.015 20.84 24.429 29.411 15.858 20.843 7.291z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-camera",
		"name": "ki-camera",
		"tags": "ki-camera",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00049,11.99951a6,6,0,1,0,6,6A6.00656,6.00656,0,0,0,16.00049,11.99951Zm0,10a4,4,0,1,1,4-4A4.00395,4.00395,0,0,1,16.00049,21.99951Z"
				},
				{
					"d": "M22.00045 11.99953H26.00045V13.99953H22.00045z"
				},
				{
					"d": "M24.61841,7.99951,23.44775,5.65869a2.9843,2.9843,0,0,0-2.68359-1.65918H11.23584A2.9843,2.9843,0,0,0,8.55225,5.65869L7.38208,7.99951H2.00049v20h28v-20ZM10.34131,6.55322a1.00892,1.00892,0,0,1,.89453-.55371h9.52832a.99494.99494,0,0,1,.89453.55371l.72363,1.44629H9.61865ZM28.00049,25.99951h-24v-16h24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-camera-f",
		"name": "ki-camera-f",
		"tags": "ki-camera-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.62,8,23.45,5.66A2.99182,2.99182,0,0,0,20.76,4H11.24A2.99182,2.99182,0,0,0,8.55,5.66L7.38,8H2V28H30V8ZM10.34,6.55a1.02139,1.02139,0,0,1,.9-.55h9.52a.99172.99172,0,0,1,.9.55L22.38,8H9.62ZM16,23a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,23Zm10-9H22V12h4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cancel",
		"name": "ki-cancel",
		"tags": "ki-cancel",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01572,14.01572,0,0,0,16,2ZM28,16a11.93975,11.93975,0,0,1-2.84528,7.74066L8.2594,6.84534A11.987,11.987,0,0,1,28,16ZM4,16A11.93975,11.93975,0,0,1,6.84528,8.25934L23.7406,25.15466A11.987,11.987,0,0,1,4,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cane",
		"name": "ki-cane",
		"tags": "ki-cane",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.84003,19.47928c.21997-.42999.33997-.90002.33997-1.38,0-.78998-.31-1.54999-.88-2.12l-6.08002-6.07001c-.10999-.13-.21997-.22998-.28998-.28998-.21002-.17999-.44-.31-.67999-.41003-.03998-.01996-.08002-.03998-.12-.04999,1.06-.71002,1.76001-1.91998,1.76001-3.27997,0-2.18005-1.77002-3.95001-3.94-3.95001-2.17999,0-3.95001,1.76996-3.95001,3.95001,0,1.48999.83002,2.78998,2.06,3.44995-1.26001.57001-2.06,1.72003-2.06,3.14001v5.46002c0,1.34998.48999,2.42999,1.39001,3.10999l-2.60999,2.85999c-.5.54999-.78003,1.27002-.78003,2.03003,0,.84998.35999,1.65997.98004,2.21997.57996.52002,1.29999.78003,2.01996.78003.51001,0,1.01001-.13,1.46002-.37.44.76001,1.25,1.37,2.53998,1.37,2.20001,0,3-1.79004,3-3v-7.69l1.04999.98999c.89001.89001,2.23004,1.09998,3.33002.60999l7.91998,7.79999,1.40002-1.41998-7.85999-7.73999ZM10,5.8793c0-1.08002.87-1.95001,1.95001-1.95001,1.07001,0,1.94.87,1.94,1.95001,0,1.06995-.87,1.94-1.94,1.94-1.08002,0-1.95001-.87006-1.95001-1.94ZM10,26.32925l-.26001.28003c-.37.39996-1.00995.42999-1.41998.06-.21002-.19-.32001-.45001-.32001-.73999,0-.25.09003-.48999.26001-.67999l1.73999-1.91003v2.98999ZM19.89001,18.80929c-.40002.39996-1.03003.39996-1.45001-.02002l-2.72998-2.57001-2-2-1.42004,1.41998,1.71002,1.71002v9.57001c-.01001.46002-.19,1.01001-1,1.01001s-.98999-.54999-1-1v-6.95001l-.73999-.20001c-.58002-.16998-1.26001-.52002-1.26001-1.84998v-5.46002c0-1.14001,1.08002-1.53998,2-1.53998l.80809.0002c.3984.0001.78039.15873,1.06167.44088l6.01024,6.0289c.19.19.29999.44.29999.70001s-.10999.52002-.28998.71002Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-caption-jump",
		"name": "ki-caption-jump",
		"tags": "ki-caption-jump",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.02166,14.97834l-18.02166,.02166v-2l18.02166,.02166c.54032,0,.97834,.43802,.97834,.97834h0c0,.54032-.43802,.97834-.97834,.97834Z"
				},
				{
					"d": "M17.02166,4.97834l-14.02166,.02166V3l14.02166,.02166c.54032,0,.97834,.43802,.97834,.97834h0c0,.54032-.43802,.97834-.97834,.97834Z"
				},
				{
					"d": "M29 3 22 3 22 5 27 5 27 24 11.41406 24 13.70703 21.70703 12.29297 20.29297 7.58594 25 12.29297 29.70703 13.70703 28.29297 11.41406 26 29 26 29 3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-car",
		"name": "ki-car",
		"tags": "ki-car",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11 14H21V16H11z"
				},
				{
					"d": "M30,8H26.61816L25.44727,5.6582A2.98446,2.98446,0,0,0,22.76416,4H9.23584A2.98446,2.98446,0,0,0,6.55273,5.6582L5.38184,8H2v2H4.38184L2.31641,14.13086A3.01406,3.01406,0,0,0,2,15.47168V28H6a3.00328,3.00328,0,0,0,3-3V24H23v1a3.00328,3.00328,0,0,0,3,3h4V15.47168a3.01392,3.01392,0,0,0-.31641-1.34082L27.61816,10H30Zm-6.83545,7.98633,4.76923-.79486A.99382.99382,0,0,1,28,15.47168V22H25V18H7v4H4V15.47168a1.002,1.002,0,0,1,.102-.43158l4.70172.94037.39258-1.96094-4.17084-.83417L5.61816,12H26.38184l.65661,1.31317-4.203.7005ZM8.3418,6.55273A.9945.9945,0,0,1,9.23584,6H22.76416a.9945.9945,0,0,1,.894.55273L25.38184,10H6.61816ZM7,25a1.001,1.001,0,0,1-1,1H4V24H7Zm2-3V20H23v2Zm17,4a1.001,1.001,0,0,1-1-1V24h3v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-car-f",
		"name": "ki-car-f",
		"tags": "ki-car-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,7.92191H26.62L25.45,5.58183a2.99189,2.99189,0,0,0-2.69-1.65992H9.24A2.99189,2.99189,0,0,0,6.55,5.58183L5.38,7.92191H2v2H4.38l-2.06,4.13a2.971,2.971,0,0,0-.32,1.34v12.53H6a3.00886,3.00886,0,0,0,3-3v-1H23v1a3.00886,3.00886,0,0,0,3,3h4v-12.53a2.971,2.971,0,0,0-.32-1.34l-2.06-4.13H30Zm-19,6H21v2H11Zm-6.89,1.03.92-1.84008,4.17.83007-.4,1.96L4.11,14.962Zm2.89,9.97a1.00291,1.00291,0,0,1-1,1H4v-2H7Zm2-3v-2H23v2Zm19,4H26a1.00291,1.00291,0,0,1-1-1v-1h3Zm-.11-10.97a.44209.44209,0,0,1,.06.15992l-4.79.8-.31994-1.98,4.19-.69995Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-case",
		"name": "ki-case",
		"tags": "ki-case",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2 10L4 10 4 8 9 8 9 24 7 24 7 26 13 26 13 24 11 24 11 8 16 8 16 10 18 10 18 6 2 6 2 10z"
				},
				{
					"d": "M20 13L20 15 22 15 22 15 24 15 24 24 24 24 24 26 26 26 26 24 26 24 26 15 28 15 28 15 30 15 30 13 20 13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cash-payments",
		"name": "ki-cash-payments",
		"tags": "ki-cash-payments",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,9a5,5,0,1,0,5,5A5.00588,5.00588,0,0,0,16,9Zm0,8a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,16,17Z"
				},
				{
					"d": "M27,5H5A3.00328,3.00328,0,0,0,2,8V23H27a3.00328,3.00328,0,0,0,3-3V8A3.00328,3.00328,0,0,0,27,5Zm0,2a1.00067,1.00067,0,0,1,1,1v2.89941A5.01485,5.01485,0,0,1,24.10059,7ZM4,8A1.00067,1.00067,0,0,1,5,7H7.89941A5.01485,5.01485,0,0,1,4,10.89941ZM4,21V17.10059A5.01485,5.01485,0,0,1,7.89941,21Zm5.9201,0A7.00533,7.00533,0,0,0,4,15.07983V12.92017A7.00533,7.00533,0,0,0,9.9201,7H22.0799A7.00533,7.00533,0,0,0,28,12.92017v2.15966A7.00533,7.00533,0,0,0,22.0799,21ZM28,20a1.00067,1.00067,0,0,1-1,1H24.10059A5.01485,5.01485,0,0,1,28,17.10059Z"
				},
				{
					"d": "M2 25H30V27H2z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cash-payments-f",
		"name": "ki-cash-payments-f",
		"tags": "ki-cash-payments-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "14",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M27,5H5A3.00879,3.00879,0,0,0,2,8V23H27a3.00887,3.00887,0,0,0,3-3V8A3.00879,3.00879,0,0,0,27,5Zm0,2a1.00291,1.00291,0,0,1,1,1v2.8999A5.00968,5.00968,0,0,1,24.1,7ZM16,19a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,19ZM4,8A1.00291,1.00291,0,0,1,5,7H7.9A5.00968,5.00968,0,0,1,4,10.8999ZM4,21V17.1A5.01,5.01,0,0,1,7.9,21Zm24-1a1.00291,1.00291,0,0,1-1,1H24.1A5.01,5.01,0,0,1,28,17.1Z"
				},
				{
					"d": "M2 25H30V27H2z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cast",
		"name": "ki-cast",
		"tags": "ki-cast",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,28.00391H19v-2h9v-19a1.001,1.001,0,0,0-1-1H4V11H2V4.00391H27a3.00328,3.00328,0,0,1,3,3Z"
				},
				{
					"d": "M7.09091,27.99859H3a1,1,0,0,1-1-1v-4.0895A5.47454,5.47454,0,0,1,7.09091,27.99859Z"
				},
				{
					"d": "M12,28H10a7.8247,7.8247,0,0,0-8-8V18A9.89369,9.89369,0,0,1,12,28Z"
				},
				{
					"d": "M17,28H15A12.71486,12.71486,0,0,0,2,15V13A14.67075,14.67075,0,0,1,17,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cast-f",
		"name": "ki-cast-f",
		"tags": "ki-cast-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.31,23.31A15.92339,15.92339,0,0,1,17,28H15A12.7162,12.7162,0,0,0,2,15V13a15.92368,15.92368,0,0,1,4.69.69A14.40211,14.40211,0,0,1,16.31,23.31Z"
				},
				{
					"d": "M30,7V28H20a19.76478,19.76478,0,0,0-.87-5.87A15.76426,15.76426,0,0,0,7.87,10.87,19.76478,19.76478,0,0,0,2,10L1.99,9,2,4H27A3.00879,3.00879,0,0,1,30,7Z"
				},
				{
					"d": "M7.09091,27.99859H3a1,1,0,0,1-1-1v-4.0895A5.47454,5.47454,0,0,1,7.09091,27.99859Z"
				},
				{
					"d": "M12,28H10a7.82536,7.82536,0,0,0-8-8V18A9.89052,9.89052,0,0,1,12,28Z"
				},
				{
					"d": "M17,28H15A12.7162,12.7162,0,0,0,2,15V13a15.92368,15.92368,0,0,1,4.69.69,14.40211,14.40211,0,0,1,9.62,9.62A15.92339,15.92339,0,0,1,17,28Z"
				},
				{
					"d": "M30,28.00391H21v-2h7v-19a1.001,1.001,0,0,0-1-1H4V9H2V4.00391H27a3.00328,3.00328,0,0,1,3,3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-caution-alert",
		"name": "ki-caution-alert",
		"tags": "ki-caution-alert",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "24",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,6.47214,26.76392,28H5.23608L16,6.47214M16,2,2,30H30L16,2Z"
				},
				{
					"d": "M14.5 13H17.5V20H14.5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-caution-alert-f",
		"name": "ki-caution-alert-f",
		"tags": "ki-caution-alert-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2,2,30H30ZM14.5,13h3v7h-3ZM16,26a2,2,0,1,1,2-2A2.00591,2.00591,0,0,1,16,26Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-caution-circle",
		"name": "ki-caution-circle",
		"tags": "ki-caution-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "22",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14.00049-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12.00049,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M14.5 8H17.5V18H14.5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-caution-circle-f",
		"name": "ki-caution-circle-f",
		"tags": "ki-caution-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01541,14.01541,0,0,0,16,2ZM14.5,8h3V18h-3ZM16,24a2,2,0,1,1,2-2A2.00591,2.00591,0,0,1,16,24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cc",
		"name": "ki-cc",
		"tags": "ki-cc",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,28H2V7A3.00328,3.00328,0,0,1,5,4H27a3.00328,3.00328,0,0,1,3,3V25A3.00328,3.00328,0,0,1,27,28ZM4,26H27a1.00067,1.00067,0,0,0,1-1V7a1.00067,1.00067,0,0,0-1-1H5A1.00067,1.00067,0,0,0,4,7Z"
				},
				{
					"d": "M12,22H10a3.00328,3.00328,0,0,1-3-3V13a3.00328,3.00328,0,0,1,3-3h2a3.00328,3.00328,0,0,1,3,3H13a1.00067,1.00067,0,0,0-1-1H10a1.00067,1.00067,0,0,0-1,1v6a1.00067,1.00067,0,0,0,1,1h2a1.00067,1.00067,0,0,0,1-1h2A3.00328,3.00328,0,0,1,12,22Z"
				},
				{
					"d": "M22,22H20a3.00328,3.00328,0,0,1-3-3V13a3.00328,3.00328,0,0,1,3-3h2a3.00328,3.00328,0,0,1,3,3H23a1.00067,1.00067,0,0,0-1-1H20a1.00067,1.00067,0,0,0-1,1v6a1.00067,1.00067,0,0,0,1,1h2a1.00067,1.00067,0,0,0,1-1h2A3.00328,3.00328,0,0,1,22,22Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cc-f",
		"name": "ki-cc-f",
		"tags": "ki-cc-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00887,3.00887,0,0,0,3-3V7A3.00879,3.00879,0,0,0,27,4ZM10,20h2a1.00291,1.00291,0,0,0,1-1h2a3.00887,3.00887,0,0,1-3,3H10a3.00887,3.00887,0,0,1-3-3V13a3.00879,3.00879,0,0,1,3-3h2a3.00879,3.00879,0,0,1,3,3H13a1.00291,1.00291,0,0,0-1-1H10a1.00291,1.00291,0,0,0-1,1v6A1.00291,1.00291,0,0,0,10,20Zm10,0h2a1.00291,1.00291,0,0,0,1-1h2a3.00887,3.00887,0,0,1-3,3H20a3.00887,3.00887,0,0,1-3-3V13a3.00879,3.00879,0,0,1,3-3h2a3.00879,3.00879,0,0,1,3,3H23a1.00291,1.00291,0,0,0-1-1H20a1.00291,1.00291,0,0,0-1,1v6A1.00291,1.00291,0,0,0,20,20Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chair",
		"name": "ki-chair",
		"tags": "ki-chair",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,12v7a1.00067,1.00067,0,0,1-1,1H23V19a3.00328,3.00328,0,0,0-3-3H17V14h3a3.00328,3.00328,0,0,0,3-3V6a3.00328,3.00328,0,0,0-3-3H12A3.00328,3.00328,0,0,0,9,6v5a3.00328,3.00328,0,0,0,3,3h3v2H12a3.00328,3.00328,0,0,0-3,3v1H8a1.00067,1.00067,0,0,1-1-1V12H3v2H5v5a3.00328,3.00328,0,0,0,3,3h7v3H7v4H9V27h6v2h2V27h6v2h2V25H17V22h7a3.00328,3.00328,0,0,0,3-3V14h2V12ZM11,11V6a1.00067,1.00067,0,0,1,1-1h8a1.00067,1.00067,0,0,1,1,1v5a1.00067,1.00067,0,0,1-1,1H12A1.00067,1.00067,0,0,1,11,11Zm10,9H11V19a1.00067,1.00067,0,0,1,1-1h8a1.00067,1.00067,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chair-f",
		"name": "ki-chair-f",
		"tags": "ki-chair-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,12v7a1.00067,1.00067,0,0,1-1,1H23V19a3.00328,3.00328,0,0,0-3-3H17V14h3a3.00328,3.00328,0,0,0,3-3V6a3.00328,3.00328,0,0,0-3-3H12A3.00328,3.00328,0,0,0,9,6v5a3.00328,3.00328,0,0,0,3,3h3v2H12a3.00328,3.00328,0,0,0-3,3v1H8a1.00067,1.00067,0,0,1-1-1V12H3v2H5v5a3.00328,3.00328,0,0,0,3,3h7v3H7v4H9V27h6v2h2V27h6v2h2V25H17V22h7a3.00328,3.00328,0,0,0,3-3V14h2V12Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chat",
		"name": "ki-chat",
		"tags": "ki-chat",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6.96484,29.688V24.96484h-3a2.002,2.002,0,0,1-2-2v-17a2.002,2.002,0,0,1,2-2h24a2.002,2.002,0,0,1,2,2v17a2.002,2.002,0,0,1-2,2H15.23047Zm-3-23.72315v17h5V26.2417l5.73438-3.27686H27.96484v-17Z"
				},
				{
					"d": "M6.96484 10.96484H24.96484V12.96484H6.96484z"
				},
				{
					"d": "M6.96484 15.96484H17.96484V17.96484H6.96484z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chat-f",
		"name": "ki-chat-f",
		"tags": "ki-chat-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.96484,3.96484h-24a2.002,2.002,0,0,0-2,2v17a2.002,2.002,0,0,0,2,2h3V29.688l8.26563-4.72315H27.96484a2.002,2.002,0,0,0,2-2v-17A2.002,2.002,0,0,0,27.96484,3.96484Zm-10,14h-11v-2h11Zm7-5h-18v-2h18Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chat-support",
		"name": "ki-chat-support",
		"tags": "ki-chat-support",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,10H20V6a2.00229,2.00229,0,0,0-2-2H4A2.00229,2.00229,0,0,0,2,6V18a2.00229,2.00229,0,0,0,2,2H5v3.76611L11.27734,20H12v4.04688a2.0023,2.0023,0,0,0,2,2h6.72949L27,29.70605V26.04688h1a2.0023,2.0023,0,0,0,2-2V12A2.00229,2.00229,0,0,0,28,10ZM12,12v6H10.72266L7,20.23389V18H4V6H18v4H14A2.00229,2.00229,0,0,0,12,12ZM28,24.04688H25v2.17675l-3.72949-2.17675H14V12H28Z"
				},
				{
					"d": "M16 15H26.04688V17H16z"
				},
				{
					"d": "M16 19H24V21H16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chat-support-alt",
		"name": "ki-chat-support-alt",
		"tags": "ki-chat-support-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "15.5",
					"r": "1.5"
				},
				{
					"cx": "11.5",
					"cy": "15.5",
					"r": "1.5"
				},
				{
					"cx": "20.5",
					"cy": "15.5",
					"r": "1.5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,6.39502c-6.07001,0-11,4.03998-11,9,0,2.01001.81,3.87,2.16998,5.37l-1.31,4.83997,6.46002-1.72998c1.14996.34003,2.39001.52002,3.67999.52002,6.07001,0,11-4.04004,11-9s-4.92999-9-11-9ZM16,22.89502h-.02002c-1.28998,0-2.51996-.21002-3.63995-.58002l-2.32001.63-2.03003.53998.42999-1.57001.42999-1.58997c-.45996-.40002-.85999-.85999-1.19-1.34003-.73999-1.07001-1.15997-2.28998-1.15997-3.58997,0-4.14001,4.25-7.5,9.5-7.5s9.5,3.35999,9.5,7.5-4.25,7.5-9.5,7.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chat-support-f",
		"name": "ki-chat-support-f",
		"tags": "ki-chat-support-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,10H20V6a2.00229,2.00229,0,0,0-2-2H4A2.00229,2.00229,0,0,0,2,6V18a2.00229,2.00229,0,0,0,2,2H5v3.76611L11.27734,20H12v4.04688a2.0023,2.0023,0,0,0,2,2h6.72949L27,29.70605V26.04688h1a2.0023,2.0023,0,0,0,2-2V12A2.00229,2.00229,0,0,0,28,10ZM12,12v6H10.72266L7,20.23389V18H4V6H18v4H14A2.00229,2.00229,0,0,0,12,12Zm12,9H16V19h8Zm2.04688-4H16V15H26.04688Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark",
		"name": "ki-checkmark",
		"tags": "ki-checkmark",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12 25.061L3.293 16.354 4.707 14.939 12 22.232 27.293 6.939 28.707 8.354 12 25.061z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark-alt",
		"name": "ki-checkmark-alt",
		"tags": "ki-checkmark-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12 25.76758 2.93945 16.70703 5.06055 14.58594 12 21.52539 26.93945 6.58594 29.06055 8.70703 12 25.76758z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark-badge",
		"name": "ki-checkmark-badge",
		"tags": "ki-checkmark-badge",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M14 21.414L9.293 16.707 10.707 15.293 14 18.586 21.293 11.293 22.707 12.707 14 21.414z"
				},
				{
					"d": "M16,30.00488,11.99512,26H6V20.00488L1.99512,16,6,11.99512V6h5.99512L16,1.99512,20.00488,6H26v5.99512L30.00488,16,26,20.00488V26H20.00488ZM8,24h4.82324L16,27.17676,19.17676,24H24V19.17676L27.17676,16,24,12.82324V8H19.17676L16,4.82324,12.82324,8H8v4.82324L4.82324,16,8,19.17676Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark-badge-f",
		"name": "ki-checkmark-badge-f",
		"tags": "ki-checkmark-badge-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,12V6H20L16,2,12,6H6v6L2,16l4,4v6h6l4,4,4-4h6V20l4-4ZM14,21.40991l-4.71-4.7L10.71,15.29,14,18.58984,21.29,11.29,22.71,12.71Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark-circle",
		"name": "ki-checkmark-circle",
		"tags": "ki-checkmark-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M13 22.914L7.293 17.207 8.707 15.792 13 20.085 23.293 9.792 24.707 11.207 13 22.914z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-checkmark-circle-f",
		"name": "ki-checkmark-circle-f",
		"tags": "ki-checkmark-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2ZM13,22.91l-5.71-5.7,1.42-1.42L13,20.09,23.29,9.79l1.42,1.42Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-down",
		"name": "ki-chevron-down",
		"tags": "ki-chevron-down",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.707 10.854L16 24.561 2.293 10.854 3.707 9.439 16 21.732 28.293 9.439 29.707 10.854z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-down-circle",
		"name": "ki-chevron-down-circle",
		"tags": "ki-chevron-down-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M16 21.164L8.793 13.957 10.207 12.542 16 18.335 21.793 12.542 23.207 13.957 16 21.164z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-down-circle-f",
		"name": "ki-chevron-down-circle-f",
		"tags": "ki-chevron-down-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm0,19.16-7.21-7.2,1.42-1.42L16,18.34l5.79-5.8,1.42,1.42Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-left",
		"name": "ki-chevron-left",
		"tags": "ki-chevron-left",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.146 29.707L8.439 16 22.146 2.293 23.561 3.707 11.268 16 23.561 28.293 22.146 29.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-left-circle",
		"name": "ki-chevron-left-circle",
		"tags": "ki-chevron-left-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,15.99953a14,14,0,1,1,14,14A14.01573,14.01573,0,0,1,2,15.99953Zm26,0a12,12,0,1,0-12,12A12.01343,12.01343,0,0,0,28,15.99953Z"
				},
				{
					"d": "M10.836 16L18.043 8.792 19.457 10.207 13.664 16 19.457 21.792 18.043 23.207 10.836 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-left-circle-f",
		"name": "ki-chevron-left-circle-f",
		"tags": "ki-chevron-left-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm3.46,19.79-1.42,1.42L10.84,16l7.2-7.21,1.42,1.42L13.66,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-right",
		"name": "ki-chevron-right",
		"tags": "ki-chevron-right",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9.854 2.293L23.561 16 9.854 29.707 8.439 28.293 20.732 16 8.439 3.707 9.854 2.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-right-circle",
		"name": "ki-chevron-right-circle",
		"tags": "ki-chevron-right-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,16.00047a14,14,0,1,1-14-14A14.01573,14.01573,0,0,1,30,16.00047Zm-26,0a12,12,0,1,0,12-12A12.01343,12.01343,0,0,0,4,16.00047Z"
				},
				{
					"d": "M21.164 16L13.957 23.208 12.543 21.793 18.336 16 12.543 10.208 13.957 8.793 21.164 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-right-circle-f",
		"name": "ki-chevron-right-circle-f",
		"tags": "ki-chevron-right-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2ZM13.96,23.21l-1.42-1.42L18.34,16l-5.8-5.79,1.42-1.42L21.16,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-up",
		"name": "ki-chevron-up",
		"tags": "ki-chevron-up",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2.293 22.146L16 8.439 29.707 22.146 28.293 23.561 16 11.268 3.707 23.561 2.293 22.146z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-up-circle",
		"name": "ki-chevron-up-circle",
		"tags": "ki-chevron-up-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2.00047a14,14,0,1,1-14,14A14.01573,14.01573,0,0,1,16,2.00047Zm0,26a12,12,0,1,0-12-12A12.01343,12.01343,0,0,0,16,28.00047Z"
				},
				{
					"d": "M16 10.836L23.207 18.043 21.793 19.458 16 13.665 10.207 19.458 8.793 18.043 16 10.836z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-chevron-up-circle-f",
		"name": "ki-chevron-up-circle-f",
		"tags": "ki-chevron-up-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm5.79,17.46L16,13.66l-5.79,5.8L8.79,18.04,16,10.84l7.21,7.2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-clock",
		"name": "ki-clock",
		"tags": "ki-clock",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,4.15384c6.53198,0,11.84615,5.31418,11.84615,11.84616s-5.31416,11.84616-11.84615,11.84616-11.84615-5.31418-11.84615-11.84616S9.46802,4.15384,16,4.15384m0-2.15384c-7.73198,0-14,6.26801-14,14s6.26802,14,14,14,14-6.26801,14-14S23.73198,2,16,2h0Z"
				},
				{
					"d": "M20.32715 20.84082 14.92285 16.51758 14.92285 6 17.07715 6 17.07715 15.48242 21.67285 19.15918 20.32715 20.84082z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-clock-f",
		"name": "ki-clock-f",
		"tags": "ki-clock-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2c-7.72998,0-14,6.26996-14,14s6.27002,14,14,14,14-6.27002,14-14S23.72998,2,16,2Zm4.33002,18.83997l-5.41003-4.32001V6h2.16003V15.47998l4.58997,3.67999-1.33997,1.67999Z",
					"data-name": "ki-clock-f"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cloud",
		"name": "ki-cloud",
		"tags": "ki-cloud",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,19.5a7.45406,7.45406,0,0,0-5.07422-7.09229A8.80526,8.80526,0,0,0,16,5a8.80075,8.80075,0,0,0-8.92029,7.40826A7.49053,7.49053,0,0,0,9,26.97467V27H23v-.02533A7.50336,7.50336,0,0,0,30,19.5ZM22.5,25H9.5a5.5,5.5,0,1,1,4.63672-8.46094l1.68359-1.07812A7.474,7.474,0,0,0,9.5,12c-.10651,0-.21008.0116-.31555.016A6.88011,6.88011,0,0,1,16,7a6.75854,6.75854,0,0,1,6.99121,6.22266l.03223.75879.73926.17236A5.49615,5.49615,0,0,1,22.5,25Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cloud-f",
		"name": "ki-cloud-f",
		"tags": "ki-cloud-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,19.5a7.45406,7.45406,0,0,0-5.07422-7.09229A8.80526,8.80526,0,0,0,16,5a8.80075,8.80075,0,0,0-8.92029,7.40826A7.49053,7.49053,0,0,0,9,26.97467V27H23v-.02533A7.50336,7.50336,0,0,0,30,19.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-coffee-maker",
		"name": "ki-coffee-maker",
		"tags": "ki-coffee-maker",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18 6H20V8H18z"
				},
				{
					"d": "M24,3.92191v-2H8v2H4V30H28V3.92191Zm-14,0H22V11H10ZM10,28V26H22v2Zm2-8V19h8v1a4,4,0,0,1-8,0Zm14,8H24V24H20.44177a5.97651,5.97651,0,0,0,1.4679-3H24V19H22V17H10v3a5.96877,5.96877,0,0,0,1.54047,4H8v4H6V5.92191H8V11a2,2,0,0,0,2,2h5v2h2V13h5a2,2,0,0,0,2-2V5.92191h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-coffee-maker-f",
		"name": "ki-coffee-maker-f",
		"tags": "ki-coffee-maker-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,3.92v-2H8v2H4V30H28V3.92ZM18,6h2V8H18Zm8,22H24V24H20.44a5.90062,5.90062,0,0,0,1.47-3H24V19H22V17H10v3a5.97951,5.97951,0,0,0,1.54,4H8v4H6V5.92H8V11a2.00591,2.00591,0,0,0,2,2h5v2h2V13h5a2.00591,2.00591,0,0,0,2-2V5.92h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-collapse",
		"name": "ki-collapse",
		"tags": "ki-collapse",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29 15L29 13 20.419 13 28.002 5.417 26.588 4.002 19 11.591 19 3 17 3 17 15 29 15z"
				},
				{
					"d": "M3 17L3 19 11.581 19 3.998 26.583 5.412 27.998 13 20.409 13 29 15 29 15 17 3 17z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-command",
		"name": "ki-command",
		"tags": "ki-command",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,19H21V13h3a5,5,0,1,0-5-5v3H13V8a5,5,0,1,0-5,5h3v6H8a5,5,0,1,0,5,5V21h6v3a5,5,0,1,0,5-5ZM21,8a3,3,0,1,1,3,3H21ZM8,11a3,3,0,1,1,3-3v3Zm3,13a3,3,0,1,1-3-3h3Zm2-5V13h6v6Zm11,8a3.00328,3.00328,0,0,1-3-3V21h3a3,3,0,0,1,0,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-compass",
		"name": "ki-compass",
		"tags": "ki-compass",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "8",
					"r": "1"
				},
				{
					"cx": "16",
					"cy": "24",
					"r": "1"
				},
				{
					"cx": "8",
					"cy": "16",
					"r": "1"
				},
				{
					"cx": "24",
					"cy": "16",
					"r": "1"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29A13,13,0,1,1,29,16,13.01505,13.01505,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11.01245,11.01245,0,0,0,16,5Z"
				},
				{
					"d": "M13,13l-3,9,9-3,3-9Zm1.58,1.58,4.26-1.42-1.42,4.26Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-compass-f",
		"name": "ki-compass-f",
		"tags": "ki-compass-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,3A13,13,0,1,0,29,16,13.01243,13.01243,0,0,0,16,3Zm0,4a1,1,0,1,1-1,1A1.00291,1.00291,0,0,1,16,7ZM8,17a1,1,0,1,1,1-1A1.00291,1.00291,0,0,1,8,17Zm8,8a1,1,0,1,1,1-1A1.00291,1.00291,0,0,1,16,25Zm3-6-9,3,3-9,9-3Zm5-2a1,1,0,1,1,1-1A1.00291,1.00291,0,0,1,24,17Z"
				},
				{
					"d": "M18.84 13.16L17.42 17.42 14.58 14.58 18.84 13.16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-compose",
		"name": "ki-compose",
		"tags": "ki-compose",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.00045,28.99953h-23v-23a3.00328,3.00328,0,0,1,3-3h13v2h-13a1.00067,1.00067,0,0,0-1,1v21h21a1.00067,1.00067,0,0,0,1-1v-13h2v13A3.00328,3.00328,0,0,1,26.00045,28.99953Z"
				},
				{
					"d": "M8.58346,23.4175l1.62793-6.05078L23.66451,3.91554a3.12536,3.12536,0,1,1,4.41993,4.41993L14.63229,21.78761Zm3.4209-5.01367-.58692,2.17773,2.17774-.58691L26.67037,6.9214a1.12557,1.12557,0,0,0-1.59179-1.59179Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-compose-f",
		"name": "ki-compose-f",
		"tags": "ki-compose-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.00045,28.99953h-23v-23a3.00328,3.00328,0,0,1,3-3h13v2h-13a1.00067,1.00067,0,0,0-1,1v21h21a1.00067,1.00067,0,0,0,1-1v-13h2v13A3.00328,3.00328,0,0,1,26.00045,28.99953Z"
				},
				{
					"d": "M29,6.13a3.11856,3.11856,0,0,1-.92,2.21L14.63,21.79,8.58,23.42l1.63-6.05L23.66,3.92a3.12652,3.12652,0,0,1,4.42005,0A3.06076,3.06076,0,0,1,29,6.13Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-copy",
		"name": "ki-copy",
		"tags": "ki-copy",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,24H8V6a3.00328,3.00328,0,0,1,3-3H26a3.00328,3.00328,0,0,1,3,3V21A3.00328,3.00328,0,0,1,26,24ZM10,22H26a1.001,1.001,0,0,0,1-1V6a1.001,1.001,0,0,0-1-1H11a1.001,1.001,0,0,0-1,1Z"
				},
				{
					"d": "M26 29L3 29 3 7 5 7 5 27 26 27 26 29z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-copy-f",
		"name": "ki-copy-f",
		"tags": "ki-copy-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,6V21a3.00887,3.00887,0,0,1-3,3H8V6a3.00879,3.00879,0,0,1,3-3H26A3.00879,3.00879,0,0,1,29,6Z"
				},
				{
					"d": "M26 29L3 29 3 7 5 7 5 27 26 27 26 29z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-coronavirus",
		"name": "ki-coronavirus",
		"tags": "ki-coronavirus",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "12",
					"r": "1"
				},
				{
					"cx": "16",
					"cy": "20",
					"r": "1"
				},
				{
					"cx": "12",
					"cy": "16",
					"r": "1"
				},
				{
					"cx": "20",
					"cy": "16",
					"r": "1"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M29,19V13H27v2H24.941a8.9513,8.9513,0,0,0-1.91614-4.61121l1.46033-1.46008,1.41418,1.41406,1.41407-1.41406L23.0708,4.68652,21.65674,6.10059,23.071,7.51477,21.61078,8.97485A8.9501,8.9501,0,0,0,17,7.05908V5h2V3H13V5h2V7.05908a8.9501,8.9501,0,0,0-4.61078,1.91577L8.929,7.51477l1.4143-1.41418L8.9292,4.68652,4.68652,8.92871l1.41407,1.41406L7.51477,8.92871,8.9751,10.38879A8.9513,8.9513,0,0,0,7.059,15H5V13H3v6H5V17H7.059A8.9513,8.9513,0,0,0,8.9751,21.61121L7.51477,23.07129,6.10059,21.65723,4.68652,23.07129,8.9292,27.31348l1.41406-1.41407L8.929,24.48523l1.46026-1.46008A8.9501,8.9501,0,0,0,15,24.94092V27H13v2h6V27H17V24.94092a8.9501,8.9501,0,0,0,4.61078-1.91577L23.071,24.48523l-1.4143,1.41418,1.41406,1.41407,4.24268-4.24219-1.41407-1.41406-1.41418,1.41406L23.0249,21.61121A8.9513,8.9513,0,0,0,24.941,17H27v2ZM16,23a7,7,0,1,1,7-7A7.00818,7.00818,0,0,1,16,23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-cpu",
		"name": "ki-cpu",
		"tags": "ki-cpu",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,12V10H27V8a3.00328,3.00328,0,0,0-3-3H22V3H20V5H12V3H10V5H8A3.00328,3.00328,0,0,0,5,8v2H3v2H5v8H3v2H5v5h5v2h2V27h8v2h2V27h2a3.00328,3.00328,0,0,0,3-3V22h2V20H27V12ZM25,24a1.00067,1.00067,0,0,1-1,1H7V8A1.00067,1.00067,0,0,1,8,7H24a1.00067,1.00067,0,0,1,1,1Z"
				},
				{
					"d": "M21,21H11V11H21Zm-8-2h6V13H13Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-credit-card",
		"name": "ki-credit-card",
		"tags": "ki-credit-card",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.00049,5.99951h-22a3.00328,3.00328,0,0,0-3,3v1h0v6h0v10h25a3.00328,3.00328,0,0,0,3-3v-14A3.00328,3.00328,0,0,0,27.00049,5.99951Zm-23,3a1.00067,1.00067,0,0,1,1-1h22a1.00067,1.00067,0,0,1,1,1v1h-24Zm0,3h24v2h-24Zm23,12h-23v-8h24v7A1.00067,1.00067,0,0,1,27.00049,23.99951Z"
				},
				{
					"d": "M5.00045 19.99953H16.00045V21.99953H5.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-credit-card-f",
		"name": "ki-credit-card-f",
		"tags": "ki-credit-card-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,6H5A3.00879,3.00879,0,0,0,2,9V26H27a3.00883,3.00883,0,0,0,3-3V9A3.00879,3.00879,0,0,0,27,6ZM16,22H5V20H16Zm12-8H4V12H28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-credit-card-fail",
		"name": "ki-credit-card-fail",
		"tags": "ki-credit-card-fail",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.00049,14v2.00391h-23v-2H20.01025v-2H4.00049v-1a1.001,1.001,0,0,1,1-1H20v-2H5.00049a3.00328,3.00328,0,0,0-3,3v17h24a3.00328,3.00328,0,0,0,3-3V14Zm0,11.00391a1.001,1.001,0,0,1-1,1h-22v-8h23Z"
				},
				{
					"d": "M5 22H16V24H5z"
				},
				{
					"d": "M29.707 6.707L28.293 5.293 26 7.586 23.707 5.293 22.293 6.707 24.586 9 22.293 11.293 23.707 12.707 26 10.414 28.293 12.707 29.707 11.293 27.414 9 29.707 6.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-credit-card-success",
		"name": "ki-credit-card-success",
		"tags": "ki-credit-card-success",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.00049,13.99414v2.00977h-23v-2H20.01025v-2H4.00049v-1a1.001,1.001,0,0,1,1-1H20v-2H5.00049a3.00328,3.00328,0,0,0-3,3v17h24a3.00328,3.00328,0,0,0,3-3V13.99414Zm0,11.00977a1.001,1.001,0,0,1-1,1h-22v-8h23Z"
				},
				{
					"d": "M5 22H16V24H5z"
				},
				{
					"d": "M24 13.414L21.293 10.707 22.707 9.293 24 10.586 28.293 6.293 29.707 7.707 24 13.414z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer",
		"name": "ki-customer",
		"tags": "ki-customer",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,21a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,22,21Zm0-4a1,1,0,1,0,1,1A1.00067,1.00067,0,0,0,22,17Z"
				},
				{
					"d": "M22,29.34082l-.666-.59473C21.0752,28.51465,15,23.03223,15,18a6.77087,6.77087,0,0,1,7-7,6.77087,6.77087,0,0,1,7,7c0,5.03223-6.0752,10.51465-6.334,10.74609ZM22,13a4.78337,4.78337,0,0,0-5,5c0,3.26855,3.502,7.11816,5,8.61426,1.498-1.4961,5-5.34571,5-8.61426A4.78337,4.78337,0,0,0,22,13Z"
				},
				{
					"d": "M5,22V20a6.00472,6.00472,0,0,1,6-6,5.51341,5.51341,0,1,0-3.43658-1.21277A8.00392,8.00392,0,0,0,3,20v4H14l-1-2ZM7.5,8.5A3.5,3.5,0,1,1,11,12,3.50424,3.50424,0,0,1,7.5,8.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer-f",
		"name": "ki-customer-f",
		"tags": "ki-customer-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,11a6.77087,6.77087,0,0,0-7,7c0,5.03223,6.0752,10.51465,6.334,10.74609l.666.59473.666-.59473C22.9248,28.51465,29,23.03223,29,18A6.77087,6.77087,0,0,0,22,11Zm0,10a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,22,21Z"
				},
				{
					"d": "M5,22V20a6.00472,6.00472,0,0,1,6-6,5.51341,5.51341,0,1,0-3.43658-1.21277A8.00392,8.00392,0,0,0,3,20v4H14l-1-2ZM7.5,8.5A3.5,3.5,0,1,1,11,12,3.50424,3.50424,0,0,1,7.5,8.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer-multi-settings",
		"name": "ki-customer-multi-settings",
		"tags": "ki-customer-multi-settings",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,22v-2h-1.36035c-.1225-.5683-.34979-1.09631-.65607-1.56952l.96613-.96613-1.41406-1.41406-.96613.96613c-.47321-.30627-1.00122-.53357-1.56952-.65607v-1.36035h-2v1.36035c-.5683.1225-1.09631.34979-1.56952.65607l-.96613-.96613-1.41406,1.41406.96613.96613c-.30627.47321-.53357,1.00122-.65607,1.56952h-1.36035v2h1.36035c.1225.5683.34979,1.09631.65607,1.56952l-.96613.96613,1.41406,1.41406.96613-.96613c.47321.30627,1.00122.53357,1.56952.65607v1.36035h2v-1.36035c.5683-.1225,1.09631-.34979,1.56952-.65607l.96613.96613,1.41406-1.41406-.96613-.96613c.30627-.47321.53357-1.00122.65607-1.56952h1.36035ZM22,23.75c-1.5166,0-2.75-1.2334-2.75-2.75s1.2334-2.75,2.75-2.75,2.75,1.2334,2.75,2.75-1.2334,2.75-2.75,2.75Z"
				},
				{
					"d": "M18,3c-2.21002,0-4,1.78998-4,4,0,1.06.41998,2.02997,1.09998,2.75-.60999.32996-1.14996.76996-1.59998,1.28998-.45001-.52002-.98999-.96002-1.59998-1.28998.67999-.72003,1.09998-1.69,1.09998-2.75,0-2.21002-1.78998-4-4-4s-4,1.78998-4,4c0,1.06.41998,2.02997,1.09998,2.75-1.84998,1.01996-3.09998,2.98999-3.09998,5.25v6h8v-2h-6v-4c0-2.21002,1.78998-4,4-4,1.42999,0,2.67999.75,3.39001,1.88.39001.62.60999,1.33997.60999,2.12h2c0-.75-.14001-1.46002-.39001-2.12.71002-1.13,1.96002-1.88,3.39001-1.88,2.21002,0,4-1.79004,4-4s-1.78998-4-4-4ZM7,7c0-1.10004.90002-2,2-2s2,.89996,2,2c0,1.09998-.90002,2-2,2s-2-.90002-2-2ZM18,9c-1.09998,0-2-.90002-2-2,0-1.10004.90002-2,2-2s2,.89996,2,2c0,1.09998-.90002,2-2,2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer-multi-settings-f",
		"name": "ki-customer-multi-settings-f",
		"tags": "ki-customer-multi-settings-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "22",
					"cy": "21",
					"r": "2.75"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M22,13c-4.41998,0-8,3.57996-8,8s3.58002,8,8,8,8-3.58002,8-8-3.58002-8-8-8ZM26.64001,22c-.12.57001-.35004,1.09998-.66003,1.57001l.97003.96997-1.41003,1.41003-.96997-.97003c-.47003.31-1,.53998-1.57001.66003v1.35999h-2v-1.35999c-.57001-.12006-1.09998-.35004-1.57001-.66003l-.96997.97003-1.41003-1.41003.97003-.96997c-.31-.47003-.54004-1-.66003-1.57001h-1.35999v-2h1.35999c.12-.57001.35004-1.10004.66003-1.57001l-.97003-.97003,1.41003-1.40997.96997.96997c.47003-.31,1-.53998,1.57001-.65997v-1.35999h2v1.35999c.57001.12,1.09998.34998,1.57001.65997l.96997-.96997,1.41003,1.40997-.97003.97003c.31.46997.54004,1,.66003,1.57001h1.35999v2h-1.35999Z"
				},
				{
					"d": "M18,3c-2.21002,0-4,1.78998-4,4,0,1.06.41998,2.02997,1.09998,2.75-.60999.32996-1.14996.76996-1.59998,1.28998-.45001-.52002-.98999-.96002-1.59998-1.28998.67999-.72003,1.09998-1.69,1.09998-2.75,0-2.21002-1.78998-4-4-4s-4,1.78998-4,4c0,1.06.41998,2.02997,1.09998,2.75-1.84998,1.01996-3.09998,2.98999-3.09998,5.25v6h8v-2h-6v-4c0-2.21002,1.78998-4,4-4,1.42999,0,2.67999.75,3.39001,1.88.39001.62.60999,1.33997.60999,2.12h2c0-.75-.14001-1.46002-.39001-2.12.71002-1.13,1.96002-1.88,3.39001-1.88,2.21002,0,4-1.79004,4-4s-1.78998-4-4-4ZM7,7c0-1.10004.90002-2,2-2s2,.89996,2,2c0,1.09998-.90002,2-2,2s-2-.90002-2-2ZM18,9c-1.09998,0-2-.90002-2-2,0-1.10004.90002-2,2-2s2,.89996,2,2c0,1.09998-.90002,2-2,2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer-previous",
		"name": "ki-customer-previous",
		"tags": "ki-customer-previous",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,13a8,8,0,1,0,8,8A8.00917,8.00917,0,0,0,21,13Zm0,14a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,21,27Z"
				},
				{
					"d": "M22 17L20 17 20 22 24 22 24 20 22 20 22 17z"
				},
				{
					"d": "M5,22V20a6.00472,6.00472,0,0,1,6-6,5.51341,5.51341,0,1,0-3.43658-1.21277A8.00392,8.00392,0,0,0,3,20v4h9l-1-2ZM7.5,8.5A3.5,3.5,0,1,1,11,12,3.50424,3.50424,0,0,1,7.5,8.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-customer-previous-f",
		"name": "ki-customer-previous-f",
		"tags": "ki-customer-previous-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,13a8,8,0,1,0,8,8A8.01062,8.01062,0,0,0,21,13Zm3,9H20V17h2v3h2Z"
				},
				{
					"d": "M5,22V20a6.00472,6.00472,0,0,1,6-6,5.51341,5.51341,0,1,0-3.43658-1.21277A8.00392,8.00392,0,0,0,3,20v4h9l-1-2ZM7.5,8.5A3.5,3.5,0,1,1,11,12,3.50424,3.50424,0,0,1,7.5,8.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dark-mode",
		"name": "ki-dark-mode",
		"tags": "ki-dark-mode",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,27c-6.06543,0-11-4.93457-11-11s4.93457-11,11-11c1.00195,0,1.97949.13379,2.90479.39844.42529.12207.72021.50879.7251.95117s-.28174.83496-.7041.96582c-2.94629.91309-4.92578,3.59863-4.92578,6.68457,0,3.85938,3.14014,7,7,7,1.1001,0,2.14648-.24609,3.10938-.73242.39746-.2002.88086-.11523,1.18408.21289.30322.32715.35303.81445.12256,1.19629-2.01172,3.33301-5.53174,5.32324-9.41602,5.32324ZM15.29785,7.02734c-4.63574.35938-8.29785,4.24609-8.29785,8.97266,0,4.96289,4.0376,9,9,9,2.12451,0,4.11572-.72852,5.69482-2.02637-.22998.01758-.46143.02637-.69482.02637-4.9624,0-9-4.03711-9-9,0-2.77832,1.24854-5.30469,3.29785-6.97266Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dark-mode-f",
		"name": "ki-dark-mode-f",
		"tags": "ki-dark-mode-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.41998,21.67999c-2.01996,3.33002-5.53998,5.32001-9.41998,5.32001-6.07001,0-11-4.92999-11-11s4.92999-11,11-11c1,0,1.97998.13,2.90002.39996.42999.12.71997.51001.72998.95001,0,.44-.28003.83002-.70001.97003-2.95001.90997-4.92999,3.58997-4.92999,6.67999,0,3.85999,3.14001,7,7,7,1.09998,0,2.15002-.25,3.10999-.73004.40002-.19995.88-.12,1.17999.21002.31.33002.36005.81.13,1.20001Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dashboard",
		"name": "ki-dashboard",
		"tags": "ki-dashboard",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.00049,15.99951a14,14,0,0,0-28,0v1H2.051a13.984,13.984,0,0,0,27.89868,0h.05078Zm-14-12a12.01672,12.01672,0,0,1,11.959,11H25.94971a9.99934,9.99934,0,0,0-19.89856,0H4.0415A12.01673,12.01673,0,0,1,16.00049,3.99951Zm3.85791,11a3.95468,3.95468,0,0,0-.42456-1.01929L22.312,11.10193a7.94965,7.94965,0,0,1,1.6189,3.89758Zm-7.71607,0H8.06982A7.97983,7.97983,0,0,1,20.898,9.68787l-2.87817,2.87829a3.95453,3.95453,0,0,0-5.87745,2.43335Zm3.85816-1a2,2,0,1,1-2,2A2.0026,2.0026,0,0,1,16.00049,13.99951Zm0,14a12.00929,12.00929,0,0,1-11.94946-11h8.0913a3.98074,3.98074,0,0,0,7.71607,0h8.09131A12.00916,12.00916,0,0,1,16.00049,27.99951Z"
				},
				{
					"d": "M13.00045 22.99953H19.00045V24.99953H13.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dashboard-f",
		"name": "ki-dashboard-f",
		"tags": "ki-dashboard-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14.01538,14.01538,0,0,0,2,16v1h.05a13.98472,13.98472,0,0,0,27.9,0H30V16A14.01538,14.01538,0,0,0,16,2ZM8.07,15A8.00428,8.00428,0,0,1,16,8a7.92385,7.92385,0,0,1,4.9,1.69l-2.88,2.88A3.89036,3.89036,0,0,0,16,12a3.9998,3.9998,0,0,0-3.86,3ZM18,16a2,2,0,1,1-2-2A2.00591,2.00591,0,0,1,18,16Zm1,9H13V23h6Zm.86-10a4.16554,4.16554,0,0,0-.43-1.02l2.88-2.88A7.94111,7.94111,0,0,1,23.93,15Zm6.09,0a10.00015,10.00015,0,0,0-19.9,0H4.04a12.00191,12.00191,0,0,1,23.92,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-date-of-birth",
		"name": "ki-date-of-birth",
		"tags": "ki-date-of-birth",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,12V8H21v4H17V8H15v4H11V8H9v4H3v3a2.98189,2.98189,0,0,0,1,2.21973V26a2.9235,2.9235,0,0,0,2.8335,3h18.333A2.9235,2.9235,0,0,0,28,26V17.21973A2.98189,2.98189,0,0,0,29,15V12Zm4,2v1a1.001,1.001,0,0,1-1,1H24a1.001,1.001,0,0,1-1-1V14Zm-6,0v1a1.001,1.001,0,0,1-1,1H18a1.001,1.001,0,0,1-1-1V14Zm-6,0v1a1.001,1.001,0,0,1-1,1H12a1.001,1.001,0,0,1-1-1V14ZM5,14H9v1a1.001,1.001,0,0,1-1,1H6a1.001,1.001,0,0,1-1-1ZM26,26a.92913.92913,0,0,1-.8335,1H6.8335A.92913.92913,0,0,1,6,26V18H8a2.97711,2.97711,0,0,0,2-.78027A2.97711,2.97711,0,0,0,12,18h2a2.97711,2.97711,0,0,0,2-.78027A2.97711,2.97711,0,0,0,18,18h2a2.97711,2.97711,0,0,0,2-.78027A2.97711,2.97711,0,0,0,24,18h2Z"
				},
				{
					"d": "M16,6a1,1,0,0,0,1-1,3.49137,3.49137,0,0,0-1-2,3.49137,3.49137,0,0,0-1,2A1,1,0,0,0,16,6Z"
				},
				{
					"d": "M22,6a1,1,0,0,0,1-1,3.49137,3.49137,0,0,0-1-2,3.49137,3.49137,0,0,0-1,2A1,1,0,0,0,22,6Z"
				},
				{
					"d": "M10,6a1,1,0,0,0,1-1,3.49137,3.49137,0,0,0-1-2A3.49137,3.49137,0,0,0,9,5,1,1,0,0,0,10,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-desktop",
		"name": "ki-desktop",
		"tags": "ki-desktop",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,21V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V21a2,2,0,0,0,2,2h8.78058l-.60022,3H11a1.99946,1.99946,0,0,0-2,2H23a1.99946,1.99946,0,0,0-2-2H19.81964l-.60022-3H28A2,2,0,0,0,30,21ZM4,20V7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H5A1,1,0,0,1,4,20Zm13.78027,6H14.21973l.59961-3h2.36132Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-desktop-f",
		"name": "ki-desktop-f",
		"tags": "ki-desktop-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,21V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V21a2,2,0,0,0,2,2h8.78058l-.60022,3H11a1.99946,1.99946,0,0,0-2,2H23a1.99946,1.99946,0,0,0-2-2H19.81964l-.60022-3H28A2,2,0,0,0,30,21ZM17.78027,26H14.21973l.59961-3h2.36132Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dew-point",
		"name": "ki-dew-point",
		"tags": "ki-dew-point",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.00079,10.56787c1.01486,.94641,2.99921,3.12473,2.99921,5.68213,0,1.65421-1.34579,3-3,3s-3-1.34579-3-3c0-2.5524,1.97657-4.72714,3.00079-5.68213m-.00079-2.56787l-.59998,.44995c-.18005,.13-4.40002,3.3501-4.40002,7.80005,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-4.44995-4.21997-7.67004-4.40002-7.80005l-.59998-.44995h0Z"
				},
				{
					"d": "M14,20.01996V6c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002,.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3,6.98004c-1.65997,0-3-1.34003-3-3,0-1.31,.83002-2.42004,2-2.82001V6c0-.54999,.45001-1,1-1s1,.45001,1,1v15.17999c1.16998,.39996,2,1.51001,2,2.82001,0,1.65997-1.34003,3-3,3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dew-point-f",
		"name": "ki-dew-point-f",
		"tags": "ki-dew-point-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.6,8.4L22,8l-0.6,0.4c-0.2,0.1-4.4,3.4-4.4,7.8c0,2.8,2.2,5,5,5s5-2.2,5-5C27,11.8,22.8,8.6,22.6,8.4z"
				},
				{
					"d": "M14,20V6c0-1.7-1.3-3-3-3S8,4.3,8,6v14c-1.2,0.9-2,2.4-2,4c0,2.8,2.2,5,5,5s5-2.2,5-5C16,22.4,15.2,20.9,14,20z M11,5 c0.5,0,1,0.5,1,1v3.9h-2V6C10,5.4,10.5,5,11,5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dislike",
		"name": "ki-dislike",
		"tags": "ki-dislike",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.82464,14.99121l-2.45605-9.75488c-.35596-1.32324-1.54687-2.23633-2.90088-2.23633h-12.4668s-7,0-7,0h-1s0,17,0,17h4.12012s3.87988,0,3.87988,0h.12012c2.71045,0,5,3.66309,5,8v1s3.87988,0,3.87988,0c.85986,0,1.68066-.36914,2.25098-1.01172.56299-.63477.82813-1.47949.72754-2.31738-.31348-2.61523-.9834-4.84961-1.99658-6.6709h5.0166c.97412,0,1.89111-.47559,2.45215-1.27148.56152-.79687.70068-1.82031.37305-2.7373ZM9.00091,5v13h-1.87988s-2.12012,0-2.12012,0V5h4ZM26.81683,16.57617c-.18994.26953-.48779.42383-.81738.42383h-8.94873s1.28662,1.62109,1.28662,1.62109c1.39307,1.75684,2.28711,4.20898,2.65674,7.28809.03271.27441-.05176.54102-.23828.75098-.19141.21582-.46631.33984-.75488.33984h-1.91455c-.35254-5.0459-3.3418-9-6.96533-9h-.12012V5h12.4668c.45117,0,.84814.30469.96533.74023l2.47998,9.83105c.13916.40234.09375.73535-.09619,1.00488Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dislike-f",
		"name": "ki-dislike-f",
		"tags": "ki-dislike-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.822,14.98999l-2.45001-9.75c-.35999-1.32996-1.54999-2.23999-2.90002-2.23999H3.00199s0,17,0,17h8.12c2.71002,0,5,3.66003,5,8v1s3.88,0,3.88,0c.85999,0,1.67999-.37,2.25-1.01001.56-.63989.83002-1.47998.72998-2.31995-.31-2.60999-.97998-4.84998-2-6.67004h5.02002c.96997,0,1.89001-.47998,2.45001-1.27002.56-.80005.70001-1.81995.37-2.73999ZM26.822,16.58008c-.19.27002-.48999.41992-.82001.41992h-8.95001s1.29004,1.62,1.29004,1.62c1.38995,1.76001,2.27997,4.21008,2.64996,7.29004.04004.2699-.04999.53992-.23999.75-.19.21997-.46002.33997-.75.33997h-1.90997c-.36005-5.05005-3.35004-9-6.97003-9h-.12V5h12.46997c.45001,0,.84003.30005.96002.73999l2.47998,9.83008c.14001.3999.10004.73999-.08997,1.01001Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-document",
		"name": "ki-document",
		"tags": "ki-document",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.27,2.00439H10.73A2.78988,2.78988,0,0,0,8.00049,4.84424V5.99951H6.81787A2.83544,2.83544,0,0,0,4.00049,8.84619V29.99951H21.18213a2.816,2.816,0,0,0,2.67529-1.99512H25.27a2.79517,2.79517,0,0,0,2.73047-2.85058V4.84424A2.79005,2.79005,0,0,0,25.27,2.00439ZM22.00049,27.15381a.83305.83305,0,0,1-.81836.8457H6.00049V8.84619a.8331.8331,0,0,1,.81738-.84668H21.18213a.83391.83391,0,0,1,.81836.84668Zm4-2a.7988.7988,0,0,1-.73047.85058H24.00049V8.84619a2.83627,2.83627,0,0,0-2.81836-2.84668H10.00049V4.84424A.7915.7915,0,0,1,10.73,4.00439H25.27a.79224.79224,0,0,1,.73047.83985Z"
				},
				{
					"d": "M9.00045 12.99953H19.00045V14.99953H9.00045z"
				},
				{
					"d": "M9.00045 16.99953H16.00045V18.99953H9.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-document-f",
		"name": "ki-document-f",
		"tags": "ki-document-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.27,2H10.73A2.79705,2.79705,0,0,0,8,4.84V6H6.82A2.836,2.836,0,0,0,4,8.85V30H21.18a2.81443,2.81443,0,0,0,2.68-2h1.41A2.78668,2.78668,0,0,0,28,25.15V4.84A2.79052,2.79052,0,0,0,25.27,2ZM16,19H9V17h7Zm3-4H9V13H19Zm7,10.15a.7987.7987,0,0,1-.73.85H24V8.85A2.836,2.836,0,0,0,21.18,6H10V4.84A.79547.79547,0,0,1,10.73,4H25.27a.79547.79547,0,0,1,.73.84Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dog",
		"name": "ki-dog",
		"tags": "ki-dog",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16.5",
					"cy": "10.5",
					"r": "1.5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M17.23584,5A9.51781,9.51781,0,0,0,13.28,4.01636L13.28418,4H4.6665A2.85129,2.85129,0,0,0,2,7V19H3a7.577,7.577,0,0,0,.79346-.06726L2,27.8999V28H4.02l.6-3H17v3h2V18.90625a.99084.99084,0,0,1,.88574-.998l3.75244.06739a6.19473,6.19473,0,0,0,6.23926-4.78907A5.91164,5.91164,0,0,0,30,12v-.61816Zm10.68262,7.78223a4.19145,4.19145,0,0,1-4.24414,3.19336l-3.81885-.06641A2.9983,2.9983,0,0,0,17,18.90625V23H5.02l.92346-4.61743A8.17048,8.17048,0,0,0,7.81836,17.3125a10.11561,10.11561,0,0,0,3.206-4.40234L12.77692,6H13a7.50944,7.50944,0,0,1,3.3418.78906l11.61084,5.80567C27.94287,12.65723,27.93164,12.71973,27.91846,12.78223Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-doorbell",
		"name": "ki-doorbell",
		"tags": "ki-doorbell",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,20.64941l-4-5V13.294a8.36254,8.36254,0,0,0-5-7.67334V2H13V5.5874A7.9853,7.9853,0,0,0,8,13v2.64941l-4,5V26h7.10107a4.99994,4.99994,0,0,0,9.79786,0H28ZM15,4h2V5.06543a7.5373,7.5373,0,0,0-.75391-.0625A8.32552,8.32552,0,0,0,15,5.07471ZM11.82227,8.69336a5.92094,5.92094,0,0,1,4.36328-1.69043A6.19918,6.19918,0,0,1,22,13.294V15H10V13A5.955,5.955,0,0,1,11.82227,8.69336ZM16,28a3.0062,3.0062,0,0,1-2.8291-2h5.6582A3.0062,3.0062,0,0,1,16,28Zm10-4H6V21.35059L9.48047,17H22.51953L26,21.35059Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-doorbell-f",
		"name": "ki-doorbell-f",
		"tags": "ki-doorbell-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.08,17H6.92L4,20.6499V26h7.1a5.00127,5.00127,0,0,0,9.8,0H28V20.6499ZM16,28a3.01374,3.01374,0,0,1-2.83-2h5.66A3.01374,3.01374,0,0,1,16,28Zm8-14.71a8.36332,8.36332,0,0,0-5-7.67V2H13V5.59A7.985,7.985,0,0,0,8,13v2H24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-download",
		"name": "ki-download",
		"tags": "ki-download",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.342 14.247L17 19.795 17 4 15 4 15 19.795 8.659 14.247 7.342 15.752 16 23.329 24.659 15.752 23.342 14.247z"
				},
				{
					"d": "M27.00045,27.99953h-22a3.00328,3.00328,0,0,1-3-3v-5h2v5a1.00067,1.00067,0,0,0,1,1h22a1.00067,1.00067,0,0,0,1-1v-5h2v5A3.00328,3.00328,0,0,1,27.00045,27.99953Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-drag-drop",
		"name": "ki-drag-drop",
		"tags": "ki-drag-drop",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M10,10a4,4,0,1,1,4-4A4.004,4.004,0,0,1,10,10Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,10,4Z"
				},
				{
					"d": "M10,20a4,4,0,1,1,4-4A4.004,4.004,0,0,1,10,20Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,10,14Z"
				},
				{
					"d": "M10,30a4,4,0,1,1,4-4A4.004,4.004,0,0,1,10,30Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,10,24Z"
				},
				{
					"d": "M22,10a4,4,0,1,1,4-4A4.004,4.004,0,0,1,22,10Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,22,4Z"
				},
				{
					"d": "M22,20a4,4,0,1,1,4-4A4.004,4.004,0,0,1,22,20Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,22,14Z"
				},
				{
					"d": "M22,30a4,4,0,1,1,4-4A4.004,4.004,0,0,1,22,30Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,22,24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-drag-drop-f",
		"name": "ki-drag-drop-f",
		"tags": "ki-drag-drop-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "10",
					"cy": "6",
					"r": "3"
				},
				{
					"cx": "22",
					"cy": "6",
					"r": "3"
				},
				{
					"cx": "10",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "22",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "10",
					"cy": "26",
					"r": "3"
				},
				{
					"cx": "22",
					"cy": "26",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dropdown",
		"name": "ki-dropdown",
		"tags": "ki-dropdown",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16 4L23.207 11.207 21.793 12.621 16 6.828 10.207 12.621 8.793 11.207 16 4z"
				},
				{
					"d": "M16 28L8.793 20.793 10.207 19.379 16 25.172 21.793 19.379 23.207 20.793 16 28z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dropper",
		"name": "ki-dropper",
		"tags": "ki-dropper",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,6.002A3.02127,3.02127,0,0,0,25.99837,3h-.001a2.95949,2.95949,0,0,0-2.11864.88574l-2.4131,2.41992-1.41689-1.417A2.96918,2.96918,0,0,0,17.934,3.999a2.905,2.905,0,0,0-2.13525.88575L13.6811,7.002l2.82017,2.81934L4.975,21.3457v1.00391a.9761.9761,0,0,1-.29787.70312l-.75511.75489a3.20151,3.20151,0,0,0-.83732,1.51855A2.98153,2.98153,0,0,0,3.672,27.93652l.00091.00086.00006.00012c.01893.02222.043.03784.06239.05933a3.1078,3.1078,0,0,0,.41176.39209c.03943.03027.085.04882.12574.077a3.02228,3.02228,0,0,0,.42.25672c.038.01782.07941.02478.118.041a2.8692,2.8692,0,0,0,.4747.1648A2.76951,2.76951,0,0,0,5.90785,29c.03418-.001.06836-.001.10157,0a2.94166,2.94166,0,0,0,1.63089-.5022,2.99958,2.99958,0,0,0,.45162-.37085l.82146-.82129a1.01867,1.01867,0,0,1,.71207-.29589h.99731l.03717-.03711,1.38014-1.34278-.01764-.01758L22.16588,15.48413l2.83128,2.83032,2.11669-2.11621a2.99134,2.99134,0,0,0,.88591-2.13476,2.96058,2.96058,0,0,0-.88591-2.10938L25.7,10.54l2.41414-2.4209A2.96051,2.96051,0,0,0,29,6.002ZM10.61544,24.20557,7.77935,21.37012l10.1363-10.135,2.8367,2.83593ZM25.99935,14.06934a1.00167,1.00167,0,0,1-.29989.71484l-.7023.70215L23.58125,14.0708l.00152-.00146L17.91742,8.40527l-.00189.002L16.50987,7.002l.70329-.70312a1.00323,1.00323,0,0,1,.71207-.29981h.00293a.98236.98236,0,0,1,.70134.29981L20.053,7.72241l-.0003.00025L21.20654,8.876l4.49683,4.49707A.97453.97453,0,0,1,25.99935,14.06934Zm.70426-7.36914L24.28606,9.126l-.20088-.20069L22.8801,7.72009,25.298,5.29492a.99382.99382,0,1,1,1.4056,1.40528Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dvr-nav",
		"name": "ki-dvr-nav",
		"tags": "ki-dvr-nav",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.73,13.8l-1.76,1.76A2.16929,2.16929,0,0,1,23,16a7.00629,7.00629,0,1,1-3.13-5.83L21.3,8.74A8.881,8.881,0,0,0,16,7a9,9,0,1,0,9,9A8.89853,8.89853,0,0,0,24.73,13.8Z"
				},
				{
					"d": "M16 19.7L11.864 15.564 13.278 14.15 16 16.872 23.293 9.579 24.707 10.993 16 19.7z"
				},
				{
					"d": "M26,29H3V6A3.00328,3.00328,0,0,1,6,3H26a3.00328,3.00328,0,0,1,3,3V26A3.00328,3.00328,0,0,1,26,29ZM5,27H26a1.001,1.001,0,0,0,1-1V6a1.001,1.001,0,0,0-1-1H6A1.001,1.001,0,0,0,5,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-dvr-nav-f",
		"name": "ki-dvr-nav-f",
		"tags": "ki-dvr-nav-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,3H6c-1.65002,0-3,1.34998-3,3V29H26c1.65002,0,3-1.35004,3-3V6c0-1.65002-1.34998-3-3-3Zm-1.28998,7.98999l-8.71002,8.71002-4.14001-4.14001,1.42004-1.41003,2.71997,2.72003,7.28998-7.29004,1.42004,1.41003Zm-8.71002,14.01001c-4.96002,0-9-4.04004-9-9S11.03998,7,16,7c1.97998,0,3.81,.64001,5.29999,1.73999l-1.42999,1.42999c-1.10999-.73999-2.44-1.16998-3.87-1.16998-3.85999,0-7,3.14001-7,7s3.14001,7,7,7,7-3.14001,7-7c0-.15002,0-.29004-.03003-.44l1.76001-1.76001c.17999,.71002,.27002,1.44,.27002,2.20001,0,4.95996-4.03998,9-9,9Z",
					"data-name": "ki-dvr-nav-f"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-edit",
		"name": "ki-edit",
		"tags": "ki-edit",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.00049,11.99951V25.18213c0,.44336-.49414.81836-1.08008.81836l-24.91992-.001v2l24.91992.001a2.96162,2.96162,0,0,0,3.08008-2.81836V11.99951Z"
				},
				{
					"d": "M24.30029,9.11963a3.00572,3.00572,0,0,0-.00488-4.23828l-.17676-.17676a3.00514,3.00514,0,0,0-4.23926-.00391L6.11572,18.41553l-1.48926,5.958,5.958-1.48926Zm-1.5957-3.001.17676.17676A1.0029,1.0029,0,0,1,22.8833,7.7085l-.206.20666-2.65747-.53149,1.27075-1.266A1.00318,1.00318,0,0,1,22.70459,6.11865ZM7.37451,21.62549l.5459-2.18653L18.31519,9.08215l2.66772.53357L9.561,21.07959Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-edit-f",
		"name": "ki-edit-f",
		"tags": "ki-edit-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.00049,11.99951V25.18213c0,.44336-.49414.81836-1.08008.81836l-24.91992-.001v2l24.91992.001a2.96162,2.96162,0,0,0,3.08008-2.81836V11.99951Z"
				},
				{
					"d": "M24.3,4.88l-.18-.18a3.00871,3.00871,0,0,0-4.24,0L6.12,18.42,4.63,24.37l5.95-1.49L24.3,9.12A3.01793,3.01793,0,0,0,24.3,4.88ZM22.88,7.71l-.2.21-2.66-.54,1.27-1.26a.99585.99585,0,0,1,1.41,0l.18.18A.99579.99579,0,0,1,22.88,7.71Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-email-read-receipt",
		"name": "ki-email-read-receipt",
		"tags": "ki-email-read-receipt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.98,10.8501c-.01-.04-.01-.09009-.02-.13013s-.04-.07983-.06-.13013a.42121.42121,0,0,0-.04-.09985,1.21487,1.21487,0,0,0-.09-.11987c-.03-.03028-.05-.06006-.08-.09009a1.25532,1.25532,0,0,0-.12-.09009c-.03-.02-.05-.0498-.08-.06006a.00973.00973,0,0,1-.01-.00976h-.01L25,7.71V5H19.96L16.47,3.12012a.97944.97944,0,0,0-.93994,0L12.04,5H7V7.71L2.53,10.12012H2.52a.00973.00973,0,0,1-.01.00976c-.03.01026-.05.04-.08.06006a1.25532,1.25532,0,0,0-.12.09009c-.03.03-.05.05981-.08.09009a1.21487,1.21487,0,0,0-.09.11987.42121.42121,0,0,0-.04.09985c-.02.0503-.05.09009-.06.13013s-.00995.09009-.02.13013A.50044.50044,0,0,0,2,10.97V25a3.00887,3.00887,0,0,0,3,3H20l-2-2H5a1.00291,1.00291,0,0,1-1-1V12.79L15.48,19.8501a.977.977,0,0,0,1.04,0l.48-.30005L21.15,17,28,12.79V17h2V10.97A.50044.50044,0,0,0,29.98,10.8501ZM7,12.29l-2-1.23L7,9.98Zm16,1.23L17.35,17l-.35.21-1,.62012L9,13.52V7H23Zm2-1.23V9.98l2,1.08008Z"
				},
				{
					"d": "M23.532 28.125 20.274 24.688 21.726 23.313 23.546 25.232 29.281 19.305 30.719 20.695 23.532 28.125z"
				},
				{
					"d": "M11 9H21V11H11z"
				},
				{
					"d": "M13 13H19V15H13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-email-read-receipt-f",
		"name": "ki-email-read-receipt-f",
		"tags": "ki-email-read-receipt-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.98,10.8501c-.01-.04-.01-.09009-.02-.13013s-.04-.07983-.06-.13013a.42121.42121,0,0,0-.04-.09985,1.21487,1.21487,0,0,0-.09-.11987c-.03-.03028-.05-.06006-.08-.09009a1.25532,1.25532,0,0,0-.12-.09009c-.03-.02-.05-.0498-.08-.06006a.00973.00973,0,0,1-.01-.00976h-.01L25,7.71V5H19.96L16.47,3.12012a.97944.97944,0,0,0-.93994,0L12.04,5H7V7.71L2.53,10.12012H2.52a.00973.00973,0,0,1-.01.00976c-.03.01026-.05.04-.08.06006a1.25532,1.25532,0,0,0-.12.09009c-.03.03-.05.05981-.08.09009a1.21487,1.21487,0,0,0-.09.11987.42121.42121,0,0,0-.04.09985c-.02.0503-.05.09009-.06.13013s-.00995.09009-.02.13013A.50044.50044,0,0,0,2,10.97V25a3.00887,3.00887,0,0,0,3,3H20l-2-2H5a1.00291,1.00291,0,0,1-1-1V12.79L15.48,19.8501a.977.977,0,0,0,1.04,0l.48-.30005L21.15,17,28,12.79V17h2V10.97A.50044.50044,0,0,0,29.98,10.8501ZM7,12.29l-2-1.23L7,9.98ZM19,15H13V13h6Zm2-4H11V9H21Zm4,1.29V9.98l2,1.08008Z"
				},
				{
					"d": "M23.532 28.125 20.274 24.687 21.726 23.312 23.546 25.232 29.281 19.305 30.719 20.695 23.532 28.125z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-emoji-frowning",
		"name": "ki-emoji-frowning",
		"tags": "ki-emoji-frowning",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "11",
					"cy": "12",
					"r": "2"
				},
				{
					"cx": "21",
					"cy": "12",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M9,23a7,7,0,0,1,14,0"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-emoji-grinning",
		"name": "ki-emoji-grinning",
		"tags": "ki-emoji-grinning",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "11",
					"cy": "12",
					"r": "2"
				},
				{
					"cx": "21",
					"cy": "12",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M23,17A7,7,0,0,1,9,17"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-equipment",
		"name": "ki-equipment",
		"tags": "ki-equipment",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4,4.00391v15H2v2.91015a3.09289,3.09289,0,0,0,3.08984,3.08985H17v-2H5.08984A1.09154,1.09154,0,0,1,4,21.91406v-.91015H17v-2H6v-13H24v2h2v-4Z"
				},
				{
					"d": "M30,28H19V10H30Zm-9-2h7V12H21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-equipment-f",
		"name": "ki-equipment-f",
		"tags": "ki-equipment-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4,4.00391v15H2v2.91015a3.09289,3.09289,0,0,0,3.08984,3.08985H17v-2H5.08984A1.09154,1.09154,0,0,1,4,21.91406v-.91015H17v-2H6v-13H24v2h2v-4Z"
				},
				{
					"d": "M30,28H19V10H30Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ethernet",
		"name": "ki-ethernet",
		"tags": "ki-ethernet",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9,2V17.15991L11.28,24H13v6h2V24h2v6h2V24h1.72L23,17.15991V2ZM21,16.83984,19.28,22H12.72L11,16.83984V11h2v6h6V11h2ZM15,15V11h2v4Zm6-6H11V4h2V7h2V4h2V7h2V4h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-exclamation-mark",
		"name": "ki-exclamation-mark",
		"tags": "ki-exclamation-mark",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "26",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M13.5 3H18.5V19.25H13.5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-expand",
		"name": "ki-expand",
		"tags": "ki-expand",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16 4L16 6 24.581 6 16.998 13.583 18.412 14.998 26 7.409 26 16 28 16 28 4 16 4z"
				},
				{
					"d": "M16 28L16 26 7.419 26 15.002 18.417 13.588 17.002 6 24.591 6 16 4 16 4 28 16 28z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-export",
		"name": "ki-export",
		"tags": "ki-export",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4,27V5A3.00328,3.00328,0,0,1,7,2h5V4H7A1.00067,1.00067,0,0,0,6,5V27a1.00067,1.00067,0,0,0,1,1h5v2H7A3.00328,3.00328,0,0,1,4,27Z"
				},
				{
					"d": "M18.918 8.658L24.467 15 10 15 10 17 24.467 17 18.918 23.342 20.424 24.658 28 16 20.424 7.342 18.918 8.658z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-eye",
		"name": "ki-eye",
		"tags": "ki-eye",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,27C6.43311,27,2.24512,16.80566,2.07129,16.37109L1.92285,16l.14844-.37109C2.24512,15.19434,6.43311,5,16,5S29.75488,15.19434,29.92871,15.62891L30.07715,16l-.14844.37109C29.75488,16.80566,25.56689,27,16,27ZM4.09424,16C4.91064,17.74316,8.74658,25,16,25s11.08936-7.25684,11.90576-9C27.08936,14.25684,23.25342,7,16,7S4.91064,14.25684,4.09424,16Z"
				},
				{
					"d": "M16,22a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.00427,4.00427,0,0,0,16,12Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-eye-cross",
		"name": "ki-eye-cross",
		"tags": "ki-eye-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.00049,16.00391h-2a4.00427,4.00427,0,0,0-4-4v-2A6.00656,6.00656,0,0,1,22.00049,16.00391Z"
				},
				{
					"d": "M29.93,16.37l.15-.37-.15-.37C29.75,15.19,25.57,5,16,5A12.691,12.691,0,0,0,8.71,7.29l-2-2L5.29,6.71,7.11,8.53a20.98434,20.98434,0,0,0-5.04,7.1L1.92,16l.15.37C2.25,16.81,6.43,27,16,27a12.69055,12.69055,0,0,0,7.29-2.29l2,2,1.42-1.42-1.82-1.82A20.98439,20.98439,0,0,0,29.93,16.37ZM16,25C8.75,25,4.91,17.74,4.09,16A19.35847,19.35847,0,0,1,8.55,9.97l2.56,2.56A5.9949,5.9949,0,0,0,16,22a5.87943,5.87943,0,0,0,3.47-1.11L21.83,23.25A10.72942,10.72942,0,0,1,16,25ZM12.56,13.98l5.47,5.47A3.93665,3.93665,0,0,1,16,20a3.99891,3.99891,0,0,1-4-4A3.81621,3.81621,0,0,1,12.56,13.98Zm10.89,8.05L10.17,8.75A10.72892,10.72892,0,0,1,16,7c7.25,0,11.09,7.26,11.91,9A19.35774,19.35774,0,0,1,23.45,22.03Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-eye-cross-f",
		"name": "ki-eye-cross-f",
		"tags": "ki-eye-cross-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.93,15.63C29.75,15.19,25.57,5,16,5a12.61638,12.61638,0,0,0-5.5,1.24l4.81,4.81A5.2069,5.2069,0,0,1,16,11a5.00181,5.00181,0,0,1,5,5,5.21706,5.21706,0,0,1-.05.69l5.36,5.36a21.27942,21.27942,0,0,0,3.62-5.68l.15-.37Z"
				},
				{
					"d": "M24.89,23.47l-4.71-4.71-6.94-6.94L8.71,7.29l-2-2L5.29,6.71,7.11,8.53a20.82092,20.82092,0,0,0-5.04,7.1L1.92,16l.15.37C2.25,16.81,6.43,27,16,27a12.69055,12.69055,0,0,0,7.29-2.29l2,2,1.42-1.42ZM16,21a5.00181,5.00181,0,0,1-5-5,4.89888,4.89888,0,0,1,.83-2.75l6.92,6.92A4.89888,4.89888,0,0,1,16,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-eye-f",
		"name": "ki-eye-f",
		"tags": "ki-eye-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.93,15.63C29.75,15.19,25.57,5,16,5S2.25,15.19,2.07,15.63L1.92,16l.15.37C2.25,16.81,6.43,27,16,27S29.75,16.81,29.93,16.37l.15-.37ZM16,21a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-face-id",
		"name": "ki-face-id",
		"tags": "ki-face-id",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M5,12H3V6A3.00328,3.00328,0,0,1,6,3h6V5H6A1.001,1.001,0,0,0,5,6Z"
				},
				{
					"d": "M26,29H20V27h6a1.001,1.001,0,0,0,1-1V20h2v6A3.00328,3.00328,0,0,1,26,29Z"
				},
				{
					"d": "M12 29L3 29 3 20 5 20 5 27 12 27 12 29z"
				},
				{
					"d": "M29,12H27V6a1.001,1.001,0,0,0-1-1H20V3h6a3.00328,3.00328,0,0,1,3,3Z"
				},
				{
					"d": "M16,24a6.9201,6.9201,0,0,1-4.95068-2.05566l1.42089-1.40821a4.98758,4.98758,0,0,0,7.05958,0l1.42089,1.40821A6.9201,6.9201,0,0,1,16,24Z"
				},
				{
					"d": "M9 11H11V15H9z"
				},
				{
					"d": "M21 11H23V15H21z"
				},
				{
					"d": "M17 19L13 19 13 17 15 17 15 11 17 11 17 19z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-facebook",
		"name": "ki-facebook",
		"tags": "ki-facebook",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,16A14.002,14.002,0,0,1,18.19,29.83V20.05h3.26L22.07,16H18.19V13.37a2.02042,2.02042,0,0,1,2.28-2.18h1.76V7.74a21.73685,21.73685,0,0,0-3.13-.27c-3.2,0-5.29,1.94-5.29,5.45V16H10.26v4.05h3.55v9.78A14.00106,14.00106,0,1,1,30,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-factory",
		"name": "ki-factory",
		"tags": "ki-factory",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.47168,6.11816a.9968.9968,0,0,0-1.02637.04981L20,11.13184V7a.99992.99992,0,0,0-1.55469-.832L11,11.13184V3H3V29H29V7A.99972.99972,0,0,0,28.47168,6.11816ZM17,27V20h4v7Zm6,0V18H15v9H5V5H9v8a.99992.99992,0,0,0,1.55469.832L18,8.86816V13a.99992.99992,0,0,0,1.55469.832L27,8.86816V27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-fast-forward",
		"name": "ki-fast-forward",
		"tags": "ki-fast-forward",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.90869,16.00439l-15.9082-9.79v6.15087l-10-6.1499V25.79346l10-6.1507v6.15167Zm-13.9082-6.21,10.0918,6.21-10.0918,6.21V9.79443Zm-10,12.4209V9.79346l8,4.91894v2.583Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-fast-forward-f",
		"name": "ki-fast-forward-f",
		"tags": "ki-fast-forward-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13 26L13 20 3 26 3 6 13 12 13 6 29 16 13 26z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-fiber",
		"name": "ki-fiber",
		"tags": "ki-fiber",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,22V10H20.0694a33.29852,33.29852,0,0,1,1.85931-6.62891l-1.85742-.74218A33.80573,33.80573,0,0,0,18.0603,10H17V2H15v8H13.9397a33.80573,33.80573,0,0,0-2.011-7.37109l-1.85742.74218A33.21764,33.21764,0,0,1,11.93073,10H9V22H7v8H25V22ZM11,12H21V22H11ZM23,28H9V24H23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-fiber-f",
		"name": "ki-fiber-f",
		"tags": "ki-fiber-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,22V10H20.0694a33.29852,33.29852,0,0,1,1.85931-6.62891l-1.85742-.74218A33.80573,33.80573,0,0,0,18.0603,10H17V2H15v8H13.9397a33.80573,33.80573,0,0,0-2.011-7.37109l-1.85742.74218A33.21764,33.21764,0,0,1,11.93073,10H9V22H7v8H25V22Zm0,6H9V24H23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-filter",
		"name": "ki-filter",
		"tags": "ki-filter",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.00045,14.99953a5,5,0,1,1,5-5A5.00589,5.00589,0,0,1,8.00045,14.99953Zm0-8a3,3,0,1,0,3,3A3.00328,3.00328,0,0,0,8.00045,6.99953Z"
				},
				{
					"d": "M24.00045,26.99953a5,5,0,1,1,5-5A5.00589,5.00589,0,0,1,24.00045,26.99953Zm0-8a3,3,0,1,0,3,3A3.00328,3.00328,0,0,0,24.00045,18.99953Z"
				},
				{
					"d": "M17.00045 8.99953H29.00045V10.99953H17.00045z"
				},
				{
					"d": "M3.00045 20.99953H15.00045V22.99953H3.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-filter-f",
		"name": "ki-filter-f",
		"tags": "ki-filter-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "8",
					"cy": "10",
					"r": "4"
				},
				{
					"cx": "24",
					"cy": "22",
					"r": "4"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M17.00045 8.99953H29.00045V10.99953H17.00045z"
				},
				{
					"d": "M3.00045 20.99953H15.00045V22.99953H3.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-flag",
		"name": "ki-flag",
		"tags": "ki-flag",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.38867,4.05359C24.09961,2.244,19.87646,3.13464,15.793,3.996c-3.95508.835-7.69238,1.62305-11.4043.05664L3,3.46765V29H5V18.44116A14.28883,14.28883,0,0,0,9.06836,19a34.78722,34.78722,0,0,0,7.13867-.99609c3.95557-.834,7.69287-1.624,11.4043-.05664L29,18.53223V4.3114ZM27,15.6084c-3.8125-1.12207-7.56543-.33008-11.20557.43848C12.0542,16.835,8.51025,17.58105,5,16.34082V6.39148c3.811,1.12012,7.56445.3291,11.20557-.43848C19.94531,5.16394,23.48926,4.41687,27,5.65906Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-flag-f",
		"name": "ki-flag-f",
		"tags": "ki-flag-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,4.31006V18.53L27.61,17.95c-3.71-1.57-7.45-.78-11.4.05a34.41361,34.41361,0,0,1-7.14,1A14.31788,14.31788,0,0,1,5,18.43994V29H3V3.47l1.39.58008C8.1,5.62,11.84,4.83,15.79,4c4.09-.87,8.31-1.76,12.6.05Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-flame",
		"name": "ki-flame",
		"tags": "ki-flame",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.9541,8.57227l-.56348-.75391-2.62256,1.72266L15.78857,1.21094l-1.11133,1.0293c-.38135,.35352-9.34326,8.74414-9.60693,16.64941-.19727,5.9248,4.46191,10.90527,10.38623,11.10254,.12109,.00488,.24121,.00684,.36182,.00684,5.76367,0,10.54688-4.58984,10.74023-10.39258l.00781-.56348c.13623-4.07129-4.41846-10.21191-4.6123-10.4707Zm-1.93945,15.36328c-.03711,1.12012-.50977,2.15918-1.32959,2.92578-.80609,.75568-1.84265,1.14294-2.95264,1.12897-.02478-.00024-.04901,.00177-.07391,.0014-2.30548-.08795-4.11584-2.02728-4.03888-4.33838,.00391-.12695,.01562-.25391,.02881-.40918,.17383-1.77637,1.0293-3.75293,1.72607-5.11328l2.11816,4.74023,3.61572-2.66016c.34619,.75195,.76172,1.85254,.86963,2.98438l.01465,.09961c.01221,.0625,.01123,.125,.01562,.21191,.00928,.14062,.01123,.28809,.00635,.42773v.00098Zm4.54492-4.39551c-.08191,2.45062-1.16614,4.63049-2.8457,6.16492,.17566-.54431,.28003-1.11499,.2998-1.70203,.00684-.20605,.00391-.42383-.00879-.60742-.00635-.14355-.01562-.28809-.04004-.43359-.24951-2.47461-1.60205-4.68164-1.65967-4.77441l-.57031-.9209-3.42871,2.52246-2.66748-5.96875-1.00049,1.55078c-.10742,.16602-2.63184,4.11523-2.98389,7.72266-.01514,.1709-.02881,.33398-.03369,.49512-.02466,.74054,.08905,1.45258,.3064,2.11945-1.82733-1.66827-2.94629-4.09137-2.85767-6.75226,.18457-5.53711,5.52832-11.70605,7.87793-14.15918l2.79443,7.8125,3.15625-2.07422c1.40137,2.04297,3.75098,6.00195,3.66943,8.44336l-.00781,.56152Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-folder",
		"name": "ki-folder",
		"tags": "ki-folder",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,7.99951H17.23633a.99469.99469,0,0,1-.89453-.55273l-.89453-1.78809a2.98413,2.98413,0,0,0-2.68311-1.65918H5a3.00328,3.00328,0,0,0-3,3v21H27a3.00328,3.00328,0,0,0,3-3v-14A3.00328,3.00328,0,0,0,27,7.99951Zm-22-2h7.76416a.99367.99367,0,0,1,.894.55371l.89453,1.78809a2.98464,2.98464,0,0,0,2.6836,1.6582H27a1.001,1.001,0,0,1,1,1v2H4v-6A1.001,1.001,0,0,1,5,5.99951Zm22,20H4v-11H28v10A1.001,1.001,0,0,1,27,25.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-folder-f",
		"name": "ki-folder-f",
		"tags": "ki-folder-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,8H17.24a.99183.99183,0,0,1-.9-.55l-.89-1.79A2.99182,2.99182,0,0,0,12.76,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00883,3.00883,0,0,0,3-3V11A3.00879,3.00879,0,0,0,27,8Zm1,7H4V13H28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-forward",
		"name": "ki-forward",
		"tags": "ki-forward",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13,9H25.58594L20.293,3.707,21.707,2.293,29.41406,10l-7.707,7.707L20.293,16.293,25.58594,11H13a8,8,0,0,0,0,16v2A10,10,0,0,1,13,9Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-freight-truck",
		"name": "ki-freight-truck",
		"tags": "ki-freight-truck",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.12,14.70996l-3.83002-3.82996c-.56-.57001-1.32001-.88-2.12-.88h-2.16998v-1c0-1.65002-1.34998-3-3-3H5c-1.65002,0-3,1.34998-3,3v12c0,1.64996,1.34998,3,3,3h1.34998c.55005,1.17999,1.76001,2,3.15002,2s2.59998-.82001,3.15002-2h6.69995c.55005,1.17999,1.76001,2,3.15002,2s2.59998-.82001,3.15002-2h1.34998c1.65002,0,3-1.35004,3-3v-4.17004c0-.79999-.31-1.56-.88-2.12Zm-21.12,7.79004c0-.17999,.03003-.34003,.09003-.5,.19995-.58002,.75995-1,1.40997-1s1.21002,.41998,1.40997,1c.06,.15997,.09003,.32001,.09003,.5,0,.82996-.66998,1.5-1.5,1.5s-1.5-.67004-1.5-1.5Zm4.96002-.5c-.24005-1.69-1.70001-3-3.46002-3s-3.21997,1.31-3.46002,3h-1.03998c-.54999,0-1-.45001-1-1V9c0-.54999,.45001-1,1-1h13c.54999,0,1,.45001,1,1v13h-6.03998Zm8.03998,.5c0-.17999,.03003-.34003,.09003-.5,.19995-.58002,.75995-1,1.40997-1s1.21002,.41998,1.40997,1c.06,.15997,.09003,.32001,.09003,.5,0,.82996-.66998,1.5-1.5,1.5s-1.5-.67004-1.5-1.5Zm7-1.5c0,.54999-.45001,1-1,1h-1.03998c-.24005-1.69-1.70001-3-3.46002-3-.53998,0-1.04999,.12-1.5,.34998v-7.34998h2.16998c.26001,0,.52002,.10999,.71002,.28998l1.71002,1.71002h-2.59003v3h5v4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-freight-truck-f",
		"name": "ki-freight-truck-f",
		"tags": "ki-freight-truck-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.12,14.70996l-3.83002-3.82996c-.56-.57001-1.32001-.88-2.12-.88h-2.16998v-1c0-1.65002-1.34998-3-3-3H5c-1.65002,0-3,1.34998-3,3v12c0,1.64996,1.34998,3,3,3h1.34998c.55005,1.17999,1.76001,2,3.15002,2s2.59998-.82001,3.15002-2h6.69995c.55005,1.17999,1.76001,2,3.15002,2s2.59998-.82001,3.15002-2h1.34998c1.65002,0,3-1.35004,3-3v-4.17004c0-.79999-.31-1.56-.88-2.12Zm-21.12,7.79004c0-.17999,.03003-.34003,.09003-.5,.19995-.58002,.75995-1,1.40997-1s1.21002,.41998,1.40997,1c.06,.15997,.09003,.32001,.09003,.5,0,.82996-.66998,1.5-1.5,1.5s-1.5-.67004-1.5-1.5Zm13,0c0-.17999,.03003-.34003,.09003-.5,.19995-.58002,.75995-1,1.40997-1s1.21002,.41998,1.40997,1c.06,.15997,.09003,.32001,.09003,.5,0,.82996-.66998,1.5-1.5,1.5s-1.5-.67004-1.5-1.5Zm7-5.5h-5v-3h2.59003l2.12,2.12c.17999,.19,.28998,.45001,.28998,.70996v.17004Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-full-screen",
		"name": "ki-full-screen",
		"tags": "ki-full-screen",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.00045,27.99953h-25v-21a3.00328,3.00328,0,0,1,3-3h22a3.00328,3.00328,0,0,1,3,3v18A3.00328,3.00328,0,0,1,27.00045,27.99953Zm-23-2h23a1.00067,1.00067,0,0,0,1-1v-18a1.00067,1.00067,0,0,0-1-1h-22a1.00067,1.00067,0,0,0-1,1Z"
				},
				{
					"d": "M8 14L6 14 6 8 14 8 14 10 8 10 8 14z"
				},
				{
					"d": "M26 14L24 14 24 10 18 10 18 8 26 8 26 14z"
				},
				{
					"d": "M26 24L18 24 18 22 24 22 24 18 26 18 26 24z"
				},
				{
					"d": "M14 24L6 24 6 18 8 18 8 22 14 22 14 24z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-full-screen-f",
		"name": "ki-full-screen-f",
		"tags": "ki-full-screen-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,27,4ZM14,24H6V18H8v4h6Zm0-14H8v4H6V8h8ZM26,24H18V22h6V18h2Zm0-10H24V10H18V8h8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-full-screen-return",
		"name": "ki-full-screen-return",
		"tags": "ki-full-screen-return",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M14 14L6 14 6 12 12 12 12 8 14 8 14 14z"
				},
				{
					"d": "M14 24L12 24 12 20 6 20 6 18 14 18 14 24z"
				},
				{
					"d": "M20 24L18 24 18 18 26 18 26 20 20 20 20 24z"
				},
				{
					"d": "M27.00045,27.99953H2v-21a3.00328,3.00328,0,0,1,3-3H27.00045a3.00328,3.00328,0,0,1,3,3v18A3.00328,3.00328,0,0,1,27.00045,27.99953ZM4,25.99953H27.00045a1.00067,1.00067,0,0,0,1-1v-18a1.00067,1.00067,0,0,0-1-1H5a1.001,1.001,0,0,0-1,1Z"
				},
				{
					"d": "M26 14L18 14 18 8 20 8 20 12 26 12 26 14z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-full-screen-return-f",
		"name": "ki-full-screen-return-f",
		"tags": "ki-full-screen-return-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,27,4ZM14,24H12V20H6V18h8Zm0-10H6V12h6V8h2Zm12,6H20v4H18V18h8Zm0-6H18V8h2v4h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-game-console",
		"name": "ki-game-console",
		"tags": "ki-game-console",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,28c-3.44434,0-4.76953-1.30273-5.89453-3.55273A1.40616,1.40616,0,0,0,19.78711,24H12.21875a1.40616,1.40616,0,0,0-.31836.44727C10.77539,26.69727,9.4502,28,6.00586,28a3.94629,3.94629,0,0,1-2.93945-1.291,3.8412,3.8412,0,0,1-1.05664-2.793s.61953-9.75617.99316-12.99219C3.28844,8.451,5,6,7.72363,6a6.12414,6.12414,0,0,1,4.68848,2h7.17578a6.12414,6.12414,0,0,1,4.68848-2c2.47558,0,4.433,2.45118,4.71191,4.8457.37943,3.257,1.00879,13.07715,1.00879,13.07715A3.84128,3.84128,0,0,1,28.93945,26.709,3.9463,3.9463,0,0,1,26,28Zm-5.85645-5.98926c.85645,0,1.08985.21973,1.751,1.542C22.72656,25.21582,23.40234,26,26,26a1.95169,1.95169,0,0,0,1.4668-.64355,1.873,1.873,0,0,0,.53711-1.27247s-.62107-9.76771-1.001-13.00683C26.83236,9.62289,25.61816,8,24.27637,8A4.37851,4.37851,0,0,0,20.707,9.707l-.293.293H11.58594l-.293-.293C10.33887,8.75293,9.8623,8,8,8,6,8,5.16568,9.62273,4.98828,11.1543c-.37278,3.21833-.98535,12.92187-.98535,12.92187a1.8696,1.8696,0,0,0,.53613,1.28028A1.95169,1.95169,0,0,0,6.00586,26c2.59766,0,3.27344-.78418,4.10547-2.44727C10.77246,22.23047,11,22,11.8623,22.01074Z"
				},
				{
					"d": "M20 12H22V14H20z"
				},
				{
					"d": "M17 15H19V17H17z"
				},
				{
					"d": "M20 18H22V20H20z"
				},
				{
					"d": "M23 15H25V17H23z"
				},
				{
					"d": "M13 15L11 15 11 14 11 13 9 13 9 14 9 15 7 15 7 17 9 17 9 18 9 19 11 19 11 18 11 17 13 17 13 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-game-console-f",
		"name": "ki-game-console-f",
		"tags": "ki-game-console-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.99,10.85C28.62,8.46,26.75,6,24.28,6a6.11577,6.11577,0,0,0-4.69,2H12.41A6.11577,6.11577,0,0,0,7.72,6C5.25,6,3.38,8.46,3,10.92l-.99,13a3.85568,3.85568,0,0,0,1.06,2.79A3.95138,3.95138,0,0,0,6.01,28c3.44,0,4.77-1.3,5.89-3.55a1.42289,1.42289,0,0,1,.32-.45h7.57a1.8538,1.8538,0,0,1,.32.45C21.23,26.7,22.56,28,26,28a3.96745,3.96745,0,0,0,2.94-1.29A3.85568,3.85568,0,0,0,30,23.92ZM13,17H11v2H9V17H7V15H9V13h2v2h2Zm6,0H17V15h2Zm3,3H20V18h2Zm0-6H20V12h2Zm3,3H23V15h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-government-building",
		"name": "ki-government-building",
		"tags": "ki-government-building",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,18V16H24.76825A9.01416,9.01416,0,0,0,17,9.05908V7h4V3H15V9.05908A9.01416,9.01416,0,0,0,7.23175,16H5v2H7v9H5v2H27V27H25V18ZM16,11a7.01014,7.01014,0,0,1,6.70514,5H9.29486A7.01014,7.01014,0,0,1,16,11Zm2,16H14V18h4ZM9,18h3v9H9Zm14,9H20V18h3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-grid",
		"name": "ki-grid",
		"tags": "ki-grid",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15,15H3V6A3.00328,3.00328,0,0,1,6,3h9ZM5,13h8V5H6A1.00067,1.00067,0,0,0,5,6Z"
				},
				{
					"d": "M29,15H17V3h9a3.00328,3.00328,0,0,1,3,3ZM19,13h8V6a1.00067,1.00067,0,0,0-1-1H19Z"
				},
				{
					"d": "M15,29H3V17H15ZM5,27h8V19H5Z"
				},
				{
					"d": "M26,29H17V17H29v9A3.00328,3.00328,0,0,1,26,29Zm-7-2h7a1.00067,1.00067,0,0,0,1-1V19H19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-grid-f",
		"name": "ki-grid-f",
		"tags": "ki-grid-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15,3V15H3V6A3.00879,3.00879,0,0,1,6,3Z"
				},
				{
					"d": "M29,6v9H17V3h9A3.00879,3.00879,0,0,1,29,6Z"
				},
				{
					"d": "M3 17H15V29H3z"
				},
				{
					"d": "M29,17v9a3.00883,3.00883,0,0,1-3,3H17V17Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-guide",
		"name": "ki-guide",
		"tags": "ki-guide",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29 5L29 3 3 3 3 5 9 5 9 11 3 11 3 13 21 13 21 19 3 19 3 21 9 21 9 27 3 27 3 29 29 29 29 27 11 27 11 21 27 21 29 21 29 19 27 19 23 19 23 13 27 13 29 13 29 11 27 11 11 11 11 5 29 5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-hand",
		"name": "ki-hand",
		"tags": "ki-hand",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,6H24.81573A2.99507,2.99507,0,0,0,22,4H20.21973A2.98154,2.98154,0,0,0,18,3H15V4.18433A2.96485,2.96485,0,0,0,14,4H11V18.82422L6.11914,14.6377,3.87891,16.87891a3.00055,3.00055,0,0,0-.0083,4.23437L11.5791,29H26a3.00328,3.00328,0,0,0,3-3V9A3.00328,3.00328,0,0,0,26,6Zm1,12v8a1.001,1.001,0,0,1-1,1H12.4209L5.293,19.707a1.0014,1.0014,0,0,1,0-1.41406l.93066-.93067L13,23.17578V6h1a1.001,1.001,0,0,1,1,1v9h2V5h1a1.001,1.001,0,0,1,1,1V16h2V6h1a1.001,1.001,0,0,1,1,1v9h2V8h1a1.001,1.001,0,0,1,1,1v9Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-headphones",
		"name": "ki-headphones",
		"tags": "ki-headphones",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,3A13.01474,13.01474,0,0,0,3,16V29H7a3.00328,3.00328,0,0,0,3-3V20a3.00328,3.00328,0,0,0-3-3H5V16a11,11,0,0,1,22,0v1H25a3.00328,3.00328,0,0,0-3,3v6a3.00328,3.00328,0,0,0,3,3h4V16A13.01474,13.01474,0,0,0,16,3ZM7,19a1.001,1.001,0,0,1,1,1v6a1.001,1.001,0,0,1-1,1H5V19Zm20,8H25a1.001,1.001,0,0,1-1-1V20a1.001,1.001,0,0,1,1-1h2v8Z"
				},
				{
					"d": "M22.00684,9.49316a8.453,8.453,0,0,0-12.28418.3125l1.49511,1.32813a6.45365,6.45365,0,0,1,9.375-.22656c.0669.06738.13379.14257.20069.21777l1.49316-1.33008C22.19336,9.69043,22.1001,9.58594,22.00684,9.49316Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-heart",
		"name": "ki-heart",
		"tags": "ki-heart",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,28.07311l-.5881-.44155c-.32661-.2452-8.0351-6.05722-11.04168-11.06851A8.30333,8.30333,0,0,1,4.7361,6.89391a7.80787,7.80787,0,0,1,8.63183-2.55449A8.288,8.288,0,0,1,16,5.88534a8.288,8.288,0,0,1,2.63207-1.54592A7.80633,7.80633,0,0,1,27.2639,6.89391a8.30333,8.30333,0,0,1,.36588,9.66914h0C24.6232,21.57434,16.91471,27.38636,16.5881,27.63156Zm-5.13867-22.182A5.8732,5.8732,0,0,0,6.26669,8.12183a6.30788,6.30788,0,0,0-.21455,7.43169C8.40453,19.47385,14.14376,24.15182,16,25.60769c1.85624-1.45683,7.59738-6.13671,9.94786-10.05417a6.30788,6.30788,0,0,0-.21455-7.43169A5.86758,5.86758,0,0,0,19.25274,6.1995,7.03776,7.03776,0,0,0,16.727,7.89L16,8.69173,15.273,7.89A7.01082,7.01082,0,0,0,12.74726,6.1995,5.98155,5.98155,0,0,0,10.86133,5.89108Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-heart-cross",
		"name": "ki-heart-cross",
		"tags": "ki-heart-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.26001,6.89001c-2.09003-2.60004-5.47003-3.60004-8.63-2.55005-1.09003,.36005-2.03003,1.03003-2.63,1.55005-.59998-.52002-1.53998-1.19-2.63-1.55005-1.75-.57996-3.56-.52997-5.19,.07001l1.60004,1.59003c.34998-.08002,.70996-.10999,1.07996-.10999,.63,0,1.26001,.09998,1.89001,.31,1.39001,.45996,2.51001,1.67999,2.52002,1.69l.72998,.79999,.72998-.79999c.01001-.01001,1.14001-1.23004,2.52002-1.69,2.37-.79004,4.90997-.04004,6.47998,1.91998,1.67999,2.08997,1.76001,4.87,.22003,7.42999-.72003,1.20001-1.75,2.46997-2.90002,3.70001l1.38,1.38c1.25-1.33002,2.39001-2.73004,3.20001-4.07001,1.95001-3.25,1.81-6.95001-.37-9.66998Z"
				},
				{
					"d": "M3.58643,5.45703l1.28906,1.28632c-.04327,.05151-.09332,.09375-.1355,.14667-2.17999,2.71997-2.32001,6.41998-.37,9.66998,3.01001,5.01001,10.72003,10.83002,11.03998,11.07001l.59003,.44,.59003-.44c.15997-.12,2.16998-1.63,4.50995-3.75,.16168-.1463,.3291-.30225,.49408-.45361l1.99188,1.98767,1.41406-1.41406L5.00049,4.04297l-1.41406,1.41406Zm12.41357,20.15295c-1.85999-1.46002-7.59998-6.14001-9.95001-10.06-1.5379-2.55652-1.45941-5.33215,.21399-7.42108l13.94202,13.91241c-1.74585,1.59686-3.36554,2.90881-4.20599,3.56866Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-heart-f",
		"name": "ki-heart-f",
		"tags": "ki-heart-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.63,16.56a36.64113,36.64113,0,0,1-6.53,7.32C18.76,26,16.75,27.51,16.59,27.63l-.59.44-.59-.44C15.09,27.39,7.38,21.57,4.37,16.56a8.29925,8.29925,0,0,1,.37-9.67,7.80994,7.80994,0,0,1,8.63-2.55A8.052,8.052,0,0,1,16,5.89a8.052,8.052,0,0,1,2.63-1.55,7.80994,7.80994,0,0,1,8.63,2.55A8.29925,8.29925,0,0,1,27.63,16.56Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-high-priority",
		"name": "ki-high-priority",
		"tags": "ki-high-priority",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13,26H29a0,0,0,0,1,0,0v2a0,0,0,0,1,0,0H13a1,1,0,0,1-1-1v0a1,1,0,0,1,1-1Z"
				},
				{
					"d": "M16.57895,6H29a0,0,0,0,1,0,0V8a0,0,0,0,1,0,0H16.57895a1,1,0,0,1-1-1V7A1,1,0,0,1,16.57895,6Z"
				},
				{
					"d": "M13,16H29a0,0,0,0,1,0,0v2a0,0,0,0,1,0,0H13a1,1,0,0,1-1-1v0a1,1,0,0,1,1-1Z"
				},
				{
					"d": "M5 8 9.586 8 7.293 10.293 8.707 11.707 13.414 7 8.707 2.293 7.293 3.707 9.586 6 3 6 3 28 10 28 10 26 5 26 5 8z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home",
		"name": "ki-home",
		"tags": "ki-home",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,29H19V22a3,3,0,0,0-6,0v7H6a3.00328,3.00328,0,0,1-3-3V12.5L16,2.75,29,12.5V26A3.00328,3.00328,0,0,1,26,29Zm-5-2h5a1.00067,1.00067,0,0,0,1-1V13.5L16,5.25,5,13.5V26a1.00067,1.00067,0,0,0,1,1h5V22a5,5,0,0,1,10,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-appliance",
		"name": "ki-home-appliance",
		"tags": "ki-home-appliance",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,2H7A3.00328,3.00328,0,0,0,4,5V30H25a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,25,2Zm1,25a1.00067,1.00067,0,0,1-1,1H6V15H26ZM6,13V5A1.00067,1.00067,0,0,1,7,4H25a1.00067,1.00067,0,0,1,1,1v8Z"
				},
				{
					"d": "M8 6H10V11H8z"
				},
				{
					"d": "M8 17H10V25H8z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-appliance-f",
		"name": "ki-home-appliance-f",
		"tags": "ki-home-appliance-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4,15V30H25a3.00887,3.00887,0,0,0,3-3V15Zm6,10H8V17h2ZM25,2H7A3.00879,3.00879,0,0,0,4,5v8H28V5A3.00879,3.00879,0,0,0,25,2ZM10,11H8V6h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-camera",
		"name": "ki-home-camera",
		"tags": "ki-home-camera",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,14a4,4,0,1,1,4-4A4.004,4.004,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,16,8Z"
				},
				{
					"d": "M15 17H17V19H15z"
				},
				{
					"d": "M24,16V10A8,8,0,0,0,8,10v6a8.007,8.007,0,0,0,7,7.93054V26H10a2,2,0,0,0-2,2H24a2,2,0,0,0-2-2H17V23.93054A8.007,8.007,0,0,0,24,16ZM10,16V10a6,6,0,0,1,12,0v6a6,6,0,0,1-12,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-camera-f",
		"name": "ki-home-camera-f",
		"tags": "ki-home-camera-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "10",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M24,16V10A8,8,0,0,0,8,10v6a8.00428,8.00428,0,0,0,7,7.93V26H10a2.00587,2.00587,0,0,0-2,2H24a2.00587,2.00587,0,0,0-2-2H17V23.93A8.00428,8.00428,0,0,0,24,16ZM12,10a4,4,0,1,1,4,4A3.99887,3.99887,0,0,1,12,10Zm3,9V17h2v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-f",
		"name": "ki-home-f",
		"tags": "ki-home-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,12.5V26a3.00883,3.00883,0,0,1-3,3H19V22a3,3,0,0,0-6,0v7H6a3.00883,3.00883,0,0,1-3-3V12.5L16,2.75Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-speaker",
		"name": "ki-home-speaker",
		"tags": "ki-home-speaker",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,30H7a3.00328,3.00328,0,0,1-3-3V2H28V27A3.00328,3.00328,0,0,1,25,30ZM6,4V27a1.00067,1.00067,0,0,0,1,1H25a1.00067,1.00067,0,0,0,1-1V4Z"
				},
				{
					"d": "M16,26a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,26Zm0-10a4,4,0,1,0,4,4A4.004,4.004,0,0,0,16,16Z"
				},
				{
					"d": "M16,12a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,16,12Zm0-4a1,1,0,1,0,1,1A1.00067,1.00067,0,0,0,16,8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-home-speaker-f",
		"name": "ki-home-speaker-f",
		"tags": "ki-home-speaker-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,16a4,4,0,1,0,4,4A3.99887,3.99887,0,0,0,16,16Zm0,0a4,4,0,1,0,4,4A3.99887,3.99887,0,0,0,16,16ZM4,3V27a3.00882,3.00882,0,0,0,3,3H25a3.00882,3.00882,0,0,0,3-3V3a1,1,0,0,0-1-1H5A1,1,0,0,0,4,3ZM16,6a3,3,0,1,1-3,3A3.00879,3.00879,0,0,1,16,6Zm0,20a6,6,0,1,1,6-6A6.00475,6.00475,0,0,1,16,26Zm0-10a4,4,0,1,0,4,4A3.99887,3.99887,0,0,0,16,16Zm0-6a1,1,0,1,0-1-1A1.003,1.003,0,0,0,16,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-hosting",
		"name": "ki-hosting",
		"tags": "ki-hosting",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M7 8H10V10H7z"
				},
				{
					"d": "M29,15H3V3H29ZM5,13H27V5H5Z"
				},
				{
					"d": "M26,29H6a3.00328,3.00328,0,0,1-3-3V17H29v9A3.00328,3.00328,0,0,1,26,29ZM5,19v7a1.00067,1.00067,0,0,0,1,1H26a1.00067,1.00067,0,0,0,1-1V19Z"
				},
				{
					"d": "M13 8H25V10H13z"
				},
				{
					"d": "M13 22H25V24H13z"
				},
				{
					"d": "M7 22H10V24H7z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-hosting-f",
		"name": "ki-hosting-f",
		"tags": "ki-hosting-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,3V15H29V3Zm7,7H7V8h3Zm15,0H13V8H25Z"
				},
				{
					"d": "M3,17v9a3.00883,3.00883,0,0,0,3,3H26a3.00883,3.00883,0,0,0,3-3V17Zm7,7H7V22h3Zm15,0H13V22H25Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-hourglass",
		"name": "ki-hourglass",
		"tags": "ki-hourglass",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26 8.36V4h2V2H4v2h2v4.36c0 .63.19 1.23.56 1.74l4.21 5.9-4.21 5.9c-.37.51-.56 1.11-.56 1.74V28H4v2h24v-2h-2v-4.36c0-.63-.19-1.23-.56-1.74L21.23 16l4.21-5.9c.37-.51.56-1.11.56-1.74Zm-2 0c0 .21-.06.41-.19.58L18.77 16l5.04 7.06c.12.17.19.37.19.58V28H8v-4.36c0-.21.06-.41.19-.58L13.23 16 8.19 8.94C8.07 8.77 8 8.57 8 8.36V4h16v4.36Z"
				},
				{
					"d": "m17 15 3-4h-8l3 4h2zM10 24v2h12v-2l-2-3h-8l-2 3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-hourglass-f",
		"name": "ki-hourglass-f",
		"tags": "ki-hourglass-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26 8.36V4h2V2H4v2h2v4.36c0 .63.19 1.23.56 1.74l4.21 5.9-4.21 5.9c-.37.51-.56 1.11-.56 1.74V28H4v2h24v-2h-2v-4.36c0-.63-.19-1.23-.56-1.74L21.23 16l4.21-5.9c.37-.51.56-1.11.56-1.74ZM22 26H10v-2l2-3h8l2 3v2Zm-5-11h-2l-3-4h8l-3 4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-humidity",
		"name": "ki-humidity",
		"tags": "ki-humidity",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.00079,5.59787c1.01486,.94641,2.99921,3.12473,2.99921,5.68213,0,1.65421-1.34579,3-3,3s-3-1.34579-3-3c0-2.5524,1.97656-4.72714,3.00079-5.68213m-.00079-2.56787l-.59998,.44995c-.18005,.13-4.40002,3.3501-4.40002,7.80005,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-4.44995-4.21997-7.67004-4.40002-7.80005l-.59998-.44995h0Z"
				},
				{
					"d": "M11.00079,18.59787c1.01486,.94641,2.99921,3.12473,2.99921,5.68213,0,1.65421-1.34579,3-3,3s-3-1.34579-3-3c0-2.5524,1.97656-4.72714,3.00079-5.68213m-.00079-2.56787l-.59998,.44995c-.18005,.13-4.40002,3.3501-4.40002,7.80005,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-4.44995-4.21997-7.67004-4.40002-7.80005l-.59998-.44995h0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-humidity-f",
		"name": "ki-humidity-f",
		"tags": "ki-humidity-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.59998,3.47992l-.59998-.44995-.59998,.44995c-.18005,.13-4.40002,3.3501-4.40002,7.80005,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-4.44995-4.21997-7.67004-4.40002-7.80005Z"
				},
				{
					"d": "M11.59998,16.47992l-.59998-.44995-.59998,.44995c-.18005,.13-4.40002,3.3501-4.40002,7.80005,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-4.44995-4.21997-7.67004-4.40002-7.80005Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-illustrator-swatch",
		"name": "ki-illustrator-swatch",
		"tags": "ki-illustrator-swatch",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,10V4H4V22h6v6H28V10ZM6,20V6H20V20Zm20,6H12V22H22V12h4Z"
				},
				{
					"d": "M8,18H18V8H8Zm2-8h6v6H10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-illustrator-swatch-f",
		"name": "ki-illustrator-swatch-f",
		"tags": "ki-illustrator-swatch-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,10V4H4V22h6v6H28V10ZM6,20V6H20V20Z"
				},
				{
					"d": "M18,18H8V8H18Zm-8-2h6V10H10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-image-preview",
		"name": "ki-image-preview",
		"tags": "ki-image-preview",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,21.86475,22.0127,17.709l-4.93848,3.95118L10,14.58594l-5,5V7A1.001,1.001,0,0,1,6,6h7V4H6A3.00328,3.00328,0,0,0,3,7V25.01172a3.00782,3.00782,0,0,0,2.98242,3l19.99951.11914H26.001a2.9999,2.9999,0,0,0,2.999-3V19H27Zm-.29492,3.97607a.99252.99252,0,0,1-.70459.29h-.00635L5.99463,26.01172a1.00271,1.00271,0,0,1-.99463-1V22.41406l5-5,6.92578,6.92578L21.9873,20.291,27,24.46875v.66211A.99607.99607,0,0,1,26.70508,25.84082Z"
				},
				{
					"d": "M21,15a5.96939,5.96939,0,0,0,4.0238-1.562L28.293,16.707,29.707,15.293l-3.43341-3.43335A5.99932,5.99932,0,1,0,21,15ZM21,5a4,4,0,1,1-4,4A4.00427,4.00427,0,0,1,21,5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-import",
		"name": "ki-import",
		"tags": "ki-import",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.082 23.342L13.533 17 28 17 28 15 13.533 15 19.082 8.658 17.576 7.342 10 16 17.576 24.658 19.082 23.342z"
				},
				{
					"d": "M4,27V5A3.00328,3.00328,0,0,1,7,2h5V4H7A1.00067,1.00067,0,0,0,6,5V27a1.00067,1.00067,0,0,0,1,1h5v2H7A3.00328,3.00328,0,0,1,4,27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-indent-decrease",
		"name": "ki-indent-decrease",
		"tags": "ki-indent-decrease",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,29H3V27H28a1,1,0,0,1,1,1h0A1,1,0,0,1,28,29Z"
				},
				{
					"d": "M28,5H3V3H28a1,1,0,0,1,1,1h0A1,1,0,0,1,28,5Z"
				},
				{
					"d": "M16,13H3V11H16a1,1,0,0,1,1,1h0A1,1,0,0,1,16,13Z"
				},
				{
					"d": "M16,21H3V19H16a1,1,0,0,1,1,1h0A1,1,0,0,1,16,21Z"
				},
				{
					"d": "M29 15L22.828 15 25.121 12.707 23.707 11.293 19 16 23.707 20.707 25.121 19.293 22.828 17 29 17 29 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-indent-increase",
		"name": "ki-indent-increase",
		"tags": "ki-indent-increase",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4,27H29v2H4a1,1,0,0,1-1-1H3A1,1,0,0,1,4,27Z"
				},
				{
					"d": "M4,3H29V5H4A1,1,0,0,1,3,4H3A1,1,0,0,1,4,3Z"
				},
				{
					"d": "M16,19H29v2H16a1,1,0,0,1-1-1h0A1,1,0,0,1,16,19Z"
				},
				{
					"d": "M16,11H29v2H16a1,1,0,0,1-1-1h0A1,1,0,0,1,16,11Z"
				},
				{
					"d": "M8.293 11.293L6.879 12.707 9.172 15 3 15 3 17 9.172 17 6.879 19.293 8.293 20.707 13 16 8.293 11.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-infinity",
		"name": "ki-infinity",
		"tags": "ki-infinity",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,24c-3.56787,0-5.88525-2.94922-8-6.16113C13.88525,21.05078,11.56787,24,8,24c-4.42383,0-6-4.13281-6-8S3.57617,8,8,8c3.56787,0,5.88525,2.94922,8,6.16113C18.11475,10.94922,20.43213,8,24,8c4.42383,0,6,4.13281,6,8S28.42383,24,24,24Zm-6.81055-8C19.22607,19.15527,21.20459,22,24,22c3.61035,0,4-4.19629,4-6s-.38965-6-4-6C21.20459,10,19.22607,12.84473,17.18945,16ZM8,10c-3.61035,0-4,4.19629-4,6s.38965,6,4,6c2.79541,0,4.77393-2.84473,6.81055-6C12.77393,12.84473,10.79541,10,8,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-info",
		"name": "ki-info",
		"tags": "ki-info",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16.00042",
					"cy": "8",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M14.50024 12.07632H17.500239999999998V25.99901H14.50024z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-info-circle",
		"name": "ki-info-circle",
		"tags": "ki-info-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16.00042",
					"cy": "9.99906",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00045,1.99953A14,14,0,1,1,2,15.99953,14.01572,14.01572,0,0,1,16.00045,1.99953Zm0,26A12,12,0,1,0,4,15.99953,12.01343,12.01343,0,0,0,16.00045,27.99953Z"
				},
				{
					"d": "M14.50042 13.99906H17.50042V23.99906H14.50042z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-info-circle-f",
		"name": "ki-info-circle-f",
		"tags": "ki-info-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,0,2,16,14.01541,14.01541,0,0,0,16,30Zm1.5-6h-3V14h3ZM16,8a2,2,0,1,1-2,2A2.00591,2.00591,0,0,1,16,8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-instagram",
		"name": "ki-instagram",
		"tags": "ki-instagram",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "22.93943",
					"cy": "9.06057",
					"r": "1.56"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,5.34234c3.47116,0,3.8823.01324,5.25311.07578a7.19337,7.19337,0,0,1,2.41392.44763A4.30517,4.30517,0,0,1,26.13425,8.333a7.19362,7.19362,0,0,1,.44763,2.41391c.06254,1.37082.07578,1.782.07578,5.25312s-.01324,3.8823-.07578,5.25311a7.19363,7.19363,0,0,1-.44763,2.41392A4.30517,4.30517,0,0,1,23.667,26.13425a7.19363,7.19363,0,0,1-2.41392.44763c-1.37061.06254-1.78172.07578-5.25311.07578s-3.8825-.01324-5.25311-.07578A7.19363,7.19363,0,0,1,8.333,26.13425,4.30517,4.30517,0,0,1,5.86575,23.667a7.19336,7.19336,0,0,1-.44763-2.41391C5.35558,19.8823,5.34234,19.47116,5.34234,16s.01324-3.8823.07578-5.25311A7.19337,7.19337,0,0,1,5.86575,8.333,4.30517,4.30517,0,0,1,8.333,5.86575a7.19336,7.19336,0,0,1,2.41391-.44763c1.37082-.06254,1.782-.07578,5.25312-.07578M16,3c-3.53059,0-3.9733.01495-5.35988.07822a9.54191,9.54191,0,0,0-3.15563.60426,6.64744,6.64744,0,0,0-3.802,3.802,9.54191,9.54191,0,0,0-.60426,3.15563C3.01495,12.0267,3,12.4694,3,16s.01495,3.9733.07822,5.35988a9.54191,9.54191,0,0,0,.60426,3.15563,6.64744,6.64744,0,0,0,3.802,3.802,9.54191,9.54191,0,0,0,3.15563.60426C12.0267,28.98506,12.46941,29,16,29s3.9733-.01494,5.35988-.07822a9.54191,9.54191,0,0,0,3.15563-.60426,6.64744,6.64744,0,0,0,3.802-3.802,9.54191,9.54191,0,0,0,.60426-3.15563C28.98505,19.9733,29,19.53059,29,16s-.01495-3.9733-.07822-5.35988a9.54191,9.54191,0,0,0-.60426-3.15563,6.64744,6.64744,0,0,0-3.802-3.802,9.54191,9.54191,0,0,0-3.15563-.60426C19.9733,3.01495,19.53059,3,16,3Z"
				},
				{
					"d": "M16,9.32432A6.67568,6.67568,0,1,0,22.67568,16,6.67568,6.67568,0,0,0,16,9.32432Zm0,11.009A4.33333,4.33333,0,1,1,20.33333,16,4.33333,4.33333,0,0,1,16,20.33333Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-internet",
		"name": "ki-internet",
		"tags": "ki-internet",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00049,1.99951a14,14,0,1,0,14,14A14.01573,14.01573,0,0,0,16.00049,1.99951Zm10.89465,9H23.30872a15.36291,15.36291,0,0,0-3.5232-6.37884A12.04626,12.04626,0,0,1,26.89514,10.99951Zm-4.89465,5a20.02,20.02,0,0,1-.238,3H10.2384a20.02177,20.02177,0,0,1-.23791-3,16.25457,16.25457,0,0,1,.28052-3H21.71973A16.25545,16.25545,0,0,1,22.00049,15.99951Zm-6,11.84033a10.94118,10.94118,0,0,1-5.33179-6.84033H21.33215A10.94139,10.94139,0,0,1,16.00049,27.83984ZM10.79712,10.99951a12.15484,12.15484,0,0,1,5.20337-6.85577,12.15573,12.15573,0,0,1,5.20325,6.85577Zm1.41821-6.37884a15.3646,15.3646,0,0,0-3.52319,6.37884H5.10571A12.04665,12.04665,0,0,1,12.21533,4.62067ZM4.39526,12.99951h3.853a18.67168,18.67168,0,0,0-.2478,3,22.37371,22.37371,0,0,0,.19531,3H4.39526a11.59643,11.59643,0,0,1,0-6Zm.71045,8h3.48a13.58068,13.58068,0,0,0,3.401,6.295A12.0453,12.0453,0,0,1,5.10571,20.99951Zm14.90845,6.295a13.58165,13.58165,0,0,0,3.40088-6.295h3.4801A12.04563,12.04563,0,0,1,20.01416,27.29449Zm7.59143-8.295H23.80518a22.39523,22.39523,0,0,0,.19531-3,18.68657,18.68657,0,0,0-.2478-3h3.8529a11.59274,11.59274,0,0,1,0,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-internet-cross",
		"name": "ki-internet-cross",
		"tags": "ki-internet-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A13.96389,13.96389,0,0,0,8.44,4.22l1.46,1.46A11.894,11.894,0,0,1,12.22,4.62a14.58183,14.58183,0,0,0-1.49,1.89l1.46,1.46A11.00023,11.00023,0,0,1,16,4.14,12.1795,12.1795,0,0,1,21.2,11H15.22l2,2h4.5A16.48673,16.48673,0,0,1,22,16c0,.59-.03,1.1499-.08,1.7l3.3,3.3H26.9c-.18005.38-.37.75-.58,1.1l1.46,1.46008A13.9961,13.9961,0,0,0,16,2Zm3.79,2.62A12.04438,12.04438,0,0,1,26.9,11H23.31A15.3531,15.3531,0,0,0,19.79,4.62ZM27.61,19h-3.8A23.419,23.419,0,0,0,24,16a18.49684,18.49684,0,0,0-.25-3h3.86a11.73317,11.73317,0,0,1,0,6Z"
				},
				{
					"d": "M4.39,3,3,4.39,5.44,6.83A13.84775,13.84775,0,0,0,2,16,14.01541,14.01541,0,0,0,16,30a13.848,13.848,0,0,0,9.17-3.43994L27.61,29,29,27.61ZM17.61,19H10.24A20.25687,20.25687,0,0,1,10,16a16.48673,16.48673,0,0,1,.28-3h1.33ZM6.86,8.25l2.05,2.05005c-.08.23-.15.46-.22.69995H5.11A12.1109,12.1109,0,0,1,6.86,8.25ZM4,16a11.86364,11.86364,0,0,1,.4-3H8.25A18.49684,18.49684,0,0,0,8,16a21.67621,21.67621,0,0,0,.2,3H4.4A11.86364,11.86364,0,0,1,4,16Zm1.11,5H8.59a13.39884,13.39884,0,0,0,3.4,6.29A11.97383,11.97383,0,0,1,5.11,21ZM16,27.84A10.93679,10.93679,0,0,1,10.67,21h8.94l1.28,1.28A10.72927,10.72927,0,0,1,16,27.84ZM20.01,27.29a12.2265,12.2265,0,0,0,2.4-3.49l1.33,1.33A11.788,11.788,0,0,1,20.01,27.29Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-internet-f",
		"name": "ki-internet-f",
		"tags": "ki-internet-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.9,21a12.02139,12.02139,0,0,1-6.89,6.29A13.4951,13.4951,0,0,0,23.42,21Z"
				},
				{
					"d": "M28,16a12.33138,12.33138,0,0,1-.39,3h-3.8A23.42037,23.42037,0,0,0,24,16a18.49684,18.49684,0,0,0-.25-3h3.86A12.3306,12.3306,0,0,1,28,16Z"
				},
				{
					"d": "M26.9,11H23.31a15.35273,15.35273,0,0,0-3.52-6.38A12.04456,12.04456,0,0,1,26.9,11Z"
				},
				{
					"d": "M21.2,11H10.8A12.1795,12.1795,0,0,1,16,4.14,12.1795,12.1795,0,0,1,21.2,11Z"
				},
				{
					"d": "M21.33,21A10.937,10.937,0,0,1,16,27.84,10.937,10.937,0,0,1,10.67,21Z"
				},
				{
					"d": "M11.99,27.29A11.97335,11.97335,0,0,1,5.11,21H8.59A13.39891,13.39891,0,0,0,11.99,27.29Z"
				},
				{
					"d": "M22,16a20.2582,20.2582,0,0,1-.24,3H10.24A20.2582,20.2582,0,0,1,10,16a16.48673,16.48673,0,0,1,.28-3H21.72A16.48673,16.48673,0,0,1,22,16Z"
				},
				{
					"d": "M8,16a21.67749,21.67749,0,0,0,.2,3H4.4a11.44945,11.44945,0,0,1,0-6H8.25A18.49684,18.49684,0,0,0,8,16Z"
				},
				{
					"d": "M12.22,4.62A15.36993,15.36993,0,0,0,8.69,11H5.11A12.01661,12.01661,0,0,1,12.22,4.62Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-italic",
		"name": "ki-italic",
		"tags": "ki-italic",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27 4L27 2 12 2 12 4 18.646 4 11.261 28 5 28 5 30 20 30 20 28 13.354 28 20.739 4 27 4z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-back-arrow",
		"name": "ki-jump-back-arrow",
		"tags": "ki-jump-back-arrow",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6,16c0,5.51367,4.48584,10,10,10s10-4.48633,10-10c0-5.36646-4.25275-9.74707-9.56384-9.97791l2.27087,2.27087-1.41406,1.41406-4.70703-4.70703L17.29297,.29297l1.41406,1.41406-2.31293,2.31293c6.43347,.21039,11.6059,5.49591,11.6059,11.98004,0,6.61719-5.3833,12-12,12-6.6167,0-12-5.38281-12-12h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-back-ten",
		"name": "ki-jump-back-ten",
		"tags": "ki-jump-back-ten",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6,16c0,5.51367,4.48584,10,10,10,5.51416,0,10-4.48633,10-10,0-5.36646-4.25275-9.74707-9.56384-9.97791l2.27087,2.27087-1.41406,1.41406-4.70703-4.70703L17.29297,.29297l1.41406,1.41406-2.31293,2.31293c6.43347,.21039,11.6059,5.49591,11.6059,11.98004,0,6.61719-5.3833,12-12,12-6.6167,0-12-5.38281-12-12h2Z"
				},
				{
					"d": "M11.91992,20.2002v-6.51562l-1.69189,.76758-.23975-1.45215,2.5918-1.2002h1.04395v8.40039h-1.7041Z"
				},
				{
					"d": "M18.65186,20.37988c-.67188,0-1.2583-.18164-1.75781-.5459-.5-.36328-.89014-.87598-1.16992-1.53613-.28027-.65918-.42041-1.42578-.42041-2.29785,0-.87988,.14014-1.64746,.42041-2.30371,.27979-.65625,.66992-1.16602,1.16992-1.53027,.49951-.36328,1.08594-.5459,1.75781-.5459s1.26025,.18262,1.76416,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027,.27979,.65625,.41992,1.42383,.41992,2.30371,0,.87207-.14014,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.09229,.5459-1.76416,.5459Zm0-1.53613c.49609,0,.88818-.25586,1.17578-.76758,.28809-.51172,.43213-1.2041,.43213-2.07617s-.14404-1.56348-.43213-2.07617c-.2876-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43213,1.2041-.43213,2.07617s.14404,1.56445,.43213,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-back-thirty",
		"name": "ki-jump-back-thirty",
		"tags": "ki-jump-back-thirty",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6,16c0,5.51367,4.48584,10,10,10s10-4.48633,10-10c0-5.36646-4.25275-9.74707-9.56384-9.97791l2.27087,2.27087-1.41406,1.41406-4.70703-4.70703L17.29297,.29297l1.41406,1.41406-2.31293,2.31293c6.43347,.21039,11.6059,5.49591,11.6059,11.98004,0,6.61719-5.3833,12-12,12-6.6167,0-12-5.38281-12-12h2Z"
				},
				{
					"d": "M11.79443,20.37988c-.46484,0-.91797-.05566-1.3623-.16797-.44434-.11133-.81836-.26367-1.12207-.45605l.38379-1.47559c.27246,.17578,.57812,.31641,.91797,.41992,.33984,.10449,.68652,.15625,1.03809,.15625,.52051,0,.93652-.11816,1.24805-.35449,.3125-.23535,.46777-.56543,.46777-.99023,0-.41504-.17188-.72363-.51562-.92383-.34375-.19922-.87207-.2998-1.58398-.2998h-.6123v-.74414l2.0166-2.29199h-3.03613v-1.45215h5.31543v.81641l-2.15918,2.45996c.74316,.12012,1.30957,.38965,1.69727,.80957,.38867,.4209,.58203,.9707,.58203,1.65039,0,.57617-.13379,1.07617-.40137,1.5-.26855,.42383-.64844,.75391-1.14062,.99023-.49219,.23535-1.06934,.35352-1.7334,.35352Z"
				},
				{
					"d": "M19.33057,20.37988c-.67188,0-1.25879-.18164-1.75781-.5459-.5-.36328-.89062-.87598-1.16992-1.53613-.28027-.65918-.4209-1.42578-.4209-2.29785,0-.87988,.14062-1.64746,.4209-2.30371,.2793-.65625,.66992-1.16602,1.16992-1.53027,.49902-.36328,1.08594-.5459,1.75781-.5459s1.25977,.18262,1.76367,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027s.41992,1.42383,.41992,2.30371c0,.87207-.13965,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.0918,.5459-1.76367,.5459Zm0-1.53613c.49609,0,.8877-.25586,1.17578-.76758s.43164-1.2041,.43164-2.07617-.14355-1.56348-.43164-2.07617c-.28809-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43262,1.2041-.43262,2.07617s.14453,1.56445,.43262,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-back-twenty",
		"name": "ki-jump-back-twenty",
		"tags": "ki-jump-back-twenty",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6,16c0,5.51367,4.48584,10,10,10s10-4.48633,10-10c0-5.36646-4.25275-9.74707-9.56384-9.97791l2.27087,2.27087-1.41406,1.41406-4.70703-4.70703L17.29297,.29297l1.41406,1.41406-2.31293,2.31293c6.43347,.21039,11.6059,5.49591,11.6059,11.98004,0,6.61719-5.3833,12-12,12-6.6167,0-12-5.38281-12-12h2Z"
				},
				{
					"d": "M9.22021,20.2002v-.74414l2.66406-2.97559c.46387-.52051,.7876-.94238,.97168-1.2666,.18408-.32324,.27588-.63379,.27588-.92969,0-.33594-.12402-.61035-.37158-.82227-.24805-.21191-.57227-.31738-.97217-.31738-.63232,0-1.24414,.25977-1.83594,.7793l-.44434-1.45117c.32812-.27246,.7124-.48242,1.15234-.63086,.43994-.14746,.8999-.22168,1.37988-.22168,.56787,0,1.06787,.1084,1.5,.32422s.76807,.51367,1.00781,.89355c.24023,.37988,.36035,.82617,.36035,1.33789,0,.30469-.0542,.60449-.16211,.90039s-.29834,.62793-.56982,.99609c-.27246,.36816-.64844,.81641-1.12842,1.34375l-1.16357,1.2959h3.16797v1.48828h-5.83203Z"
				},
				{
					"d": "M19.41992,20.37988c-.67188,0-1.2583-.18164-1.75781-.5459-.5-.36328-.89014-.87598-1.16992-1.53613-.28027-.65918-.42041-1.42578-.42041-2.29785,0-.87988,.14014-1.64746,.42041-2.30371,.27979-.65625,.66992-1.16602,1.16992-1.53027,.49951-.36328,1.08594-.5459,1.75781-.5459s1.26025,.18262,1.76416,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027,.27979,.65625,.41992,1.42383,.41992,2.30371,0,.87207-.14014,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.09229,.5459-1.76416,.5459Zm0-1.53613c.49609,0,.88818-.25586,1.17578-.76758,.28809-.51172,.43213-1.2041,.43213-2.07617s-.14404-1.56348-.43213-2.07617c-.2876-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43213,1.2041-.43213,2.07617s.14404,1.56445,.43213,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-forward-arrow",
		"name": "ki-jump-forward-arrow",
		"tags": "ki-jump-forward-arrow",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,16c0,5.51367-4.48584,10-10,10s-10-4.48633-10-10c0-5.36646,4.25275-9.74707,9.56384-9.97791l-2.27087,2.27087,1.41406,1.41406,4.70703-4.70703L14.70703,.29297l-1.41406,1.41406,2.31293,2.31293c-6.43347,.21039-11.6059,5.49591-11.6059,11.98004,0,6.61719,5.3833,12,12,12s12-5.38281,12-12h-2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-forward-ten",
		"name": "ki-jump-forward-ten",
		"tags": "ki-jump-forward-ten",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,16c0,5.51367-4.48584,10-10,10s-10-4.48633-10-10c0-5.36646,4.25275-9.74707,9.56384-9.97791l-2.27087,2.27087,1.41406,1.41406,4.70703-4.70703L14.70703,.29297l-1.41406,1.41406,2.31293,2.31293c-6.43347,.21039-11.6059,5.49591-11.6059,11.98004,0,6.61719,5.3833,12,12,12s12-5.38281,12-12h-2Z"
				},
				{
					"d": "M11.91992,20.2002v-6.51562l-1.69189,.76758-.23975-1.45215,2.5918-1.2002h1.04395v8.40039h-1.7041Z"
				},
				{
					"d": "M18.65186,20.37988c-.67188,0-1.2583-.18164-1.75781-.5459-.5-.36328-.89014-.87598-1.16992-1.53613-.28027-.65918-.42041-1.42578-.42041-2.29785,0-.87988,.14014-1.64746,.42041-2.30371,.27979-.65625,.66992-1.16602,1.16992-1.53027,.49951-.36328,1.08594-.5459,1.75781-.5459s1.26025,.18262,1.76416,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027,.27979,.65625,.41992,1.42383,.41992,2.30371,0,.87207-.14014,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.09229,.5459-1.76416,.5459Zm0-1.53613c.49609,0,.88818-.25586,1.17578-.76758,.28809-.51172,.43213-1.2041,.43213-2.07617s-.14404-1.56348-.43213-2.07617c-.2876-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43213,1.2041-.43213,2.07617s.14404,1.56445,.43213,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-forward-thirty",
		"name": "ki-jump-forward-thirty",
		"tags": "ki-jump-forward-thirty",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,16c0,5.51367-4.48584,10-10,10s-10-4.48633-10-10c0-5.36646,4.25275-9.74707,9.56384-9.97791l-2.27087,2.27087,1.41406,1.41406,4.70703-4.70703L14.70703,.29297l-1.41406,1.41406,2.31293,2.31293c-6.43347,.21039-11.6059,5.49591-11.6059,11.98004,0,6.61719,5.3833,12,12,12s12-5.38281,12-12h-2Z"
				},
				{
					"d": "M11.79443,20.37988c-.46484,0-.91797-.05566-1.3623-.16797-.44434-.11133-.81836-.26367-1.12207-.45605l.38379-1.47559c.27246,.17578,.57812,.31641,.91797,.41992,.33984,.10449,.68652,.15625,1.03809,.15625,.52051,0,.93652-.11816,1.24805-.35449,.3125-.23535,.46777-.56543,.46777-.99023,0-.41504-.17188-.72363-.51562-.92383-.34375-.19922-.87207-.2998-1.58398-.2998h-.6123v-.74414l2.0166-2.29199h-3.03613v-1.45215h5.31543v.81641l-2.15918,2.45996c.74316,.12012,1.30957,.38965,1.69727,.80957,.38867,.4209,.58203,.9707,.58203,1.65039,0,.57617-.13379,1.07617-.40137,1.5-.26855,.42383-.64844,.75391-1.14062,.99023-.49219,.23535-1.06934,.35352-1.7334,.35352Z"
				},
				{
					"d": "M19.33057,20.37988c-.67188,0-1.25879-.18164-1.75781-.5459-.5-.36328-.89062-.87598-1.16992-1.53613-.28027-.65918-.4209-1.42578-.4209-2.29785,0-.87988,.14062-1.64746,.4209-2.30371,.2793-.65625,.66992-1.16602,1.16992-1.53027,.49902-.36328,1.08594-.5459,1.75781-.5459s1.25977,.18262,1.76367,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027s.41992,1.42383,.41992,2.30371c0,.87207-.13965,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.0918,.5459-1.76367,.5459Zm0-1.53613c.49609,0,.8877-.25586,1.17578-.76758s.43164-1.2041,.43164-2.07617-.14355-1.56348-.43164-2.07617c-.28809-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43262,1.2041-.43262,2.07617s.14453,1.56445,.43262,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-jump-forward-twenty",
		"name": "ki-jump-forward-twenty",
		"tags": "ki-jump-forward-twenty",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,16c0,5.51367-4.48584,10-10,10s-10-4.48633-10-10c0-5.36646,4.25275-9.74707,9.56384-9.97791l-2.27087,2.27087,1.41406,1.41406,4.70703-4.70703L14.70703,.29297l-1.41406,1.41406,2.31293,2.31293c-6.43347,.21039-11.6059,5.49591-11.6059,11.98004,0,6.61719,5.3833,12,12,12s12-5.38281,12-12h-2Z"
				},
				{
					"d": "M9.22021,20.2002v-.74414l2.66406-2.97559c.46387-.52051,.7876-.94238,.97168-1.2666,.18408-.32324,.27588-.63379,.27588-.92969,0-.33594-.12402-.61035-.37158-.82227-.24805-.21191-.57227-.31738-.97217-.31738-.63232,0-1.24414,.25977-1.83594,.7793l-.44434-1.45117c.32812-.27246,.7124-.48242,1.15234-.63086,.43994-.14746,.8999-.22168,1.37988-.22168,.56787,0,1.06787,.1084,1.5,.32422s.76807,.51367,1.00781,.89355c.24023,.37988,.36035,.82617,.36035,1.33789,0,.30469-.0542,.60449-.16211,.90039s-.29834,.62793-.56982,.99609c-.27246,.36816-.64844,.81641-1.12842,1.34375l-1.16357,1.2959h3.16797v1.48828h-5.83203Z"
				},
				{
					"d": "M19.41992,20.37988c-.67188,0-1.2583-.18164-1.75781-.5459-.5-.36328-.89014-.87598-1.16992-1.53613-.28027-.65918-.42041-1.42578-.42041-2.29785,0-.87988,.14014-1.64746,.42041-2.30371,.27979-.65625,.66992-1.16602,1.16992-1.53027,.49951-.36328,1.08594-.5459,1.75781-.5459s1.26025,.18262,1.76416,.5459c.50391,.36426,.89551,.87402,1.17578,1.53027,.27979,.65625,.41992,1.42383,.41992,2.30371,0,.87207-.14014,1.63867-.41992,2.29785-.28027,.66016-.67188,1.17285-1.17578,1.53613-.50391,.36426-1.09229,.5459-1.76416,.5459Zm0-1.53613c.49609,0,.88818-.25586,1.17578-.76758,.28809-.51172,.43213-1.2041,.43213-2.07617s-.14404-1.56348-.43213-2.07617c-.2876-.51172-.67969-.76758-1.17578-.76758-.48828,0-.87598,.25586-1.16406,.76758-.28809,.5127-.43213,1.2041-.43213,2.07617s.14404,1.56445,.43213,2.07617,.67578,.76758,1.16406,.76758Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-key",
		"name": "ki-key",
		"tags": "ki-key",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9,11.99562a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,9,11.99562Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,7.99562Z"
				},
				{
					"d": "M18.5603,13.1441a6.26373,6.26373,0,0,0,.21-.74c.03-.12.06006-.25.1001-.43a9.17188,9.17188,0,0,0,.12988-1.47,8.59223,8.59223,0,1,0-7.1,8.37,2.21034,2.21034,0,0,0,.46008-.1,6.39472,6.39472,0,0,0,.78-.22l3.43994,3.44h2l.41992.41v2l1.58008,1.59h2l.41992.41v2.01l1.59009,1.59h5.40991v-5.42Zm-5.55005,3.32-.16992.08a1.81983,1.81983,0,0,1-.21.08,5.13567,5.13567,0,0,1-.74.21l-.13013.03a.77726.77726,0,0,1-.19995.04,6.493,6.493,0,1,1,5.43994-6.4,7.08149,7.08149,0,0,1-.10986,1.18l-.03.12-.04.15c-.03.15-.07007.3-.1101.44l-.00989.04c-.04.14-.09.27-.14.4l-.10009.18A6.27924,6.27924,0,0,1,13.01025,16.46411Zm14.99,11.54h-2.59l-.41-.42v-2.01l-1.59-1.58h-2l-.41-.41v-2l-1.59-1.59h-2l-2.35-2.35c.01,0,.01-.01.02-.01a3.59776,3.59776,0,0,0,.32-.22c.14-.09.28-.2.41-.3.12-.1.24-.2.35-.3a8.25256,8.25256,0,0,0,1.42-1.64,1.03938,1.03938,0,0,0,.06995-.11l10.35,10.35Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-key-f",
		"name": "ki-key-f",
		"tags": "ki-key-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.56006,13.14a6.26755,6.26755,0,0,0,.21-.74c.03-.12.06006-.25.1001-.43A9.173,9.173,0,0,0,19,10.5a8.59224,8.59224,0,1,0-7.1,8.37,2.2103,2.2103,0,0,0,.46009-.1,6.39472,6.39472,0,0,0,.78-.22l3.43994,3.44h2L19,22.4v2l1.58008,1.59h2L23,26.4v2.01L24.59009,30H30V24.58ZM9,11a2,2,0,1,1,2-2A2.00591,2.00591,0,0,1,9,11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-kite",
		"name": "ki-kite",
		"tags": "ki-kite",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15.93179,29.00717l-13-13,13-13,13,13Zm-10-13,10,10,10-10-10-10Z"
				},
				{
					"d": "M15.93179,22.00717l-6-6,6-6,6,6Zm-3-6,3,3,3-3-3-3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-kite-f",
		"name": "ki-kite-f",
		"tags": "ki-kite-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15.93179,3.00717l-13,13,13,13,13-13Zm-4,13,4-4,4,4-4,4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-label",
		"name": "ki-label",
		"tags": "ki-label",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20.41413,26H5a3,3,0,0,1-3-3V9A3,3,0,0,1,5,6H20.41413l9.293,9.293a.99989.99989,0,0,1,0,1.41406ZM5,8A1,1,0,0,0,4,9V23a1,1,0,0,0,1,1H19.586l8-8-8-8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-label-f",
		"name": "ki-label-f",
		"tags": "ki-label-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.71,16.71,20.41,26H5a2.99606,2.99606,0,0,1-3-3V9A2.996,2.996,0,0,1,5,6H20.41l9.3,9.29A1.00794,1.00794,0,0,1,29.71,16.71Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-laptop",
		"name": "ki-laptop",
		"tags": "ki-laptop",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.00049,20.99951v-16H4v16H2v3a3.00328,3.00328,0,0,0,3,3H27.00049a3.00328,3.00328,0,0,0,3-3v-3ZM6,6.99951H26.00049v14H6Zm22.00049,17a1.00067,1.00067,0,0,1-1,1H5a1.001,1.001,0,0,1-1-1v-1H28.00049Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-laptop-f",
		"name": "ki-laptop-f",
		"tags": "ki-laptop-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,21V5H4V21H2v3a3.00883,3.00883,0,0,0,3,3H27a3.00883,3.00883,0,0,0,3-3V21Zm0,3a1.003,1.003,0,0,1-1,1H5a1.003,1.003,0,0,1-1-1V23H28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-layers",
		"name": "ki-layers",
		"tags": "ki-layers",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29 19.27L29 21.58 16 29 3 21.58 3 19.27 16 26.7 29 19.27z"
				},
				{
					"d": "M16,21.30273,4.543,14.75586a2.99945,2.99945,0,0,1,0-5.209L16,3,27.457,9.54688a2.99945,2.99945,0,0,1,0,5.209Zm10.46484-8.2832a.99982.99982,0,0,0,0-1.73633L16,5.30273,5.53516,11.2832a.99982.99982,0,0,0,0,1.73633L16,19"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-layers-f",
		"name": "ki-layers-f",
		"tags": "ki-layers-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29 19.27L29 21.58 16 29 3 21.58 3 19.27 16 26.7 29 19.27z"
				},
				{
					"d": "M28.97,12.1499A2.99906,2.99906,0,0,1,27.46,14.76L16,21.30005,4.54,14.76a3.002,3.002,0,0,1,0-5.21L16,3,27.46,9.55005A2.97091,2.97091,0,0,1,28.97,12.1499Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-leaf",
		"name": "ki-leaf",
		"tags": "ki-leaf",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.98389,10.82178l-.12354-.68213-.68213-.12354a20.04765,20.04765,0,0,0-10.94244,1.39832,16.411,16.411,0,0,0-6.73969-8.28259L11,2.84814l-.49609.2837C10.19727,3.30664,3,7.51709,3,16s7.69336,12.8252,8,13a14.70148,14.70148,0,0,0,4.28271.55273,14.13733,14.13733,0,0,0,10.24366-4.02539C31.48877,19.57568,30.04834,11.17627,29.98389,10.82178ZM5,16C5,9.90527,9.48291,6.25439,11.002,5.19238,12.523,6.249,17,9.88037,17,16a13.22262,13.22262,0,0,1-5,10.034V13H10V26.0412A13.18017,13.18017,0,0,1,5,16Zm19.1123,8.11328c-3.4486,3.455-7.998,3.60358-10.64788,3.32025L16,25l7.67334-7.26074-1.34668-1.47852-3.84357,3.49982A14.06509,14.06509,0,0,0,19,16a14.21619,14.21619,0,0,0-.2511-2.61145,17.81078,17.81078,0,0,1,9.35462-1.49646C28.29,13.91748,28.40381,19.8291,24.1123,24.11328Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-leaf-cross",
		"name": "ki-leaf-cross",
		"tags": "ki-leaf-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11,5.19a13.9808,13.9808,0,0,1,5.83,8.82l2.16,2.16A.91374.91374,0,0,0,19,16a14.44417,14.44417,0,0,0-.25-2.61,17.881,17.881,0,0,1,9.35-1.5,16.17567,16.17567,0,0,1-2.69,10.7l1.44,1.44c4.41-5.76,3.19-12.88,3.13-13.21l-.12-.68L29.18,10.02a20.02581,20.02581,0,0,0-10.94,1.39A16.48562,16.48562,0,0,0,11.5,3.13L11,2.85l-.5.28A16.18379,16.18379,0,0,0,7.93,5.11L9.35,6.53A14.51511,14.51511,0,0,1,11,5.19Z"
				},
				{
					"d": "M25.53,25.53l-1.42-1.42-3.49-3.49-1.47-1.47H19.15l-.42-.42-1.77-1.77V16.96L7.99,7.99,6.55,6.55,4,4,2.58594,5.41406l2.76269,2.7627A14.12719,14.12719,0,0,0,3,16c0,8.48,7.69,12.83,8,13a14.65825,14.65825,0,0,0,4.28.55,14.50724,14.50724,0,0,0,8.728-2.71387l2.57794,2.57794L28,28l-2.47-2.47ZM5,16A12.08271,12.08271,0,0,1,6.81671,9.64484L10,12.82812V26.04A13.17159,13.17159,0,0,1,5,16Zm7,10.03V14.82812l4.52533,4.52533A14.02461,14.02461,0,0,1,12,26.03Zm1.46,1.4L16,25l3.16821-3.00366,3.39844,3.39844A13.47557,13.47557,0,0,1,13.46,27.43Z"
				},
				{
					"d": "M22.07 19.25L23.67 17.74 22.33 16.26 20.63 17.81 22.07 19.25z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-leaf-f",
		"name": "ki-leaf-f",
		"tags": "ki-leaf-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.52846,25.52847c-3.26001,3.26001-7.22998,4.02002-10.25,4.02002-.45001,0-.87-.02002-1.26001-.03998,2.03003-1.52002,4.97003-4.35004,6.29004-8.67999l3.37-3.09003-1.35999-1.47998-1.38,1.26996c.03998-.46997,.06-.94995,.06-1.44995,0-2.01001-.35004-3.81006-.91003-5.39001,4.53003-1.46002,8.87-.71002,9.09003-.67004l.67999,.12006,.12,.67999c.07001,.35999,1.51001,8.76001-4.45001,14.70996Zm-7.50693-14.66608c-1.95001-5.03998-6.28998-7.58997-6.52002-7.72998l-.5-.28003-.5,.28003c-.28998,.16998-7.06,4.13-7.47998,12.09003-.01001,.27997-.02002,.56995-.02002,.85999,0,.23999,.01001,.46997,.02002,.70001,.35004,6.27997,4.91998,10.14996,6.97998,11.58997V13.00241h2v15.47998c1-.64996,2.59003-1.87,4-3.69995,1.04004-1.34003,1.99005-3.01001,2.52002-5.03003,.29999-1.12,.47998-2.34003,.47998-3.66998,0-1.97003-.37994-3.71002-.97998-5.22003Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-library",
		"name": "ki-library",
		"tags": "ki-library",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.00049,7.00439h-1v-1a3.00328,3.00328,0,0,0-3-3h-16a3.00328,3.00328,0,0,0-3,3v19h4v4h19a3.00328,3.00328,0,0,0,3-3v-16A3.00328,3.00328,0,0,0,26.00049,7.00439Zm-21,16v-17a1.001,1.001,0,0,1,1-1h16a1.001,1.001,0,0,1,1,1v16a1.001,1.001,0,0,1-1,1h-17Zm22,3a1.001,1.001,0,0,1-1,1h-17v-2h13a3.00328,3.00328,0,0,0,3-3v-13h1a1.001,1.001,0,0,1,1,1Z"
				},
				{
					"d": "M10,20.94287l9.7207-6.94336L10,7.05615Zm2-10,4.2793,3.05664L12,17.05615Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-library-f",
		"name": "ki-library-f",
		"tags": "ki-library-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,7H25V6a3.00879,3.00879,0,0,0-3-3H6A3.00879,3.00879,0,0,0,3,6V25H7v4H26a3.00238,3.00238,0,0,0,3-3V10A3.00879,3.00879,0,0,0,26,7ZM11,9l7,5-7,5ZM27,26a.99654.99654,0,0,1-1,1H9V25H22a3.00238,3.00238,0,0,0,3-3V9h1a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lighting",
		"name": "ki-lighting",
		"tags": "ki-lighting",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2a9.01016,9.01016,0,0,0-9,9c0,2.61426,1.46777,5.12012,2.647,7.13281A9.18311,9.18311,0,0,1,11,21v4l1.21924,5h7.56152l1.18945-4.75781L20.98865,22H21V21a9.18311,9.18311,0,0,1,1.353-2.86719C23.53223,16.12012,25,13.61426,25,11A9.01016,9.01016,0,0,0,16,2Zm2.21924,26H13.78076l-.5-2h5.43848ZM19,24H13V22h6Zm1.62744-6.87793A15.52841,15.52841,0,0,0,19.17041,20H17V14h1a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2h1v6H12.82959a15.52841,15.52841,0,0,0-1.457-2.87793C10.26025,15.22363,9,13.07227,9,11a7,7,0,0,1,14,0C23,13.07227,21.73975,15.22363,20.62744,17.12207Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lighting-f",
		"name": "ki-lighting-f",
		"tags": "ki-lighting-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2a9.01016,9.01016,0,0,0-9,9c0,2.61426,1.46777,5.12012,2.647,7.13281A9.18311,9.18311,0,0,1,11,21v4l1.21924,5h7.56152l1.18945-4.75781L20.98865,22H21V21a9.18311,9.18311,0,0,1,1.353-2.86719C23.53223,16.12012,25,13.61426,25,11A9.01016,9.01016,0,0,0,16,2ZM14,12h4a1,1,0,0,1,0,2H17v6H15V14H14a1,1,0,0,1,0-2Zm-.21924,16-.5-2h5.43848l-.5,2ZM19,24H13V22h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lightning",
		"name": "ki-lightning",
		"tags": "ki-lightning",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15,8.60556V14h8.263L17,23.39444V18H8.737L15,8.60556M17,2,5,20H15V30L27,12H17V2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lightning-f",
		"name": "ki-lightning-f",
		"tags": "ki-lightning-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 30L15 20 5 20 17 2 17 12 27 12 15 30z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-like",
		"name": "ki-like",
		"tags": "ki-like",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.45068,14.27148A3.00431,3.00431,0,0,0,25.99854,13H20.98193a18.10276,18.10276,0,0,0,1.99659-6.6709A2.964,2.964,0,0,0,22.251,4.01172,3.01263,3.01263,0,0,0,20,3H16.12012V4c0,4.33691-2.28955,8-5,8H3V29H23.4668a3.00909,3.00909,0,0,0,2.90088-2.23633l2.45605-9.75488A3.00359,3.00359,0,0,0,28.45068,14.27148ZM5,27V14H9V27ZM26.91211,16.42871l-2.48,9.83106A1.00164,1.00164,0,0,1,23.4668,27H11V14h.12012c3.62353,0,6.61279-3.9541,6.96533-9H20a1.00956,1.00956,0,0,1,.75488.33984.94846.94846,0,0,1,.23828.751,14.34506,14.34506,0,0,1-2.65673,7.28809L17.0498,15h8.94874a.98782.98782,0,0,1,.81738.42383A1.05717,1.05717,0,0,1,26.91211,16.42871Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-like-f",
		"name": "ki-like-f",
		"tags": "ki-like-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.45,14.27A3.01889,3.01889,0,0,0,26,13H20.98a17.929,17.929,0,0,0,2-6.67A2.98979,2.98979,0,0,0,20,3H16.12V4c0,4.34-2.29,8-5,8H3V29H23.47a3.01075,3.01075,0,0,0,2.9-2.24l2.45-9.75A3.00577,3.00577,0,0,0,28.45,14.27Zm-1.54,2.15991L24.43,26.26a.99367.99367,0,0,1-.96.74H11V14h.12c3.62,0,6.61-3.94995,6.97-9H20a.98075.98075,0,0,1,.75.34.91532.91532,0,0,1,.24.75,14.39088,14.39088,0,0,1-2.65,7.29L17.05,15H26a.9872.9872,0,0,1,.82.41992A1.06627,1.06627,0,0,1,26.91,16.42993Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-link",
		"name": "ki-link",
		"tags": "ki-link",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11.05078,27.94629A6.99659,6.99659,0,0,1,6.10059,16l4.24218-4.24219,1.41407,1.41407L7.51465,17.41406a5.00016,5.00016,0,0,0,7.07129,7.07129l4.24219-4.24219,1.41406,1.41407L16,25.89941A6.97885,6.97885,0,0,1,11.05078,27.94629Z"
				},
				{
					"d": "M21.65723,20.24219l-1.41407-1.41407,4.24219-4.24218a5.00016,5.00016,0,1,0-7.07129-7.07129l-4.24218,4.24219-1.41407-1.41407L16,6.10059A6.99994,6.99994,0,0,1,25.89941,16Z"
				},
				{
					"d": "M8.99937 15.00011H23.00064V16.9999H8.99937z",
					"transform": "rotate(-45 16 16)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-link-broken",
		"name": "ki-link-broken",
		"tags": "ki-link-broken",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.071,18.82829l-1.41407-1.41407,2.82834-2.82833A5.00016,5.00016,0,0,0,17.41394,7.5146L14.5856,10.34293,13.17154,8.92887l2.82834-2.82833A6.99994,6.99994,0,0,1,25.89929,16Z"
				},
				{
					"d": "M11.05066,27.94624A6.99659,6.99659,0,0,1,6.10046,16L8.9289,13.17151,10.343,14.58557,7.51453,17.414a5.00016,5.00016,0,0,0,7.07129,7.07129l2.82843-2.82844,1.41407,1.41407-2.82844,2.82843A6.97885,6.97885,0,0,1,11.05066,27.94624Z"
				},
				{
					"d": "M17.53558 11.46449H21.53558V13.46449H17.53558z",
					"transform": "rotate(-45 19.53559 12.46448)"
				},
				{
					"d": "M10.46452 18.53555H14.46452V20.53555H10.46452z",
					"transform": "rotate(-45 12.46452 19.53556)"
				},
				{
					"d": "M15.00035 5.99986H17.00014V26.000140000000002H15.00035z",
					"transform": "rotate(-44.999 16.00024 16)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-linkedin",
		"name": "ki-linkedin",
		"tags": "ki-linkedin",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,5V26.99929a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H27A2,2,0,0,1,29,5ZM10.74922,12.732H6.84058V25.14917h3.90864Zm.29921-3.96409A2.25355,2.25355,0,1,0,8.7949,11.01147,2.21368,2.21368,0,0,0,11.04843,8.7679Zm14.111,8.71106c0-3.79279-2.35694-5.08653-4.538-5.08653a4.26419,4.26419,0,0,0-3.71522,2.06945h-.04981V12.74154h-3.759V25.15871H17.006V18.4265a2.37706,2.37706,0,0,1,2.29695-2.668c1.09714,0,1.94784.61707,1.94784,2.61807v6.78211h3.90864Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-linkout",
		"name": "ki-linkout",
		"tags": "ki-linkout",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.00045,28.99953h-23v-23a3,3,0,0,1,3-3h7v2h-7a1,1,0,0,0-1,1v21h21a1,1,0,0,0,1-1v-7h2v7A3,3,0,0,1,26.00045,28.99953Z"
				},
				{
					"d": "M17 3.004L17 5.004 25.582 5.004 15.293 15.292 16.708 16.707 27 6.414 27 15.004 29 15.004 29 3.004 17 3.004z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list",
		"name": "ki-list",
		"tags": "ki-list",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,7a.96064.96064,0,0,1-.90909,1H9V6H28.09091A.96064.96064,0,0,1,29,7Z"
				},
				{
					"d": "M29,16a.96064.96064,0,0,1-.90909,1H9V15H28.09091A.96064.96064,0,0,1,29,16Z"
				},
				{
					"d": "M29,25a.96064.96064,0,0,1-.90909,1H9V24H28.09091A.96064.96064,0,0,1,29,25Z"
				},
				{
					"d": "M3 24H5V26H3z"
				},
				{
					"d": "M3 15H5V17H3z"
				},
				{
					"d": "M3 6H5V8H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list-alt",
		"name": "ki-list-alt",
		"tags": "ki-list-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8,4H28a2,2,0,0,1,2,2V6a2,2,0,0,1-2,2H8A0,0,0,0,1,8,8V4A0,0,0,0,1,8,4Z"
				},
				{
					"d": "M2 4H6V8H2z"
				},
				{
					"d": "M2 14H6V18H2z"
				},
				{
					"d": "M2 24H6V28H2z"
				},
				{
					"d": "M8,14H28a2,2,0,0,1,2,2v0a2,2,0,0,1-2,2H8a0,0,0,0,1,0,0V14A0,0,0,0,1,8,14Z"
				},
				{
					"d": "M8,24H28a2,2,0,0,1,2,2v0a2,2,0,0,1-2,2H8a0,0,0,0,1,0,0V24A0,0,0,0,1,8,24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list-close",
		"name": "ki-list-close",
		"tags": "ki-list-close",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16 12.621L8.793 5.414 10.207 4 16 9.793 21.793 4 23.207 5.414 16 12.621z"
				},
				{
					"d": "M16 19.379L23.207 26.586 21.793 28 16 22.207 10.207 28 8.793 26.586 16 19.379z"
				},
				{
					"d": "M3 15H29V17H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list-expand",
		"name": "ki-list-expand",
		"tags": "ki-list-expand",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16 4L23.207 11.207 21.793 12.621 16 6.828 10.207 12.621 8.793 11.207 16 4z"
				},
				{
					"d": "M16 28L8.793 20.793 10.207 19.379 16 25.172 21.793 19.379 23.207 20.793 16 28z"
				},
				{
					"d": "M3 15H29V17H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list-ordered",
		"name": "ki-list-ordered",
		"tags": "ki-list-ordered",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,7H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M29,17H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M29,27H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M9 17L9 19 3 19 3 17 5 17 5 15 3 15 3 13 7 13 7 17 9 17z"
				},
				{
					"d": "M7 7L7 3 3 3 3 5 5 5 5 7 3 7 3 9 9 9 9 7 7 7z"
				},
				{
					"d": "M7 22L6 22 5 22 3 22 3 24 5 24 5 26 3 26 3 28 9 28 9 26 7 26 7 22z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-list-unordered",
		"name": "ki-list-unordered",
		"tags": "ki-list-unordered",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9,9H3V3H9ZM5,7H7V5H5Z"
				},
				{
					"d": "M29,7H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M29,17H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M29,27H13a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H29Z"
				},
				{
					"d": "M9,29H3V23H9ZM5,27H7V25H5Z"
				},
				{
					"d": "M9,19H3V13H9ZM5,17H7V15H5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-live-tv",
		"name": "ki-live-tv",
		"tags": "ki-live-tv",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12.00045,19.72316V8.2759l10.01563,5.72363Zm2-8V16.2759l3.98438-2.27637Z"
				},
				{
					"d": "M27.00049,3.99951h-22a3.00328,3.00328,0,0,0-3,3v14a3.00328,3.00328,0,0,0,3,3h10v2h-4a2,2,0,0,0-2,2h14a2.00006,2.00006,0,0,0-2-2h-4v-2h10a3.00328,3.00328,0,0,0,3-3v-14A3.00328,3.00328,0,0,0,27.00049,3.99951Zm1,17a1.00067,1.00067,0,0,1-1,1h-22a1.00067,1.00067,0,0,1-1-1v-14a1.00067,1.00067,0,0,1,1-1h22a1.00067,1.00067,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-live-tv-cross",
		"name": "ki-live-tv-cross",
		"tags": "ki-live-tv-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H7.2l2,2h17.8c.5,0,1,.4,1,1v14c0,.5-.5,1-1,1h-1.8l2,2c1.5-.1,2.8-1.4,2.8-3V7c0-1.7-1.4-3-3-3Z",
					"class": "kjcls-1"
				},
				{
					"d": "M27,4H7.2l2,2h17.8c.5,0,1,.4,1,1v14c0,.5-.5,1-1,1h-1.8l2,2c1.5-.1,2.8-1.4,2.8-3V7c0-1.7-1.4-3-3-3Z"
				},
				{
					"d": "M22,14.1l-3,1.7-1.5-1.5-5.5-5.6v-.4l10,5.7Z"
				},
				{
					"d": "M21.6,24l4.7,4.7,1.4-1.4-3.3-3.3-7.2-7.2-1.5-1.5-3.8-3.8-5.6-5.6-1.9-1.9-1.8-1.8-1.4,1.4,1.4,1.4c-.4.5-.7,1.2-.7,1.9v14c0,1.6,1.4,3,3,3h10v2h-4c-1.1,0-2,.9-2,2h14c0-1.1-.9-2-2-2h-4v-2h4.6ZM5,22c-.6,0-1-.5-1-1V7c0-.2,0-.3.1-.5l7.9,7.9v5.4l3.4-2,4.2,4.2H5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-live-tv-cross-f",
		"name": "ki-live-tv-cross-f",
		"tags": "ki-live-tv-cross-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,7v14c0,1.6-1.2,2.9-2.8,3l-8.2-8.2,3-1.7-10-5.7v.4l-4.8-4.8h19.8c1.6,0,3,1.3,3,3Z"
				},
				{
					"d": "M17,24v2h4c1.1,0,2,.9,2,2h-14c0-1.1.9-2,2-2h4v-2H5c-1.7,0-3-1.4-3-3V7c0-.7.3-1.4.7-1.9l-1.4-1.4,1.4-1.4,1.8,1.8,7.5,7.5v8.2l3.4-2,1.8-1,7.2,7.2,3.3,3.3-1.4,1.4-4.7-4.7s-4.6,0-4.6,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-live-tv-f",
		"name": "ki-live-tv-f",
		"tags": "ki-live-tv-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H5A3.00879,3.00879,0,0,0,2,7V21a3.00883,3.00883,0,0,0,3,3H15v2H11a1.99946,1.99946,0,0,0-2,2H23a1.99946,1.99946,0,0,0-2-2H17V24H27a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,27,4ZM13,18.01V9.99L19.99,14Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-location-arrow",
		"name": "ki-location-arrow",
		"tags": "ki-location-arrow",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.15723,30.3418l-5.16065-9.28614.64942-2.70117-2.70118.64942L1.6582,13.84277l27.106-10.60644Zm-3.03369-9.57715,2.71923,4.89355L25.23584,6.76367,6.3418,14.15723,11.23486,16.877,16.354,15.64551Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-location-arrow-f",
		"name": "ki-location-arrow-f",
		"tags": "ki-location-arrow-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.76 3.24L18.16 30.34 13 21.06 13.65 18.35 10.94 19 1.66 13.84 28.76 3.24z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-location-circle",
		"name": "ki-location-circle",
		"tags": "ki-location-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20.192 11.808L11 15.343 15.243 16.757 16.657 21 20.192 11.808z"
				},
				{
					"d": "M16,3A13,13,0,1,0,29,16,13.01505,13.01505,0,0,0,16,3Zm1,23.94934V25H15v1.94934A11.01139,11.01139,0,0,1,5.05066,17H7V15H5.05066A11.01139,11.01139,0,0,1,15,5.05066V7h2V5.05066A11.01139,11.01139,0,0,1,26.94934,15H25v2h1.94934A11.01139,11.01139,0,0,1,17,26.94934Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-location-circle-f",
		"name": "ki-location-circle-f",
		"tags": "ki-location-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,3A13,13,0,1,0,29,16,13.01243,13.01243,0,0,0,16,3ZM15,5h2V7H15ZM7,17H5V15H7ZM17,27H15V25h2Zm-.34-6-1.42-4.24L11,15.34l9.19-3.52991ZM25,17V15h2v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lock",
		"name": "ki-lock",
		"tags": "ki-lock",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.00049,11.99951v-3a7,7,0,0,0-14,0v3h-5v15a3.00328,3.00328,0,0,0,3,3h18a3.00328,3.00328,0,0,0,3-3v-15Zm-12-3a5,5,0,0,1,10,0v3h-10Zm15,18a1.00067,1.00067,0,0,1-1,1h-18a1.00067,1.00067,0,0,1-1-1v-13h20Z"
				},
				{
					"d": "M15.00045 16.99953H17.00045V24.99953H15.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lock-f",
		"name": "ki-lock-f",
		"tags": "ki-lock-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,12V9A7,7,0,0,0,9,9v3H4V27a3.00883,3.00883,0,0,0,3,3H25a3.00883,3.00883,0,0,0,3-3V12ZM17,25H15V17h2Zm4-13H11V9A5,5,0,0,1,21,9Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lock-unlock",
		"name": "ki-lock-unlock",
		"tags": "ki-lock-unlock",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11,12V9a5.00451,5.00451,0,0,1,9.59-2h2.12A7.001,7.001,0,0,0,9,9v3H4V27a3.00883,3.00883,0,0,0,3,3H25a3.00883,3.00883,0,0,0,3-3V12ZM26,27a1.003,1.003,0,0,1-1,1H7a1.003,1.003,0,0,1-1-1V14H26Z"
				},
				{
					"d": "M15.00045 16.99953H17.00045V24.99953H15.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-lock-unlock-f",
		"name": "ki-lock-unlock-f",
		"tags": "ki-lock-unlock-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11,12V9a5.00451,5.00451,0,0,1,9.59-2h2.12A7.001,7.001,0,0,0,9,9v3H4V27a3.00883,3.00883,0,0,0,3,3H25a3.00883,3.00883,0,0,0,3-3V12Zm6,13H15V17h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-low-priority",
		"name": "ki-low-priority",
		"tags": "ki-low-priority",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13,3H29a0,0,0,0,1,0,0V5a0,0,0,0,1,0,0H13a1,1,0,0,1-1-1V4A1,1,0,0,1,13,3Z"
				},
				{
					"d": "M16.57895,25H29a0,0,0,0,1,0,0v2a0,0,0,0,1,0,0H16.57895a1,1,0,0,1-1-1v0a1,1,0,0,1,1-1Z"
				},
				{
					"d": "M13,14H29a0,0,0,0,1,0,0v2a0,0,0,0,1,0,0H13a1,1,0,0,1-1-1v0A1,1,0,0,1,13,14Z"
				},
				{
					"d": "M8.707 21.293 7.293 22.707 9.586 25 5 25 5 5 10 5 10 3 3 3 3 27 9.586 27 7.293 29.293 8.707 30.707 13.414 26 8.707 21.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-magnify-check",
		"name": "ki-magnify-check",
		"tags": "ki-magnify-check",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.707,27.293l-6.25915-6.25928a11.01826,11.01826,0,1,0-1.41407,1.41406L27.293,28.707ZM5,14a9,9,0,1,1,9,9A9.00984,9.00984,0,0,1,5,14Z"
				},
				{
					"d": "M13 18.414 9.293 14.707 10.707 13.293 13 15.586 18.293 10.293 19.707 11.707 13 18.414z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail",
		"name": "ki-mail",
		"tags": "ki-mail",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2.00049,3.99951v21a3.00328,3.00328,0,0,0,3,3h22a3.00328,3.00328,0,0,0,3-3v-21Zm23.429,2-9.42895,8.64356L6.57141,5.99951Zm1.571,20h-22a1.00067,1.00067,0,0,1-1-1V6.35626l12,10.9997,12-10.9997V24.99951A1.00067,1.00067,0,0,1,27.00049,25.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail-f",
		"name": "ki-mail-f",
		"tags": "ki-mail-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,14.64,4.37,4H27.64C23.83,7.47,17.97,12.83,16,14.64Z"
				},
				{
					"d": "M30,4.55V25a3.00883,3.00883,0,0,1-3,3H5a3.00883,3.00883,0,0,1-3-3V4.54L16,17.36S16.35,17.04,30,4.55Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail-mark-read",
		"name": "ki-mail-mark-read",
		"tags": "ki-mail-mark-read",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.998,10.98511c-.00007-.00489.00164-.00952.00152-.01441a.97864.97864,0,0,0-.0202-.12463,1.01017,1.01017,0,0,0-.01978-.12219.98669.98669,0,0,0-.05572-.13208,1.0047,1.0047,0,0,0-.04785-.10645.99238.99238,0,0,0-.09021-.11572.98116.98116,0,0,0-.07166-.088,1.02363,1.02363,0,0,0-.12634-.09473.99728.99728,0,0,0-.08-.05994l-.00634-.00244-.00733-.00537-13-7a1.00661,1.00661,0,0,0-.94824,0l-13,7-.00733.00537-.00634.00244a.99728.99728,0,0,0-.08.05994,1.02363,1.02363,0,0,0-.12634.09473.98116.98116,0,0,0-.07166.088.99238.99238,0,0,0-.09021.11572,1.0047,1.0047,0,0,0-.04785.10645.98669.98669,0,0,0-.05572.13208,1.01017,1.01017,0,0,0-.01978.12219.97864.97864,0,0,0-.0202.12463c-.00012.00489.00159.00952.00152.01441L2,11V25a3.00328,3.00328,0,0,0,3,3H27a3.00328,3.00328,0,0,0,3-3V11ZM16,5.13574l10.998,5.92188L16,17.82617,5.002,11.05762ZM28,25a1.001,1.001,0,0,1-1,1H5a1.001,1.001,0,0,1-1-1V12.79l11.47607,7.06152a.99884.99884,0,0,0,1.04786,0L28,12.79Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail-mark-read-f",
		"name": "ki-mail-mark-read-f",
		"tags": "ki-mail-mark-read-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.96,10.73a.84854.84854,0,0,0-.09-.22.8313.8313,0,0,0-.13-.18.28436.28436,0,0,0-.1-.09.63836.63836,0,0,0-.13-.1.03677.03677,0,0,0-.03-.01.0098.0098,0,0,0-.01-.01l-13-7a.98008.98008,0,0,0-.93994,0l-13,7a.0098.0098,0,0,0-.01.01.03677.03677,0,0,0-.03.01.52621.52621,0,0,0-.12.1.31347.31347,0,0,0-.11.09.8313.8313,0,0,0-.13.18A1.06006,1.06006,0,0,0,2,11V25a3.00887,3.00887,0,0,0,3,3H27a3.00887,3.00887,0,0,0,3-3V11A.84318.84318,0,0,0,29.96,10.73ZM16,5.14,26.89,11,16,16.86,5.11,11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail-mark-unread",
		"name": "ki-mail-mark-unread",
		"tags": "ki-mail-mark-unread",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,13.07715H25v-1.6709a1.00047,1.00047,0,0,0-.46436-.84473l-10.51513-6.415a.998.998,0,0,0-1.041,0L2.56445,10.498l-.10009.06347A1.00047,1.00047,0,0,0,2,11.40625V22a3.00328,3.00328,0,0,0,3,3H6a3.00328,3.00328,0,0,0,3,3H26a3.00328,3.00328,0,0,0,3-3V13.07715Zm-2.93994,2L17.5,20.89258,9.93994,15.07715ZM5,23a1.001,1.001,0,0,1-1-1V11.96484L13.5,6.1709,23,11.96484v1.11231H6V23Zm21,3H9a1.001,1.001,0,0,1-1-1V16.10852l8.89014,6.83875a1.00176,1.00176,0,0,0,1.21972,0L27,16.10852V25A1.001,1.001,0,0,1,26,26Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mail-mark-unread-f",
		"name": "ki-mail-mark-unread-f",
		"tags": "ki-mail-mark-unread-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,13.08v-1.67a1.026,1.026,0,0,0-.46-.84985L14.02,4.1499a.97661.97661,0,0,0-1.04,0L2.56,10.5l-.1.06006a1.026,1.026,0,0,0-.46.84985V22a3.00887,3.00887,0,0,0,3,3H6a3.00887,3.00887,0,0,0,3,3H26a3.00887,3.00887,0,0,0,3-3V13.08Zm.06,2L17.5,20.89,9.94,15.08ZM27,25a1.00291,1.00291,0,0,1-1,1H9a1.00291,1.00291,0,0,1-1-1V16.11l8.89,6.84a1.03043,1.03043,0,0,0,1.22,0L27,16.11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-maintenance",
		"name": "ki-maintenance",
		"tags": "ki-maintenance",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.311,6.9707,27.69678,5.709,23.41162,9.99414,22.00537,8.58887l4.28418-4.28418-1.25976-.61426A6.84676,6.84676,0,0,0,22.00146,2.999a7.0085,7.0085,0,0,0-7,7,6.90252,6.90252,0,0,0,.40955,2.356L3.88818,23.877a2.99419,2.99419,0,1,0,4.23047,4.23828L19.64508,16.58887a6.8861,6.8861,0,0,0,2.35638.41015,7.00848,7.00848,0,0,0,7-7A6.86235,6.86235,0,0,0,28.311,6.9707ZM6.69971,26.70605a.99031.99031,0,0,1-1.40625-.00976.97308.97308,0,0,1,.00488-1.40039L16.40186,14.19238a7.01747,7.01747,0,0,0,.61993.71411c.02447.02478.04889.04908.07373.07349a7.10506,7.10506,0,0,0,.71161.61768ZM22.00146,14.999a4.87846,4.87846,0,0,1-2.15722-.49218,5.03413,5.03413,0,0,1-2.35309-2.35474l-.00092-.002A4.86575,4.86575,0,0,1,17.00146,9.999a5.00589,5.00589,0,0,1,5-5,5.09447,5.09447,0,0,1,.71583.04981l-3.54,3.54,4.23437,4.2334,3.54-3.54a5.1185,5.1185,0,0,1,.0498.71679A5.00588,5.00588,0,0,1,22.00146,14.999Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-maintenance-f",
		"name": "ki-maintenance-f",
		"tags": "ki-maintenance-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,10a7.0077,7.0077,0,0,1-7,7,6.83212,6.83212,0,0,1-2.35-.41L8.12,28.12a2.98172,2.98172,0,0,1-4.24-.01,2.96975,2.96975,0,0,1,.01-4.23L15.41,12.35A6.83325,6.83325,0,0,1,15,10a7.0077,7.0077,0,0,1,7-7,6.83289,6.83289,0,0,1,3.03.68994L26.29,4.30005,22.01,8.59l1.4,1.4L27.7,5.71l.61,1.26A6.83175,6.83175,0,0,1,29,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-map",
		"name": "ki-map",
		"tags": "ki-map",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.52539,3.14966a.99786.99786,0,0,0-.97266-.04395L20,6.88208,12.44727,3.10571c-.0246-.0122-.0514-.0166-.07666-.02661a.97984.97984,0,0,0-.12708-.04394,1.02242,1.02242,0,0,0-.11169-.01929.99435.99435,0,0,0-.13446-.011.97731.97731,0,0,0-.12214.01.9883.9883,0,0,0-.12207.02088.9761.9761,0,0,0-.12274.04284c-.02563.01026-.05273.01465-.0777.0271l-8,4A1.00041,1.00041,0,0,0,3,8.00024V28a1.00021,1.00021,0,0,0,1.44727.89453L12,25.11816l7.55273,3.77637c.01471.00733.03156.0044.04645.011a.89746.89746,0,0,0,.80164,0c.01489-.00659.03174-.00366.04645-.011l8-4A1.0004,1.0004,0,0,0,29,24V4.00024A1.00036,1.00036,0,0,0,28.52539,3.14966ZM11,23.38184l-6,3V8.61841l6-3Zm8,3-6-3V5.61841l6,3Zm8-3-6,3V8.61841l6-3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-map-f",
		"name": "ki-map-f",
		"tags": "ki-map-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.53,3.1499A1.00671,1.00671,0,0,0,27.55,3.11L20,6.88,12.45,3.11a.26138.26138,0,0,0-.08-.03A.49917.49917,0,0,0,12.24,3.04a.359.359,0,0,0-.11-.02A.58463.58463,0,0,0,12,3c-.04,0-.08.01-.12.01-.05.01-.09.02-.13.03a.56966.56966,0,0,0-.12.03992.26138.26138,0,0,0-.08.03l-8,4A.98806.98806,0,0,0,3,8V28a.99884.99884,0,0,0,.47.85A1.01421,1.01421,0,0,0,4,29a1.03026,1.03026,0,0,0,.45-.11L12,25.12l7.55,3.77c.02.00989.03.00989.05.0199a.93313.93313,0,0,0,.8,0c.02-.01.03-.01.05-.0199l8-4A.98806.98806,0,0,0,29,24V4A.99889.99889,0,0,0,28.53,3.1499ZM11,23.38l-6,3V8.62l6-3Zm16,0-6,3V8.62l6-3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-map-point",
		"name": "ki-map-point",
		"tags": "ki-map-point",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,18.99953a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,18.99953Zm0-10a4,4,0,1,0,4,4A4.00427,4.00427,0,0,0,16,8.99953Z"
				},
				{
					"d": "M16,30.2798l-.62451-.499C14.95166,29.44191,5,21.38332,5,12.99953a11,11,0,0,1,22,0c0,8.38379-9.95166,16.44238-10.37549,16.78125ZM16,3.99953a9.01016,9.01016,0,0,0-9,9C7,19.29836,13.86523,25.814,16,27.687c2.13477-1.873,9-8.38867,9-14.6875A9.01016,9.01016,0,0,0,16,3.99953Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-map-point-f",
		"name": "ki-map-point-f",
		"tags": "ki-map-point-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A11.00656,11.00656,0,0,0,5,13c0,8.38,9.95,16.44,10.38,16.78l.62.5.62-.5C17.05,29.44,27,21.38,27,13A11.00656,11.00656,0,0,0,16,2Zm0,16a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,18Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-menu",
		"name": "ki-menu",
		"tags": "ki-menu",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.00045,7.99953h-25v-2h25a1,1,0,0,1,1,1h0A1,1,0,0,1,28.00045,7.99953Z"
				},
				{
					"d": "M28.00045,16.99953h-25v-2h25a1,1,0,0,1,1,1h0A1,1,0,0,1,28.00045,16.99953Z"
				},
				{
					"d": "M28.00045,25.99953h-25v-2h25a1,1,0,0,1,1,1h0A1,1,0,0,1,28.00045,25.99953Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-menu-dots",
		"name": "ki-menu-dots",
		"tags": "ki-menu-dots",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "5",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "27",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "16",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-menu-dots-vertical",
		"name": "ki-menu-dots-vertical",
		"tags": "ki-menu-dots-vertical",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "5",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "27",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "16",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-metro",
		"name": "ki-metro",
		"tags": "ki-metro",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,2H7A3.00328,3.00328,0,0,0,4,5V23a3.00328,3.00328,0,0,0,3,3H8.63226L6.41,30H8.7l2.21729-4H21.0827L23.3,30h2.29l-2.22229-4H25a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,25,2ZM7,4H25a1.00067,1.00067,0,0,1,1,1V6H6V5A1.00067,1.00067,0,0,1,7,4ZM22,8v8H17V8ZM15,8v8H10V8ZM25,24H7a1.00067,1.00067,0,0,1-1-1V8H8V18H24V8h2V23A1.00067,1.00067,0,0,1,25,24Z"
				},
				{
					"d": "M9 20H13V22H9z"
				},
				{
					"d": "M19 20H23V22H19z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-microphone",
		"name": "ki-microphone",
		"tags": "ki-microphone",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00045,18.99953c-4.83594,0-7-3.01367-7-6v-8a3.00328,3.00328,0,0,1,3-3h8a3.00328,3.00328,0,0,1,3,3v8C23.00045,15.98586,20.83639,18.99953,16.00045,18.99953Zm-4-15a1.00067,1.00067,0,0,0-1,1v8c0,2.50488,1.86914,4,5,4s5-1.49512,5-4v-8a1.00067,1.00067,0,0,0-1-1Z"
				},
				{
					"d": "M28.00049,13.99951h-2c0,4.41113-4.48633,8-10,8s-10-3.58887-10-8h-2c0,5.23242,4.8501,9.53192,11,9.95777v4.04223h-3a2,2,0,0,0-2,2h12a2.00006,2.00006,0,0,0-2-2h-3V23.95728C23.15039,23.53143,28.00049,19.23193,28.00049,13.99951Z"
				},
				{
					"d": "M13.00045 6.99953H19.00045V8.99953H13.00045z"
				},
				{
					"d": "M13.00045 10.99953H19.00045V12.99953H13.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-microphone-f",
		"name": "ki-microphone-f",
		"tags": "ki-microphone-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,2H12A3.00879,3.00879,0,0,0,9,5v8c0,2.99,2.16,6,7,6s7-3.01,7-6V5A3.00879,3.00879,0,0,0,20,2ZM19,13H13V11h6Zm0-4H13V7h6Z"
				},
				{
					"d": "M28.00049,13.99951h-2c0,4.41113-4.48633,8-10,8s-10-3.58887-10-8h-2c0,5.23242,4.8501,9.53192,11,9.95777v4.04223h-3a2,2,0,0,0-2,2h12a2.00006,2.00006,0,0,0-2-2h-3V23.95728C23.15039,23.53143,28.00049,19.23193,28.00049,13.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minimize",
		"name": "ki-minimize",
		"tags": "ki-minimize",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2 26H30V28H2z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minus",
		"name": "ki-minus",
		"tags": "ki-minus",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4 15H28V17H4z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minus-alt",
		"name": "ki-minus-alt",
		"tags": "ki-minus-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2 14H30V18H2z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minus-circle",
		"name": "ki-minus-circle",
		"tags": "ki-minus-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M9 15H23V17H9z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minus-circle-alt",
		"name": "ki-minus-circle-alt",
		"tags": "ki-minus-circle-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.00253,14.00253,0,0,0,16,2ZM5,18V14H27v4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-minus-circle-f",
		"name": "ki-minus-circle-f",
		"tags": "ki-minus-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm7,15H9V15H23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mobile",
		"name": "ki-mobile",
		"tags": "ki-mobile",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,2H10A3.00328,3.00328,0,0,0,7,5V27a3.00328,3.00328,0,0,0,3,3H22a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,22,2ZM10,4H22a1.001,1.001,0,0,1,1,1V6H9V5A1.001,1.001,0,0,1,10,4ZM23,8V24H9V8ZM22,28H10a1.001,1.001,0,0,1-1-1V26H23v1A1.001,1.001,0,0,1,22,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-mobile-f",
		"name": "ki-mobile-f",
		"tags": "ki-mobile-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,2H10A3.00879,3.00879,0,0,0,7,5V27a3.00883,3.00883,0,0,0,3,3H22a3.00883,3.00883,0,0,0,3-3V5A3.00879,3.00879,0,0,0,22,2Zm1,25a1.003,1.003,0,0,1-1,1H10a1.003,1.003,0,0,1-1-1V26H23ZM23,6H9V5a1.003,1.003,0,0,1,1-1H22a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem",
		"name": "ki-modem",
		"tags": "ki-modem",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,28h2v2H9V28h2V5a3.00328,3.00328,0,0,1,3-3h4a3.00328,3.00328,0,0,1,3,3Zm-8,0h6V5a1.00067,1.00067,0,0,0-1-1H14a1.00067,1.00067,0,0,0-1,1Z"
				},
				{
					"d": "M15 9H17V11H15z"
				},
				{
					"d": "M15 13H17V15H15z"
				},
				{
					"d": "M15 17H17V19H15z"
				},
				{
					"d": "M15 21H17V23H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem-d3-1-scs",
		"name": "ki-modem-d3-1-scs",
		"tags": "ki-modem-d3-1-scs",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.03516,27.96445c-2.28174,0-5.58301-.19922-7.06445-.42676-1.68896-.25781-2.69775-.70215-4.15137-1.82812-1.79541-1.39062-2.78418-4.85059-2.78418-9.74512,0-4.57031.75586-7.48047,2.37842-9.1582,1.37646-1.4248,3.06982-1.94434,4.69434-2.29297,2.22266-.47754,5.29395-.54883,6.92725-.54883s4.70459.07129,6.92725.54883c1.62451.34863,3.31787.86816,4.69482,2.29395,1.62207,1.67676,2.37793,4.58691,2.37793,9.15723,0,4.89453-.98877,8.35449-2.78418,9.74512-1.45361,1.12598-2.4624,1.57031-4.15186,1.82812-1.48096.22754-4.78223.42676-7.06396.42676ZM16.03516,5.96445c-1.55371,0-4.46533.06543-6.50732.50391-1.52002.32617-2.72705.74512-3.67627,1.72754-1.22266,1.26367-1.81641,3.80469-1.81641,7.76855,0,4.87207,1.0376,7.41211,2.00879,8.16309,1.18604.91895,1.88037,1.22656,3.22998,1.43359,1.37646.21094,4.59912.40332,6.76123.40332s5.38477-.19238,6.76074-.40332c1.3501-.20703,2.04443-.51465,3.23047-1.43359.97119-.75098,2.00879-3.29102,2.00879-8.16309,0-3.96387-.59375-6.50488-1.81592-7.76758l-.00049-.00098c-.94922-.98242-2.15625-1.40137-3.67627-1.72754-2.04199-.43848-4.95361-.50391-6.50732-.50391Z"
				},
				{
					"d": "M14.03516 8.96445H18.03516V10.96445H14.03516z"
				},
				{
					"d": "M10.03516 8.96445H12.03516V10.96445H10.03516z"
				},
				{
					"d": "M20.03516 8.96445H22.03516V10.96445H20.03516z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem-d3-1-scs-f",
		"name": "ki-modem-d3-1-scs-f",
		"tags": "ki-modem-d3-1-scs-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.65997,6.80929c-1.37994-1.42999-3.06995-1.95001-4.69995-2.30005-2.22003-.46997-5.29004-.53998-6.92004-.53998-1.63995,0-4.70996.07001-6.92999.53998-1.63.35004-3.32001.87006-4.70001,2.30005-1.62,1.66998-2.37,4.57996-2.37,9.15997,0,4.89001.98004,8.35004,2.78003,9.73999,1.45001,1.13,2.46002,1.57001,4.14996,1.83002,1.48004.22998,4.78003.42999,7.07001.42999,2.28003,0,5.58002-.20001,7.06-.42999,1.69-.26001,2.70001-.70001,4.15002-1.83002,1.79999-1.38995,2.78998-4.84998,2.78998-9.73999,0-4.58002-.75995-7.48999-2.38-9.15997ZM12.03998,10.96927h-2v-2h2v2ZM18.03998,10.96927h-4v-2h4v2ZM22.03998,10.96927h-2v-2h2v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem-f",
		"name": "ki-modem-f",
		"tags": "ki-modem-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,28V5a3.00328,3.00328,0,0,0-3-3H14a3.00328,3.00328,0,0,0-3,3V28H9v2H23V28Zm-4-5H15V21h2Zm0-4H15V17h2Zm0-4H15V13h2Zm0-4H15V9h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem-s-onu",
		"name": "ki-modem-s-onu",
		"tags": "ki-modem-s-onu",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.69189,26.96445H7.23779c-2.35596,0-4.27295-1.79395-4.27295-4V6.96445c0-1.10254.89697-2,2-2h22c1.10303,0,2,.89746,2,2v16c0,2.20605-1.91699,4-4.27295,4ZM4.96484,6.96445v16c0,1.10254,1.01953,2,2.27295,2h17.4541c1.25342,0,2.27295-.89746,2.27295-2V6.96445H4.96484Z"
				},
				{
					"d": "M6.96484 8.96445H8.96484V13.96445H6.96484z"
				},
				{
					"d": "M6.96484 15.96445H8.96484V17.96445H6.96484z"
				},
				{
					"d": "M6.96484 19.96445H8.96484V21.96445H6.96484z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-modem-s-onu-f",
		"name": "ki-modem-s-onu-f",
		"tags": "ki-modem-s-onu-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.03998,4.96927H5.03998c-1.10999,0-2,.89001-2,2v16c0,2.20001,1.91003,4,4.27002,4h17.45001c2.35999,0,4.27997-1.79999,4.27997-4V6.96927c0-1.10999-.89996-2-2-2ZM9.03998,21.96927h-2v-2h2v2ZM9.03998,17.96927h-2v-2h2v2ZM9.03998,13.96927h-2v-5h2v5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-moon-waning-gibbous",
		"name": "ki-moon-waning-gibbous",
		"tags": "ki-moon-waning-gibbous",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,3c-7.17969,0-13,5.82031-13,13s5.82031,13,13,13,13-5.82031,13-13S23.17969,3,16,3ZM5,16c0-5.96283,4.77197-10.82159,10.69604-10.98462,1.08472,.82361,5.30396,4.44733,5.30396,10.98462,0,6.40204-3.33063,10.01691-4.34192,10.9668-.21869,.01367-.43591,.0332-.65808,.0332-6.06543,0-11-4.93457-11-11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-moonrise",
		"name": "ki-moonrise",
		"tags": "ki-moonrise",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.9165,15c-.49951-4.49341-4.31696-8-8.94104-8S7.53394,10.50659,7.03442,15H3.97546v2H27.97546v-2h-3.05896Zm-15.86975,0c.48682-3.3877,3.4082-6,6.92871-6s6.44189,2.6123,6.92871,6H9.04675Z"
				},
				{
					"d": "M11.26843 24.29297 12.6825 25.70703 14.97546 23.41406 14.97546 30 16.97546 30 16.97546 23.41406 19.26843 25.70703 20.6825 24.29297 15.97546 19.58594 11.26843 24.29297z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-moonrise-f",
		"name": "ki-moonrise-f",
		"tags": "ki-moonrise-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m28,15v2H4v-2h3.06c.5-4.48999,4.32001-8,8.94-8s8.44,3.51001,8.94,8h3.06Z"
				},
				{
					"d": "M11.29297 24.29297 12.70703 25.70703 15 23.41406 15 30 17 30 17 23.41406 19.29297 25.70703 20.70703 24.29297 16 19.58594 11.29297 24.29297z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-moonset",
		"name": "ki-moonset",
		"tags": "ki-moonset",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.26843 23.29297 16.97546 25.58594 16.97546 19 14.97546 19 14.97546 25.58594 12.6825 23.29297 11.26843 24.70703 15.97546 29.41406 20.6825 24.70703 19.26843 23.29297z"
				},
				{
					"d": "M24.9165,15c-.49951-4.49341-4.31696-8-8.94104-8S7.53394,10.50659,7.03442,15H3.97546v2H27.97546v-2h-3.05896Zm-15.86975,0c.48682-3.3877,3.4082-6,6.92871-6s6.44189,2.6123,6.92871,6H9.04675Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-moonset-f",
		"name": "ki-moonset-f",
		"tags": "ki-moonset-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.29297 23.29297 17 25.58594 17 19 15 19 15 25.58594 12.70703 23.29297 11.29297 24.70703 16 29.41406 20.70703 24.70703 19.29297 23.29297z"
				},
				{
					"d": "m28,14.9993v2H4v-2h3.06c.5-4.49005,4.32001-8,8.94-8s8.44,3.50995,8.94,8h3.06Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-more-horz",
		"name": "ki-more-horz",
		"tags": "ki-more-horz",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "5",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "27",
					"cy": "16",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "16",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-more-vert",
		"name": "ki-more-vert",
		"tags": "ki-more-vert",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "5",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "27",
					"r": "3"
				},
				{
					"cx": "16",
					"cy": "16",
					"r": "3"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-move",
		"name": "ki-move",
		"tags": "ki-move",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.293 11.293L22.879 12.707 25.172 15 17 15 17 6.768 19.293 9.061 20.707 7.646 16 2.939 11.293 7.646 12.707 9.061 15 6.768 15 15 6.828 15 9.121 12.707 7.707 11.293 3 16 7.707 20.707 9.121 19.293 6.828 17 15 17 15 25.172 12.707 22.879 11.293 24.293 16 29 20.707 24.293 19.293 22.879 17 25.172 17 17 25.172 17 22.879 19.293 24.293 20.707 29 16 24.293 11.293z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-move-to",
		"name": "ki-move-to",
		"tags": "ki-move-to",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,8H17.24a.99167.99167,0,0,1-.9-.55l-.89-1.79A2.99188,2.99188,0,0,0,12.76,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00887,3.00887,0,0,0,3-3V11A3.00879,3.00879,0,0,0,27,8Zm1,17a1.00291,1.00291,0,0,1-1,1H4V7A1.00291,1.00291,0,0,1,5,6h7.76a.99167.99167,0,0,1,.9.55L14.55,8.34A2.99177,2.99177,0,0,0,17.24,10H27a1.00291,1.00291,0,0,1,1,1Z"
				},
				{
					"d": "M20 13L18.586 14.414 21.172 17 7 17 7 19 21.172 19 18.586 21.586 20 23 25 18 20 13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-multidwelling-wifi-6e",
		"name": "ki-multidwelling-wifi-6e",
		"tags": "ki-multidwelling-wifi-6e",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.88623,7.94922c-2.10468-.83264-5.07513-.85999-9.88623-.8609v-.00043c-.13824,0-.26752.00006-.4021.00006-.02936,0-.05475-.00006-.08423-.00006v.00012c-4.80664.00092-7.29358.02795-9.3999.86121-2.69141,1.06445-4.11377,3.84863-4.11377,8.05078s1.42236,6.98633,4.11377,8.05078c2.10468.83264,5.07513.85999,9.88623.8609v.00043c.13824,0,.26752-.00006.4021-.00006.02936,0,.05475.00006.08423.00006v-.00012c4.80664-.00092,7.29358-.02795,9.3999-.86121,2.69141-1.06445,4.11377-3.84863,4.11377-8.05078s-1.42236-6.98633-4.11377-8.05078ZM25.15088,22.19141c-1.77301.70105-4.14557.72009-8.76361.72064-4.81104-.00006-7.72839-.00507-9.53815-.72064-2.35498-.93164-2.84912-3.88086-2.84912-6.19141s.49414-5.25977,2.84912-6.19141c1.77301-.70105,4.14557-.72009,8.76361-.72064,4.81104.00006,7.72839.00507,9.53815.72064,2.35498.93164,2.84912,3.88086,2.84912,6.19141s-.49414,5.25977-2.84912,6.19141Z"
				},
				{
					"d": "M13 19H19V21H13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-multidwelling-wifi-6e-f",
		"name": "ki-multidwelling-wifi-6e-f",
		"tags": "ki-multidwelling-wifi-6e-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.89001,7.85999c-2.10999-.83002-5.07001-.85999-9.89001-.85999h-.48999c-4.81,0-7.29004.02997-9.40002.85999-2.69,1.07001-4.10999,3.84998-4.10999,8.04999s1.41998,6.98999,4.10999,8.04999c2.10999.84003,5.07001.86005,9.89001.86005h.48999c4.81,0,7.29004-.02002,9.40002-.86005,2.69-1.06,4.10999-3.84998,4.10999-8.04999s-1.41998-6.97998-4.10999-8.04999ZM19,20.90997h-6v-2h6v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-music",
		"name": "ki-music",
		"tags": "ki-music",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9,5.10449V21H7a4,4,0,1,0,4,4V11.895l16-1.77734V21H25a4,4,0,1,0,4,4V2.88281ZM9,25a2,2,0,1,1-2-2H9Zm18,0a2,2,0,1,1-2-2h2ZM11,9.88281V6.89551L27,5.11719v2.9873Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-name-badge",
		"name": "ki-name-badge",
		"tags": "ki-name-badge",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,5H5A3.00328,3.00328,0,0,0,2,8V27H27a3.00328,3.00328,0,0,0,3-3V8A3.00328,3.00328,0,0,0,27,5Zm1,19a1.001,1.001,0,0,1-1,1H4V8A1.001,1.001,0,0,1,5,7H27a1.001,1.001,0,0,1,1,1Z"
				},
				{
					"d": "M21.96027,15.666a4.00007,4.00007,0,1,0-5.92054,0A7.0029,7.0029,0,0,0,12,22v1h2V22a5,5,0,0,1,10,0v1h2V22A7.0029,7.0029,0,0,0,21.96027,15.666ZM17,13a2,2,0,1,1,2,2A2.00229,2.00229,0,0,1,17,13Z"
				},
				{
					"d": "M6 9H13V11H6z"
				},
				{
					"d": "M6 13H11V15H6z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-network",
		"name": "ki-network",
		"tags": "ki-network",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19,19v4H10a3,3,0,0,1,0-6H22A5,5,0,0,0,22,7H13V3H3V13H13V9h9a3,3,0,0,1,0,6H10a5,5,0,0,0,0,10h9v4H29V19Zm-8-8H5V5h6ZM27,27H21V21h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-network-alt",
		"name": "ki-network-alt",
		"tags": "ki-network-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,19V15H17V13h4V3H11V13h4v2H7v4H3V29H13V19H9V17H23v2H19V29H29V19ZM13,5h6v6H13ZM11,27H5V21h6Zm16,0H21V21h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-network-alt-f",
		"name": "ki-network-alt-f",
		"tags": "ki-network-alt-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29 19 29 29 19 29 19 19 23 19 23 17 9 17 9 19 13 19 13 29 3 29 3 19 7 19 7 15 15 15 15 13 11 13 11 3 21 3 21 13 17 13 17 15 25 15 25 19 29 19z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-network-f",
		"name": "ki-network-f",
		"tags": "ki-network-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m29,19v10h-10v-4h-9c-2.76001,0-5-2.23999-5-5s2.23999-5,5-5h12c1.65002,0,3-1.35004,3-3s-1.34998-3-3-3h-9v4H3V3h10v4h9c2.76001,0,5,2.23999,5,5s-2.23999,5-5,5h-12c-1.65002,0-3,1.34998-3,3s1.34998,3,3,3h9v-4h10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notes",
		"name": "ki-notes",
		"tags": "ki-notes",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.20045,7.99953H13v-2H28.20045a.91692.91692,0,0,1,.8,1h0A.91693.91693,0,0,1,28.20045,7.99953Z"
				},
				{
					"d": "M28.00045,16.99953H9v-2H28.00045a1,1,0,0,1,1,1h0A1,1,0,0,1,28.00045,16.99953Z"
				},
				{
					"d": "M3 6H11V8H3z"
				},
				{
					"d": "M3 15H7V17H3z"
				},
				{
					"d": "M28.20045,25.99953H13v-2H28.20045a.91692.91692,0,0,1,.8,1h0A.91693.91693,0,0,1,28.20045,25.99953Z"
				},
				{
					"d": "M3 24H11V26H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification",
		"name": "ki-notification",
		"tags": "ki-notification",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.83008a2.98356,2.98356,0,0,0-.87988-2.124L26.293,16.87891a1.00687,1.00687,0,0,1-.293-.707V13a10.0337,10.0337,0,0,0-3.16309-7.29688,9.92928,9.92928,0,0,0-7.501-2.68164A10.18251,10.18251,0,0,0,6,13.30957v2.86231a1.00687,1.00687,0,0,1-.293.707L3.87988,18.70605A2.98348,2.98348,0,0,0,3,20.83008V24h9.14337a4.00047,4.00047,0,1,0,7.71332,0H29ZM18,25a2,2,0,0,1-4,0,1.97188,1.97188,0,0,1,.27051-1h3.459A1.97188,1.97188,0,0,1,18,25Zm9-3H5V20.83008a.99712.99712,0,0,1,.29395-.71L7.12109,18.293A2.98156,2.98156,0,0,0,8,16.17188V13.30957a8.17859,8.17859,0,0,1,7.46484-8.292A8.00068,8.00068,0,0,1,24,13v3.17188a2.98147,2.98147,0,0,0,.87891,2.12109l1.82714,1.82715a.99712.99712,0,0,1,.29395.71Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification-f",
		"name": "ki-notification-f",
		"tags": "ki-notification-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.83a2.95593,2.95593,0,0,0-.88-2.12l-1.83-1.83a1.05185,1.05185,0,0,1-.29-.71008V13a10.05781,10.05781,0,0,0-3.16-7.3A9.9388,9.9388,0,0,0,15.34,3.02,10.1848,10.1848,0,0,0,6,13.31006v2.85986a1.05185,1.05185,0,0,1-.29.71008L3.88,18.71A2.95593,2.95593,0,0,0,3,20.83V24h9.14A4.22966,4.22966,0,0,0,12,25a4,4,0,0,0,8,0,4.22966,4.22966,0,0,0-.14-1H29ZM16,27a2.00591,2.00591,0,0,1-2-2,1.94943,1.94943,0,0,1,.27-1h3.46A1.94943,1.94943,0,0,1,18,25,2.00591,2.00591,0,0,1,16,27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification-read",
		"name": "ki-notification-read",
		"tags": "ki-notification-read",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.83044a2.95565,2.95565,0,0,0-.88-2.11987l-1.83-1.82985a1.05178,1.05178,0,0,1-.29-.71V13.65081a5.80068,5.80068,0,0,1-2,.35007v2.1698a2.95572,2.95572,0,0,0,.88,2.12l1.83,1.82985a.98985.98985,0,0,1,.29.70992v1.17H5v-1.17a.98985.98985,0,0,1,.29-.70992l1.83-1.82985a2.95572,2.95572,0,0,0,.88-2.12V13.311a8.17539,8.17539,0,0,1,7.46-8.28955,7.94575,7.94575,0,0,1,3.12.40989,6.11247,6.11247,0,0,1,1.2-1.68984,9.92068,9.92068,0,0,0-4.44-.71993A10.18443,10.18443,0,0,0,6,13.311v2.8597a1.05178,1.05178,0,0,1-.29.71L3.88,18.71057A2.95565,2.95565,0,0,0,3,20.83044v3.16985h9.14337a4.00043,4.00043,0,1,0,7.71338,0H29Zm-11,4.1698a2,2,0,0,1-4,0,1.9717,1.9717,0,0,1,.27051-1h3.459A1.97885,1.97885,0,0,1,18,25.00024Z"
				},
				{
					"d": "M23.94,12.001H24a3.99977,3.99977,0,1,0,0-7.99953,3.93691,3.93691,0,0,0-2.33.76,3.72051,3.72051,0,0,0-1.28,1.55A3.84844,3.84844,0,0,0,20,8.00124,3.99937,3.99937,0,0,0,23.94,12.001ZM22.18585,7.19159l.0166-.03381.01532-.03442a1.75839,1.75839,0,0,1,.62848-.74446A1.92484,1.92484,0,0,1,24,6.00136a1.9999,1.9999,0,1,1,0,3.99976l-.03241.00024A2.00574,2.00574,0,0,1,22,8.00124,1.84908,1.84908,0,0,1,22.18585,7.19159Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification-read-f",
		"name": "ki-notification-read-f",
		"tags": "ki-notification-read-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.94,12.001H24a3.99977,3.99977,0,1,0,0-7.99953,3.93691,3.93691,0,0,0-2.33.76,3.72051,3.72051,0,0,0-1.28,1.55A3.84844,3.84844,0,0,0,20,8.00124,3.99937,3.99937,0,0,0,23.94,12.001ZM22.18585,7.19159l.0166-.03381.01532-.03442a1.75839,1.75839,0,0,1,.62848-.74446A1.92484,1.92484,0,0,1,24,6.00136a1.9999,1.9999,0,1,1,0,3.99976l-.03241.00024A2.00574,2.00574,0,0,1,22,8.00124,1.84908,1.84908,0,0,1,22.18585,7.19159Z"
				},
				{
					"d": "M29,20.83044a2.95565,2.95565,0,0,0-.88-2.11987l-1.83-1.82985a1.05178,1.05178,0,0,1-.29-.71V13.67083a5.27672,5.27672,0,0,1-.97.24,5.88228,5.88228,0,0,1-1.03.09008h-.09A5.99245,5.99245,0,0,1,18,8.00124a5.67162,5.67162,0,0,1,.59-2.52988,4.65672,4.65672,0,0,1,.31994-.63c.08-.13.16-.25.24005-.37.09-.12.18-.23.28-.35.11-.13.23-.26.35-.38a9.92068,9.92068,0,0,0-4.44-.71993A10.18443,10.18443,0,0,0,6,13.311v2.8597a1.05178,1.05178,0,0,1-.29.71L3.88,18.71057A2.95565,2.95565,0,0,0,3,20.83044v3.16985h9.14a4.22924,4.22924,0,0,0-.14,1,4,4,0,0,0,8,0,4.22924,4.22924,0,0,0-.14-1H29ZM16,27.00012a2.00585,2.00585,0,0,1-2-1.99988,1.94928,1.94928,0,0,1,.27-1h3.46a1.94928,1.94928,0,0,1,.27,1A2.00585,2.00585,0,0,1,16,27.00012Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification-unread",
		"name": "ki-notification-unread",
		"tags": "ki-notification-unread",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.83044a2.95565,2.95565,0,0,0-.88-2.11987l-1.83-1.82985a1.05178,1.05178,0,0,1-.29-.71V13.65081a5.80068,5.80068,0,0,1-2,.35007v2.1698a2.95572,2.95572,0,0,0,.88,2.12l1.83,1.82985a.98985.98985,0,0,1,.29.70992v1.17H5v-1.17a.98985.98985,0,0,1,.29-.70992l1.83-1.82985a2.95572,2.95572,0,0,0,.88-2.12V13.311a8.17539,8.17539,0,0,1,7.46-8.28955,7.94575,7.94575,0,0,1,3.12.40989,6.11247,6.11247,0,0,1,1.2-1.68984,9.92068,9.92068,0,0,0-4.44-.71993A10.18443,10.18443,0,0,0,6,13.311v2.8597a1.05178,1.05178,0,0,1-.29.71L3.88,18.71057A2.95565,2.95565,0,0,0,3,20.83044v3.16985h9.14337a4.00047,4.00047,0,1,0,7.71332,0H29Zm-11,4.1698a2,2,0,0,1-4,0,1.9717,1.9717,0,0,1,.27051-1h3.459A1.9717,1.9717,0,0,1,18,25.00024Z"
				},
				{
					"d": "M23.94,12.001H24a3.99977,3.99977,0,1,0,0-7.99953,3.93691,3.93691,0,0,0-2.33.76,3.72051,3.72051,0,0,0-1.28,1.55A3.84844,3.84844,0,0,0,20,8.00124,3.99937,3.99937,0,0,0,23.94,12.001Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-notification-unread-f",
		"name": "ki-notification-unread-f",
		"tags": "ki-notification-unread-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.83044a2.95545,2.95545,0,0,0-.88-2.11987l-1.83-1.83a1.05138,1.05138,0,0,1-.29-.71V13.6499a6.59487,6.59487,0,0,1-.97.26l.009-.00146-.009.00232a5.88228,5.88228,0,0,1-1.03.09008h-.09A5.99247,5.99247,0,0,1,18,8.00122a5.67212,5.67212,0,0,1,.59-2.52991,4.67123,4.67123,0,0,1,.31994-.63c.08-.12988.16-.25.24005-.36987.09-.12.18-.23.28-.35.11-.13.23-.26.35-.38a9.92015,9.92015,0,0,0-4.44-.72A10.1846,10.1846,0,0,0,6,13.311v2.85961a1.05138,1.05138,0,0,1-.29.71l-1.83,1.83A2.95545,2.95545,0,0,0,3,20.83044v3.1698h9.14a4.22973,4.22973,0,0,0-.14,1,4,4,0,0,0,8,0,4.22973,4.22973,0,0,0-.14-1H29ZM16,27.00012a2.00588,2.00588,0,0,1-2-1.99988,1.94945,1.94945,0,0,1,.27-1h3.46a1.94945,1.94945,0,0,1,.27,1A2.00588,2.00588,0,0,1,16,27.00012Z"
				},
				{
					"d": "M28,8a3.98831,3.98831,0,0,1-4,4h-.06A3.9995,3.9995,0,0,1,20,8a3.84884,3.84884,0,0,1,.39-1.68994,3.72064,3.72064,0,0,1,1.28-1.55A3.93674,3.93674,0,0,1,24,4,3.99891,3.99891,0,0,1,28,8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-office",
		"name": "ki-office",
		"tags": "ki-office",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15,3v8H3V29H29V3ZM9,27V23a1,1,0,0,1,2,0v4Zm6,0H13V23a3,3,0,0,0-6,0v4H5V13H15Zm12,0H17V5H27Z"
				},
				{
					"d": "M19 7H21V10H19z"
				},
				{
					"d": "M23 7H25V10H23z"
				},
				{
					"d": "M19 12H21V15H19z"
				},
				{
					"d": "M23 12H25V15H23z"
				},
				{
					"d": "M19 17H21V20H19z"
				},
				{
					"d": "M23 17H25V20H23z"
				},
				{
					"d": "M19 22H21V25H19z"
				},
				{
					"d": "M23 22H25V25H23z"
				},
				{
					"d": "M7 15H9V18H7z"
				},
				{
					"d": "M11 15H13V18H11z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-office-f",
		"name": "ki-office-f",
		"tags": "ki-office-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15,3V11H3V29H29V3H15ZM7,15h2v3h-2v-3Zm6,12h-2v-4c0-.54999-.45001-1-1-1s-1,.45001-1,1v4h-2v-4c0-1.65002,1.34998-3,3-3s3,1.34998,3,3v4Zm0-9h-2v-3h2v3Zm8,7h-2v-3h2v3Zm0-5h-2v-3h2v3Zm0-5h-2v-3h2v3Zm0-5h-2v-3h2v3Zm4,15h-2v-3h2v3Zm0-5h-2v-3h2v3Zm0-5h-2v-3h2v3Zm0-5h-2v-3h2v3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ok",
		"name": "ki-ok",
		"tags": "ki-ok",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M12,11H11a3.00328,3.00328,0,0,0-3,3v4a3.00328,3.00328,0,0,0,3,3h1a3.00328,3.00328,0,0,0,3-3V14A3.00328,3.00328,0,0,0,12,11Zm1,7a1.001,1.001,0,0,1-1,1H11a1.001,1.001,0,0,1-1-1V14a1.001,1.001,0,0,1,1-1h1a1.001,1.001,0,0,1,1,1Z"
				},
				{
					"d": "M21.30957,16A5.997,5.997,0,0,0,24,11H22a3.99564,3.99564,0,0,1-3,3.85791V11H17V21h2V17.14209A3.99564,3.99564,0,0,1,22,21h2A5.997,5.997,0,0,0,21.30957,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-on-demand",
		"name": "ki-on-demand",
		"tags": "ki-on-demand",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27 4L27 17 27 22 27 28 29 28 29 22 29 17 29 4 27 4z"
				},
				{
					"d": "M23 17L23 22 23 28 25 28 25 22 25 17 25 4 23 4 23 17z"
				},
				{
					"d": "M18.00045,28.00051h-15v-21a3.00328,3.00328,0,0,1,3-3h12a3.00328,3.00328,0,0,1,3,3v18A3.00328,3.00328,0,0,1,18.00045,28.00051Zm-13-2h13a1.00068,1.00068,0,0,0,1-1v-18a1.00067,1.00067,0,0,0-1-1h-12a1.00067,1.00067,0,0,0-1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-on-demand-f",
		"name": "ki-on-demand-f",
		"tags": "ki-on-demand-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27 4L27 17 27 22 27 28 29 28 29 22 29 17 29 4 27 4z"
				},
				{
					"d": "M23 17L23 22 23 28 25 28 25 22 25 17 25 4 23 4 23 17z"
				},
				{
					"d": "M18,4H6A3.00879,3.00879,0,0,0,3,7V28H18a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,18,4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-open-package",
		"name": "ki-open-package",
		"tags": "ki-open-package",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.38721,4h-9.00537l-2.38184,4.76367-2.38184-4.76367H1.61279l2.38721,7.1626V28H28V11.1626l2.38721-7.1626Zm-7.76904,2h4.99463l-1.33362,4h-5.66101l2-4Zm-7.23633,0l2,4H5.72083l-1.33362-4H15.38184Zm-4.38184,20v-4h2v4h-2Zm-2-6v6h-3V12h12v14h-3v-6h-6Zm17,6h-2v-6h-2v6h-2V12h6v14Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-open-package-f",
		"name": "ki-open-package-f",
		"tags": "ki-open-package-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.38,4l-2.38,4.76001-2.38-4.76001H1.60999l2.39001,7.15997V28H28V11.16998l2.39001-7.16998h-9.01001ZM13,26v-4h-2v4h-2v-6h6v6h-2Zm7,0h-2V12H6.39001l-.67004-2H26.28003l-.67004,2h-5.60999v14Zm4,0h-2v-6h2v6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ota",
		"name": "ki-ota",
		"tags": "ki-ota",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.32177,22.27832,20.9668,20.913a6.943,6.943,0,0,0,2.062-4.96163,7.02859,7.02859,0,0,0-14.05717,0,6.943,6.943,0,0,0,2.062,4.96163l-1.355,1.36529A8.85357,8.85357,0,0,1,7.04861,15.9514a8.95164,8.95164,0,0,1,17.90327,0A8.85357,8.85357,0,0,1,22.32177,22.27832Z"
				},
				{
					"d": "M6.81494,25.19336a12.87475,12.87475,0,0,1-3.81445-9.18945,13,13,0,0,1,26,0A12.8781,12.8781,0,0,1,25.186,25.19336l-1.41114-1.418a10.888,10.888,0,0,0,3.22559-7.77148,11,11,0,0,0-22,0,10.88807,10.88807,0,0,0,3.22558,7.77148Z"
				},
				{
					"d": "M17,20.89893a5,5,0,1,0-2,0V27H14a2,2,0,0,0-2,2h8a2,2,0,0,0-2-2H17ZM13,16a3,3,0,1,1,3,3A3.00328,3.00328,0,0,1,13,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ota-cross",
		"name": "ki-ota-cross",
		"tags": "ki-ota-cross",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,16a12.7855,12.7855,0,0,1-2.03,6.97l-1.45-1.45A10.99362,10.99362,0,0,0,10.49,6.49L9.03,5.03A12.99567,12.99567,0,0,1,29,16Z"
				},
				{
					"d": "M18.75665,20.17072,28.293,29.707,29.707,28.293l-26-26L2.293,3.707,6.14954,7.5636A12.93411,12.93411,0,0,0,6.81,25.19l1.42-1.41a10.947,10.947,0,0,1-.66711-14.803l4.27032,4.27032A4.95579,4.95579,0,0,0,11,16a5.01684,5.01684,0,0,0,4,4.9V27H14a2.00587,2.00587,0,0,0-2,2h8a2.01456,2.01456,0,0,0-2-2H17V20.9A4.90166,4.90166,0,0,0,18.75665,20.17072ZM16,19a3.00883,3.00883,0,0,1-3-3,2.96422,2.96422,0,0,1,.29779-1.28815l3.99036,3.99036A2.96422,2.96422,0,0,1,16,19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-other",
		"name": "ki-other",
		"tags": "ki-other",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17,22a3.98288,3.98288,0,0,0-1.21564-2.86255L15,16H11l-.78436,3.13745a3.97814,3.97814,0,0,0,0,5.7251L11,28h4l.78436-3.13745A3.98288,3.98288,0,0,0,17,22Zm-2,0a2,2,0,1,1-2-2A2.00229,2.00229,0,0,1,15,22Z"
				},
				{
					"d": "M7 23L2 23 2 4 30 4 30 7 28 7 28 6 4 6 4 21 7 21 7 23z"
				},
				{
					"d": "M28,28H21a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2V26A2,2,0,0,1,28,28Zm0-17H21V26h7Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-other-f",
		"name": "ki-other-f",
		"tags": "ki-other-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17,22a3.98288,3.98288,0,0,0-1.21564-2.86255L15,16H11l-.78436,3.13745a3.97814,3.97814,0,0,0,0,5.7251L11,28h4l.78436-3.13745A3.98288,3.98288,0,0,0,17,22Zm-2,0a2,2,0,1,1-2-2A2.00229,2.00229,0,0,1,15,22Z"
				},
				{
					"d": "M7 23L2 23 2 4 30 4 30 7 28 7 28 6 4 6 4 21 7 21 7 23z"
				},
				{
					"d": "M28,28H21a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2V26A2,2,0,0,1,28,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-outage",
		"name": "ki-outage",
		"tags": "ki-outage",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17,12V2L12.6,8.6,14.04,10.04,15,8.61V11l3,3h5.26l-2.1,3.15991L22.6,18.6,27,12Zm0,11.39V18H8.74l4.18-6.26-1.45-1.45L5,20H15V30l6.47-9.71L20.03,18.85ZM15,14h.18L15,13.82007Z"
				},
				{
					"d": "M15.01578 -1.40056H16.98422V33.40055H15.01578z",
					"transform": "rotate(-45 16 16)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-outage-f",
		"name": "ki-outage-f",
		"tags": "ki-outage-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M14.04 10.04L15 11 18 14 22 18 22 18 22.6 18.6 27 12 17 12 17 2 12.6 8.6 14.04 10.04 14.04 10.04z"
				},
				{
					"d": "M4.39 3L3 4.39 10.44 11.83 5 20 15 20 15 30 20.44 21.83 27.61 29 29 27.61 4.39 3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-outlet",
		"name": "ki-outlet",
		"tags": "ki-outlet",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,29H3V6A3.00328,3.00328,0,0,1,6,3H26a3.00328,3.00328,0,0,1,3,3V26A3.00328,3.00328,0,0,1,26,29ZM5,27H26a1.001,1.001,0,0,0,1-1V6a1.001,1.001,0,0,0-1-1H6A1.001,1.001,0,0,0,5,6Z"
				},
				{
					"d": "M9 8H13V17H9z"
				},
				{
					"d": "M19 8H23V17H19z"
				},
				{
					"d": "M15,20h2a2,2,0,0,1,2,2v2a0,0,0,0,1,0,0H13a0,0,0,0,1,0,0V22A2,2,0,0,1,15,20Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-outlet-f",
		"name": "ki-outlet-f",
		"tags": "ki-outlet-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,3H6A3.00328,3.00328,0,0,0,3,6V29H26a3.00328,3.00328,0,0,0,3-3V6A3.00328,3.00328,0,0,0,26,3ZM9,8h4v9H9ZM19,24H13V22a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm4-7H19V8h4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-package",
		"name": "ki-package",
		"tags": "ki-package",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,5V27H30V5Zm9,2h2v4H11ZM4,7H9v6h6V7h5V25H4ZM28,25H22V7h2v6h2V7h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-package-f",
		"name": "ki-package-f",
		"tags": "ki-package-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,6V28H30V6H2ZM15,14h-6v-6h2v4h2v-4h2v6Zm7,12h-2V8h2V26Zm4-12h-2v-6h2v6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pause",
		"name": "ki-pause",
		"tags": "ki-pause",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,28.99953H18V3h8Zm-6-2h4V5H20Z"
				},
				{
					"d": "M14,28.99953H6V3h8Zm-6-2h4V5H8Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pause-circle",
		"name": "ki-pause-circle",
		"tags": "ki-pause-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M10 10H14V22H10zM18 10H22V22H18z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pause-circle-f",
		"name": "ki-pause-circle-f",
		"tags": "ki-pause-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01541,14.01541,0,0,0,16,2ZM14,22H10V10h4Zm8,0H18V10h4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pause-f",
		"name": "ki-pause-f",
		"tags": "ki-pause-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18 3H26V29H18z"
				},
				{
					"d": "M6 3H14V29H6z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-payment",
		"name": "ki-payment",
		"tags": "ki-payment",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,13V12a3.00328,3.00328,0,0,0-3-3H17V7H15V9H14a3.00328,3.00328,0,0,0-3,3v2a3.00328,3.00328,0,0,0,3,3h1v4H14a1.00067,1.00067,0,0,1-1-1V19H11v1a3.00328,3.00328,0,0,0,3,3h1v2h2V23h1a3.00328,3.00328,0,0,0,3-3V18a3.00328,3.00328,0,0,0-3-3H17V11h1a1.00067,1.00067,0,0,1,1,1v1Zm-3,4a1.00067,1.00067,0,0,1,1,1v2a1.00067,1.00067,0,0,1-1,1H17V17Zm-3-2H14a1.00067,1.00067,0,0,1-1-1V12a1.00067,1.00067,0,0,1,1-1h1Z"
				},
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01312,12.01312,0,0,0,16,4Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-payment-f",
		"name": "ki-payment-f",
		"tags": "ki-payment-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01541,14.01541,0,0,0,16,2Zm5,11H19V12a1.00291,1.00291,0,0,0-1-1H17v4h1a3.00879,3.00879,0,0,1,3,3v2a3.00887,3.00887,0,0,1-3,3H17v2H15V23H14a3.00887,3.00887,0,0,1-3-3V19h2v1a1.00291,1.00291,0,0,0,1,1h1V17H14a3.00887,3.00887,0,0,1-3-3V12a3.00879,3.00879,0,0,1,3-3h1V7h2V9h1a3.00879,3.00879,0,0,1,3,3Z"
				},
				{
					"d": "M19,18v2a1.00291,1.00291,0,0,1-1,1H17V17h1A1.00291,1.00291,0,0,1,19,18Z"
				},
				{
					"d": "M15,11v4H14a1.00291,1.00291,0,0,1-1-1V12a1.00291,1.00291,0,0,1,1-1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pdf",
		"name": "ki-pdf",
		"tags": "ki-pdf",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,2H9A3.00879,3.00879,0,0,0,6,5V15H4v8H6v7H25a3.00883,3.00883,0,0,0,3-3V5A3.00879,3.00879,0,0,0,25,2ZM6,17h9v4H6ZM26,27a1.003,1.003,0,0,1-1,1H8V23h9V15H8V5A1.003,1.003,0,0,1,9,4H25a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-person",
		"name": "ki-person",
		"tags": "ki-person",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.70233,13.34973a6,6,0,1,0-5.40466,0A11.00945,11.00945,0,0,0,5,24v6H27V24A11.00945,11.00945,0,0,0,18.70233,13.34973ZM12,8a4,4,0,1,1,4,4A4.00427,4.00427,0,0,1,12,8ZM25,28H7V24a9,9,0,0,1,18,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-person-f",
		"name": "ki-person-f",
		"tags": "ki-person-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.70233,13.34973a6,6,0,1,0-5.40466,0A11.00945,11.00945,0,0,0,5,24v6H27V24A11.00945,11.00945,0,0,0,18.70233,13.34973Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-person-multi",
		"name": "ki-person-multi",
		"tags": "ki-person-multi",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.391,14.36365a5.00006,5.00006,0,1,0-4.77234.00525A7.98068,7.98068,0,0,0,16,16.71a7.98068,7.98068,0,0,0-3.61865-2.34106A5.00009,5.00009,0,1,0,7.609,14.36365,8.00063,8.00063,0,0,0,2,22v6H30V22A8.00063,8.00063,0,0,0,24.391,14.36365ZM10,7a3,3,0,1,1-3,3A3.00328,3.00328,0,0,1,10,7Zm6,19H4V22a5.99533,5.99533,0,0,1,10.83-3.55A5.90486,5.90486,0,0,1,16,22ZM22,7a3,3,0,1,1-3,3A3.00328,3.00328,0,0,1,22,7Zm6,19H18V22a7.96036,7.96036,0,0,0-.83-3.55A5.99533,5.99533,0,0,1,28,22Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-person-multi-f",
		"name": "ki-person-multi-f",
		"tags": "ki-person-multi-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12.3905,14.36389a5.00008,5.00008,0,1,0-4.781,0A8.00316,8.00316,0,0,0,2,22v5H18V22A7.63778,7.63778,0,0,0,12.3905,14.36389Z"
				},
				{
					"d": "M24.391,14.36365a5,5,0,1,0-4.78186.00012A7.87855,7.87855,0,0,0,17.5,15.39,9.08735,9.08735,0,0,1,20,22v5H30V22A8.00063,8.00063,0,0,0,24.391,14.36365Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-phone",
		"name": "ki-phone",
		"tags": "ki-phone",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.13522,28.99953c-.04395,0-.08838-.001-.13233-.00293-14.3789-.667-22.33252-8.62012-23-23a2.88361,2.88361,0,0,1,.791-2.11377A2.825,2.825,0,0,1,5.85446,3h5.8999l2.40137,8.40576-3.55567,2.52441a19.60619,19.60619,0,0,0,7.57666,7.51367l2.39453-3.60644L29,20.24562V26.145a2.823,2.823,0,0,1-.88379,2.06152A2.88185,2.88185,0,0,1,26.13522,28.99953ZM5.85446,5a.84117.84117,0,0,0-.61377.26416.861.861,0,0,0-.23975.64013C5.622,19.28078,12.7192,26.37843,26.09615,26.99855a.8129.8129,0,0,0,.63917-.23828A.84386.84386,0,0,0,27,26.145V21.75343l-5.57129-1.59179-2.55908,3.85449-.78369-.374a21.15471,21.15471,0,0,1-9.67285-9.5918l-.36621-.76025,3.79736-2.6958L10.24557,5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-phone-f",
		"name": "ki-phone-f",
		"tags": "ki-phone-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,20.25v5.9a2.837,2.837,0,0,1-.88,2.06,2.93272,2.93272,0,0,1-1.98.79H26C11.62,28.33,3.67,20.38,3,6a2.96483,2.96483,0,0,1,.79-2.12A2.83718,2.83718,0,0,1,5.85,3h5.9l2.41,8.41L10.6,13.93a19.54232,19.54232,0,0,0,7.58,7.51l2.39-3.6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-phone-office",
		"name": "ki-phone-office",
		"tags": "ki-phone-office",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,28H11V4H30ZM13,26H28V6H13Z"
				},
				{
					"d": "M9,28H5a3.00328,3.00328,0,0,1-3-3V7A3.00328,3.00328,0,0,1,5,4H9ZM5,6A1.001,1.001,0,0,0,4,7V25a1.001,1.001,0,0,0,1,1H7V6Z"
				},
				{
					"d": "M26,16H15V8H26Zm-9-2h7V10H17Z"
				},
				{
					"d": "M15 18H26V20H15z"
				},
				{
					"d": "M15 22H26V24H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-phone-office-f",
		"name": "ki-phone-office-f",
		"tags": "ki-phone-office-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11,4V28H30V4ZM26,24H15V22H26Zm0-4H15V18H26Zm0-4H15V8H26Z"
				},
				{
					"d": "M9,4V28H5a3.00883,3.00883,0,0,1-3-3V7A3.00879,3.00879,0,0,1,5,4Z"
				},
				{
					"d": "M17 10H24V14H17z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pie-chart",
		"name": "ki-pie-chart",
		"tags": "ki-pie-chart",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M14,6.2009v11.7991h11.7991c-.92926,4.55878-4.96997,8-9.7991,8-5.51401,0-10-4.48599-10-10,0-4.82913,3.44122-8.86984,8-9.7991m2-2.2009c-6.62744,0-12,5.37256-12,12s5.37256,12,12,12,12-5.37262,12-12h-12V4h0Z"
				},
				{
					"d": "M20,4.2009c3.91223,.79745,7.00165,3.88687,7.7991,7.7991h-7.7991V4.2009m-2-2.2009V14h12c0-6.62744-5.37256-12-12-12h0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pie-chart-f",
		"name": "ki-pie-chart-f",
		"tags": "ki-pie-chart-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,4c-6.62744,0-12,5.37256-12,12s5.37256,12,12,12,12-5.37262,12-12h-12V4Z"
				},
				{
					"d": "M20,4.2009c3.91223,.79745,7.00165,3.88687,7.7991,7.7991h-7.7991V4.2009m-2-2.2009V14h12c0-6.62744-5.37256-12-12-12h0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pin",
		"name": "ki-pin",
		"tags": "ki-pin",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.125,21a11.16911,11.16911,0,0,0-5.83691-9.78125L20.49127,4H23.125V2H8.875V4h2.63373l-.79682,7.21875A11.16911,11.16911,0,0,0,4.875,21v1H15v8h2V22H27.125ZM6.93066,20a9.16009,9.16009,0,0,1,5.14551-7.23145l.50293-.23925L13.52051,4h4.959l.94141,8.5293.50293.23925A9.16009,9.16009,0,0,1,25.06934,20Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pin-f",
		"name": "ki-pin-f",
		"tags": "ki-pin-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.12,21v1H17v8H15V22H4.88V21a11.15863,11.15863,0,0,1,5.83-9.78L11.51,4H8.88V2H23.12V4H20.49l.8,7.22A11.15863,11.15863,0,0,1,27.12,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-pipe",
		"name": "ki-pipe",
		"tags": "ki-pipe",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.68749,22.27441,16,21.62207l-.68751.65234C14.76953,22.78809,13,24.57617,13,26a3,3,0,0,0,6,0C19,24.57617,17.23047,22.78809,16.68749,22.27441ZM16,27a1.00152,1.00152,0,0,1-1-.998,4.32156,4.32156,0,0,1,1-1.55273A4.30706,4.30706,0,0,1,17,26,1.00067,1.00067,0,0,1,16,27Z"
				},
				{
					"d": "M23,10v3H13V9h3V3H3V9H6v5.64844A5.35722,5.35722,0,0,0,11.35156,20H23v3h6V10ZM5,5h9V7H5ZM17,18V17H15v1H11.35156A3.35588,3.35588,0,0,1,8,14.64844V9h3v4a2.0026,2.0026,0,0,0,2,2H23v3Zm10,1v2H25V12h2v7Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-placeholder-image",
		"name": "ki-placeholder-image",
		"tags": "ki-placeholder-image",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,4H6A3.00879,3.00879,0,0,0,3,7V28H26a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,26,4ZM6,6H26a1.003,1.003,0,0,1,1,1v9.86523l-5.06152-4.21777-4.88965,4.88965-7-8L5,14.58594V7A1.003,1.003,0,0,1,6,6ZM26,26H5V17.41406l4.95117-4.95117,7,8,5.11035-5.11035L27,19.46814V25A1.003,1.003,0,0,1,26,26Z"
				},
				{
					"d": "M18,13a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,18,13Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,9Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-placeholder-image-f",
		"name": "ki-placeholder-image-f",
		"tags": "ki-placeholder-image-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,4H6A3.00879,3.00879,0,0,0,3,7V28H26a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,26,4ZM6,6H26a1.003,1.003,0,0,1,1,1v9.86523l-5.06152-4.21777-4.88965,4.88965-7-8L5,14.58594V7A1.003,1.003,0,0,1,6,6Z"
				},
				{
					"d": "M18,13a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,18,13Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-play",
		"name": "ki-play",
		"tags": "ki-play",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M6.00045,28.99953V3L26.893,15.99953Zm2-22.3999V25.39992l15.10742-9.40039Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-play-circle",
		"name": "ki-play-circle",
		"tags": "ki-play-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M22 16L12 22 12 10 22 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-play-circle-f",
		"name": "ki-play-circle-f",
		"tags": "ki-play-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01541,14.01541,0,0,0,16,2ZM12,22V10l10,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-play-f",
		"name": "ki-play-f",
		"tags": "ki-play-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.89 16L6 29 6 3 26.89 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-player-in-player",
		"name": "ki-player-in-player",
		"tags": "ki-player-in-player",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.00045,27.99953h-25v-21a3.00328,3.00328,0,0,1,3-3h22a3.00328,3.00328,0,0,1,3,3v18A3.00328,3.00328,0,0,1,27.00045,27.99953Zm-23-2h23a1.00067,1.00067,0,0,0,1-1v-18a1.00067,1.00067,0,0,0-1-1h-22a1.00067,1.00067,0,0,0-1,1Z"
				},
				{
					"d": "M26,24H14V15H26ZM16,22h8V17H16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-player-in-player-f",
		"name": "ki-player-in-player-f",
		"tags": "ki-player-in-player-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,4H5A3.00879,3.00879,0,0,0,2,7V28H27a3.00883,3.00883,0,0,0,3-3V7A3.00879,3.00879,0,0,0,27,4ZM26,24H14V15H26Z"
				},
				{
					"d": "M16 17H24V22H16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plume-pod",
		"name": "ki-plume-pod",
		"tags": "ki-plume-pod",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.8125,28H10.1875a2.99621,2.99621,0,0,1-2.63379-1.56348L3.103,17.39941a2.96921,2.96921,0,0,1,.019-2.83593l4.4126-8.96289A3.01024,3.01024,0,0,1,10.1875,4h11.625a2.99621,2.99621,0,0,1,2.63379,1.56348L28.897,14.60059a2.96921,2.96921,0,0,1-.019,2.83593l-4.4126,8.96289A3.01024,3.01024,0,0,1,21.8125,28ZM10.1875,6a.99858.99858,0,0,0-.87793.52051L4.897,15.4834a1.02172,1.02172,0,0,0-.019.99609L9.32861,25.5166A.98771.98771,0,0,0,10.1875,26h11.625a.99858.99858,0,0,0,.87793-.52051L27.103,16.5166a1.02172,1.02172,0,0,0,.019-.99609L22.67139,6.4834A.98771.98771,0,0,0,21.8125,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plume-pod-f",
		"name": "ki-plume-pod-f",
		"tags": "ki-plume-pod-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.9,14.6,24.45,5.56006A3.01675,3.01675,0,0,0,21.81,4H10.19A3.02991,3.02991,0,0,0,7.53,5.6L3.12,14.56006A2.98089,2.98089,0,0,0,3.1,17.3999l4.45,9.04A3.017,3.017,0,0,0,10.19,28H21.81a3.03,3.03,0,0,0,2.66-1.6001l4.41-8.96A2.98113,2.98113,0,0,0,28.9,14.6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plus",
		"name": "ki-plus",
		"tags": "ki-plus",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28 15L17 15 17 4 15 4 15 15 4 15 4 17 15 17 15 28 17 28 17 17 28 17 28 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plus-alt",
		"name": "ki-plus-alt",
		"tags": "ki-plus-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28 14L18 14 18 4 14 4 14 14 4 14 4 18 14 18 14 28 18 28 18 18 28 18 28 14z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plus-circle",
		"name": "ki-plus-circle",
		"tags": "ki-plus-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M23 15L17 15 17 9 15 9 15 15 9 15 9 17 15 17 15 23 17 23 17 17 23 17 23 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-plus-circle-f",
		"name": "ki-plus-circle-f",
		"tags": "ki-plus-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm7,15H17v6H15V17H9V15h6V9h2v6h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-power",
		"name": "ki-power",
		"tags": "ki-power",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 3H17V13H15z"
				},
				{
					"d": "M21.58,4.26l-.71,1.87a11,11,0,1,1-9.74,0l-.71-1.87a13,13,0,1,0,11.16,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-precipitation",
		"name": "ki-precipitation",
		"tags": "ki-precipitation",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00078,5.31787C17.01564,6.26428,19,8.44263,19,11a3,3,0,0,1-6,0c0-2.55237,1.97658-4.72717,3.00078-5.68213M16,2.75,15.4,3.2C15.22,3.33,11,6.55005,11,11a5,5,0,0,0,10,0c0-4.44995-4.22-7.67-4.4-7.8L16,2.75Z"
				},
				{
					"d": "M8.00078,18.31787C9.01564,19.26428,11,21.44263,11,24a3,3,0,0,1-6,0c0-2.55237,1.97658-4.72717,3.00078-5.68213M8,15.75l-.6.45C7.22,16.33,3,19.55005,3,24a5,5,0,0,0,10,0c0-4.45-4.22-7.67-4.4-7.8L8,15.75Z"
				},
				{
					"d": "M24.00078,18.31787C25.01564,19.26428,27,21.44263,27,24a3,3,0,0,1-6,0c0-2.55237,1.97658-4.72717,3.00078-5.68213M24,15.75l-.6.45C23.22,16.33,19,19.55005,19,24a5,5,0,0,0,10,0c0-4.45-4.22-7.67-4.4-7.8l-.6-.45Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-precipitation-f",
		"name": "ki-precipitation-f",
		"tags": "ki-precipitation-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,11a5,5,0,0,1-10,0c0-4.44995,4.22-7.67,4.4-7.8L16,2.75,16.6,3.2C16.78,3.33,21,6.55005,21,11Z"
				},
				{
					"d": "M13,24A5,5,0,0,1,3,24c0-4.45,4.22-7.67,4.4-7.8l.6-.45.6.45C8.78,16.33,13,19.55005,13,24Z"
				},
				{
					"d": "M29,24a5,5,0,0,1-10,0c0-4.45,4.22-7.67,4.4-7.8l.6-.45.6.45C24.78,16.33,29,19.55005,29,24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-presentation",
		"name": "ki-presentation",
		"tags": "ki-presentation",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12 9H20V11H12z"
				},
				{
					"d": "M8 13H24V15H8z"
				},
				{
					"d": "M29.82666,17.7168,27.86719,4H4.13281L2.17334,17.7168A1.99671,1.99671,0,0,0,4.15283,20H15v6H12a2,2,0,0,0-2,2H22a2,2,0,0,0-2-2H17V20H27.84717A1.99671,1.99671,0,0,0,29.82666,17.7168ZM4.15283,18,5.86719,6H26.13281l1.71631,12Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-presentation-f",
		"name": "ki-presentation-f",
		"tags": "ki-presentation-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.83,17.72,27.87,4H4.13L2.17,17.72A1.99922,1.99922,0,0,0,4.15,20H15v6H12a2.00587,2.00587,0,0,0-2,2H22a2.00587,2.00587,0,0,0-2-2H17V20H27.85A1.99922,1.99922,0,0,0,29.83,17.72ZM12,9h8v2H12Zm12,6H8V13H24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-price-tag",
		"name": "ki-price-tag",
		"tags": "ki-price-tag",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.32861 2.91406 6.34723 4.91095 3.84717 2.26172l-1.4541 1.37305 2.52527 2.67596L2.91456 16.3291l14.08545 14.08496L30.41407 17 16.32861 2.91406ZM5.08545 15.6709l1.76416-8.82129 8.82178-1.76367L27.58594 17 17 27.58594 5.08545 15.6709Z"
				},
				{
					"d": "M21.29346 18.12109c1.16846-1.16992 1.16846-3.07227-.00049-4.24219l-1.17139-1.17188c-1.13379-1.13281-3.10986-1.13281-4.24268 0l-.87897.87885-2.58569-2.58569.87921-.87909c.37695-.37891 1.03564-.37891 1.41357 0l.58594.58594 1.41406-1.41406-.58545-.58594c-1.13379-1.13281-3.10986-1.13281-4.24268 0l-.87897.87885-1.29291-1.29291-1.41406 1.41406 1.29279 1.29279-.87921.87909c-1.16846 1.16992-1.16846 3.07227.00049 4.24219l1.17139 1.17188c1.13379 1.13281 3.10986 1.13281 4.24268 0l.87897-.87885 2.58569 2.58569-.87921.87909c-.37695.37891-1.03564.37891-1.41357 0l-.58594-.58594-1.41406 1.41406.58545.58594c.56689.56641 1.32031.87891 2.12158.87891s1.55469-.3125 2.12109-.87891l.87897-.87885 1.29291 1.29291 1.41406-1.41406-1.29279-1.29279.87921-.87909Zm-8.58691-2.24219c-.37695.37891-1.03564.37891-1.41357 0l-1.17139-1.17188c-.38965-.38965-.38965-1.02441-.00049-1.41406l.87897-.87885 2.58569 2.58569-.87921.87909Zm3.7077-.87872.87921-.87909c.37695-.37891 1.03564-.37891 1.41357 0l1.17139 1.17188c.38965.38965.38965 1.02441.00049 1.41406l-.87897.87885-2.58569-2.58569Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-price-tag-f",
		"name": "ki-price-tag-f",
		"tags": "ki-price-tag-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m16.33002 2.90997-9.98004 2-2.5-2.64996-1.45996 1.37L4.91999 6.31 2.90998 16.32996l14.09003 14.08002 13.40997-13.40997L16.33002 2.90997Zm3.95996 18.79999L19 20.40997l-.88.88c-.57001.57001-1.32001.88-2.12.88s-1.54999-.31-2.12-.88l-.59003-.58002 1.42004-1.41998.57996.59003c.38.38 1.04004.38 1.42004 0l.88-.88-2.59003-2.59003-.88.88c-1.13 1.14001-3.10999 1.14001-4.23999 0l-1.16998-1.16998c-1.17004-1.16998-1.17004-3.07001 0-4.23999l.88-.88-1.30005-1.29004L9.71 8.28998l1.28998 1.29999.88-.88c1.13-1.13995 3.10999-1.13995 4.23999 0l.59003.58002-1.42004 1.41998L14.71 10.12c-.38-.38-1.04004-.38-1.42004 0l-.88.88 2.59003 2.58997.88-.88c1.13-1.13995 3.10999-1.13995 4.23999 0l1.16998 1.17004c1.17004 1.16998 1.17004 3.07001 0 4.23999l-.88.88 1.30005 1.28998-1.42004 1.41998Z"
				},
				{
					"d": "m19.88 16.70996-.88.88-2.59003-2.58997.88-.88c.38-.38 1.04004-.38 1.42004 0l1.16998 1.16998c.39001.39001.39001 1.03003 0 1.41998ZM13.59003 15l-.88.88c-.38.38-1.04004.38-1.42004 0l-1.16998-1.17004c-.39001-.38995-.39001-1.02997 0-1.41998l.88-.88 2.59003 2.59003Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-print",
		"name": "ki-print",
		"tags": "ki-print",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.00024,9.00415H23.00049V3.00439h-14V9.00415H6.00024a3.00887,3.00887,0,0,0-3,3v8a3.00891,3.00891,0,0,0,3,3h3v6h14v-6h3a3.00883,3.00883,0,0,0,3-3v-8A3.00879,3.00879,0,0,0,26.00024,9.00415ZM11.00049,5.00439h10V9.00415h-10Zm9.99975,21.99976h-10v-10h10Zm6-7a1.00291,1.00291,0,0,1-1,1h-3V16.99951h2.00025v-2h-18v2H9.00024v4.00464h-3a1.003,1.003,0,0,1-1-1v-8a1.003,1.003,0,0,1,1-1H9.00049v.00024h14v-.00024h2.99975a1.00288,1.00288,0,0,1,1,1Z"
				},
				{
					"d": "M13.00045 22.99953H19.00045V24.99953H13.00045z"
				},
				{
					"d": "M15.00045 18.99953H19.00045V20.99953H15.00045z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-print-f",
		"name": "ki-print-f",
		"tags": "ki-print-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,9H23V3H9V9H6a3.00879,3.00879,0,0,0-3,3v8a3.00883,3.00883,0,0,0,3,3H9v6H23V23h3a3.00883,3.00883,0,0,0,3-3V12A3.00879,3.00879,0,0,0,26,9ZM13,25V23h6v2Zm6-4H15V19h4Zm8-1a1.003,1.003,0,0,1-1,1H23V17h2V15H7v2H9v4H6a1.003,1.003,0,0,1-1-1V12a1.003,1.003,0,0,1,1-1H26a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-puzzle",
		"name": "ki-puzzle",
		"tags": "ki-puzzle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,29H20V27a2,2,0,0,0-4,0v2H7V20a4,4,0,0,1,0-8V7h7a4,4,0,0,1,8,0h7v7H27a2,2,0,0,0,0,4h2Zm-7-2h5V20a4,4,0,0,1,0-8V9H20V7a2,2,0,0,0-4,0V9H9v5H7a2,2,0,0,0,0,4H9v9h5a4,4,0,0,1,8,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-puzzle-f",
		"name": "ki-puzzle-f",
		"tags": "ki-puzzle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m25,16c0,1.09998.90002,2,2,2h2v11h-9v-2c0-1.10004-.90002-2-2-2s-2,.89996-2,2v2H7v-9c-2.21002,0-4-1.79004-4-4s1.78998-4,4-4v-5h7c0-2.21002,1.78998-4,4-4s4,1.78998,4,4h7v7h-2c-1.09998,0-2,.89996-2,2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-qr-code",
		"name": "ki-qr-code",
		"tags": "ki-qr-code",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,15H15V3H3ZM5,5h8v8H5Z"
				},
				{
					"d": "M7 7H11V11H7z"
				},
				{
					"d": "M17,3V15H29V3ZM27,13H19V5h8Z"
				},
				{
					"d": "M21 7H25V11H21z"
				},
				{
					"d": "M3,29H15V17H3ZM5,19h8v8H5Z"
				},
				{
					"d": "M7 21H11V25H7z"
				},
				{
					"d": "M17 17H21V21H17z"
				},
				{
					"d": "M23 17H29V19H23z"
				},
				{
					"d": "M17 23H19V29H17z"
				},
				{
					"d": "M25 25L21 25 21 29 25 29 29 29 29 25 29 21 25 21 25 25z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-question-circle",
		"name": "ki-question-circle",
		"tags": "ki-question-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00045,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16.00045,29.99953Zm0-26a12,12,0,1,0,12,12A12.01312,12.01312,0,0,0,16.00045,3.99953Z"
				},
				{
					"d": "M17.26032,18.99953h-2v-2c0-1.94727,1.19336-2.92481,2.24512-3.78809.34961-.28613.71-.582,1.04785-.91894a.2769.2769,0,0,0,.04492-.34766c-.1455-.35058-.80175-.94531-2.33789-.94531a3.39434,3.39434,0,0,0-3.1123,1.46l-1.78223-.90723a5.3148,5.3148,0,0,1,4.89453-2.55273c2.4209,0,3.749,1.126,4.18555,2.18066a2.27873,2.27873,0,0,1-.47852,2.52637A15.79827,15.79827,0,0,1,18.774,14.75832c-1.02246.83789-1.51367,1.2832-1.51367,2.24121Z"
				},
				{
					"d": "M15.25987 21H17.25987V24H15.25987z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-question-circle-f",
		"name": "ki-question-circle-f",
		"tags": "ki-question-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm1.26,22h-2V21h2Zm2.71-10.29c-.41.4-.83.75-1.2,1.05-1.02.84-1.51,1.28-1.51,2.24v2h-2V17c0-1.95,1.19-2.93,2.25-3.79a11.05044,11.05044,0,0,0,1.04-.92.27466.27466,0,0,0,.05-.35c-.15-.35-.8-.94-2.34-.94a3.38131,3.38131,0,0,0-3.11,1.46l-1.78-.91A5.30542,5.30542,0,0,1,16.26,9c2.42,0,3.75,1.13,4.19,2.18A2.2965,2.2965,0,0,1,19.97,13.71Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-quote",
		"name": "ki-quote",
		"tags": "ki-quote",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12.75439,26H5.67432l2-7H5a3.00328,3.00328,0,0,1-3-3V6H12a3.00328,3.00328,0,0,1,3,3l-.03857,9.27441ZM8.32568,24h2.91993L13,17.86035V9a1.001,1.001,0,0,0-1-1H4v8a1.001,1.001,0,0,0,1,1h5.32568Z"
				},
				{
					"d": "M27.75439,26H20.67432l2-7H20a3.00328,3.00328,0,0,1-3-3V6H27a3.00328,3.00328,0,0,1,3,3l-.03857,9.27441Zm-4.42871-2h2.91993L28,17.86035V9a1.001,1.001,0,0,0-1-1H19v8a1.001,1.001,0,0,0,1,1h5.32568Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-radio",
		"name": "ki-radio",
		"tags": "ki-radio",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,28A12,12,0,1,1,28,16,12.01343,12.01343,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10.01146,10.01146,0,0,0,16,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-radio-f",
		"name": "ki-radio-f",
		"tags": "ki-radio-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "16",
					"r": "7"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M16,28A12,12,0,1,1,28,16,12.01343,12.01343,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10.01146,10.01146,0,0,0,16,6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-rainbow",
		"name": "ki-rainbow",
		"tags": "ki-rainbow",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,25H28V21A12,12,0,0,0,4,21v4H2V21a14,14,0,0,1,28,0Z"
				},
				{
					"d": "M26,25H24V21A8,8,0,0,0,8,21v4H6V21a10,10,0,0,1,20,0Z"
				},
				{
					"d": "M22,25H20V21a4,4,0,0,0-8,0v4H10V21a6,6,0,0,1,12,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record",
		"name": "ki-record",
		"tags": "ki-record",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29A13,13,0,1,1,29,16,13.01474,13.01474,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11.01245,11.01245,0,0,0,16,5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-alt",
		"name": "ki-record-alt",
		"tags": "ki-record-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,23a7,7,0,1,1,7-7A7.00848,7.00848,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.00588,5.00588,0,0,0,16,11Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-alt-f",
		"name": "ki-record-alt-f",
		"tags": "ki-record-alt-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "16",
					"r": "7"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-cancel",
		"name": "ki-record-cancel",
		"tags": "ki-record-cancel",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,3A13,13,0,1,0,29,16,13.01474,13.01474,0,0,0,16,3ZM27,16a10.94746,10.94746,0,0,1-2.55212,7.03381L8.96619,7.55212A10.99172,10.99172,0,0,1,27,16ZM5,16A10.94746,10.94746,0,0,1,7.55212,8.96619L23.03381,24.44788A10.99172,10.99172,0,0,1,5,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-f",
		"name": "ki-record-f",
		"tags": "ki-record-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "16",
					"r": "13"
				}
			],
			"ellipses": "",
			"paths": "",
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-series",
		"name": "ki-record-series",
		"tags": "ki-record-series",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,9H9A7,7,0,0,0,9,23H23A7,7,0,0,0,23,9ZM4,16a5,5,0,1,1,5,5A5.00588,5.00588,0,0,1,4,16Zm9.89453,5c.00958-.00934.01776-.02.02728-.02942.07874-.078.151-.16211.226-.24377.07763-.08448.15783-.16632.23132-.25452.07245-.087.13751-.17969.20575-.27014.06769-.08966.13849-.17676.20184-.26972.06568-.09631.12323-.19812.18415-.29779.05731-.09381.11834-.185.17132-.28167.05725-.1045.10565-.21418.15766-.32178.04718-.09766.09851-.19275.14123-.29285.04828-.11316.08679-.23108.12921-.34717.03644-.09985.0777-.19726.10968-.29913.04-.12756.06916-.25958.102-.3902.02381-.09472.05323-.18719.07312-.28344.03174-.15339.05115-.31086.07257-.46772.01056-.07733.02735-.15277.03534-.23089a7.02171,7.02171,0,0,0,0-1.43958c-.008-.07812-.02478-.15344-.03534-.23083-.02148-.15686-.04083-.31439-.07257-.46784-.01989-.09625-.04931-.18878-.07312-.28357-.03277-.13049-.062-.26251-.102-.39-.032-.10193-.07324-.19928-.10968-.29913-.04242-.11609-.08093-.234-.12921-.34717-.04272-.1001-.09405-.19519-.14123-.29285-.052-.1076-.10041-.21728-.15766-.32178-.05292-.09655-.11389-.18768-.17114-.28143-.061-.09979-.11859-.20172-.18433-.2981-.06341-.09307-.13434-.18023-.20208-.27-.06812-.09034-.13318-.18293-.20551-.26978-.07349-.0882-.15369-.17-.23132-.25452-.075-.08166-.14728-.16577-.226-.24377-.00952-.0094-.0177-.02008-.02728-.02942H16a5,5,0,0,1,0,10ZM23,21H20.88947a6.97795,6.97795,0,0,0,0-10H23a5,5,0,0,1,0,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-series-cancel",
		"name": "ki-record-series-cancel",
		"tags": "ki-record-series-cancel",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,9H9A7,7,0,0,0,9,23H23A7,7,0,0,0,23,9Zm-9,7a4.966,4.966,0,0,1-.83289,2.75262L6.24683,11.83319A4.992,4.992,0,0,1,14,16ZM4,16a4.966,4.966,0,0,1,.83289-2.75262l6.92028,6.91943A4.992,4.992,0,0,1,4,16Zm9.89453,5c.00958-.00934.01776-.02.02728-.02942.07874-.078.151-.16211.226-.24377.07763-.08448.15783-.16632.23132-.25452.07245-.087.13751-.17969.20575-.27014.06769-.08966.13849-.17676.20184-.26972.06568-.09631.12323-.19812.18415-.29779.05731-.09381.11834-.185.17132-.28167.05725-.1045.10565-.21418.15766-.32178.04718-.09766.09851-.19275.14123-.29285.04828-.11316.08679-.23108.12921-.34717.03644-.09985.0777-.19726.10968-.29913.04-.12756.06916-.25958.102-.3902.02381-.09472.05323-.18719.07312-.28344.03174-.15339.05115-.31086.07257-.46772.01056-.07733.02735-.15277.03534-.23089a7.02171,7.02171,0,0,0,0-1.43958c-.008-.07812-.02478-.15344-.03534-.23083-.02148-.15686-.04083-.31439-.07257-.46784-.01989-.09625-.04931-.18878-.07312-.28357-.03277-.13049-.062-.26251-.102-.39-.032-.10193-.07324-.19928-.10968-.29913-.04242-.11609-.08093-.234-.12921-.34717-.04272-.1001-.09405-.19519-.14123-.29285-.052-.1076-.10041-.21728-.15766-.32178-.05292-.09655-.11389-.18768-.17114-.28143-.061-.09979-.11859-.20172-.18433-.2981-.06341-.09307-.13434-.18023-.20208-.27-.06812-.09034-.13318-.18293-.20551-.26978-.07349-.0882-.15369-.17-.23132-.25452-.075-.08166-.14728-.16577-.226-.24377-.00952-.0094-.0177-.02008-.02728-.02942H16a5,5,0,0,1,0,10ZM23,21H20.88947a6.97795,6.97795,0,0,0,0-10H23a5,5,0,0,1,0,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-series-f",
		"name": "ki-record-series-f",
		"tags": "ki-record-series-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,9H9A7,7,0,0,0,9,23H23A7,7,0,0,0,23,9ZM16,21H13.89l.03-.03c.08-.08.15-.16.23-.24.08-.09.16-.17.23-.26a2.68994,2.68994,0,0,0,.2-.27c.07-.09.14-.17.21-.27.06-.09.12-.2.18-.3a2.59267,2.59267,0,0,0,.17-.28,3.174,3.174,0,0,0,.16-.32c.05-.1.1-.19.14-.29a3.61229,3.61229,0,0,0,.13-.35c.04-.1.08-.2.11-.3.04-.13.07-.26.1-.39.03-.09.06-.19.08-.28.03-.15.05-.31.07-.47a1.809,1.809,0,0,0,.03-.23,6.50323,6.50323,0,0,0,0-1.44,1.80951,1.80951,0,0,0-.03-.23c-.02-.16-.04-.32-.07-.47-.02-.09-.05-.18995-.08-.28-.03-.13-.06006-.26-.1-.39-.03-.1-.07-.2-.11-.3a3.61229,3.61229,0,0,0-.13-.35c-.04-.1-.09-.19-.14-.29a3.18674,3.18674,0,0,0-.16-.32,2.5918,2.5918,0,0,0-.17-.28c-.06-.1-.12-.21-.18-.3-.07-.1-.14-.18-.21-.27a2.69075,2.69075,0,0,0-.2-.27c-.07-.09-.15-.17-.23-.26-.08-.08-.15-.16-.23-.24L13.89,11H16a5,5,0,0,1,0,10Zm7,0H20.89a6.97919,6.97919,0,0,0,0-10H23a5,5,0,0,1,0,10Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-record-series-reminder",
		"name": "ki-record-series-reminder",
		"tags": "ki-record-series-reminder",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23,9H9A7,7,0,0,0,9,23H23A7,7,0,0,0,23,9ZM4,16a5,5,0,1,1,5,5A5.00588,5.00588,0,0,1,4,16Zm9.89453,5c.00995-.0097.01843-.02081.02832-.03058.07446-.07379.1427-.15344.21381-.23047.082-.08886.1665-.17535.244-.26837.06573-.079.12469-.16357.187-.24548.07452-.098.15173-.19361.22113-.29547.05774-.08472.10791-.17456.16192-.26191.06513-.10534.13337-.20843.193-.31732.05023-.09167.0921-.18811.13824-.28222.05414-.11036.11182-.21857.16022-.332.04327-.10145.07727-.20746.11578-.31122.04126-.11121.08679-.22028.1225-.33405.03644-.11615.06244-.23651.0929-.35522.02722-.1062.05975-.21033.08209-.31842.02893-.1402.0459-.28431.06628-.42737.01288-.09052.032-.17908.04144-.27069a7.03254,7.03254,0,0,0,0-1.43836c-.00939-.09155-.02856-.18-.04144-.27057-.02044-.14306-.03735-.28735-.06628-.42755-.02234-.10809-.05493-.21228-.08216-.31854-.03045-.11865-.05639-.239-.09283-.355-.03571-.11377-.08124-.22284-.1225-.334-.03851-.10376-.07251-.20977-.11578-.31122-.0484-.11346-.10608-.22167-.16022-.332-.04614-.09411-.088-.19055-.13824-.28222-.05957-.10883-.12781-.21186-.19287-.31708-.05414-.08746-.10425-.17737-.16205-.26221-.06946-.102-.14679-.19769-.22138-.29577-.06219-.08185-.12109-.1662-.18676-.24512-.07746-.093-.16193-.17951-.244-.26837-.07111-.077-.13935-.15668-.21381-.23047-.00989-.00977-.01837-.02088-.02832-.03058H16a5,5,0,0,1,0,10ZM23,21H20.88928a6.97751,6.97751,0,0,0,0-10H23a5,5,0,0,1,0,10Z"
				},
				{
					"d": "M10 13L8 13 8 17 12 17 12 15 10 15 10 13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-refresh",
		"name": "ki-refresh",
		"tags": "ki-refresh",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.62646,14.54053l5.041,5.04,5.04-5.04-1.41406-1.41407-2.63892,2.6388a11.81711,11.81711,0,1,0-4.72046,9.702l-1.20117-1.59961A9.74475,9.74475,0,0,1,15.8335,25.8335a9.83351,9.83351,0,1,1,9.8197-10.095l-2.61267-2.61207Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-reminder",
		"name": "ki-reminder",
		"tags": "ki-reminder",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M23 17L15 17 15 7 17 7 17 15 23 15 23 17z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-reminder-f",
		"name": "ki-reminder-f",
		"tags": "ki-reminder-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm7,15H15V7h2v8h6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-remote",
		"name": "ki-remote",
		"tags": "ki-remote",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22,30H10a2.0026,2.0026,0,0,1-2-2V5a3.00328,3.00328,0,0,1,3-3H21a3.00328,3.00328,0,0,1,3,3V28A2.0026,2.0026,0,0,1,22,30ZM11,4a1.00067,1.00067,0,0,0-1,1V28.002L22,28V5a1.00067,1.00067,0,0,0-1-1Z"
				},
				{
					"d": "M16,23.41406,11.58594,19,16,14.58594,20.41406,19ZM14.41406,19,16,20.58594,17.58594,19,16,17.41406Z"
				},
				{
					"d": "M18 6H20V8H18z"
				},
				{
					"d": "M12 6H14V8H12z"
				},
				{
					"d": "M18 10H20V12H18z"
				},
				{
					"d": "M12 10H14V12H12z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-remote-f",
		"name": "ki-remote-f",
		"tags": "ki-remote-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,2H11A3.00879,3.00879,0,0,0,8,5V28a2.00591,2.00591,0,0,0,2,2H22a2.00591,2.00591,0,0,0,2-2V5A3.00879,3.00879,0,0,0,21,2ZM18,6h2V8H18Zm0,4h2v2H18ZM12,6h2V8H12Zm0,4h2v2H12Zm4,13.40991L11.59,19,16,14.59,20.41,19Z"
				},
				{
					"d": "M14.87568 17.87565H17.124319999999997V20.124290000000002H14.87568z",
					"transform": "rotate(-44.999 16 18.99998)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-remove-format",
		"name": "ki-remove-format",
		"tags": "ki-remove-format",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.542,23.69238l5.57227-5.57226a2.97326,2.97326,0,0,0,.0039-4.23633L23.94727,9.70312a3.01553,3.01553,0,0,0-4.24415,0L14.40625,15h-.001l-.58246.5835L12.40625,17h.00238L7.416,22.001l6,5.999H29V26H20.24011ZM21.11328,11.12207a.99766.99766,0,0,1,1.41895-.00586l4.1748,4.18555a.97177.97177,0,0,1,0,1.39648l-4.79687,4.79785-5.58594-5.58593ZM14.24414,26l-4-4.001,4.667-4.67382,5.58594,5.58593L17.415,26Z"
				},
				{
					"d": "M3 3H17V5H3z"
				},
				{
					"d": "M3 7H14V9H3z"
				},
				{
					"d": "M3 11H11V13H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-remove-read-receipt",
		"name": "ki-remove-read-receipt",
		"tags": "ki-remove-read-receipt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.97998,10.8501c-.01001-.04004-.01001-.09009-.01996-.13013-.01001-.04004-.04004-.07983-.06-.13013-.01001-.02979-.02002-.06982-.04004-.09985-.02997-.05005-.06-.08008-.08997-.11987-.03003-.03027-.05005-.06006-.08002-.09009-.03003-.03003-.08002-.06006-.12-.09009-.03003-.02002-.04999-.0498-.08002-.06006,0,0-.01001,0-.01001-.00977h-.01001l-4.46997-2.41016v-2.70996h-5.03998l-3.49005-1.87988c-.28998-.16016-.64996-.16016-.93994,0l-3.49005,1.87988H7v2.70996l-4.46997,2.41016h-.01001c0,.00977-.01001,.00977-.01001,.00977-.03003,.01025-.04999,.04004-.08002,.06006-.03998,.03003-.08997,.06006-.12,.09009-.02997,.03003-.04999,.05981-.08002,.09009-.02997,.03979-.06,.06982-.08997,.11987-.02002,.03003-.03003,.07007-.04004,.09985-.01996,.05029-.04999,.09009-.06,.13013-.00995,.04004-.00995,.09009-.01996,.13013s-.02002,.07983-.02002,.11987v14.03003c0,1.6499,1.34998,3,3,3h15v-2H5c-.54999,0-1-.44995-1-1V12.79004l11.47998,7.06006c.16003,.09985,.34003,.1499,.52002,.1499s.35999-.05005,.52002-.1499l.47998-.30005,4.15002-2.55005,6.84998-4.20996v4.20996h2v-6.03003c0-.04004-.01001-.07983-.02002-.11987Zm-22.97998,1.43994l-2-1.22998,2-1.08008v2.31006Zm16,1.22998l-5.65002,3.47998-.34998,.20996-1,.62012-7-4.31006V7h14v6.52002Zm2-1.22998v-2.31006l2,1.08008-2,1.22998Z"
				},
				{
					"d": "M11 9H21V11H11z"
				},
				{
					"d": "M13 13H19V15H13z"
				},
				{
					"d": "M30.70703 20.70703 29.29297 19.29297 26.5 22.08594 23.70703 19.29297 22.29297 20.70703 25.08594 23.5 22.29297 26.29297 23.70703 27.70703 26.5 24.91406 29.29297 27.70703 30.70703 26.29297 27.91406 23.5 30.70703 20.70703z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-remove-read-receipt-f",
		"name": "ki-remove-read-receipt-f",
		"tags": "ki-remove-read-receipt-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.97998,10.84998c-.01001-.03998-.01001-.08997-.01996-.13-.01001-.03998-.04004-.07996-.06-.13-.01001-.02997-.02002-.07001-.04004-.09998-.02997-.04999-.06-.08002-.08997-.12-.03003-.03003-.05005-.06-.08002-.09003-.03003-.02997-.08002-.06-.12-.08997-.03003-.02002-.04999-.04999-.08002-.06,0,0-.01001,0-.01001-.01001h-.01001l-4.46997-2.41003v-2.70996h-5.03998l-3.49005-1.88c-.28998-.16003-.64996-.16003-.93994,0l-3.49005,1.88H7v2.70996l-4.46997,2.41003h-.01001c0,.01001-.01001,.01001-.01001,.01001-.03003,.01001-.04999,.03998-.08002,.06-.03998,.02997-.08997,.06-.12,.08997-.02997,.03003-.04999,.06-.08002,.09003-.02997,.03998-.06,.07001-.08997,.12-.02002,.02997-.03003,.07001-.04004,.09998-.01996,.05005-.04999,.09003-.06,.13-.00995,.04004-.00995,.09003-.01996,.13-.01001,.04004-.02002,.08002-.02002,.12v14.03003c0,1.64996,1.34998,3,3,3h15v-2H5c-.54999,0-1-.45001-1-1V12.78998l11.47998,7.06c.16003,.10004,.34003,.15002,.52002,.15002s.35999-.04999,.52002-.15002l.47998-.29999,4.15002-2.54999,6.84998-4.21002v4.21002h2v-6.03003c0-.03998-.01001-.07996-.02002-.12Zm-22.97998,1.44l-2-1.22998,2-1.08002v2.31Zm12,2.71002h-6v-2h6v2Zm2-4H11v-2h10v2Zm4,1.28998v-2.31l2,1.08002-2,1.22998Z"
				},
				{
					"d": "M30.70703 20.70703 29.29297 19.29297 26.5 22.08594 23.70703 19.29297 22.29297 20.70703 25.08594 23.5 22.29297 26.29297 23.70703 27.70703 26.5 24.91406 29.29297 27.70703 30.70703 26.29297 27.91406 23.5 30.70703 20.70703z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-reply",
		"name": "ki-reply",
		"tags": "ki-reply",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19,9H6.41406l5.293-5.293L10.293,2.293,2.58594,10l7.707,7.707L11.707,16.293,6.41406,11H19a8,8,0,0,1,0,16v2A10,10,0,0,0,19,9Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-reply-all",
		"name": "ki-reply-all",
		"tags": "ki-reply-all",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19,9H13.41406l5.293-5.293L17.293,2.293,9.58594,10l7.707,7.707L18.707,16.293,13.41406,11H19a8,8,0,0,1,0,16v2A10,10,0,0,0,19,9Z"
				},
				{
					"d": "M11.707 3.707L10.293 2.293 2.586 10 10.293 17.707 11.707 16.293 5.414 10 11.707 3.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-restart",
		"name": "ki-restart",
		"tags": "ki-restart",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.62646,14.54053l5.041,5.04,5.04-5.04-1.41406-1.41407-2.63892,2.6388a11.81711,11.81711,0,1,0-4.72046,9.702l-1.20117-1.59961A9.74475,9.74475,0,0,1,15.8335,25.8335a9.83351,9.83351,0,1,1,9.8197-10.095l-2.61267-2.61207Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-rewind",
		"name": "ki-rewind",
		"tags": "ki-rewind",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.99951,6.20654l-10,6.1507V6.20557l-15.9082,9.79,15.9082,9.79V19.63477l10,6.1499Zm-12,15.999-10.0918-6.21,10.0918-6.21V22.20557Zm10,.001-8-4.91894v-2.583l8-4.91992Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-rewind-f",
		"name": "ki-rewind-f",
		"tags": "ki-rewind-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19 26L19 20 29 26 29 6 19 12 19 6 3 16 19 26z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-rocketship",
		"name": "ki-rocketship",
		"tags": "ki-rocketship",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "21.39001",
					"cy": "10.5",
					"r": "2.5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M11.89001,23.5c0,.92999-.37,1.81-1.03003,2.46997-1.10999,1.12-4.71997,1.82001-5.79999,2.01001l-1.40002.25.24005-1.40002c.19-1.07996.89996-4.68994,2.00995-5.79999,1.33002-1.32996,3.63-1.32996,4.95001,0,.66003.66003,1.03003,1.54004,1.03003,2.47003Z"
				},
				{
					"d": "M28.88,3.85999l-.09998-.72998-.73004-.12c-.26001-.04004-6.5-1.02002-11.78998,3.20996-.82001.66003-1.66003,1.65002-2.45001,2.75l-5.25-1.06-5.35999,5.35999,7.08002,3.54004,5,4.98999,3.31995,6.90997,5.27002-5.32996-.85999-5.41003c.87-.66998,1.75-1.41998,2.58997-2.26001,4.30005-4.31,3.32001-11.53998,3.28003-11.84998ZM16.10999,19.81l-4.01001-4.01001c.85004-1.69,3.29004-6.32001,5.41003-8.02002,3.58002-2.85999,7.76001-2.95001,9.45996-2.85999.11005,1.83002.06006,6.52002-2.78998,9.37-3.01001,3.01001-6.65997,4.87-8.07001,5.52002Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-rocketship-f",
		"name": "ki-rocketship-f",
		"tags": "ki-rocketship-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12,23.5c0,.92999-.35999,1.81-1.03003,2.46997-1.10999,1.12-4.71997,1.82001-5.79999,2.01001l-1.39996.25.25-1.40002c.19-1.07996.88995-4.68994,2.01001-5.79999,1.35999-1.37,3.57996-1.37,4.93994,0,.67004.66003,1.03003,1.54004,1.03003,2.47003Z"
				},
				{
					"d": "M28.98999,3.85999l-.09998-.72998-.73004-.12c-.25995-.04004-6.5-1.02002-11.77997,3.20996-.82001.66003-1.66003,1.65002-2.45001,2.75l-5.26001-1.06-5.35999,5.35999,7.08002,3.54004,5,4.98999,3.32001,6.90997,5.26996-5.32996-.85999-5.41003c.87-.66998,1.75-1.41998,2.59003-2.26001,4.29999-4.31,3.32001-11.53998,3.27997-11.84998ZM10.54999,14.65997l-3.85999-1.92999,2.64001-2.64001,3.39996.67999c-.94,1.51001-1.71997,2.98004-2.17999,3.89001ZM19.28998,25.28998l-1.84998-3.83997c.90997-.44,2.29999-1.16003,3.85999-2.19l.54999,3.42999-2.56,2.59998ZM21.5,13c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-router",
		"name": "ki-router",
		"tags": "ki-router",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,2H12A3.00328,3.00328,0,0,0,9,5V26a2.995,2.995,0,0,0,2,2.81567V30h2V29h6v1h2V28.81573A2.99507,2.99507,0,0,0,23,26V5A3.00328,3.00328,0,0,0,20,2Zm1,24a1.00067,1.00067,0,0,1-1,1H12a1.00067,1.00067,0,0,1-1-1V25H21Zm0-3H11V5a1.00067,1.00067,0,0,1,1-1h8a1.00067,1.00067,0,0,1,1,1Z"
				},
				{
					"d": "M15 12H17V15H15z"
				},
				{
					"d": "M15 7H17V10H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-router-f",
		"name": "ki-router-f",
		"tags": "ki-router-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,2H12A3.00879,3.00879,0,0,0,9,5V26a3.01047,3.01047,0,0,0,2,2.82V30h2V29h6v1h2V28.82A3.01047,3.01047,0,0,0,23,26V5A3.00879,3.00879,0,0,0,20,2ZM15,7h2v3H15Zm0,5h2v3H15Zm6,13H11V23H21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-router-wave",
		"name": "ki-router-wave",
		"tags": "ki-router-wave",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.948,25.46387l-.50879-3.52051L23.95531,5.499A2.99957,2.99957,0,0,0,20.9973,2h-9.999a2.99958,2.99958,0,0,0-2.958,3.499l.51612,16.44532-.49952,3.46679A2.99956,2.99956,0,0,0,10.99779,29v1h3V29h4v1h3V29a2.99083,2.99083,0,0,0,2.31934-1.09766A2.95982,2.95982,0,0,0,23.948,25.46387ZM10.22533,4.36621A.996.996,0,0,1,10.99828,4h9.999a1.00064,1.00064,0,0,1,.98047,1.19629L21.46837,21H10.52807L10.03685,5.36133l-.019-.165A.9953.9953,0,0,1,10.22533,4.36621ZM21.77025,26.63379A.996.996,0,0,1,20.9973,27h-9.999a.996.996,0,0,1-.77295-.36621,1.03109,1.03109,0,0,1-.19824-.88281L10.42486,23h11.1463l.40661,2.80371A.9953.9953,0,0,1,21.77025,26.63379Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-router-wave-f",
		"name": "ki-router-wave-f",
		"tags": "ki-router-wave-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.95,25.46l-.51-3.52L23.96,5.5A3.00507,3.00507,0,0,0,21,2H11A3.00507,3.00507,0,0,0,8.04,5.5l.52,16.43994-.5,3.47A3.00042,3.00042,0,0,0,11,29v1h3V29h4v1h3V29a3.001,3.001,0,0,0,2.95-3.54ZM10.42,23l.14-.93994L10.53,21H21.47l-.03,1.06006L21.58,23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-save",
		"name": "ki-save",
		"tags": "ki-save",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,25a4,4,0,1,1,4-4A4.004,4.004,0,0,1,16,25Zm0-6a2,2,0,1,0,2,2A2.0026,2.0026,0,0,0,16,19Z"
				},
				{
					"d": "M22.41406,3H3V29H29V9.58594ZM15,5V8H9V5ZM9,27V15H23V27Zm18,0H25V13H7V27H5V5H7v5H17V5h4.58594L27,10.41406Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-save-f",
		"name": "ki-save-f",
		"tags": "ki-save-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "21",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M22.41,3H3V29H29V9.59ZM12,21a4,4,0,1,1,4,4A3.99891,3.99891,0,0,1,12,21Zm15,6H25V13H7V27H5V5H7v5H17V5h4.59L27,10.40991Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-scales",
		"name": "ki-scales",
		"tags": "ki-scales",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,8V6H17V3H15V6H3V8H6.61328L4.27966,15H3v1a5,5,0,0,0,10,0V15H11.72034L9.38672,8H15V24H6a3.00328,3.00328,0,0,0-3,3v2H29V27a3.00328,3.00328,0,0,0-3-3H17V8h5.61328l-2.33362,7H19v1a5,5,0,0,0,10,0V15H27.72034L25.38672,8ZM8,19a3.0062,3.0062,0,0,1-2.8291-2h5.6582A3.0062,3.0062,0,0,1,8,19ZM6.38721,15,8,10.16309,9.61279,15ZM27,27H5a1.00067,1.00067,0,0,1,1-1H26A1.00067,1.00067,0,0,1,27,27Zm-3-8a3.0062,3.0062,0,0,1-2.8291-2h5.6582A3.0062,3.0062,0,0,1,24,19Zm-1.61279-4L24,10.16309,25.61279,15Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-search",
		"name": "ki-search",
		"tags": "ki-search",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,27.58594l-6.55212-6.55213a11.01774,11.01774,0,1,0-1.41407,1.41407L27.58594,29ZM5,14a9,9,0,1,1,9,9A9.01047,9.01047,0,0,1,5,14Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-search-f",
		"name": "ki-search-f",
		"tags": "ki-search-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "14",
					"cy": "14",
					"r": "7"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M29,27.58594l-6.55212-6.55212c1.59161-1.90833,2.55212-4.36041,2.55212-7.03381,0-6.06543-4.93457-11-11-11S3,7.93457,3,14s4.93457,11,11,11c2.6734,0,5.12549-.96051,7.03381-2.55212l6.55212,6.55212,1.41406-1.41406ZM5,14c0-4.9624,4.0376-9,9-9s9,4.0376,9,9-4.0376,9-9,9S5,18.9624,5,14Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-search-previous",
		"name": "ki-search-previous",
		"tags": "ki-search-previous",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.44948,21.0354A10.99758,10.99758,0,0,0,6.22166,6.22168L6,6.44336V4H4v6h6V8H7.27146l.36426-.36426a9.00025,9.00025,0,1,1,.00147,12.72949c-.11231-.1123-.22168-.22656-.32324-.33984l-.10987-.125q-.26294-.30175-.49512-.62109a8.92261,8.92261,0,0,1-1.7085-5.36914l-1.99994-.01954a10.90721,10.90721,0,0,0,2.09076,6.56446c.189.25976.39063.51367.603.75781l.12842.14453c.12793.14258.26074.28223.39893.4209a10.99461,10.99461,0,0,0,14.81528.67261L27.586,29,29,27.58594Z"
				},
				{
					"d": "M17 16L12 16 12 10 14 10 14 14 17 14 17 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-select",
		"name": "ki-select",
		"tags": "ki-select",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,12.00027H24.82a3.01032,3.01032,0,0,0-2.82-2H20.22a2.986,2.986,0,0,0-2.22-1H17v-2a3.00879,3.00879,0,0,0-3-3H11V18.82448L6.11914,14.638,3.87891,16.87917a3.00056,3.00056,0,0,0-.0083,4.23438l7.70849,7.88672H26a3.00328,3.00328,0,0,0,3-3v-11A3.00879,3.00879,0,0,0,26,12.00027Zm1,14a1.001,1.001,0,0,1-1,1H12.4209L5.293,19.7073a1.00141,1.00141,0,0,1,0-1.41407l.93066-.93066L13,23.17605V6.00027h1a1.00291,1.00291,0,0,1,1,1v9h2v-5h1a1.00291,1.00291,0,0,1,1,1v4h2v-4h1a1.00291,1.00291,0,0,1,1,1v3h2v-2h1a1.00291,1.00291,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-send",
		"name": "ki-send",
		"tags": "ki-send",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.15723,30.3418l-5.25782-9.46094,2.96-4.74024-4.74024,2.96L1.6582,13.84277,28.76367,3.23633Zm-2.9375-9.40235,2.623,4.71875L25.23633,6.76367,6.3418,14.15723l4.71875,2.623L22.14062,9.85938Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-send-f",
		"name": "ki-send-f",
		"tags": "ki-send-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28 4L18 29 14 21 20 12 20 12 11 18 3 14 28 4z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-services",
		"name": "ki-services",
		"tags": "ki-services",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.00241,9.97281a3.00492,3.00492,0,0,0-3.58786-2.9147A2.94622,2.94622,0,0,0,24.53662,8.2915l-2.16821,2.88861a2.98578,2.98578,0,0,0-2.36792-1.17962h-9.184a2.9951,2.9951,0,0,0-2.816-2.001h-3a3,3,0,0,0-3,3v13h6a2.99539,2.99539,0,0,0,2.81543-1.999H21.00049a2.99986,2.99986,0,0,0,2.49594-1.33571l5.9414-8.91111A3.13477,3.13477,0,0,0,30.00241,9.97281ZM9.00049,20.99951a1,1,0,0,1-1,1h-4v-11a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1Zm18.832-10.44336-6,8.999a1.00014,1.00014,0,0,1-.83212.44531H11.00049v-8h9a1,1,0,0,1,0,2h-4v2h4a2.9779,2.9779,0,0,0,2.55072-1.44694c.36458-.6024.70223-1.22069,1.12476-1.784l2.49249-3.3228a1,1,0,0,1,1.66406,1.10937Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-services-f",
		"name": "ki-services-f",
		"tags": "ki-services-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28.67,7.51a2.99314,2.99314,0,0,0-4.13.78l-2.17,2.89A2.99321,2.99321,0,0,0,20,10H10.82A3.01033,3.01033,0,0,0,8,8H5a2.996,2.996,0,0,0-3,3V24H8a3.01041,3.01041,0,0,0,2.82-2H21a3.00605,3.00605,0,0,0,2.5-1.34l5.94-8.91A3.13036,3.13036,0,0,0,30,9.97,2.97142,2.97142,0,0,0,28.67,7.51Zm-.84,3.05-6,9A1.01058,1.01058,0,0,1,21,20H11V12h9a1,1,0,0,1,0,2H16v2h4a2.96959,2.96959,0,0,0,2.55-1.45,20.57061,20.57061,0,0,1,1.13-1.78L26.17,9.45A.95676.95676,0,0,1,26.81,9.02a1.01193,1.01193,0,0,1,.75.15.9781.9781,0,0,1,.42.64A1.0031,1.0031,0,0,1,27.83,10.56Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-set-top-box",
		"name": "ki-set-top-box",
		"tags": "ki-set-top-box",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "7",
					"cy": "14",
					"r": "1"
				},
				{
					"cx": "25",
					"cy": "18",
					"r": "1"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M2,9V23H4v2H9V23H23v2h5V23h2V9ZM28,21H4V11H28Z"
				},
				{
					"d": "M6 17H13V19H6z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-set-top-box-f",
		"name": "ki-set-top-box-f",
		"tags": "ki-set-top-box-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,9V23H4v2H9V23H23v2h5V23h2V9Zm5,4a1,1,0,1,1-1,1A1,1,0,0,1,7,13Zm6,6H6V17h7Zm12,0a1,1,0,1,1,1-1A1,1,0,0,1,25,19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-settings",
		"name": "ki-settings",
		"tags": "ki-settings",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,30H12V27.86865a2.749,2.749,0,0,0-1.09473-2.18945l-.38965-.29248A2.73912,2.73912,0,0,0,7.355,25.29883L5.68213,26.41357,1.65186,19.69678l2.12939-1.41944a2.73708,2.73708,0,0,0,0-4.55468L1.65186,12.30322,5.68213,5.58643,7.355,6.70117a2.73834,2.73834,0,0,0,3.16016-.0874l.39062-.293A2.7499,2.7499,0,0,0,12,4.13135V2h8V4.13135A2.749,2.749,0,0,0,21.09473,6.3208l.38965.29248a2.73916,2.73916,0,0,0,3.16064.08789l1.67285-1.11474,4.03027,6.71679-2.12939,1.41944a2.73708,2.73708,0,0,0,0,4.55468l2.12939,1.41944-4.03027,6.71679L24.645,25.29883a2.74416,2.74416,0,0,0-3.16016.0874l-.39062.293A2.7499,2.7499,0,0,0,20,27.86865Zm-6-2h4v-.13135a4.75909,4.75909,0,0,1,1.89453-3.78955l.39063-.293a4.745,4.745,0,0,1,5.39648-.19922l1.97022-3.28369-.54248-.36181a4.737,4.737,0,0,1,0-7.88282h0l.54248-.36181L25.68164,8.41309a4.74314,4.74314,0,0,1-5.397-.19971l-.38965-.292A4.75979,4.75979,0,0,1,18,4.13135V4H14v.13135A4.75909,4.75909,0,0,1,12.10547,7.9209l-.39063.293a4.74305,4.74305,0,0,1-5.39648.19922L4.34814,11.69678l.54248.36181a4.737,4.737,0,0,1,0,7.88282l-.54248.36181,1.97022,3.28369a4.74558,4.74558,0,0,1,5.397.19971l.38965.292a4.75979,4.75979,0,0,1,1.895,3.79Z"
				},
				{
					"d": "M16,22a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.00458,4.00458,0,0,0,16,12Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-settings-f",
		"name": "ki-settings-f",
		"tags": "ki-settings-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,16a2.74319,2.74319,0,0,1,1.22-2.28l2.13-1.42L26.32,5.59,24.65,6.7a2.7521,2.7521,0,0,1-3.17-.09l-.39-.29A2.75172,2.75172,0,0,1,20,4.13V2H12V4.13a2.75172,2.75172,0,0,1-1.09,2.19L10.52,6.61a2.7521,2.7521,0,0,1-3.17.09L5.68,5.59,1.65,12.3l2.13,1.42a2.74053,2.74053,0,0,1,0,4.56L1.65,19.7l4.03,6.71L7.35,25.3a2.752,2.752,0,0,1,3.17.09l.38995.29A2.75172,2.75172,0,0,1,12,27.87V30h8V27.87a2.75172,2.75172,0,0,1,1.09-2.19l.39-.29a2.752,2.752,0,0,1,3.17-.09l1.67,1.11,4.03-6.71-2.13-1.42A2.74317,2.74317,0,0,1,27,16ZM16,21a5,5,0,1,1,5-5A5.00181,5.00181,0,0,1,16,21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-share",
		"name": "ki-share",
		"tags": "ki-share",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,19a4.98452,4.98452,0,0,0-4.38257,2.6438L12.6582,17.77759a4.65837,4.65837,0,0,0,.15845-3.046L20.34424,11.386a5.1691,5.1691,0,1,0-1.03955-1.72724l-7.38062,3.28028a4.99013,4.99013,0,1,0-.3374,6.53058L19.03931,23.61C19.02905,23.74091,19,23.86646,19,24a5,5,0,1,0,5-5ZM24,5a3,3,0,1,1-3,3A3.00328,3.00328,0,0,1,24,5ZM8,19a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,8,19Zm16,8a3,3,0,1,1,3-3A3.00328,3.00328,0,0,1,24,27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-share-f",
		"name": "ki-share-f",
		"tags": "ki-share-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,24a5,5,0,0,1-10,0c0-.13.03-.26.04-.39L11.59,19.47a5.01335,5.01335,0,1,1,.33-6.53L19.3,9.66A5.0853,5.0853,0,0,1,19,8a5.0275,5.0275,0,1,1,1.34,3.39l-7.52,3.34A5.334,5.334,0,0,1,13,16a5.02888,5.02888,0,0,1-.34,1.78l6.96,3.86A4.98251,4.98251,0,0,1,29,24Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-shield",
		"name": "ki-shield",
		"tags": "ki-shield",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,1.90137,4,7.35645v3.11328a22.095,22.095,0,0,0,11.521,19.4082l.479.26074.479-.26074A22.095,22.095,0,0,0,28,10.46973V7.35645ZM6,10.46973V8.64355L15,4.5531V27.22626A20.0917,20.0917,0,0,1,6,10.46973Zm20,0a20.0917,20.0917,0,0,1-9,16.75653V4.5531l9,4.09045Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-shield-f",
		"name": "ki-shield-f",
		"tags": "ki-shield-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,1.90137,4,7.35645v3.11328a22.09544,22.09544,0,0,0,11.52148,19.4082L16,30.13867l.47852-.26074A22.09544,22.09544,0,0,0,28,10.46973V7.35645ZM6,10.46973V8.64355L15,4.5531V27.22626A20.0917,20.0917,0,0,1,6,10.46973Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-shopping-cart",
		"name": "ki-shopping-cart",
		"tags": "ki-shopping-cart",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "10",
					"cy": "27",
					"r": "2"
				},
				{
					"cx": "24",
					"cy": "27",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M7.51349,7,6.84668,3H3V5H5.15332l2.582,15.49316A2.98928,2.98928,0,0,0,10.69434,23H26V21H10.69434a.99619.99619,0,0,1-.98633-.835L9.51379,19H24.36035a3.00666,3.00666,0,0,0,2.94141-2.41113L29.21973,7Zm17.82733,9.19727A1.00173,1.00173,0,0,1,24.36035,17H9.18042L7.84686,9H26.78027Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-shopping-cart-add",
		"name": "ki-shopping-cart-add",
		"tags": "ki-shopping-cart-add",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "10",
					"cy": "27",
					"r": "2"
				},
				{
					"cx": "24",
					"cy": "27",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M27,8l-1.65918,8.19727A1.00173,1.00173,0,0,1,24.36035,17H9.18042L6.84668,3H3V5H5.15332l2.582,15.49316A2.98928,2.98928,0,0,0,10.69434,23H26V21H10.69434a.99619.99619,0,0,1-.98633-.835L9.51379,19H24.36035a3.00666,3.00666,0,0,0,2.94141-2.41113L29,8Z"
				},
				{
					"d": "M16 15L18 15 18 11 22 11 22 9 18 9 18 5 16 5 16 9 12 9 12 11 16 11 16 15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-shopping-cart-f",
		"name": "ki-shopping-cart-f",
		"tags": "ki-shopping-cart-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "10",
					"cy": "27",
					"r": "2"
				},
				{
					"cx": "24",
					"cy": "27",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M7.51349,7,6.84668,3H3V5H5.15332l2.582,15.49316A2.98928,2.98928,0,0,0,10.69434,23H26V21H10.69434a.99619.99619,0,0,1-.98633-.835L9.51379,19H24.36035a3.00666,3.00666,0,0,0,2.94141-2.41113L29.21973,7Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sign-language",
		"name": "ki-sign-language",
		"tags": "ki-sign-language",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.15,8.49A3.00162,3.00162,0,0,0,23.97,7.11a2.43614,2.43614,0,0,0-.54-.01L21.21,4.88a3.08783,3.08783,0,0,0-4.25,0L15.74,6.1a3.04676,3.04676,0,0,0-2.78.78L11.74,8.1a3.03936,3.03936,0,0,0-2.78.78l-.87.88L7.29,8.96a3.24709,3.24709,0,0,0-4.58,0,3.00569,3.00569,0,0,0,0,4.25l14,14a2.99679,2.99679,0,0,0,2.12.88H20v-2H18.83a1.01715,1.01715,0,0,1-.71-.29993l-14-14a1.002,1.002,0,0,1,0-1.41,1.23737,1.23737,0,0,1,1.76,0l5.41,5.41h0l3.53,3.53-.00012-.00025L15.38,19.88a2.90167,2.90167,0,0,0,1.99.77991,2.29842,2.29842,0,0,0,.79-.12988,3.25161,3.25161,0,0,0,2.15-2.3501,4.0061,4.0061,0,0,0,.08-.48v-.01a3.129,3.129,0,0,0,.73-.54l.11-.10986a6.62816,6.62816,0,0,0,.32,1.63989,8.31057,8.31057,0,0,0,1.74,2.89014L25.36,23.64l1.42-1.42-.29-.29-1.78-1.77c-.33-.33984-3.18-3.41992,0-6.58984L23.29,12.1499l-.4.41016L21.47,13.97,19.85,15.6l-.14.14a1.008,1.008,0,0,1-1.42,0l-.39-.39L17.41,14.86l.89-.89,1.59-1.58,1.41-1.42,1.59-1.58.01-.01A.968.968,0,0,1,23.72,9.09a.92027.92027,0,0,1,.33.11.97657.97657,0,0,1,.41.37012l3.54,4.74V16h2V13.64Zm-7.77-2.2a1.034,1.034,0,0,1,1.41,0L21.47,7.97,19.89008,9.56006,17.5,7.16992Zm-4,2a1.034,1.034,0,0,1,1.41,0L18.47,10.97l-1.57989,1.59009L13.5,9.16992Zm3.15,10.35A.93635.93635,0,0,1,16.79,18.46l-7.29-7.29.88-.87988a1.024,1.024,0,0,1,1.41,0L15.47,13.97l-.87994.89,2.29,2.28991a2.8985,2.8985,0,0,0,1.4.79A1.21218,1.21218,0,0,1,17.53,18.64Z"
				},
				{
					"d": "M6.23242,22.76758,7.46484,24H5a1.00067,1.00067,0,0,1-1-1V18H2v5a3.00328,3.00328,0,0,0,3,3H7.707L6.35352,27.35352l1.41406,1.41406,3.64648-3.64649L7.64648,21.35352Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-signal",
		"name": "ki-signal",
		"tags": "ki-signal",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M7,21v6H5V21H7m0-2H5a2,2,0,0,0-2,2v8H7a2,2,0,0,0,2-2V21a2,2,0,0,0-2-2Z"
				},
				{
					"d": "M27,5V27H25V5h2m0-2H25a2,2,0,0,0-2,2V29h4a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"
				},
				{
					"d": "M17,13V27H15V13h2m0-2H15a2,2,0,0,0-2,2V29h4a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-signal-f",
		"name": "ki-signal-f",
		"tags": "ki-signal-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M5,19H7a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H3a0,0,0,0,1,0,0V21a2,2,0,0,1,2-2Z"
				},
				{
					"d": "M25,3h2a2,2,0,0,1,2,2V27a2,2,0,0,1-2,2H23a0,0,0,0,1,0,0V5a2,2,0,0,1,2-2Z"
				},
				{
					"d": "M15,11h2a2,2,0,0,1,2,2V27a2,2,0,0,1-2,2H13a0,0,0,0,1,0,0V13a2,2,0,0,1,2-2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-signature",
		"name": "ki-signature",
		"tags": "ki-signature",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,29H27a3.8662,3.8662,0,0,0-4-4c-2.31,0-4.65.93994-7.13,1.92993C13.33,27.95,10.69,29,8,29c-2.83,0-4.58-1.43994-4.93-4H5.09c.27,1.38,1.2,2,2.91,2,2.31,0,4.65-.93994,7.13-1.92993C17.67,24.05005,20.31,23,23,23A5.869,5.869,0,0,1,29,29Z"
				},
				{
					"d": "M22.207,3.87891a3.00243,3.00243,0,0,0-4.24219,0L4.19238,17.65137l-1.6289,5.87109,5.87109-1.62891L22.207,8.12109a2.99889,2.99889,0,0,0,0-4.24218ZM7.39355,20.10645l-1.957.543.543-1.957L17.12891,7.543,18.543,8.957ZM20.793,6.707,19.957,7.543,18.543,6.12891l.83594-.83594a1.0014,1.0014,0,0,1,1.41406.001.99845.99845,0,0,1,0,1.41308Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sim-card",
		"name": "ki-sim-card",
		"tags": "ki-sim-card",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,29H3V15.64941l4-5V4H26a3.00328,3.00328,0,0,1,3,3V26A3.00328,3.00328,0,0,1,26,29ZM5,27H26a1.001,1.001,0,0,0,1-1V7a1.001,1.001,0,0,0-1-1H9v5.35059l-4,5Z"
				},
				{
					"d": "M25,25H7V17H25ZM9,23H23V19H9Z"
				},
				{
					"d": "M11 7H13V14H11z"
				},
				{
					"d": "M23 7H25V14H23z"
				},
				{
					"d": "M19 7H21V14H19z"
				},
				{
					"d": "M15 7H17V14H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sim-card-f",
		"name": "ki-sim-card-f",
		"tags": "ki-sim-card-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,4H7v6.6499l-4,5V29H26a3.00887,3.00887,0,0,0,3-3V7A3.00879,3.00879,0,0,0,26,4ZM19,7h2v7H19ZM15,7h2v7H15ZM11,7h2v7H11ZM25,25H7V17H25Zm0-11H23V7h2Z"
				},
				{
					"d": "M9 19H23V23H9z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sketch",
		"name": "ki-sketch",
		"tags": "ki-sketch",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.43555,4.48824A2.98573,2.98573,0,0,0,22.8916,3.07809H9.1084A2.98573,2.98573,0,0,0,6.56445,4.48824L1.78516,12.1357,16,30.72457,30.21484,12.1357ZM10.41406,11.07809,16,5.49215l5.58594,5.58594Zm12.00971,2L16,26.7286,9.57623,13.07809Zm-15.05884,0,3.746,7.9602-6.08728-7.9602Zm17.27014,0h2.34131l-6.08728,7.9602Zm2.5611-2H25V7.56435ZM23,5.09182V9.664L18.41406,5.07809H22.8916A.98452.98452,0,0,1,23,5.09182Zm-9.41406-.01373L9,9.664V5.09182a.98636.98636,0,0,1,.1084-.01373ZM7,7.56435v3.51374H4.80383Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sketch-f",
		"name": "ki-sketch-f",
		"tags": "ki-sketch-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.44,4.49a3.01146,3.01146,0,0,0-2.55-1.41H9.11A3.01146,3.01146,0,0,0,6.56,4.49L1.79,12.14,16,30.72,30.21,12.14ZM7,11.08H4.8L7,7.56006Zm9-5.59,5.59,5.59H10.41Zm0,21.24L9.58,13.08H22.42ZM25,7.56006,27.2,11.08H25Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-smart-watch",
		"name": "ki-smart-watch",
		"tags": "ki-smart-watch",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,14.07809h-.20154a10.01193,10.01193,0,0,0-3.9696-6.10895l-.98169-5.891H11.15283l-.98169,5.89105a9.96771,9.96771,0,0,0,0,16.21789l.98169,5.89106h9.69434l.98169-5.89106a10.01194,10.01194,0,0,0,3.9696-6.10894H26a1,1,0,0,0,1-1v-2A1,1,0,0,0,26,14.07809Zm-13.15283-10h6.30566l.45477,2.684a9.85546,9.85546,0,0,0-7.2152,0Zm6.30566,24H12.84717l-.45477-2.684a9.85546,9.85546,0,0,0,7.2152,0Zm-3.15283-4a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,16,24.07809Z"
				},
				{
					"d": "M13,19.07809H12a1,1,0,0,1-1-1v-3h2Z"
				},
				{
					"d": "M20,19.07809H19v-6h2v5A1,1,0,0,1,20,19.07809Z"
				},
				{
					"d": "M15 11.07809H17V19.07809H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-smart-watch-f",
		"name": "ki-smart-watch-f",
		"tags": "ki-smart-watch-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,14.08h-.2a10.00117,10.00117,0,0,0-3.97-6.11l-.98-5.89h-9.7l-.98,5.89a9.97134,9.97134,0,0,0,0,16.22l.98,5.89h9.7l.98-5.89a10.05684,10.05684,0,0,0,3.97-6.11H26a1.00292,1.00292,0,0,0,1-1v-2A1.003,1.003,0,0,0,26,14.08Zm-13.15-10h6.3L19.61,6.76a9.92169,9.92169,0,0,0-7.22,0Zm4.15,7v8H15v-8Zm-6,7v-3h2v4H12A1.00292,1.00292,0,0,1,11,18.08Zm8.15,10h-6.3L12.39,25.39a9.78916,9.78916,0,0,0,7.22,0Zm1.85-10a1.00292,1.00292,0,0,1-1,1H19v-6h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-soccer",
		"name": "ki-soccer",
		"tags": "ki-soccer",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.22,11.42A12.3234,12.3234,0,0,0,28.58,9.87c-.09-.18-.17-.35-.27-.51a12.92293,12.92293,0,0,0-.88-1.42l-.33-.45c-.11-.16-.24-.31-.37-.47a14.23727,14.23727,0,0,0-.99-1.07c-.18-.17-.36-.33-.54-.49-.23-.19-.46-.38-.7-.57a11.39687,11.39687,0,0,0-1.49-1c-.02-.02-.03-.03-.05-.03-.46-.26-.93-.5-1.42-.72a.68919.68919,0,0,1-.1-.04c-.19-.08-.4-.16-.6-.24-.01,0-.02-.01-.04-.01-.21-.08-.43-.15-.64-.22-.44-.14-.89-.25-1.34-.35L18.13,2.16c-.23-.03-.47-.06-.7-.09A13.56065,13.56065,0,0,0,16,2,14.01518,14.01518,0,0,0,2.63,20.17c.06.19.12.37.19.56a12.24412,12.24412,0,0,0,.62,1.44c.18.38.38.74.59,1.09A13.93432,13.93432,0,0,0,8.72,27.95a9.58778,9.58778,0,0,0,1.09.59,11.35327,11.35327,0,0,0,1.44.62c.19.07.37.13.56.19A13.50547,13.50547,0,0,0,16,30,14.00257,14.00257,0,0,0,30,16,13.68251,13.68251,0,0,0,29.22,11.42ZM15.86,21.76l4.11-1.65,3.05,1.53v4.04a11.82657,11.82657,0,0,1-4.84,2.09l-3.05-3.06Zm-3.58-4.9,2.24-3.74,4.5.74v4.48l-3.76,1.5ZM26.14,9.62l-2.25-.45-.43-2.55A11.982,11.982,0,0,1,26.14,9.62ZM23.35,11.1l3.9.78a12.10769,12.10769,0,0,1,.73,4.1,11.4564,11.4564,0,0,1-.11,1.56l-3.9,2.34L21.02,18.4V13.43Zm3.82,9.19a11.92609,11.92609,0,0,1-2.15,3.56V21.58ZM14.68,4.06a11.2043,11.2043,0,0,1,1.3-.08A12.025,12.025,0,0,1,21.2,5.19l.75,4.48-2.28,2.28-4.99-.83L13.11,7.97Zm-2.36.5-.93,2.32L8.79,6.4A11.88506,11.88506,0,0,1,12.32,4.56ZM4.91,20.6A12.169,12.169,0,0,1,4,16.42l1.84,1.84ZM4.19,13.78A12.0629,12.0629,0,0,1,6.96,8.09L11.35,8.91l1.53,3.06L10.37,16.15,7.32,16.91ZM9.2,25.87a12.11755,12.11755,0,0,1-3.04-3.02l1.6-3.99,2.95-.73L13.91,21.32l-.74,2.96Zm2.3,1.23,2.28-.91,1.77,1.77A11.81444,11.81444,0,0,1,11.5,27.1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-soccer-f",
		"name": "ki-soccer-f",
		"tags": "ki-soccer-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.03,3.91l-.01-.04-.05.01A13.84391,13.84391,0,0,0,16,2a14.04008,14.04008,0,1,0,7.03,1.91ZM4.21,13.8A11.92713,11.92713,0,0,1,6.98,8.11l4.38.82,1.54,3.06-2.51,4.18-3.05.76Zm8.98,10.5L9.21,25.89a12.07851,12.07851,0,0,1-3.03-3.02l1.59-3.99,2.96-.74,3.2,3.2ZM13.13,7.99,14.7,4.07c.43-.04.86-.07,1.3-.07a11.88451,11.88451,0,0,1,5.22,1.21L21.96,9.69l-2.27,2.27-4.99-.83ZM23.04,25.7a11.94293,11.94293,0,0,1-4.84,2.09l-3.06-3.06.74-2.96,4.11-1.64,3.05,1.52Zm.95-5.8-2.95-1.48V13.45l2.32-2.33,3.9.78A11.8756,11.8756,0,0,1,28,16a13.31859,13.31859,0,0,1-.11,1.56Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sort",
		"name": "ki-sort",
		"tags": "ki-sort",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17 24.586L17 7.505 22.495 13 23.955 11.541 16 3.586 8.045 11.541 9.505 13 15 7.505 15 24.586 9.707 19.293 8.293 20.707 16 28.414 23.707 20.707 22.293 19.293 17 24.586z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sort-down",
		"name": "ki-sort-down",
		"tags": "ki-sort-down",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24 19 8 19 16 27 24 19z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sort-up",
		"name": "ki-sort-up",
		"tags": "ki-sort-up",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8 13 24 13 16 5 8 13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sort-up-down",
		"name": "ki-sort-up-down",
		"tags": "ki-sort-up-down",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8 13 24 13 16 5 8 13z"
				},
				{
					"d": "M24 19 8 19 16 27 24 19z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-space",
		"name": "ki-space",
		"tags": "ki-space",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,13v5H4V13H2v5H2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2h0V13Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-spam",
		"name": "ki-spam",
		"tags": "ki-spam",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "21.5",
					"r": "1.5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M21.38477,29H10.61523L3,21.38477V10.61523L10.61523,3H21.38477L29,10.61523V21.38477Zm-9.94141-2h9.11328L27,20.55664V11.44336L20.55664,5H11.44336L5,11.44336v9.11328Z"
				},
				{
					"d": "M15 9H17V18H15z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-spam-f",
		"name": "ki-spam-f",
		"tags": "ki-spam-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21.38,3H10.62L3,10.62V21.38L10.62,29H21.38L29,21.38V10.62ZM15,9h2v9H15Zm1,14a1.5,1.5,0,1,1,1.5-1.5A1.498,1.498,0,0,1,16,23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sparkles",
		"name": "ki-sparkles",
		"tags": "ki-sparkles",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,17H22a5.00588,5.00588,0,0,1-5,5v2a5.00588,5.00588,0,0,1,5,5h2a5.00588,5.00588,0,0,1,5-5V22A5.00588,5.00588,0,0,1,24,17Zm-1,8.41333A7.04258,7.04258,0,0,0,20.58661,23,7.04189,7.04189,0,0,0,23,20.58655,7.04215,7.04215,0,0,0,25.41345,23,7.04284,7.04284,0,0,0,23,25.41333Z"
				},
				{
					"d": "M23,12a9.00984,9.00984,0,0,1-9-9H12a9.00984,9.00984,0,0,1-9,9v2a9.00984,9.00984,0,0,1,9,9h2a9.00984,9.00984,0,0,1,9-9ZM13,18.44421A11.05275,11.05275,0,0,0,7.55579,13,11.05275,11.05275,0,0,0,13,7.55579,11.05275,11.05275,0,0,0,18.44421,13,11.05275,11.05275,0,0,0,13,18.44421Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker",
		"name": "ki-speaker",
		"tags": "ki-speaker",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13.69727,11.08447H10a3.00328,3.00328,0,0,0-3,3v5a3.00328,3.00328,0,0,0,3,3h3.74121L24,27.78369V4.21631ZM9,19.08447v-5a1.00067,1.00067,0,0,1,1-1h3v7H10A1.00067,1.00067,0,0,1,9,19.08447Zm13,5.30078-7-3.889V12.61963l7-4.667Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker-f",
		"name": "ki-speaker-f",
		"tags": "ki-speaker-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13.7,11.08H10a3.00883,3.00883,0,0,0-3,3v5a3.00234,3.00234,0,0,0,3,3h3.74L24,27.78V4.22Zm-.7,9H10a.99651.99651,0,0,1-1-1v-5a1.003,1.003,0,0,1,1-1h3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker-mute",
		"name": "ki-speaker-mute",
		"tags": "ki-speaker-mute",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.69727,11H5a3.00328,3.00328,0,0,0-3,3v5a3.00328,3.00328,0,0,0,3,3H8.74121L19,27.69922V4.13184ZM4,19V14a1.00067,1.00067,0,0,1,1-1H8v7H5A1.00067,1.00067,0,0,1,4,19Zm13,5.30078-7-3.889V12.53516l7-4.667Z"
				},
				{
					"d": "M30.707 12.707L29.293 11.293 26 14.586 22.707 11.293 21.293 12.707 24.586 16 21.293 19.293 22.707 20.707 26 17.414 29.293 20.707 30.707 19.293 27.414 16 30.707 12.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker-mute-f",
		"name": "ki-speaker-mute-f",
		"tags": "ki-speaker-mute-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.69727,11H5a3.00328,3.00328,0,0,0-3,3v5a3.00328,3.00328,0,0,0,3,3H8.74121L19,27.69922V4.13184ZM4,19V14a1.00067,1.00067,0,0,1,1-1H8v7H5A1.00067,1.00067,0,0,1,4,19Z"
				},
				{
					"d": "M30.707 12.707L29.293 11.293 26 14.586 22.707 11.293 21.293 12.707 24.586 16 21.293 19.293 22.707 20.707 26 17.414 29.293 20.707 30.707 19.293 27.414 16 30.707 12.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker-sound",
		"name": "ki-speaker-sound",
		"tags": "ki-speaker-sound",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.16314,16.00415a10.00507,10.00507,0,0,1-4,8l-1.43994-1.44a7.975,7.975,0,0,0,0-13.12l1.43994-1.44A9.99047,9.99047,0,0,1,30.16314,16.00415Z"
				},
				{
					"d": "M26.16314,16.00415a5.96207,5.96207,0,0,1-2.94995,5.05l-1.47-1.47a4.135,4.135,0,0,0,2.41992-3.58,4.12265,4.12265,0,0,0-2.41992-3.58l.41992-.42,1.05005-1.05A5.94885,5.94885,0,0,1,26.16314,16.00415Z"
				},
				{
					"d": "M8.69727,11H5a3.00328,3.00328,0,0,0-3,3v5a3.00328,3.00328,0,0,0,3,3H8.74121L19,27.69922V4.13184ZM4,19V14a1.00067,1.00067,0,0,1,1-1H8v7H5A1.00067,1.00067,0,0,1,4,19Zm13,5.30078-7-3.889V12.53516l7-4.667Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-speaker-sound-f",
		"name": "ki-speaker-sound-f",
		"tags": "ki-speaker-sound-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.16314,16.00415a10.00507,10.00507,0,0,1-4,8l-1.43994-1.44a7.975,7.975,0,0,0,0-13.12l1.43994-1.44A9.99047,9.99047,0,0,1,30.16314,16.00415Z"
				},
				{
					"d": "M26.16314,16.00415a5.96207,5.96207,0,0,1-2.94995,5.05l-1.47-1.47a4.135,4.135,0,0,0,2.41992-3.58,4.12265,4.12265,0,0,0-2.41992-3.58l.41992-.42,1.05005-1.05A5.94885,5.94885,0,0,1,26.16314,16.00415Z"
				},
				{
					"d": "M8.69727,11H5a3.00328,3.00328,0,0,0-3,3v5a3.00328,3.00328,0,0,0,3,3H8.74121L19,27.69922V4.13184ZM4,19V14a1.00067,1.00067,0,0,1,1-1H8v7H5A1.00067,1.00067,0,0,1,4,19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-spectrum-sans",
		"name": "ki-spectrum-sans",
		"tags": "ki-spectrum-sans",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30.49332,29.00717H22.32339l-2.05957-5H11.714l-2.12012,5H1.49332l10.833-26h7.334Zm-6.83008-2h3.83008l-9.167-22h-4.666l-9.167,22H8.26968l2.12012-5H21.60367Zm-2.88281-7h-9.5752l4.78809-11.626Zm-6.58887-2H17.7941l-1.80078-4.374Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-spectrum-sans-f",
		"name": "ki-spectrum-sans-f",
		"tags": "ki-spectrum-sans-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.60282,3.00717h-7.22l-10.39,26h8l1.78-5h8.44l1.78,5h8Zm-6.61,15,3-7.84,3,7.84Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sports",
		"name": "ki-sports",
		"tags": "ki-sports",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,5H23V2H9V5H7A2.80787,2.80787,0,0,0,4,7.55566v3.88868A2.52466,2.52466,0,0,0,5.59082,13.7041,3.46432,3.46432,0,0,0,7,14V12a1.46463,1.46463,0,0,1-.58887-.11914C6.165,11.76953,6,11.59473,6,11.44434V7.55566C6,7.3291,6.38965,7,7,7H9v5a7.00552,7.00552,0,0,0,6,6.9201V22H12.5a2.05855,2.05855,0,0,0-2.15137,1.94043A.25257.25257,0,0,1,10.167,24,2.0908,2.0908,0,0,0,8,26v4H24V26a2.0908,2.0908,0,0,0-2.167-2c-.10059,0-.16211-.03906-.166-.01074A2.0929,2.0929,0,0,0,19.5,22H17V18.9201A7.00552,7.00552,0,0,0,23,12V7h2c.61035,0,1,.3291,1,.55566v3.88868C26,11.6709,25.61035,12,25,12v2a2.80787,2.80787,0,0,0,3-2.55566V7.55566A2.80787,2.80787,0,0,0,25,5ZM19.667,24.01074A2.092,2.092,0,0,0,21.833,26c.10351,0,.16113.03809.167.01172V28H9.99512l-.01074-1.94043A.256.256,0,0,1,10.167,26a2.05825,2.05825,0,0,0,2.15039-1.94043A.25607.25607,0,0,1,12.5,24h7C19.60254,24,19.66406,24.041,19.667,24.01074ZM21,12a5,5,0,0,1-10,0V4H21Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sports-f",
		"name": "ki-sports-f",
		"tags": "ki-sports-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,7.56v3.88A2.81331,2.81331,0,0,1,25,14V12c.61,0,1-.33,1-.56V7.56c0-.23-.39-.56-1-.56H23v5a7.00287,7.00287,0,0,1-6,6.92V22h2.5a2.097,2.097,0,0,1,2.17,1.99c0-.03.06.01.16.01A2.09218,2.09218,0,0,1,24,26v4H8V26a2.09218,2.09218,0,0,1,2.17-2,.26319.26319,0,0,0,.18-.06A2.05309,2.05309,0,0,1,12.5,22H15V18.92A7.00287,7.00287,0,0,1,9,12V7H7c-.61,0-1,.33-1,.56v3.88c0,.15.17.33.41.44A1.415,1.415,0,0,0,7,12v2a3.368,3.368,0,0,1-1.41-.3A2.516,2.516,0,0,1,4,11.44V7.56A2.81327,2.81327,0,0,1,7,5H9V2H23V5h2A2.81327,2.81327,0,0,1,28,7.56Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sprinkler",
		"name": "ki-sprinkler",
		"tags": "ki-sprinkler",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,24h2V22H20V20a3.00328,3.00328,0,0,0-3-3V15h2a2,2,0,0,0-2-2H15a2,2,0,0,0-2,2h2v2a3.00328,3.00328,0,0,0-3,3v2H10v2h2v4H4v2H28V28H20Zm-6-4a1.00067,1.00067,0,0,1,1-1h2a1.00067,1.00067,0,0,1,1,1v2H14Zm0,8V24h4v4Z"
				},
				{
					"d": "M20.37868 8.50011H24.621319999999997V10.4999H20.37868z",
					"transform": "rotate(-45 22.5 9.5)"
				},
				{
					"d": "M8.50011 7.37868H10.4999V11.62132H8.50011z",
					"transform": "rotate(-45 9.5 9.5)"
				},
				{
					"d": "M15 7H17V11H15z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M25.58579 4.00011H28.41422V5.9999H25.58579z",
					"transform": "rotate(-45 27 5)"
				},
				{
					"d": "M4.00011 3.58579H5.9999V6.41422H4.00011z",
					"transform": "rotate(-45 5 5)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sprinkler-f",
		"name": "ki-sprinkler-f",
		"tags": "ki-sprinkler-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,24h2V22H20V20a3.00328,3.00328,0,0,0-3-3V15h2a2,2,0,0,0-2-2H15a2,2,0,0,0-2,2h2v2a3.00328,3.00328,0,0,0-3,3v2H10v2h2v4H4v2H28V28H20Zm-6-4a1.00067,1.00067,0,0,1,1-1h2a1.00067,1.00067,0,0,1,1,1v2H14Z"
				},
				{
					"d": "M20.37868 8.50011H24.621319999999997V10.4999H20.37868z",
					"transform": "rotate(-45 22.5 9.5)"
				},
				{
					"d": "M8.50011 7.37868H10.4999V11.62132H8.50011z",
					"transform": "rotate(-45 9.5 9.5)"
				},
				{
					"d": "M15 7H17V11H15z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M25.58579 4.00011H28.41422V5.9999H25.58579z",
					"transform": "rotate(-45 27 5)"
				},
				{
					"d": "M4.00011 3.58579H5.9999V6.41422H4.00011z",
					"transform": "rotate(-45 5 5)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-square-checkbox",
		"name": "ki-square-checkbox",
		"tags": "ki-square-checkbox",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,29H3V5A2,2,0,0,1,5,3H27a2,2,0,0,1,2,2V27A2,2,0,0,1,27,29ZM5,27H27V5H5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-square-checkbox-f",
		"name": "ki-square-checkbox-f",
		"tags": "ki-square-checkbox-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,3H5A2.00587,2.00587,0,0,0,3,5V29H27a2.00591,2.00591,0,0,0,2-2V5A2.00587,2.00587,0,0,0,27,3ZM14,21.41l-4.71-4.7,1.42-1.42L14,18.59l7.29-7.3,1.42,1.42Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-square-checkbox-indeterminate",
		"name": "ki-square-checkbox-indeterminate",
		"tags": "ki-square-checkbox-indeterminate",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,29H3V5A2,2,0,0,1,5,3H27a2,2,0,0,1,2,2V27A2,2,0,0,1,27,29ZM5,27H27V5H5Z"
				},
				{
					"d": "M9 15H23V17H9z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-square-checkbox-indeterminate-f",
		"name": "ki-square-checkbox-indeterminate-f",
		"tags": "ki-square-checkbox-indeterminate-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,3H5A2.00583,2.00583,0,0,0,3,5V29H27a2.00591,2.00591,0,0,0,2-2V5A2.00583,2.00583,0,0,0,27,3ZM23,17H9V15H23Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-stamp",
		"name": "ki-stamp",
		"tags": "ki-stamp",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,17H20v-.58008a7.65651,7.65651,0,0,1,.40039-2.457,18.60932,18.60932,0,0,1,.87109-2.06543l.17774-.38281A6.00089,6.00089,0,1,0,10,9a5.91,5.91,0,0,0,.55469,2.52441l.09375.19825a21.16255,21.16255,0,0,1,.94336,2.21679A7.828,7.828,0,0,1,12,16.4502V17H3v8H6v1a3.00328,3.00328,0,0,0,3,3H23a3.00328,3.00328,0,0,0,3-3V25h3ZM13.35352,5.999a3.97988,3.97988,0,0,1,3.16308-.96679,4.04,4.04,0,0,1,3.459,3.55468,3.96987,3.96987,0,0,1-.34375,2.09375l-.17188.36817c-.29254.62524-.58343,1.27514-.82965,1.95117H13.36987c-.269-.73535-.59-1.44482-.91186-2.12793l-.09473-.20215A3.89457,3.89457,0,0,1,12,9,4.00676,4.00676,0,0,1,13.35352,5.999ZM13.88971,15h4.2182A9.78036,9.78036,0,0,0,18,16.41992V17H14v-.5498A9.965,9.965,0,0,0,13.88971,15ZM24,26a1.00067,1.00067,0,0,1-1,1H9a1.00067,1.00067,0,0,1-1-1V25H24Zm3-3H5V19H27Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-star",
		"name": "ki-star",
		"tags": "ki-star",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.633,29.00246a2.09489,2.09489,0,0,1-1.97656-2.73535l2.35009-7.28028-6.15039-4.498a2.08636,2.08636,0,0,1,1.22364-3.77051H11.675l2.34863-7.27637a2.07558,2.07558,0,0,1,3.95264,0l2.34863,7.27637h7.59571a2.08641,2.08641,0,0,1,1.22461,3.76953l-6.15137,4.499,2.34961,7.28028a2.0788,2.0788,0,0,1-3.2002,2.32715L16.0002,24.10207,9.85713,28.59523A2.0669,2.0669,0,0,1,8.633,29.00246ZM4.07979,12.71828c-.09326.11914-.06641.13867-.043.15625l7.31738,5.35058L8.55977,26.88234a.07266.07266,0,0,0,.03076.09863l7.40967-5.35742L23.32393,26.98c.13672-.03516.127-.06739.11621-.09864l-2.79395-8.65625,7.31836-5.35156a.0727.0727,0,0,0,.0293-.09863l-9.124-.05664L16.07344,4.05715c-.01025-.03223-.01856-.05664-.07324-.05664l-2.86914,8.71777Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-star-f",
		"name": "ki-star-f",
		"tags": "ki-star-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.63278,29.00246a2.09489,2.09489,0,0,1-1.97657-2.73535l2.3501-7.28028-6.15039-4.498a2.08636,2.08636,0,0,1,1.22363-3.77051h7.59522L14.0234,3.44191a2.07558,2.07558,0,0,1,3.95264,0l2.34863,7.27637h7.5957A2.08641,2.08641,0,0,1,29.145,14.48781l-6.15136,4.499,2.34961,7.28028a2.0788,2.0788,0,0,1-3.2002,2.32715L16,24.10207,9.8569,28.59523A2.067,2.067,0,0,1,8.63278,29.00246Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-star-half",
		"name": "ki-star-half",
		"tags": "ki-star-half",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.89,12.15a2.04034,2.04034,0,0,0-1.97-1.43h-7.6L17.98,3.44a2.08122,2.08122,0,0,0-3.96,0l-2.34,7.28H4.08a2.04034,2.04034,0,0,0-1.97,1.43,2.30149,2.30149,0,0,0-.11.68,2.04436,2.04436,0,0,0,.86,1.66l6.15,4.5L6.66,26.27A2.09024,2.09024,0,0,0,8.63,29a2.07643,2.07643,0,0,0,1.23-.4L16,24.1l6.14,4.49a2.076,2.076,0,0,0,3.2-2.32l-2.35-7.28,6.16-4.5A2.05919,2.05919,0,0,0,29.89,12.15Zm-1.93.72-7.31,5.36,2.79,8.65c.01.03.02.06-.12.1L16,21.62V4c.05,0,.06.02.07.06l2.8,8.66,9.12.05C28.01,12.84,27.99,12.86,27.96,12.87Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-start-over",
		"name": "ki-start-over",
		"tags": "ki-start-over",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.5,9H6.41406l4.293-4.293L9.293,3.293,2.58594,10l6.707,6.707L10.707,15.293,6.41406,11H19.5a7.5,7.5,0,0,1,0,15H8v2H19.5a9.5,9.5,0,0,0,0-19Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-stop",
		"name": "ki-stop",
		"tags": "ki-stop",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,29H3V3H29ZM5,27H27V5H5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-stop-circle",
		"name": "ki-stop-circle",
		"tags": "ki-stop-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Z"
				},
				{
					"d": "M21,21H11V11H21Zm-8-2h6V13H13Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-stop-circle-f",
		"name": "ki-stop-circle-f",
		"tags": "ki-stop-circle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01541,14.01541,0,0,0,16,2Zm5,19H11V11H21Z"
				},
				{
					"d": "M13 13H19V19H13z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-stop-f",
		"name": "ki-stop-f",
		"tags": "ki-stop-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3 3H29V29H3z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-store",
		"name": "ki-store",
		"tags": "ki-store",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.99283,25.00717h-7v-8h7Zm-5-2h3v-4h-3Z"
				},
				{
					"d": "M26.611,3.00717H5.37467L2.99283,7.77084V26.00717a3.00329,3.00329,0,0,0,3,3h3v-8.5a2.50263,2.50263,0,0,1,2.5-2.5,2.51747,2.51747,0,0,1,2.5,2.5v8.5h12a3.00328,3.00328,0,0,0,3-3V7.77084Zm-21.61817,6h4v1a2,2,0,0,1-4,0Zm6,0h4v1a2,2,0,0,1-4,0Zm6,0h4v1a2,2,0,0,1-4,0Zm6,0h4v1a2,2,0,0,1-4,0Zm2.38184-4,1,2H5.611l1-2Zm.61816,22h-10v-6.5a4.51708,4.51708,0,0,0-4.5-4.5,4.50492,4.50492,0,0,0-4.5,4.5v6.5h-1a1.001,1.001,0,0,1-1-1V13.45083a3.919,3.919,0,0,0,5-.82587,3.94676,3.94676,0,0,0,6,0,3.94676,3.94676,0,0,0,6,0,3.919,3.919,0,0,0,5,.82587V26.00717A1.001,1.001,0,0,1,25.99283,27.00717Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-streaming-box",
		"name": "ki-streaming-box",
		"tags": "ki-streaming-box",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "25",
					"cy": "23",
					"r": "1"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M2,14V25a3.00328,3.00328,0,0,0,3,3H27a3.00328,3.00328,0,0,0,3-3V14ZM28,25a1.00067,1.00067,0,0,1-1,1H5a1.00067,1.00067,0,0,1-1-1V20H28Zm0-7H4V16H28Z"
				},
				{
					"d": "M6 22H10V24H6z"
				},
				{
					"d": "M24.56836,7.9043a20.06124,20.06124,0,0,0-17.13672,0L6.58008,6.09375a22.06041,22.06041,0,0,1,18.83984,0Z"
				},
				{
					"d": "M21.6123,11.92285a14.57906,14.57906,0,0,0-11.2246,0L9.62207,10.0752a16.56151,16.56151,0,0,1,12.75586,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-streaming-box-f",
		"name": "ki-streaming-box-f",
		"tags": "ki-streaming-box-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M2,14V25a3.00883,3.00883,0,0,0,3,3H27a3.00883,3.00883,0,0,0,3-3V14Zm8,10H6V22h4Zm15,0a1,1,0,1,1,1-1A1.003,1.003,0,0,1,25,24Zm3-6H4V16H28Z"
				},
				{
					"d": "M24.56836,7.9043a20.06124,20.06124,0,0,0-17.13672,0L6.58008,6.09375a22.06041,22.06041,0,0,1,18.83984,0Z"
				},
				{
					"d": "M21.6123,11.92285a14.57906,14.57906,0,0,0-11.2246,0L9.62207,10.0752a16.56151,16.56151,0,0,1,12.75586,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-strikethrough",
		"name": "ki-strikethrough",
		"tags": "ki-strikethrough",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,17H20.89A6.96976,6.96976,0,0,1,23,22v1a5.00181,5.00181,0,0,1-5,5H13a3.99916,3.99916,0,0,1-3.77-2.67l1.88-.66A2.02018,2.02018,0,0,0,13,26h5a3.00887,3.00887,0,0,0,3-3V22a5.00181,5.00181,0,0,0-5-5H2V15h9.11A6.96976,6.96976,0,0,1,9,10V9a5.00181,5.00181,0,0,1,5-5h5a3.99921,3.99921,0,0,1,3.77,2.66992l-1.88.66A2.02024,2.02024,0,0,0,19,6H14a3.00879,3.00879,0,0,0-3,3v1a5.00181,5.00181,0,0,0,5,5H30Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-subscript",
		"name": "ki-subscript",
		"tags": "ki-subscript",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,22h4v-3c0-1.7-1.3-3-3-3h-4v2h4c0.6,0,1,0.4,1,1v1h-2c-1.7,0-3,1.3-3,3v3h7v-2h-5v-1C24,22.4,24.4,22,25,22z"
				},
				{
					"d": "M5,8h5v16H8v2h2h2h2v-2h-2V8h5v2h2V6H3v4h2V8z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sunrise",
		"name": "ki-sunrise",
		"tags": "ki-sunrise",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.941,15A8.99639,8.99639,0,0,0,7.059,15H4v2H28V15ZM9.07129,15a7.00059,7.00059,0,0,1,13.85742,0Z"
				},
				{
					"d": "M11.293 24.293L12.707 25.707 15 23.414 15 30 17 30 17 23.414 19.293 25.707 20.707 24.293 16 19.586 11.293 24.293z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M6.11095 5.53988H8.11074V8.68181H6.11095z",
					"transform": "rotate(-45 7.11084 7.11084)"
				},
				{
					"d": "M23.3182 6.11095H26.46013V8.11074H23.3182z",
					"transform": "rotate(-45 24.88916 7.11084)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sunrise-f",
		"name": "ki-sunrise-f",
		"tags": "ki-sunrise-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m28,15v2H4v-2h3.06c.5-4.48999,4.32001-8,8.94-8s8.44,3.51001,8.94,8h3.06Z"
				},
				{
					"d": "M11.29297 24.29297 12.70703 25.70703 15 23.41406 15 30 17 30 17 23.41406 19.29297 25.70703 20.70703 24.29297 16 19.58594 11.29297 24.29297z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M6.11095 5.53988H8.11074V8.68181H6.11095z",
					"transform": "rotate(-45 7.11084 7.11084)"
				},
				{
					"d": "M23.3182 6.11095H26.46013V8.11074H23.3182z",
					"transform": "rotate(-45 24.88916 7.11084)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sunset",
		"name": "ki-sunset",
		"tags": "ki-sunset",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.293 23.293L17 25.586 17 19 15 19 15 25.586 12.707 23.293 11.293 24.707 16 29.414 20.707 24.707 19.293 23.293z"
				},
				{
					"d": "M24.941,15A8.99639,8.99639,0,0,0,7.059,15H4v2H28V15ZM9.07129,15a7.00059,7.00059,0,0,1,13.85742,0Z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M6.11095 5.53988H8.11074V8.68181H6.11095z",
					"transform": "rotate(-45 7.11084 7.11084)"
				},
				{
					"d": "M23.3182 6.11095H26.46013V8.11074H23.3182z",
					"transform": "rotate(-45 24.88916 7.11084)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sunset-f",
		"name": "ki-sunset-f",
		"tags": "ki-sunset-f",
		"styles": "",
		"viewBox": "0 0 32.07071 32.07071",
		"width": "32.07071",
		"height": "32.07071",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.29297 23.29297 17 25.58594 17 19 15 19 15 25.58594 12.70703 23.29297 11.29297 24.70703 16 29.41406 20.70703 24.70703 19.29297 23.29297z"
				},
				{
					"d": "m28,15v2H4v-2h3.06c.5-4.48999,4.32001-8,8.94-8s8.44,3.51001,8.94,8h3.06Z"
				},
				{
					"d": "M15 2H17V5H15z"
				},
				{
					"d": "M6.11095 5.53988H8.11074V8.68181H6.11095z",
					"transform": "rotate(-45 7.11084 7.11084)"
				},
				{
					"d": "M23.3182 6.11095H26.46013V8.11074H23.3182z",
					"transform": "rotate(-45 24.88916 7.11084)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-superscript",
		"name": "ki-superscript",
		"tags": "ki-superscript",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25,12h4V9c0-1.7-1.3-3-3-3h-4v2h4c0.6,0,1,0.4,1,1v1h-2c-1.7,0-3,1.3-3,3v3h7v-2h-5v-1C24,12.4,24.4,12,25,12z"
				},
				{
					"d": "M5,8h5v16H8v2h2h2h2v-2h-2V8h5v2h2V6H3v4h2V8z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-support",
		"name": "ki-support",
		"tags": "ki-support",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00049,1.99951a14,14,0,1,0,14,14A14.01573,14.01573,0,0,0,16.00049,1.99951Zm7.74072,4.84522-3.55664,3.55652a6.94581,6.94581,0,0,0-8.36841,0L8.25977,6.84473a11.95233,11.95233,0,0,1,15.48144,0ZM16.00049,20.99951a5,5,0,1,1,5-5A5.00588,5.00588,0,0,1,16.00049,20.99951Zm-12-5A11.93959,11.93959,0,0,1,6.8457,8.25879l3.5564,3.55652a6.946,6.946,0,0,0,.00012,8.36834L6.8457,23.74023A11.93959,11.93959,0,0,1,4.00049,15.99951ZM8.25977,25.1543l3.55651-3.55658a6.94555,6.94555,0,0,0,8.36829.00006l3.55664,3.55652a11.95236,11.95236,0,0,1-15.48144,0Zm16.8955-1.41407-3.55664-3.55651a6.94534,6.94534,0,0,0,0-8.36841l3.55664-3.55652a11.95233,11.95233,0,0,1,0,15.48144Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-support-f",
		"name": "ki-support-f",
		"tags": "ki-support-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01538,14.01538,0,0,0,16,2Zm0,2a11.93606,11.93606,0,0,1,7.74,2.84L20.18,10.4a6.94027,6.94027,0,0,0-8.36,0L8.26,6.84A11.93606,11.93606,0,0,1,16,4Zm5,12a5,5,0,1,1-5-5A5.00181,5.00181,0,0,1,21,16ZM16,28a11.89089,11.89089,0,0,1-7.74-2.85l3.56-3.55a6.94,6.94,0,0,0,8.36,0l3.56,3.55A11.89089,11.89089,0,0,1,16,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-swap",
		"name": "ki-swap",
		"tags": "ki-swap",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M12.071 14.518 10.657 15.932 15.725 21 3 21 3 23 15.732 23 10.657 28.074 12.071 29.489 19.556 22.003 12.071 14.518z"
				},
				{
					"d": "M19.929 17.482 21.343 16.068 16.275 11 29 11 29 9 16.268 9 21.343 3.926 19.929 2.511 12.444 9.997 19.929 17.482z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-sync",
		"name": "ki-sync",
		"tags": "ki-sync",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,16h2c0-6.07001,4.92999-11,11-11,4.15997,0,7.92999,2.35999,9.78998,6h-2.78998s0,2,0,2h6s0-6,0-6h-2s0,2.07996,0,2.07996c-2.34998-3.71997-6.47998-6.07996-11-6.07996-7.16998,0-13,5.82996-13,13Z"
				},
				{
					"d": "M3,19v6s2,0,2,0v-2.08002c2.34003,3.72003,6.47998,6.08002,11,6.08002,7.16998,0,13-5.83002,13-13h-2c0,6.06-4.94,11-11,11-4.15997,0-7.92999-2.35999-9.78998-6h2.78998s0-2,0-2H3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tablet",
		"name": "ki-tablet",
		"tags": "ki-tablet",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M13.00045 23.99953H19.00045V25.99953H13.00045z"
				},
				{
					"d": "M24.00049,1.99951h-16a3.00328,3.00328,0,0,0-3,3v22a3.00328,3.00328,0,0,0,3,3h16a3.00328,3.00328,0,0,0,3-3v-22A3.00328,3.00328,0,0,0,24.00049,1.99951Zm-16,2h16a1.00067,1.00067,0,0,1,1,1v1h-18v-1A1.00067,1.00067,0,0,1,8.00049,3.99951Zm16,24h-16a1.00067,1.00067,0,0,1-1-1v-19h18v19A1.00067,1.00067,0,0,1,24.00049,27.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tablet-f",
		"name": "ki-tablet-f",
		"tags": "ki-tablet-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,2H8A3.00879,3.00879,0,0,0,5,5V27a3.00883,3.00883,0,0,0,3,3H24a3.00883,3.00883,0,0,0,3-3V5A3.00879,3.00879,0,0,0,24,2ZM19,26H13V24h6ZM25,6H7V5A1.003,1.003,0,0,1,8,4H24a1.003,1.003,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tape",
		"name": "ki-tape",
		"tags": "ki-tape",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24.00049,9.99951a5.9899,5.9899,0,0,0-4.4596,10H12.46a5.99125,5.99125,0,1,0-4.45947,2h16a6,6,0,0,0,0-12Zm-20,6a4,4,0,1,1,4,4A4.004,4.004,0,0,1,4.00049,15.99951Zm20,4a4,4,0,1,1,4-4A4.00395,4.00395,0,0,1,24.00049,19.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tape-f",
		"name": "ki-tape-f",
		"tags": "ki-tape-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,16a6.00475,6.00475,0,0,1-6,6H8a6.022,6.022,0,1,1,4.46-2h7.08A5.99626,5.99626,0,1,1,30,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-feels-like",
		"name": "ki-temperature-feels-like",
		"tags": "ki-temperature-feels-like",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M14,20.01996V6c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002,.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3,6.98004c-1.65997,0-3-1.34003-3-3,0-1.31,.83002-2.42004,2-2.82001V6c0-.54999,.45001-1,1-1s1,.45001,1,1v15.17999c1.16998,.39996,2,1.51001,2,2.82001,0,1.65997-1.34003,3-3,3Z"
				},
				{
					"d": "M22,8c1.65421,0,3,1.34579,3,3s-1.34579,3-3,3-3-1.34579-3-3,1.34579-3,3-3m0-2c-2.76143,0-5,2.23859-5,5s2.23857,5,5,5,5-2.23859,5-5-2.23857-5-5-5h0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-feels-like-f",
		"name": "ki-temperature-feels-like-f",
		"tags": "ki-temperature-feels-like-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "22",
					"cy": "11",
					"r": "5"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M14,20V6c0-1.7-1.3-3-3-3S8,4.3,8,6v14c-1.2,0.9-2,2.4-2,4c0,2.8,2.2,5,5,5s5-2.2,5-5C16,22.4,15.2,20.9,14,20z M11,5 c0.5,0,1,0.5,1,1v3.9h-2V6C10,5.4,10.5,5,11,5z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-high",
		"name": "ki-temperature-high",
		"tags": "ki-temperature-high",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m14,20.01996V6c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3,6.98004c-1.65997,0-3-1.34003-3-3,0-1.31.83002-2.42004,2-2.82001V6c0-.54999.45001-1,1-1s1,.45001,1,1v15.17999c1.16998.39996,2,1.51001,2,2.82001,0,1.65997-1.34003,3-3,3Z"
				},
				{
					"d": "M27.70703 15.22226 22 9.51523 16.29297 15.22226 17.70703 16.63632 21 13.34335 21 21.92929 23 21.92929 23 13.34335 26.29297 16.63632 27.70703 15.22226z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-high-f",
		"name": "ki-temperature-high-f",
		"tags": "ki-temperature-high-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.70703 15.22226 22 9.51523 16.29297 15.22226 17.70703 16.63632 21 13.34335 21 21.92929 23 21.92929 23 13.34335 26.29297 16.63632 27.70703 15.22226z"
				},
				{
					"d": "m14,20.01993V5.99997c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3-15.01996c.54999,0,1,.45001,1,1v3.92932h-2v-3.92932c0-.54999.45001-1,1-1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-low",
		"name": "ki-temperature-low",
		"tags": "ki-temperature-low",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m14,20.01996V6c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3,6.98004c-1.65997,0-3-1.34003-3-3,0-1.31.83002-2.42004,2-2.82001V6c0-.54999.45001-1,1-1s1,.45001,1,1v15.17999c1.16998.39996,2,1.51001,2,2.82001,0,1.65997-1.34003,3-3,3Z"
				},
				{
					"d": "M26.29297 14.8082 23 18.10116 23 9.51523 21 9.51523 21 18.10116 17.70703 14.8082 16.29297 16.22226 22 21.92929 27.70703 16.22226 26.29297 14.8082z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-temperature-low-f",
		"name": "ki-temperature-low-f",
		"tags": "ki-temperature-low-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.30469 14.91757 23 18.16604 23 9.51523 21 9.51523 21 18.16604 17.69531 14.91757 16.30469 16.33163 22 21.93027 27.69531 16.33163 26.30469 14.91757z"
				},
				{
					"d": "m14,20.01993V5.99997c0-1.65002-1.34998-3-3-3s-3,1.34998-3,3v14.01996c-1.21002.92004-2,2.35004-2,3.98004,0,2.76001,2.23999,5,5,5s5-2.23999,5-5c0-1.63-.78998-3.06-2-3.98004Zm-3-15.01996c.54999,0,1,.45001,1,1v3.92932h-2v-3.92932c0-.54999.45001-1,1-1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-terminal",
		"name": "ki-terminal",
		"tags": "ki-terminal",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M7.707 19.707L6.293 18.293 8.586 16 6.293 13.707 7.707 12.293 11.414 16 7.707 19.707z"
				},
				{
					"d": "M13 18H19V20H13z"
				},
				{
					"d": "M27.00043,3.99951h-22a3.00328,3.00328,0,0,0-3,3v21h25a3.00328,3.00328,0,0,0,3-3v-18A3.00328,3.00328,0,0,0,27.00043,3.99951Zm-22,2h22a1.00067,1.00067,0,0,1,1,1V8h-24V6.99951A1.00067,1.00067,0,0,1,5.00043,5.99951Zm22,20h-23V10h24V24.99951A1.00067,1.00067,0,0,1,27.00043,25.99951Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-text-editor",
		"name": "ki-text-editor",
		"tags": "ki-text-editor",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,3H20V5h6a1.00067,1.00067,0,0,1,1,1V26a1.00067,1.00067,0,0,1-1,1H5V10H3V29H26a3.00328,3.00328,0,0,0,3-3V6A3.00328,3.00328,0,0,0,26,3Z"
				},
				{
					"d": "M5 5L9 5 9 15 7 15 7 17 9 17 11 17 13 17 13 15 11 15 11 5 15 5 15 7 17 7 17 3 3 3 3 7 5 7 5 5z"
				},
				{
					"d": "M15 11H25V13H15z"
				},
				{
					"d": "M15 15H25V17H15z"
				},
				{
					"d": "M7 19H25V21H7z"
				},
				{
					"d": "M7 23H25V25H7z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-thermostat",
		"name": "ki-thermostat",
		"tags": "ki-thermostat",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,30A14,14,0,1,1,30,16,14.01572,14.01572,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.01312,12.01312,0,0,0,16,4Z"
				},
				{
					"d": "M16,7.07324a8.99894,8.99894,0,0,0-4.501,16.792l1.002-1.73046A6.99359,6.99359,0,0,1,15,9.15308v2.92016h2V9.15308a6.99359,6.99359,0,0,1,2.499,12.98169l1.002,1.73046A8.99894,8.99894,0,0,0,16,7.07324Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-thermostat-f",
		"name": "ki-thermostat-f",
		"tags": "ki-thermostat-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,2A14,14,0,1,0,30,16,14.01572,14.01572,0,0,0,16,2Zm4.502,21.792-1.0039-1.73047A6.9932,6.9932,0,0,0,17,9.07983V12H15V9.07983a6.9932,6.9932,0,0,0-2.498,12.98169L11.498,23.792a9,9,0,1,1,9.0039,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ticket",
		"name": "ki-ticket",
		"tags": "ki-ticket",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11 19H13V22H11z"
				},
				{
					"d": "M29.00049,13.00391h1v-9h-28v9h1a3,3,0,0,1,0,6h-1v9h28v-9h-1a3,3,0,1,1,0-6Zm-1,7.89941v5.10059H13V24H11v2.00391H4.00049V20.90332a5.00053,5.00053,0,0,0,0-9.79883V6.00391H11V17h2V6.00391H28.00049v5.10058a5.00053,5.00053,0,0,0,0,9.79883Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-ticket-f",
		"name": "ki-ticket-f",
		"tags": "ki-ticket-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,13h1V4H2v9H3a3,3,0,0,1,0,6H2v9H30V19H29a3,3,0,0,1,0-6ZM13,26H11V24h2Zm0-4H11V19h2Zm0-5H11V6h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tool-box",
		"name": "ki-tool-box",
		"tags": "ki-tool-box",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,8H25V7a3.00328,3.00328,0,0,0-3-3H10A3.00328,3.00328,0,0,0,7,7V8H5a3.00328,3.00328,0,0,0-3,3V28H30V11A3.00328,3.00328,0,0,0,27,8ZM9,7a1.001,1.001,0,0,1,1-1H22a1.001,1.001,0,0,1,1,1V8H9ZM28,26H4V16h8v5h8V16h8ZM14,16h4v3H14Zm6-2H4V11a1.001,1.001,0,0,1,1-1H27a1.001,1.001,0,0,1,1,1v3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-transfer-number",
		"name": "ki-transfer-number",
		"tags": "ki-transfer-number",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M7 17L22.586 17 21.293 18.293 22.707 19.707 26.414 16 22.707 12.293 21.293 13.707 22.586 15 7 15 7 17z"
				},
				{
					"d": "M13,22H3V10H13v3h2V7a3.00328,3.00328,0,0,0-3-3H4A3.00328,3.00328,0,0,0,1,7V25a3.00328,3.00328,0,0,0,3,3h8a3.00328,3.00328,0,0,0,3-3V19H13ZM4,6h8a1.00067,1.00067,0,0,1,1,1V8H3V7A1.00067,1.00067,0,0,1,4,6Zm8,20H4a1.00067,1.00067,0,0,1-1-1V24H13v1A1.00067,1.00067,0,0,1,12,26Z"
				},
				{
					"d": "M28,4H20a3.00328,3.00328,0,0,0-3,3v6h2V10H29V22H19V19H17v6a3.00328,3.00328,0,0,0,3,3h8a3.00328,3.00328,0,0,0,3-3V7A3.00328,3.00328,0,0,0,28,4ZM19,8V7a1.00067,1.00067,0,0,1,1-1h8a1.00067,1.00067,0,0,1,1,1V8Zm9,18H20a1.00067,1.00067,0,0,1-1-1V24H29v1A1.00067,1.00067,0,0,1,28,26Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-trash",
		"name": "ki-trash",
		"tags": "ki-trash",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M19.00049 10.99951H21.00049V24.99951H19.00049z"
				},
				{
					"d": "M15.00049 10.99951H17.00049V24.99951H15.00049z"
				},
				{
					"d": "M11.00049 10.99951H13.00049V24.99951H11.00049z"
				},
				{
					"d": "M28.00049,5.99951h-7v-1a3.00328,3.00328,0,0,0-3-3h-4a3.00328,3.00328,0,0,0-3,3v1h-7v2H6.04443l.87012,19.13574a2.99417,2.99417,0,0,0,2.99707,2.86426H22.08936a2.99314,2.99314,0,0,0,2.99609-2.86328L25.9563,7.99951h2.04419Zm-15-1a1.00067,1.00067,0,0,1,1-1h4a1.00067,1.00067,0,0,1,1,1v1h-6ZM23.0874,27.04541a.99706.99706,0,0,1-.998.9541H9.91162a.99794.99794,0,0,1-.999-.9541L8.04736,7.99951H23.95361Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-trash-f",
		"name": "ki-trash-f",
		"tags": "ki-trash-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M21,6V5a3.00879,3.00879,0,0,0-3-3H14a3.00879,3.00879,0,0,0-3,3V6H4V8H6.04l.87,19.14a3.00187,3.00187,0,0,0,3,2.86H22.09a3.00187,3.00187,0,0,0,3-2.86L25.96,8H28V6ZM13,25H11V11h2ZM13,5a1.003,1.003,0,0,1,1-1h4a1.003,1.003,0,0,1,1,1V6H13Zm4,20H15V11h2Zm4,0H19V11h2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-triangle",
		"name": "ki-triangle",
		"tags": "ki-triangle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.68457,28H2.31543L16,2.91211Zm-24-2H26.31543L16,7.08789Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-triangle-f",
		"name": "ki-triangle-f",
		"tags": "ki-triangle-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.68457,28H2.31543L16,2.91211Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-triple-fast-forward-f",
		"name": "ki-triple-fast-forward-f",
		"tags": "ki-triple-fast-forward-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17 6L32 16 17 26 17 24 29 16 17 8 17 6z"
				},
				{
					"d": "M10 26L10 20 0 26 0 6 10 12 10 6 26 16 10 26z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-triple-rewind-f",
		"name": "ki-triple-rewind-f",
		"tags": "ki-triple-rewind-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 6L0 16 15 26 15 24 3 16 15 8 15 6z"
				},
				{
					"d": "M22 26L22 20 32 26 32 6 22 12 22 6 6 16 22 26z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-truck",
		"name": "ki-truck",
		"tags": "ki-truck",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,16H25.69l-1.5-4L23.42,9.95A2.972,2.972,0,0,0,21,8.03V6h3V4H2V6H5V8a3.00879,3.00879,0,0,0-3,3V23a3.00887,3.00887,0,0,0,3,3H6.35a3.48066,3.48066,0,0,0,6.3,0h6.7a3.48066,3.48066,0,0,0,6.3,0H30V19A3.00879,3.00879,0,0,0,27,16Zm-4.19-2,.75,2H18V14ZM14,6h5V8H14ZM7,6h5V8H7ZM9.5,26A1.498,1.498,0,0,1,8,24.5a1.3859,1.3859,0,0,1,.09-.5A1.494,1.494,0,0,1,10.91,24a1.3859,1.3859,0,0,1,.09.5A1.498,1.498,0,0,1,9.5,26ZM21,24.5a1.3859,1.3859,0,0,1,.09-.5A1.494,1.494,0,0,1,23.91,24a1.3859,1.3859,0,0,1,.09.5,1.5,1.5,0,0,1-3,0Zm7-.5H25.96a3.49529,3.49529,0,0,0-6.92,0H12.96a3.49529,3.49529,0,0,0-6.92,0H5a1.00291,1.00291,0,0,1-1-1V11a1.00291,1.00291,0,0,1,1-1H20.61a1.00677,1.00677,0,0,1,.94.6499L22.06,12H16v6H27a1.00291,1.00291,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-truck-f",
		"name": "ki-truck-f",
		"tags": "ki-truck-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,16H25.69l-1.5-4L23.42,9.95A2.972,2.972,0,0,0,21,8.03V6h3V4H2V6H5V8a3.00879,3.00879,0,0,0-3,3V23a3.00887,3.00887,0,0,0,3,3H6.35a3.48066,3.48066,0,0,0,6.3,0h6.7a3.48066,3.48066,0,0,0,6.3,0H30V19A3.00879,3.00879,0,0,0,27,16ZM19,8H14V6h5ZM7,6h5V8H7ZM9.5,26A1.5,1.5,0,1,1,11,24.5,1.498,1.498,0,0,1,9.5,26ZM16,16V12h6l1.56,4Zm6.5,10A1.5,1.5,0,1,1,24,24.5,1.498,1.498,0,0,1,22.5,26Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv",
		"name": "ki-tv",
		"tags": "ki-tv",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,4H4A2,2,0,0,0,2,6V23a2,2,0,0,0,2,2H6L5,28H7l1-3H24l1,3h2l-1-3h2a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,19H4V6H28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv-dvr",
		"name": "ki-tv-dvr",
		"tags": "ki-tv-dvr",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28 4H4c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h2l-1 3h2l1-3h16l1 3h2l-1-3h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 19H4V6h24v17Z"
				},
				{
					"d": "M8 17.75v-5.78h2.05c.64 0 1.2.12 1.68.36s.85.57 1.11 1.01c.26.43.4.94.4 1.52s-.13 1.09-.39 1.53-.63.77-1.11 1.01c-.48.24-1.04.35-1.7.35H7.99Zm1.2-1.04h.86c.6 0 1.07-.17 1.42-.5.35-.33.52-.78.52-1.35s-.17-1.02-.52-1.35c-.35-.33-.82-.49-1.42-.49H9.2v3.7ZM15.84 17.77l-2.46-5.8h1.31l1.55 3.98 1.54-3.98h1.26l-2.48 5.8h-.73ZM19.78 17.75v-5.78h1.92c.7 0 1.25.16 1.65.49s.59.78.59 1.36c0 .42-.13.77-.38 1.05-.26.28-.61.48-1.07.58l2 2.29h-1.46l-1.84-2.21h-.24v2.21h-1.16Zm1.92-4.81h-.76v1.75h.76c.34 0 .6-.07.78-.22.18-.15.27-.36.27-.65 0-.59-.35-.88-1.06-.88Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv-dvr-f",
		"name": "ki-tv-dvr-f",
		"tags": "ki-tv-dvr-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M11.48,13.51c-.35-.33-.82-.5-1.42-.5h-.86v3.7h.86c.6,0,1.07-.17,1.42-.5.35-.33.52-.78.52-1.35s-.17-1.02-.52-1.35ZM11.48,13.51c-.35-.33-.82-.5-1.42-.5h-.86v3.7h.86c.6,0,1.07-.17,1.42-.5.35-.33.52-.78.52-1.35s-.17-1.02-.52-1.35ZM11.48,13.51c-.35-.33-.82-.5-1.42-.5h-.86v3.7h.86c.6,0,1.07-.17,1.42-.5.35-.33.52-.78.52-1.35s-.17-1.02-.52-1.35ZM21.7,12.94h-.76v1.75h.76c.34,0,.6-.08.78-.22.19-.15.28-.36.28-.65,0-.59-.36-.88-1.06-.88ZM21.7,12.94h-.76v1.75h.76c.34,0,.6-.08.78-.22.19-.15.28-.36.28-.65,0-.59-.36-.88-1.06-.88ZM11.48,13.51c-.35-.33-.82-.5-1.42-.5h-.86v3.7h.86c.6,0,1.07-.17,1.42-.5.35-.33.52-.78.52-1.35s-.17-1.02-.52-1.35ZM28,4H4c-1.1,0-2,.9-2,2v17c0,1.1.9,2,2,2h2l-1,3h2l1-3h16l1,3h2l-1-3h2c1.1,0,2-.9,2-2V6c0-1.1-.9-2-2-2ZM28,23H4V6h24v17ZM26,8H6v13h20v-13ZM12.85,16.39c-.26.43-.63.77-1.11,1-.47.24-1.04.36-1.69.36h-2.05v-5.78h2.05c.64,0,1.2.12,1.68.36.48.24.85.57,1.12,1.01.26.43.39.94.39,1.52s-.13,1.09-.39,1.53ZM16.57,17.77h-.73l-2.46-5.8h1.31l1.55,3.98,1.55-3.98h1.26l-2.48,5.8ZM23.02,17.75l-1.84-2.21h-.24v2.21h-1.16v-5.78h1.92c.7,0,1.25.16,1.65.49.39.33.59.78.59,1.36,0,.42-.13.77-.39,1.05-.25.29-.61.48-1.07.58l2,2.3h-1.46Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv-f",
		"name": "ki-tv-f",
		"tags": "ki-tv-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,4H4A2,2,0,0,0,2,6V23a2,2,0,0,0,2,2H6L5,28H7l1-3H24l1,3h2l-1-3h2a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,19H4V6H28Z"
				},
				{
					"d": "M6 8H26V21H6z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv-send",
		"name": "ki-tv-send",
		"tags": "ki-tv-send",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28,18v3a1.003,1.003,0,0,1-1,1H5a1.003,1.003,0,0,1-1-1V7A1.003,1.003,0,0,1,5,6H16V4H5A3.00879,3.00879,0,0,0,2,7V21a3.00883,3.00883,0,0,0,3,3H15v2H9a1.99946,1.99946,0,0,0-2,2H25a1.99946,1.99946,0,0,0-2-2H17V24H27a3.00883,3.00883,0,0,0,3-3V18Z"
				},
				{
					"d": "M30 16L30 14 21.419 14 29.002 6.417 27.588 5.002 20 12.591 20 4 18 4 18 16 30 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-tv-send-f",
		"name": "ki-tv-send-f",
		"tags": "ki-tv-send-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30 16L30 14 21.419 14 29.002 6.417 27.588 5.002 20 12.591 20 4 18 4 18 16 30 16z"
				},
				{
					"d": "M28,18H16V4H5A3.00879,3.00879,0,0,0,2,7V21a3.00883,3.00883,0,0,0,3,3H15v2H9a1.99946,1.99946,0,0,0-2,2H25a1.99946,1.99946,0,0,0-2-2H17V24H27a3.00883,3.00883,0,0,0,3-3V18Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-twitter",
		"name": "ki-twitter",
		"tags": "ki-twitter",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5Zm19.46288,7.685c.00924.14855.00924.28786.00924.4364A9.48567,9.48567,0,0,1,7.875,21.10714a7.506,7.506,0,0,0,.78926.04642,6.68873,6.68873,0,0,0,4.14145-1.43A3.33951,3.33951,0,0,1,9.695,17.41139a3.42756,3.42756,0,0,0,1.50428-.05571A3.34761,3.34761,0,0,1,8.525,14.08715v-.04642a3.33375,3.33375,0,0,0,1.51358.41781A3.33279,3.33279,0,0,1,9.00783,10.0107a9.48162,9.48162,0,0,0,6.87145,3.48215,3.34029,3.34029,0,0,1,5.68285-3.04575,6.74932,6.74932,0,0,0,2.11717-.80785,3.37113,3.37113,0,0,1-1.46715,1.84791,6.8983,6.8983,0,0,0,1.91285-.5293A6.83568,6.83568,0,0,1,22.46288,12.685Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-underline",
		"name": "ki-underline",
		"tags": "ki-underline",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M5 28H27V30H5z"
				},
				{
					"d": "M21,2V4h2V16A7,7,0,0,1,9,16V4h2V2H5V4H7V16a9,9,0,0,0,18,0V4h2V2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-upgrade",
		"name": "ki-upgrade",
		"tags": "ki-upgrade",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m16,4.82842l7.17157,7.17157h-4.23157v12h-5.88v-12h-4.23157l7.17157-7.17157m0-2.82843L4,13.99999h7.06v12h9.88v-12h7.06L16,1.99999h0Z"
				},
				{
					"d": "m6,28h20c1.10383,0,2,.89617,2,2H4c0-1.10383.89617-2,2-2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-upgrade-f",
		"name": "ki-upgrade-f",
		"tags": "ki-upgrade-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M28 14L20.94 14 20.94 26 11.06 26 11.06 14 4 14 16 2 28 14z"
				},
				{
					"d": "M6,28H26a2,2,0,0,1,2,2v0a0,0,0,0,1,0,0H4a0,0,0,0,1,0,0v0A2,2,0,0,1,6,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-upload",
		"name": "ki-upload",
		"tags": "ki-upload",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M8.658 12.753L15 7.204 15 23 17 23 17 7.204 23.342 12.753 24.658 11.247 16 3.671 7.342 11.247 8.658 12.753z"
				},
				{
					"d": "M27,28H5a3.00328,3.00328,0,0,1-3-3V9A3.00328,3.00328,0,0,1,5,6H6V8H5A1.00067,1.00067,0,0,0,4,9V25a1.00067,1.00067,0,0,0,1,1H27a1.00067,1.00067,0,0,0,1-1V9a1.00067,1.00067,0,0,0-1-1H26V6h1a3.00328,3.00328,0,0,1,3,3V25A3.00328,3.00328,0,0,1,27,28Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-video-camera",
		"name": "ki-video-camera",
		"tags": "ki-video-camera",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M30,8.77441l-6,3.43946V10a3.00328,3.00328,0,0,0-3-3H5a3.00328,3.00328,0,0,0-3,3V25H21a3.00328,3.00328,0,0,0,3-3V19.78613l6,3.43946ZM22,22a1.001,1.001,0,0,1-1,1H4V10A1.001,1.001,0,0,1,5,9H21a1.001,1.001,0,0,1,1,1V22Zm6-2.22559-4-2.293v-2.9629l4-2.293Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-video-camera-f",
		"name": "ki-video-camera-f",
		"tags": "ki-video-camera-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M24,12.21V10a3.00879,3.00879,0,0,0-3-3H5a3.00879,3.00879,0,0,0-3,3V25H21a3.00887,3.00887,0,0,0,3-3V19.79L30,23.23V8.77ZM22,22a1.00291,1.00291,0,0,1-1,1H4V10A1.00291,1.00291,0,0,1,5,9H21a1.00291,1.00291,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-video-popout",
		"name": "ki-video-popout",
		"tags": "ki-video-popout",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,16h-2V8c0-1.10461-.89539-2-2-2H5c-1.10455,0-2,.89539-2,2v12c0,1.10455,.89545,2,2,2h11v2c0,1.10455,.89545,2,2,2h9c1.10455,0,2-.89545,2-2v-6c0-1.10461-.89545-2-2-2ZM5,20.21313c-.11755,0-.21313-.09558-.21313-.21313V8c0-.11755,.09558-.2132,.21313-.2132H23c.11755,0,.2132,.09564,.2132,.2132v8h-5.2132c-1.10455,0-2,.89539-2,2v2.21313H5Z"
				},
				{
					"d": "M11 10 11 12.58594 7.70703 9.29297 6.29297 10.70703 9.58594 14 7 14 7 16 13 16 13 10 11 10z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-video-popout-f",
		"name": "ki-video-popout-f",
		"tags": "ki-video-popout-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M17,24v-6c0-.55176,.44824-1,1-1h9c.55176,0,1,.44824,1,1v6c0,.55176-.44824,1-1,1h-9c-.55176,0-1-.44824-1-1Z"
				},
				{
					"d": "M23,6H5c-1.09998,0-2,.89996-2,2v12c0,1.09998,.90002,2,2,2H15v-4c0-1.65002,1.34998-3,3-3h7v-7c0-1.10004-.90002-2-2-2Zm-10,10H7v-2h2.58594l-3.29297-3.29297,1.41406-1.41406,3.29297,3.29297v-2.58594h2v6Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wallet",
		"name": "ki-wallet",
		"tags": "ki-wallet",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "22",
					"cy": "16",
					"r": "2"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M27,10V7a3.00887,3.00887,0,0,0-3-3H5A3.00887,3.00887,0,0,0,2,7V25a3.00887,3.00887,0,0,0,3,3H24a3.00887,3.00887,0,0,0,3-3V22a3.00887,3.00887,0,0,0,3-3V13A3.00887,3.00887,0,0,0,27,10ZM25,25a1.00291,1.00291,0,0,1-1,1H5a1.00291,1.00291,0,0,1-1-1V7A1.00291,1.00291,0,0,1,5,6H24a1.00291,1.00291,0,0,1,1,1v3H19a3.00887,3.00887,0,0,0-3,3v6a3.00887,3.00887,0,0,0,3,3h6Zm3-6a1.00291,1.00291,0,0,1-1,1H19a1.00291,1.00291,0,0,1-1-1V13a1.00291,1.00291,0,0,1,1-1h8a1.00291,1.00291,0,0,1,1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-waveform-lines",
		"name": "ki-waveform-lines",
		"tags": "ki-waveform-lines",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 4H17V28H15z"
				},
				{
					"d": "M19 12H21V20H19z"
				},
				{
					"d": "M23 9H25V23H23z"
				},
				{
					"d": "M27 14H29V18H27z"
				},
				{
					"d": "M10.98633 10H12.98633V22H10.98633z"
				},
				{
					"d": "M6.98607 12.99997H8.98609V19.00003H6.98607z",
					"transform": "rotate(-.266 7.98696 15.99983)"
				},
				{
					"d": "M2.9585 15H4.9585V17H2.9585z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather",
		"name": "ki-weather",
		"tags": "ki-weather",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00045,23.99953a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,16.00045,23.99953Zm0-14a6,6,0,1,0,6,6A6.00656,6.00656,0,0,0,16.00045,9.99953Z"
				},
				{
					"d": "M22.17202 5.99964H27.828870000000002V7.99943H22.17202z",
					"transform": "rotate(-45 25.00045 6.99953)"
				},
				{
					"d": "M4.17202 23.99964H9.82887V25.99943H4.17202z",
					"transform": "rotate(-45 7.00045 24.99953)"
				},
				{
					"d": "M6.00056 4.1711H8.000350000000001V9.827950000000001H6.00056z",
					"transform": "rotate(-45 7.00045 6.99953)"
				},
				{
					"d": "M24.00056 22.1711H26.00035V27.82795H24.00056z",
					"transform": "rotate(-45 25.00045 24.99952)"
				},
				{
					"d": "M15.00045 1.85402H17.00045V5.99953H15.00045z"
				},
				{
					"d": "M15.00045 25.99953H17.00045V30.14406H15.00045z"
				},
				{
					"d": "M1.85983 15.00197H6.00046V17.00197H1.85983z"
				},
				{
					"d": "M27.07028 13.93214H29.07028V18.07179H27.07028z",
					"transform": "rotate(-89.932 28.07028 16.00197)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-f",
		"name": "ki-weather-f",
		"tags": "ki-weather-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "16",
					"r": "8"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M22.17202 5.99964H27.828870000000002V7.99943H22.17202z",
					"transform": "rotate(-45 25.00045 6.99953)"
				},
				{
					"d": "M4.17202 23.99964H9.82887V25.99943H4.17202z",
					"transform": "rotate(-45 7.00045 24.99953)"
				},
				{
					"d": "M6.00056 4.1711H8.000350000000001V9.827950000000001H6.00056z",
					"transform": "rotate(-45 7.00045 6.99953)"
				},
				{
					"d": "M24.00056 22.1711H26.00035V27.82795H24.00056z",
					"transform": "rotate(-45 25.00045 24.99952)"
				},
				{
					"d": "M15.00045 1.85402H17.00045V5.99953H15.00045z"
				},
				{
					"d": "M15.00045 25.99953H17.00045V30.14406H15.00045z"
				},
				{
					"d": "M1.85983 15.00197H6.00046V17.00197H1.85983z"
				},
				{
					"d": "M27.07028 13.93214H29.07028V18.07179H27.07028z",
					"transform": "rotate(-89.932 28.07028 16.00197)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-hurricane",
		"name": "ki-weather-hurricane",
		"tags": "ki-weather-hurricane",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M25.75,10.8999a.67149.67149,0,0,0-.07-.10986A9.37053,9.37053,0,0,0,24.52,9.1c-.06-.07-.13-.15-.19-.22-.16-.20007-.32-.39-.47-.55a2.39425,2.39425,0,0,0-.22-.23,3.24645,3.24645,0,0,0-.27-.26L25.8,4.6a.99617.99617,0,0,0,.09-1.04993A.977.977,0,0,0,25,3C18.12,3,13.65,4.63,10.9,6.25a.67323.67323,0,0,0-.11.07007A9.374,9.374,0,0,0,9.1,7.48c-.07.06006-.15.13-.22.18994-.2.16-.39.32007-.55.47009a2.38759,2.38759,0,0,0-.23.22,3.24537,3.24537,0,0,0-.26.27,10.27416,10.27416,0,0,0-1.2,1.6A10.8728,10.8728,0,0,0,5,16a10.92953,10.92953,0,0,0,1.25,5.1.67232.67232,0,0,0,.07.11,4.6188,4.6188,0,0,0,.31.51,9.90435,9.90435,0,0,0,1.13,1.53c.17.18994.33.37.48.53a4.08836,4.08836,0,0,0,.36.36c.01.00989.02.0199.03.0199l-2.43,3.24A.9964.9964,0,0,0,6.11,28.45.977.977,0,0,0,7,29c6.88,0,11.35-1.63,14.1-3.25a.67323.67323,0,0,0,.11-.07007c.33-.19995.63-.38989.91-.58.03-.02.07-.04993.1-.06995.14-.1001.27-.20007.4-.3.17-.13.33-.25.49-.39.01-.01.01-.01.02-.01.15-.13.29-.25.41-.36.14-.12.26-.23.37-.34.08-.06994.15-.15.23-.2301.01-.00989.02-.0199.02-.0299a10.27982,10.27982,0,0,0,1.2-1.6A10.8728,10.8728,0,0,0,27,16,10.92966,10.92966,0,0,0,25.75,10.8999ZM25,16a8.96159,8.96159,0,0,1-1.79,5.38.20734.20734,0,0,0-.04.05994.26627.26627,0,0,0-.05.06006c-.06.08-.12.1499-.18.22-.05.07007-.11.13-.17.2a12.70116,12.70116,0,0,1-2.96,2.23,21.49635,21.49635,0,0,1-7,2.38013A30.98672,30.98672,0,0,1,9.04,26.95l1.19-1.59.57-.76a.99172.99172,0,0,0,.18-.76,1.0279,1.0279,0,0,0-.42-.67A.26409.26409,0,0,0,10.5,23.12c-.08-.05994-.15-.12-.22-.18006-.07-.04993-.13-.11-.2-.16992a12.708,12.708,0,0,1-2.23-2.96A8.86048,8.86048,0,0,1,7,16a8.96159,8.96159,0,0,1,1.79-5.38.21059.21059,0,0,0,.04-.05994A.26627.26627,0,0,0,8.88,10.5c.06-.08008.12-.15.18-.22.05-.07007.11-.13013.17-.20007a12.708,12.708,0,0,1,2.96-2.23,21.49946,21.49946,0,0,1,7-2.38,30.98672,30.98672,0,0,1,3.77-.41992L21.77,6.64l-.57.75989a.99183.99183,0,0,0-.18.76,1.02761,1.02761,0,0,0,.42.67.26486.26486,0,0,0,.06.05c.08.05994.15.12.22.18006.07.04993.13.10986.2.16992a12.70532,12.70532,0,0,1,2.23,2.96A8.86009,8.86009,0,0,1,25,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-snow",
		"name": "ki-weather-snow",
		"tags": "ki-weather-snow",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.90918,9.82031A7.99627,7.99627,0,0,0,8.09082,9.81836c-.02954.00452-.05646.01623-.08588.02124a5.94057,5.94057,0,0,0-.90191.22266c-.048.01611-.09412.03466-.14148.05188a5.96809,5.96809,0,0,0-.85779.38452c-.02515.01391-.0484.03039-.0733.04455a6.01976,6.01976,0,0,0-.78485.53369c-.01294.01038-.027.01917-.03986.02979a6.04091,6.04091,0,0,0-.68164.66138c-.02814.03161-.05768.06128-.08515.0935a6.03345,6.03345,0,0,0-.5382.74207c-.02729.04407-.05432.08752-.08051.13244a5.962,5.962,0,0,0-.40069.82422c-.01856.04712-.03479.09461-.05213.14209a5.92773,5.92773,0,0,0-.25659.9137c-.007.03674-.01062.0741-.017.111A5.96852,5.96852,0,0,0,9,21.75v-2a3.99976,3.99976,0,1,1,4-4h2a6.00673,6.00673,0,0,0-4.88062-5.89136,5.99148,5.99148,0,0,1,11.87134.92652l.04346.96484H23a4,4,0,0,1,0,8v2a5.99945,5.99945,0,0,0,.90918-11.92969Z"
				},
				{
					"d": "M19 18L17 18 17 20 15 20 15 22 17 22 17 24 19 24 19 22 21 22 21 20 19 20 19 18z"
				},
				{
					"d": "M13 23L11 23 11 25 9 25 9 27 11 27 11 29 13 29 13 27 15 27 15 25 13 25 13 23z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-sunny",
		"name": "ki-weather-sunny",
		"tags": "ki-weather-sunny",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16.00045,23.99953a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,16.00045,23.99953Zm0-14a6,6,0,1,0,6,6A6.00656,6.00656,0,0,0,16.00045,9.99953Z"
				},
				{
					"d": "M15.00045 2H17.00045V5.99953H15.00045z"
				},
				{
					"d": "M15.00045 25.99953H17.00045V30H15.00045z"
				},
				{
					"d": "M2.00094 15.00197H6.00048V17.00197H2.00094z"
				},
				{
					"d": "M26.99974 14.00265H28.99974V18.001289999999997H26.99974z",
					"transform": "rotate(-89.93 27.99974 16.00197)"
				},
				{
					"d": "M6.51487 5.51447H8.51487V9.514H6.51487z",
					"transform": "rotate(-45 7.51487 7.51423)"
				},
				{
					"d": "M23.48543 22.48456H25.48543V26.48503H23.48543z",
					"transform": "rotate(-45 24.48544 24.4848)"
				},
				{
					"d": "M5.51684 23.48617H9.51638V25.48617H5.51684z",
					"transform": "rotate(-45.054 7.5166 24.48617)"
				},
				{
					"d": "M22.48717 6.5163H26.48581V8.516300000000001H22.48717z",
					"transform": "rotate(-44.93 24.48648 7.5163)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-sunny-f",
		"name": "ki-weather-sunny-f",
		"tags": "ki-weather-sunny-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": [
				{
					"cx": "16",
					"cy": "16",
					"r": "8"
				}
			],
			"ellipses": "",
			"paths": [
				{
					"d": "M15.00045 2H17.00045V5.99953H15.00045z"
				},
				{
					"d": "M15.00045 25.99953H17.00045V30H15.00045z"
				},
				{
					"d": "M2.00094 15.00197H6.00048V17.00197H2.00094z"
				},
				{
					"d": "M26.99974 14.00265H28.99974V18.001289999999997H26.99974z",
					"transform": "rotate(-89.93 27.99974 16.00197)"
				},
				{
					"d": "M6.51487 5.51447H8.51487V9.514H6.51487z",
					"transform": "rotate(-45 7.51487 7.51423)"
				},
				{
					"d": "M23.48543 22.48456H25.48543V26.48503H23.48543z",
					"transform": "rotate(-45 24.48544 24.4848)"
				},
				{
					"d": "M5.51684 23.48617H9.51638V25.48617H5.51684z",
					"transform": "rotate(-45.054 7.5166 24.48617)"
				},
				{
					"d": "M22.48717 6.5163H26.48581V8.516300000000001H22.48717z",
					"transform": "rotate(-44.93 24.48648 7.5163)"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-tornado",
		"name": "ki-weather-tornado",
		"tags": "ki-weather-tornado",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29,6.00024C29,3.38965,20.85547,3,16,3S3,3.38965,3,6.00024A1.43205,1.43205,0,0,0,3.605,7.0918l.48285.58252c.71582.86047,1.45606,1.74926,2.09668,2.5979a17.21692,17.21692,0,0,1,1.71875,2.75134,6.93641,6.93641,0,0,1,.52734,1.50891,4.52487,4.52487,0,0,1,.0459,1.677A8.81625,8.81625,0,0,1,8.16309,17.32l-.14551.42c-.16016.459-.3291.94336-.46,1.42786a7.37759,7.37759,0,0,0-.23535,3.57653l.00085.004.00012.00086.00031.001.1452.67188.05475.00806c.59759,1.655,1.98944,3.04443,4.25189,4.23852A10.42047,10.42047,0,0,0,15.919,29a1.54517,1.54517,0,0,0,1.38378-.60254c.457-.678.19825-1.46411-.76757-2.3363-.57911-.64368-.7461-1.2843.166-2.44751a21.75539,21.75539,0,0,1,3.51856-3.18006l.43939-.34985.2149-.17065-.00024-.00037c.59381-.47107,1.17786-.942,1.72485-1.42761a16.35566,16.35566,0,0,0,1.43067-1.44446c.57226-.66907,1.04785-1.26965,1.44629-1.82739a18.48128,18.48128,0,0,0,1.70605-2.73963,14.978,14.978,0,0,0,.82324-1.9259,25.23769,25.23769,0,0,0,.98242-4.38916L28.969,6.15564A1.14933,1.14933,0,0,0,29,6.00024Zm-13-1a40.20665,40.20665,0,0,1,10.27148,1A40.19638,40.19638,0,0,1,16,7.00049,40.19638,40.19638,0,0,1,5.72852,6.00024,40.20665,40.20665,0,0,1,16,5.00024ZM7.78906,9.07788c-.16937-.22449-.35376-.45-.53143-.67505A54.07961,54.07961,0,0,0,16,9.00073c3.21466,0,7.859-.17541,10.63892-1.04846a15.851,15.851,0,0,1-.52466,1.943,12.75969,12.75969,0,0,1-.52588,1.267A45.71734,45.71734,0,0,1,16,12.001a59.821,59.821,0,0,1-6.5484-.33789A21.16307,21.16307,0,0,0,7.78906,9.07788ZM9.48437,19.7041c.09253-.34155.2082-.66577.31989-.98877,1.85669.18433,3.96875.28638,6.19574.28638.99725,0,1.95532-.02075,2.87939-.05737-.31414.249-.62469.49585-.92712.74072-.113.09143-.21912.18286-.32983.27392-.22528.18555-.44861.37159-.66162.55664-.12677.11011-.24421.2212-.36567.33155-.18353.16662-.36389.334-.53344.502-.11866.11743-.22821.23633-.33893.35449-.09271.09912-.19666.19678-.28333.29663a55.45291,55.45291,0,0,1-6.23736-.35681c-.00141-.04309.00183-.08923.00177-.13318a5.03634,5.03634,0,0,1,.04077-.635c.01019-.08154.02038-.16308.03442-.2478a8.08958,8.08958,0,0,1,.2024-.91064l-.00013-.00013Zm3.20215,6.18323A7.963,7.963,0,0,1,9.9436,23.7356c1.31452.12878,2.768.20776,4.30158.24267a3.2009,3.2009,0,0,0,.26556,2.6875A15.95166,15.95166,0,0,1,12.68652,25.88733Zm11.16993-11.848c-.37208.5205-.8125,1.07727-1.34278,1.69751a13.98789,13.98789,0,0,1-1.0169,1.03747c-1.64521.14734-3.53058.2273-5.49677.2273-2.00348,0-3.908-.08387-5.60321-.23719.01477-.067.03619-.13476.04852-.20141a6.53439,6.53439,0,0,0-.05566-2.43482c-.02466-.11889-.07019-.24511-.102-.36621,1.75537.1565,3.69787.23926,5.71234.23926a56.20418,56.20418,0,0,0,8.27106-.547C24.13959,13.64526,24.00342,13.83887,23.85645,14.03931Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-tropical-storm",
		"name": "ki-weather-tropical-storm",
		"tags": "ki-weather-tropical-storm",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,22a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.00427,4.00427,0,0,0,16,12Z"
				},
				{
					"d": "M25.75,10.8999a.67149.67149,0,0,0-.07-.10986A9.37053,9.37053,0,0,0,24.52,9.1c-.06-.07-.13-.15-.19-.22-.16-.20007-.32-.39-.47-.55a2.39425,2.39425,0,0,0-.22-.23,3.24645,3.24645,0,0,0-.27-.26L25.8,4.6a.99617.99617,0,0,0,.09-1.04993A.977.977,0,0,0,25,3C18.12,3,13.65,4.63,10.9,6.25a.67323.67323,0,0,0-.11.07007A9.374,9.374,0,0,0,9.1,7.48c-.07.06006-.15.13-.22.18994-.2.16-.39.32007-.55.47009a2.38759,2.38759,0,0,0-.23.22,3.24537,3.24537,0,0,0-.26.27,10.27416,10.27416,0,0,0-1.2,1.6A10.8728,10.8728,0,0,0,5,16a10.92953,10.92953,0,0,0,1.25,5.1.67232.67232,0,0,0,.07.11,4.6188,4.6188,0,0,0,.31.51,9.90435,9.90435,0,0,0,1.13,1.53c.17.18994.33.37.48.53a4.08836,4.08836,0,0,0,.36.36c.01.00989.02.0199.03.0199l-2.43,3.24A.9964.9964,0,0,0,6.11,28.45.977.977,0,0,0,7,29c6.88,0,11.35-1.63,14.1-3.25a.67323.67323,0,0,0,.11-.07007c.33-.19995.63-.38989.91-.58.03-.02.07-.04993.1-.06995.14-.1001.27-.20007.4-.3.17-.13.33-.25.49-.39.01-.01.01-.01.02-.01.15-.13.29-.25.41-.36.14-.12.26-.23.37-.34.08-.06994.15-.15.23-.2301.01-.00989.02-.0199.02-.0299a10.27982,10.27982,0,0,0,1.2-1.6A10.8728,10.8728,0,0,0,27,16,10.92966,10.92966,0,0,0,25.75,10.8999ZM25,16a8.96159,8.96159,0,0,1-1.79,5.38.20734.20734,0,0,0-.04.05994.26627.26627,0,0,0-.05.06006c-.06.08-.12.1499-.18.22-.05.07007-.11.13-.17.2a12.70116,12.70116,0,0,1-2.96,2.23,21.49635,21.49635,0,0,1-7,2.38013A30.98672,30.98672,0,0,1,9.04,26.95l1.19-1.59.57-.76a.99172.99172,0,0,0,.18-.76,1.0279,1.0279,0,0,0-.42-.67A.26409.26409,0,0,0,10.5,23.12c-.08-.05994-.15-.12-.22-.18006-.07-.04993-.13-.11-.2-.16992a12.708,12.708,0,0,1-2.23-2.96A8.86048,8.86048,0,0,1,7,16a8.96159,8.96159,0,0,1,1.79-5.38.21059.21059,0,0,0,.04-.05994A.26627.26627,0,0,0,8.88,10.5c.06-.08008.12-.15.18-.22.05-.07007.11-.13013.17-.20007a12.708,12.708,0,0,1,2.96-2.23,21.49946,21.49946,0,0,1,7-2.38,30.98672,30.98672,0,0,1,3.77-.41992L21.77,6.64l-.57.75989a.99183.99183,0,0,0-.18.76,1.02761,1.02761,0,0,0,.42.67.26486.26486,0,0,0,.06.05c.08.05994.15.12.22.18006.07.04993.13.10986.2.16992a12.70532,12.70532,0,0,1,2.23,2.96A8.86009,8.86009,0,0,1,25,16Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-weather-winter",
		"name": "ki-weather-winter",
		"tags": "ki-weather-winter",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.707 13.707L28.293 12.293 25.586 15 18.414 15 24.414 9 28 9 28 7 25 7 25 4 23 4 23 7.586 17 13.586 17 6.414 19.707 3.707 18.293 2.293 16 4.586 13.707 2.293 12.293 3.707 15 6.414 15 13.586 9 7.586 9 4 7 4 7 7 4 7 4 9 7.586 9 13.586 15 6.414 15 3.707 12.293 2.293 13.707 4.586 16 2.293 18.293 3.707 19.707 6.414 17 13.586 17 7.586 23 4 23 4 25 7 25 7 28 9 28 9 24.414 15 18.414 15 25.586 12.293 28.293 13.707 29.707 16 27.414 18.293 29.707 19.707 28.293 17 25.586 17 18.414 23 24.414 23 28 25 28 25 25 28 25 28 23 24.414 23 18.414 17 25.586 17 28.293 19.707 29.707 18.293 27.414 16 29.707 13.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wheelchair",
		"name": "ki-wheelchair",
		"tags": "ki-wheelchair",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M29.89001,7.97928c0-2.16998-1.77002-3.94-3.94-3.94-2.17999,0-3.95001,1.77002-3.95001,3.94,0,.22998.02002.45001.06.66998,0,0-3.87-3.76001-3.90997-3.79999-.57001-.59003-1.33002-.91998-2.15002-.91998h-5.88c-1.51001,0-2.83997,1.07001-3.08002,2.48999-.14996.88.10004,1.77002.67004,2.44.57001.67999,1.40997,1.07001,2.28998,1.07001h4.59003l1.06995,1.07996-1.53998,1.95001c-1.10999-.54999-2.37-.85999-3.70001-.85999-1.95996,0-3.76996.66998-5.20001,1.79999l1.43005,1.42999c1.06-.77997,2.35999-1.22998,3.76996-1.22998.86005,0,1.67999.16998,2.42999.48999.63.25,1.20001.60004,1.71002,1.04004,1,.83997,1.73999,1.98999,2.06,3.29999.14001.51001.21002,1.03998.21002,1.57996,0,.14001,0,.28003-.02002.42004-.07001,1.25-.51001,2.39996-1.21002,3.34998l1.43005,1.42999c1.04999-1.32996,1.69995-2.97998,1.78998-4.77997h2.17999v4.88c0,1.51001,1.07001,2.83997,2.48999,3.07996.16998.03003.34003.04004.51001.04004.70001,0,1.39001-.25,1.92999-.71002.67999-.57001,1.07001-1.40997,1.07001-2.28998v-8c0-1.65002-1.34998-3-3-3h-.90002l.73004-1.03003c.5-.70001.65997-1.53998.5-2.32001.48999.23004,1.03998.35004,1.62.35004,2.16998,0,3.94-1.77002,3.94-3.95001ZM24,16.92929c.54999,0,1,.45001,1,1v8c0,.28998-.13.57001-.35999.76001-.13.12-.41003.29999-.82001.22998-.46002-.08002-.82001-.57001-.82001-1.10999v-5.88c0-.54999-.45001-1-1-1h-3.32001c-.37-1.95001-1.40997-3.65002-2.88-4.88l1.28003-1.62,1.20996,1.20996,1.42004-1.41998-4-4c-.19-.17999-.44-.28998-.71002-.28998h-5c-.28998,0-.57001-.13-.76001-.35999-.12-.13-.28998-.41003-.22998-.82001.08002-.46002.57001-.82001,1.10999-.82001h5.88c.27002,0,.52002.10999.73999.32996.04004.05005,5.34003,5.20001,5.34003,5.20001.34998.34003.39996.88.12,1.29004l-1.85004,2.59998c-.20996.31-.23999.71002-.06995,1.03998.16998.33002.50995.54004.88995.54004h2.83002ZM24,7.97928c0-1.07001.87-1.94,1.95001-1.94,1.07001,0,1.94.87,1.94,1.94,0,1.08002-.87,1.95001-1.94,1.95001-1.08002,0-1.95001-.87-1.95001-1.95001Z"
				},
				{
					"d": "M14.17999,25.69925c-1.06.78003-2.35999,1.23004-3.76001,1.23004-3.53998,0-6.41998-2.88-6.41998-6.42004,0-1.39996.45001-2.69995,1.22998-3.75995l-1.42999-1.42999c-1.13,1.42999-1.79999,3.22998-1.79999,5.18994,0,4.65002,3.77002,8.42004,8.41998,8.42004,1.96002,0,3.76001-.67004,5.19-1.79999l-1.42999-1.43005Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi",
		"name": "ki-wifi",
		"tags": "ki-wifi",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M4.75977,14.44238,1.65332,9.78223l.73145-.57032c7.42772-5.793,19.89746-5.79,27.23535.00293l.72363.57227L27.24316,14.4375l-.84668-.63965c-5.665-4.28613-15.18457-4.28613-20.78906-.00293ZM15.97656,8.55469A19.75948,19.75948,0,0,1,26.7373,11.5918l.90332-1.35547C21.23633,5.79,10.83691,5.791,4.3623,10.24121l.89844,1.34668A19.58181,19.58181,0,0,1,15.97656,8.55469Z"
				},
				{
					"d": "M8.85156,20.27148,5.69727,15.70117,6.5,15.12988c5.20312-3.70312,13.72266-3.70508,18.99414-.0039l.8125.56933-3.14941,4.56348-.80664-.49024a13.00832,13.00832,0,0,0-12.6875-.00878Zm7.09571-4.165a14.87006,14.87006,0,0,1,6.61425,1.49414l.94727-1.37207a15.77242,15.77242,0,0,0-15.02051-.00489l.94336,1.36817A14.37188,14.37188,0,0,1,15.94727,16.10645Z"
				},
				{
					"d": "M18.52539,27.00391H13.47363l-3.7539-5.47168.99609-.52344a12.15043,12.15043,0,0,1,10.55957-.00488l1.01367.51757Zm-3.999-2h2.94629l1.831-2.667a10.53735,10.53735,0,0,0-6.6123-.00781Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-6",
		"name": "ki-wifi-6",
		"tags": "ki-wifi-6",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.98761,3.57239l.00238-.00238-.01001-.12c-.01001-.05005-.01996-.11005-.03998-.16003-.04999-.16998-.12-.32001-.21002-.45001-.06-.10999-.13-.19995-.20996-.28998-1.38-1.56-5.23004-1.13-7.78003-.34998-1.27002,.38995-2.52002,1-3.52997,1.72998-.67004,.47998-1.24005,1.02002-1.63,1.57001-.25,.34998-.42999,.70001-.53003,1.06-.01996,.02997-.01996,.04999-.02997,.08002-.04004,.44995-1.02002,11.34998-1.02002,14.35999,0,1.92999,.39001,4.60999,.71002,6.51001,.25,1.44,1.48999,2.48999,2.95996,2.48999h8.664c1.46533,0,2.70801-1.04785,2.95459-2.49219,.32471-1.90234,.71143-4.5752,.71143-6.50781,0-2.99756-.9704-16.80194-1.01239-17.42761Zm-11.95758,3.36761c.33997-.69,1.75-2.04999,4.29999-2.83002,1.48999-.45001,2.77997-.60999,3.76001-.60999,1.00995,0,1.69,.15997,1.89996,.35999l.01001,.09998c-.19,.57001-1.84998,2.11005-4.79999,3.01001-3,.91003-4.82001,.66003-5.20001,.38-.01001,0-.01001-.01001-.02002-.02002-.01996-.00995-.02997-.01996-.03998-.03998-.01001-.04999-.01001-.12,.02002-.21002,.01996-.03998,.03998-.08997,.07001-.13995Zm9.30396,21.06H11.66998c-.48999,0-.89996-.35004-.98999-.83002-.17078-1.01788-.42285-2.64001-.56714-4.16998h11.77448c-.14404,1.52863-.39606,3.15094-.57043,4.17188-.08203,.47949-.49512,.82812-.98291,.82812Zm-1.33398-7l-2-2h-3l-2,2h-2c0-2.08002,.5-8.21002,.78998-11.60004,.02002,.01001,.05005,.02002,.08002,.03003,.28998,.08002,.62,.13,1,.15997,.09003,.01001,.19,.02002,.28998,.02002,.10004,0,.21002,.01001,.31,.01001,1.24005,0,2.76001-.26001,4.32001-.73999,.79004-.23999,1.57001-.55005,2.30005-.91003,.75995-.38,1.45996-.81,2.03998-1.26001,0,0,.04175-.03656,.1037-.09302,.2796,4.37231,.7663,12.28198,.7663,14.38306h-3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-6-f",
		"name": "ki-wifi-6-f",
		"tags": "ki-wifi-6-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.98999,3.57001l-.01001-.12c-.01001-.05005-.01996-.11005-.03998-.16003-.04999-.16998-.12-.32001-.21002-.45001-.06-.10999-.13-.19995-.20996-.28998-1.38-1.56-5.23004-1.13-7.78003-.34998-1.27002,.38995-2.52002,1-3.52997,1.72998-.67004,.47998-1.24005,1.02002-1.63,1.57001-.25,.34998-.42999,.70001-.53003,1.06-.01996,.02997-.01996,.04999-.02997,.08002-.04004,.44995-1.02002,11.34998-1.02002,14.35999,0,1.92999,.39001,4.60999,.71002,6.51001,.25,1.44,1.48999,2.48999,2.95996,2.48999h8.66003c1.46997,0,2.70996-1.04999,2.95996-2.48999,.32001-1.90002,.71002-4.58002,.71002-6.51001,0-3-.96997-16.82001-1.01001-17.42999ZM10.10999,23c-.07001-.71002-.10999-1.40002-.10999-2h2l2-2h3l2,2h3c0,.59998-.03998,1.28998-.10999,2H10.10999Zm.92004-16.06c.33997-.69,1.75-2.04999,4.29999-2.83002,1.48999-.45001,2.77997-.60999,3.76001-.60999,1.00995,0,1.69,.15997,1.89996,.35999l.01001,.09998c-.19,.57001-1.84998,2.11005-4.79999,3.01001-3,.91003-4.82001,.66003-5.20001,.38-.01001,0-.01001-.01001-.02002-.02002-.01996-.00995-.02997-.01996-.03998-.03998-.01001-.04999-.01001-.12,.02002-.21002,.01996-.03998,.03998-.08997,.07001-.13995Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-6e",
		"name": "ki-wifi-6e",
		"tags": "ki-wifi-6e",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.98999,24.40138l-.95996-19.39001-.03003-.59998c-.01001-.04999-.02002-.10999-.03998-.16003-.09003-.28998-.23004-.52997-.42004-.73999-1.38-1.56-5.22998-1.13-7.77997-.34998-1.27002,.39001-2.52002,1-3.53003,1.72998-1.08997,.78003-1.88995,1.70001-2.15997,2.63-.02002,.03003-.02002,.04999-.03003,.08002l-.06,.96997-.96997,15.79004c-.01001,.08997-.01001,.17999-.01001,.26996v1.91003c0,1.64996,1.34003,3,3,3h10c1.65002,0,3-1.35004,3-3v-1.91003c0-.08997,0-.17999-.01001-.22998ZM10.89001,10.39137c.35999,.10004,.78998,.16003,1.28998,.17999,.10004,0,.21002,.01001,.31,.01001,1.23999,0,2.76001-.26001,4.32001-.73999,1.60999-.48999,3.20001-1.28003,4.34003-2.16998l.80151,15.87H10.06812l.8219-13.15002Zm.15997-2.48999c.34003-.69,1.75-2.04999,4.29999-2.83002,1.49005-.45001,2.78003-.60999,3.76001-.60999,1.01001,0,1.69,.15997,1.90002,.35999l.01001,.10004c-.19,.57001-1.85004,2.10999-4.80005,3.01001-3,.90997-4.81995,.65997-5.19995,.37994-.03003-.01996-.05005-.03998-.06-.06-.02002-.06995,0-.19,.08997-.34998Zm9.95001,19.64001H11c-.54999,0-1-.45001-1-1v-1h12v1c0,.54999-.45001,1-1,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-6e-f",
		"name": "ki-wifi-6e-f",
		"tags": "ki-wifi-6e-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M23.98999,24.40137l-.95996-19.39001-.03003-.59998c-.01001-.04999-.02002-.10999-.03998-.16003-.09003-.28998-.23004-.52997-.42004-.73999-1.38-1.56-5.22998-1.13-7.77997-.34998-1.27002,.39001-2.52002,1-3.53003,1.72998-1.08997,.78003-1.88995,1.70001-2.15997,2.63-.02002,.03003-.02002,.04999-.03003,.08002l-.06,.96997-.96997,15.79004c-.01001,.08997-.01001,.17999-.01001,.26996v1.91003c0,1.64996,1.34003,3,3,3h10c1.65002,0,3-1.35004,3-3v-1.91003c0-.08997,0-.17999-.01001-.22998ZM11.04999,7.90137c.34003-.69,1.75-2.04999,4.29999-2.83002,1.49005-.45001,2.78003-.60999,3.76001-.60999,1.01001,0,1.69,.15997,1.90002,.35999l.01001,.10004c-.19,.57001-1.85004,2.10999-4.80005,3.01001-3,.90997-4.81995,.65997-5.19995,.37994-.03003-.01996-.05005-.03998-.06-.06-.02002-.06995,0-.19,.08997-.34998Zm10.95001,18.64001c0,.54999-.45001,1-1,1H11c-.54999,0-1-.45001-1-1v-1h12v1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-7",
		"name": "ki-wifi-7",
		"tags": "ki-wifi-7",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m24.03003,4.58997l-.12006-.25-.21997-.15997c-.08002-.04999-1.22003-.85004-3.12-1.45001-1.22998-.40997-2.78003-.72998-4.57001-.72998s-3.34003.32001-4.57001.72998c-1.89996.59998-3.03998,1.40002-3.12,1.45001l-.21997.15997-.12006.25c-.95996,2.17004-.96997,5.28003-.96997,5.41003v17c0,1.64996,1.25,3,2.78003,3h12.43994c1.53003,0,2.78003-1.35004,2.78003-3V10c0-.13-.01001-3.23999-.96997-5.41003Zm-11.35004-.14996c.95001-.25,2.06-.44,3.32001-.44s2.37.19,3.32001.44c.08002.17999.12.35999.12.56,0,.54999-.44,1-1,1h-4.88c-.56,0-1-.45001-1-1,0-.20001.03998-.38.12-.56Zm-2.98999,1.22998c.19-.10999.48999-.27997.88-.46997.09998,1.56,1.39996,2.79999,2.98999,2.79999h4.88c1.59003,0,2.89001-1.23999,2.98999-2.79999.39001.19.69.35999.88.46997.67999,1.78003.69,4.29999.69,4.33002v9.20007c-1.31885.27789-4.17126.79993-7,.79993-2.82251,0-5.67944-.52295-7-.80066v-9.19934c0-.03003.01001-2.54999.69-4.33002Zm.09003,22.33002c-.42004,0-.78003-.46002-.78003-1v-5.75757c.5365.10754,1.21741.23285,2,.35065v6.40692h-1.21997Zm3.21997,0v-6.15686c.64319.06342,1.31647.1106,2,.13586v6.021h-2Zm4,0v-6.021c.68353-.02527,1.35681-.07239,2-.1358v6.1568h-2Zm5.21997,0h-1.21997v-6.40692c.78259-.1178,1.4635-.2431,2-.35065v5.75757c0,.53998-.35999,1-.78003,1Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-7-f",
		"name": "ki-wifi-7-f",
		"tags": "ki-wifi-7-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m24.03003,4.58997l-.12006-.25-.21997-.15997c-.01001-.01001-.07001-.04999-.15997-.10004-.03003-.01996-.06006-.03998-.10004-.06-.52002-.32996-1.82001-1.04999-3.66998-1.52997-.21002-.06-.42999-.10999-.66003-.16003-.25995-.06-.52997-.10999-.81-.14996-.19-.03003-.38995-.06-.58997-.08002-.29999-.03998-.60999-.06-.92999-.08002-.25-.00995-.51001-.01996-.77002-.01996s-.52002.01001-.77002.01996c-.32001.02002-.63.04004-.92999.08002-.20001.02002-.39996.04999-.58997.08002-.28003.03998-.55005.08997-.81.14996-.23004.05005-.45001.10004-.66003.16003-1.84998.47998-3.14996,1.20001-3.66998,1.52997-.03998.02002-.07001.04004-.10004.06-.08997.05005-.14996.09003-.15997.10004l-.21997.15997-.12006.25c-.95996,2.17004-.96997,5.28003-.96997,5.41003v17c0,1.64996,1.25,3,2.78003,3h12.43994c1.53003,0,2.78003-1.35004,2.78003-3V10c0-.13-.01001-3.23999-.96997-5.41003Zm-11.35004-.14996c-.08002.17999-.12.35999-.12.56,0,.54999.44,1,1,1h4.88c.56,0,1-.45001,1-1,0-.20001-.03998-.38-.12-.56.85999.22998,1.57001.51001,2.10999.76001v.00995c-.10999,1.56-1.39996,2.79004-2.98999,2.79004h-4.88c-1.59003,0-2.88-1.23004-2.98999-2.79004v-.00995c.53998-.25,1.25-.53003,2.10999-.76001Zm10.32001,16.81c-.53998.09998-1.21997.22998-2,.33997v6.41003h-2v-6.16003c-.64001.07001-1.32001.12-2,.14001v6.02002h-2v-6.02002c-.67999-.02002-1.35999-.07001-2-.14001v6.16003h-2v-6.41003c-.78003-.10999-1.46002-.23999-2-.33997v-2.04999c1.32001.27997,4.17999.79999,7,.79999s5.67999-.52002,7-.79999v2.04999Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-f",
		"name": "ki-wifi-f",
		"tags": "ki-wifi-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,7.20209A19.78934,19.78934,0,0,0,2,13l1.994,1.994a17.00193,17.00193,0,0,1,24.01208,0L30,13A19.78934,19.78934,0,0,0,16,7.20209Z"
				},
				{
					"d": "M6.002,17.002l1.994,1.994a11.33436,11.33436,0,0,1,16.00794,0l1.994-1.994a14.13431,14.13431,0,0,0-19.996,0Z"
				},
				{
					"d": "M10.00409,21.00409,11.998,22.998a5.66729,5.66729,0,0,1,8.004,0l1.9939-1.9939a8.46673,8.46673,0,0,0-11.99182,0Z"
				},
				{
					"d": "M14,25.0061,16,27l1.9939-1.9939a2.80694,2.80694,0,0,0-3.9939,0Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wifi-outdoors",
		"name": "ki-wifi-outdoors",
		"tags": "ki-wifi-outdoors",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 5.14c3.56 0 6.77 1.44 9.1 3.76l1.51-1.51C22.89 4.68 19.14 3 15 3S7.11 4.68 4.39 7.39L5.9 8.9c2.33-2.33 5.54-3.76 9.1-3.76Z"
				},
				{
					"d": "M22.56 10.42c-1.94-1.94-4.62-3.14-7.58-3.14s-5.64 1.2-7.58 3.14h.02l1.51 1.51c1.55-1.54 3.7-2.51 6.06-2.51s4.51.96 6.06 2.51l1.51-1.51Z"
				},
				{
					"d": "M19.54 13.46c-1.16-1.17-2.76-1.89-4.54-1.89s-3.39.72-4.54 1.89l1.51 1.51c.78-.77 1.85-1.25 3.03-1.25s2.25.48 3.03 1.25l1.51-1.51ZM13.48 16.49 15 18l1.51-1.51c-.39-.4-.92-.63-1.51-.63s-1.13.24-1.52.63Z"
				},
				{
					"d": "M29.77 26.06 23.3 13.32 15 21.59l-3-3-2.97 2.96L6 15 2 25h3v2H3v2h25c.72 0 1.37-.37 1.73-.99.36-.61.37-1.35.04-1.95ZM7 27v-2h1.4l1.65-1.65L12 21.41l3 3 7.76-7.73L28 27H7Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-wind",
		"name": "ki-wind",
		"tags": "ki-wind",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26,17H3v-2H26c.55127,0,1-.44824,1-1v-1c0-.55176-.44873-1-1-1h-3v-2h3c1.6543,0,3,1.3457,3,3v1c0,1.6543-1.3457,3-3,3Z"
				},
				{
					"d": "M18,11H7v-2h11c.55127,0,1-.44824,1-1v-1c0-.55176-.44873-1-1-1h-2v-2h2c1.6543,0,3,1.3457,3,3v1c0,1.6543-1.3457,3-3,3Z"
				},
				{
					"d": "M22,28h-2v-2h2c.55127,0,1-.44824,1-1v-1c0-.55176-.44873-1-1-1H7v-2h15c1.6543,0,3,1.3457,3,3v1c0,1.6543-1.3457,3-3,3Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-x",
		"name": "ki-x",
		"tags": "ki-x",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M26.707 6.707L25.293 5.293 16 14.586 6.707 5.293 5.293 6.707 14.586 16 5.293 25.293 6.707 26.707 16 17.414 25.293 26.707 26.707 25.293 17.414 16 26.707 6.707z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-x-alt",
		"name": "ki-x-alt",
		"tags": "ki-x-alt",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27.414 7.414L24.586 4.586 16 13.172 7.414 4.586 4.586 7.414 13.172 16 4.586 24.586 7.414 27.414 16 18.828 24.586 27.414 27.414 24.586 18.828 16 27.414 7.414z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-x-circle",
		"name": "ki-x-circle",
		"tags": "ki-x-circle",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M16,29.99953a14,14,0,1,1,14-14A14.01573,14.01573,0,0,1,16,29.99953Zm0-26a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,16,3.99953Z"
				},
				{
					"d": "M20.243 10.343L16 14.585 11.757 10.343 10.343 11.757 14.586 16 10.343 20.242 11.757 21.656 16 17.414 20.243 21.656 21.657 20.242 17.414 16 21.657 11.757 20.243 10.343z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-x-twitter",
		"name": "ki-x-twitter",
		"tags": "ki-x-twitter",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M18.42066,13.93225L27.88318,2.92929h-2.24458l-8.21918,9.56157L10.85062,2.92929H3.28058l9.92469,14.45791L3.28058,28.92929h2.24458l8.68135-10.10071,6.93185,10.10071h7.58106l-10.29875-14.99704ZM15.33985,17.50821l-1.00131-1.44139L6.32842,4.62372h3.44393l6.46975,9.2315,1.00124,1.44139,8.39526,12.01521h-3.44393l-6.85482-9.80361Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-xumo",
		"name": "ki-xumo",
		"tags": "ki-xumo",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m26,29H6c-1.6543,0-3-1.3457-3-3V6c0-1.6543,1.3457-3,3-3h20c1.6543,0,3,1.3457,3,3v20c0,1.6543-1.3457,3-3,3ZM6,5c-.55127,0-1,.44824-1,1v20c0,.55176.44873,1,1,1h20c.55127,0,1-.44824,1-1V6c0-.55176-.44873-1-1-1H6Z"
				},
				{
					"d": "M11 22H21V24H11z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-xumo-f",
		"name": "ki-xumo-f",
		"tags": "ki-xumo-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "m27,3H5c-1.09998,0-2,.89996-2,2v22c0,1.09998.90002,2,2,2h22c1.09998,0,2-.90002,2-2V5c0-1.10004-.90002-2-2-2Zm-6,21h-10v-2h10v2Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-youtube",
		"name": "ki-youtube",
		"tags": "ki-youtube",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M27,3H5A2.00587,2.00587,0,0,0,3,5V27a2.00591,2.00591,0,0,0,2,2H27a2.00591,2.00591,0,0,0,2-2V5A2.00587,2.00587,0,0,0,27,3ZM24.62,20.36a2.238,2.238,0,0,1-1.59,1.6,53.18666,53.18666,0,0,1-7.03.38,53.18666,53.18666,0,0,1-7.03-.38,2.238,2.238,0,0,1-1.59-1.6A23.46756,23.46756,0,0,1,7,16a23.46756,23.46756,0,0,1,.38-4.36,2.23821,2.23821,0,0,1,1.59-1.6A53.18666,53.18666,0,0,1,16,9.66a53.18666,53.18666,0,0,1,7.03.38,2.23821,2.23821,0,0,1,1.59,1.6A23.46756,23.46756,0,0,1,25,16,23.46756,23.46756,0,0,1,24.62,20.36Z"
				},
				{
					"d": "M18.86 16L14.16 18.68 14.16 13.32 18.86 16z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-zeplin",
		"name": "ki-zeplin",
		"tags": "ki-zeplin",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,8a35.10536,35.10536,0,0,0-9.42,1.53L7.74,7.5A3.00379,3.00379,0,0,0,3,9.95v3.66A3.648,3.648,0,0,0,2,16a3.64823,3.64823,0,0,0,1,2.39v3.66a2.97461,2.97461,0,0,0,1.63,2.67A2.89528,2.89528,0,0,0,6,25.06a3.00345,3.00345,0,0,0,1.74-.56l2.84-2.03A35.10564,35.10564,0,0,0,20,24c7.38,0,10-4.31,10-8S27.38,8,20,8Zm-9.39,3.61A30.92717,30.92717,0,0,1,20,10c4.55,0,7.43,1.85,7.92,5H4.43c.89-1.1,3.06-2.31,5.8-3.26C10.35,11.69,10.48,11.65,10.61,11.61ZM5,9.95a.96824.96824,0,0,1,.54-.89.97812.97812,0,0,1,1.04.07l1.69,1.2A19.14917,19.14917,0,0,0,5,11.94ZM6.58,22.87a.97824.97824,0,0,1-1.04.07A.9683.9683,0,0,1,5,22.05V20.06a19.03756,19.03756,0,0,0,3.26,1.61ZM20,22a30.929,30.929,0,0,1-9.39-1.61H10.6a3.82639,3.82639,0,0,1-.36-.13h-.01C7.49,19.31,5.32,18.1,4.43,17H27.92C27.43,20.15,24.55,22,20,22Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-zeplin-f",
		"name": "ki-zeplin-f",
		"tags": "ki-zeplin-f",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M20,7.99822a35.10536,35.10536,0,0,0-9.42,1.53l-2.84-2.03A3.00379,3.00379,0,0,0,3,9.94824v3.66a3.648,3.648,0,0,0-1,2.39,3.64825,3.64825,0,0,0,1,2.39v3.66a2.9746,2.9746,0,0,0,1.63,2.67,2.89516,2.89516,0,0,0,1.37.34,3.00345,3.00345,0,0,0,1.74-.56l2.84-2.03a35.10564,35.10564,0,0,0,9.42,1.53c7.38,0,10-4.31,10-8S27.38,7.99822,20,7.99822Zm-15,1.95a.96824.96824,0,0,1,.54-.89.97814.97814,0,0,1,1.04.07l1.69,1.19995A19.14844,19.14844,0,0,0,5,11.93823Zm5.23,1.79c.12-.05.25-.09.38-.13a30.92748,30.92748,0,0,1,9.39-1.61c4.55,0,7.43,1.85,7.92,5H4.43C5.32,13.89819,7.49,12.68823,10.23,11.73821Zm-3.65,11.13a.97826.97826,0,0,1-1.04.07.96832.96832,0,0,1-.54-.89v-1.99a19.03684,19.03684,0,0,0,3.26,1.61Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-zoom",
		"name": "ki-zoom",
		"tags": "ki-zoom",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M15 9L13 9 13 13 9 13 9 15 13 15 13 19 15 19 15 15 19 15 19 13 15 13 15 9z"
				},
				{
					"d": "M28.707,27.293l-5.90582-5.90582a11.52205,11.52205,0,1,0-1.414,1.41412L27.293,28.707ZM14,23.5A9.5,9.5,0,1,1,23.5,14,9.51081,9.51081,0,0,1,14,23.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "ki-zoom-out",
		"name": "ki-zoom-out",
		"tags": "ki-zoom-out",
		"styles": "",
		"viewBox": "0 0 32 32",
		"width": "32",
		"height": "32",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M9 13H19V15H9z"
				},
				{
					"d": "M28.70703,27.29297l-5.90582-5.90582c1.68146-2.00006,2.69879-4.57599,2.69879-7.38715,0-6.34082-5.15869-11.5-11.5-11.5S2.5,7.65918,2.5,14s5.15869,11.5,11.5,11.5c2.81134,0,5.38721-1.01733,7.38721-2.69873l5.90576,5.90576,1.41406-1.41406Zm-14.70703-3.79297c-5.23828,0-9.5-4.26172-9.5-9.5S8.76172,4.5,14,4.5s9.5,4.26172,9.5,9.5-4.26172,9.5-9.5,9.5Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	}
];
	function camelCaseFromHyphenated(s) {
		return s.replace(/-([a-z0-9])/gi, function (match, token) { return token.toUpperCase(); });
	}
	icons.forEach(function (item, i) {
		icons[camelCaseFromHyphenated(item.id)] = icons[i];
	});
	return icons;
});
